(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode('._banner_hmwzu_1{--current-bg-color: var(--lhds-color-ui-200);background:var(--current-bg-color);border-radius:var(--swui-border-radius)}._banner_hmwzu_1 ._iconBackground_hmwzu_7{height:40px;width:40px;background-color:#fff;border-radius:50%;display:flex;justify-content:center;align-items:center}._banner_hmwzu_1._standard_hmwzu_17{--current-bg-color: var(--lhds-color-ui-200)}._banner_hmwzu_1._info_hmwzu_21{--current-bg-color: var(--lhds-color-blue-100)}._banner_hmwzu_1._success_hmwzu_25{--current-bg-color: var(--lhds-color-green-100)}._banner_hmwzu_1._warning_hmwzu_29{--current-bg-color: var(--lhds-color-orange-100)}._banner_hmwzu_1._error_hmwzu_33{--current-bg-color: var(--lhds-color-red-100)}._spinner_1xjtk_1{animation:_rotator_1xjtk_1 2s linear infinite both}._spinner_1xjtk_1 circle{stroke-linecap:round;transform-origin:center;fill:transparent;stroke-dasharray:283;stroke-dashoffset:280;stroke-width:10px}._spinner_1xjtk_1._standard_1xjtk_13{stroke:var(--lhds-color-blue-500)}._spinner_1xjtk_1._standard_1xjtk_13 circle{animation:_dash_1xjtk_1 1.4s ease-in-out infinite both}._spinner_1xjtk_1._inverted_1xjtk_21{stroke:var(--lhds-color-ui-300)}._spinner_1xjtk_1._inverted_1xjtk_21 circle{animation:_dash_1xjtk_1 1.4s ease-in-out infinite both}._spinner_1xjtk_1._customColor_1xjtk_29 circle{animation:_dash_1xjtk_1 1.4s ease-in-out infinite both}._spinner_1xjtk_1._medium_1xjtk_35{width:54px;height:54px}._spinner_1xjtk_1._small_1xjtk_40{width:34px;height:34px}._spinner_1xjtk_1._tiny_1xjtk_45{width:20px;height:20px}@keyframes _dash_1xjtk_1{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}to{stroke-dashoffset:280;transform:rotate(360deg)}}@keyframes _rotator_1xjtk_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}._link_oed7a_1{--swui-link-font-family: var(--swui-font-primary);--swui-link-font-weight: var(--swui-font-weight-link);--swui-link-text-decoration: underline;--swui-link-letter-spacing: var(--swui-text-letter-spacing);--swui-link-color: var(--swui-text-action-color);--swui-link-color-hover: var(--swui-text-action-color-focus);--swui-link-color-active: var(--swui-text-action-color-active);--swui-link-color-focus: var(--swui-text-action-color-focus);--swui-link-color-disabled: var(--lhds-color-ui-600);--current-color: var(--swui-link-color);--current-font-size: var(--swui-font-size-medium);--current-line-height: var(--swui-line-height-medium);--current-letter-spacing: var(--swui-link-letter-spacing);--current-font-weight: var(--swui-link-font-weight);font-size:var(--current-font-size);line-height:var(--current-line-height);color:var(--current-color);letter-spacing:var(--current-letter-spacing);font-family:var(--swui-link-font-family);font-weight:var(--current-font-weight);box-sizing:border-box;-webkit-text-decoration:var(--swui-link-text-decoration);text-decoration:var(--swui-link-text-decoration)}._link_oed7a_1:not(._disabled_oed7a_31){cursor:pointer}._link_oed7a_1:focus-visible{outline:var(--swui-focus-outline)}._link_oed7a_1:focus:not(:active){cursor:pointer}._link_oed7a_1:focus._disabled_oed7a_31{cursor:default}._link_oed7a_1:hover{--current-color: var(--swui-link-color-hover)}._link_oed7a_1:active{--current-color: var(--swui-link-color-active)}._link_oed7a_1._disabled_oed7a_31{--current-color: var(--swui-link-color-disabled)}._link_oed7a_1._bold_oed7a_64{--current-font-weight: var(--swui-font-weight-text-bold)}._link_oed7a_1._caption_oed7a_68{--current-font-size: var(--swui-font-size-small);--current-line-height: var(--swui-line-height-small);--current-letter-spacing: 0;font-style:italic}._link_oed7a_1._overline_oed7a_75{--current-font-size: var(--swui-font-size-smaller);--current-line-height: var(--swui-line-height-smaller);--current-letter-spacing: .1rem;text-transform:uppercase}._link_oed7a_1._large_oed7a_82{--current-font-size: var(--swui-font-size-large);--current-line-height: var(--swui-line-height-large);--current-letter-spacing: 0}._link_oed7a_1._medium_oed7a_88{--current-font-size: var(--swui-font-size-medium);--current-line-height: var(--swui-line-height-medium)}._link_oed7a_1._small_oed7a_93{--current-font-size: var(--swui-font-size-small);--current-line-height: var(--swui-line-height-small);--current-letter-spacing: 0}._link_oed7a_1._smaller_oed7a_99{--current-font-size: var(--swui-font-size-smaller);--current-line-height: var(--swui-line-height-smaller);--current-letter-spacing: 0}._resultItemRow_1y7mx_1{display:flex;flex-direction:column}._resultItemRow_1y7mx_1 ._link_1y7mx_5{margin-top:4px}._resultList_13lxa_1{margin:0;padding-inline-start:20px;padding-inline-end:0;padding-bottom:calc(var(--swui-metrics-spacing) * 2)}._resultList_13lxa_1 li:not(:last-child){margin-bottom:calc(var(--swui-metrics-spacing))}._crumb_c5ozi_1{font-size:1.2rem;font-family:var(--swui-font-primary);font-weight:var(--swui-font-weight-text-bold);letter-spacing:.1rem;text-decoration:none;color:var(--lhds-color-ui-600)}._crumb_c5ozi_1:focus-visible{outline:var(--swui-focus-outline)}._crumb_c5ozi_1:not(:last-of-type){cursor:pointer}._crumb_c5ozi_1:not(:last-of-type):hover{text-decoration:underline;color:var(--swui-text-action-color-hover)}._crumb_c5ozi_1:not(:last-of-type):focus{color:var(--swui-text-action-color-focus)}._crumb_c5ozi_1:not(:last-of-type):active{text-decoration:underline;color:var(--swui-text-action-color-active)}._button_5nfpd_1{--swui-button-height-small: 24px;--swui-button-height-medium: 36px;--swui-button-height-large: 48px;--swui-button-height-larger: 72px;--swui-button-icon-height-small: 1.6rem;--swui-button-icon-height-small-icon-only: 1.6rem;--swui-button-icon-height-medium: 2rem;--swui-button-icon-height-medium-icon-only: 2rem;--swui-button-icon-height-large: 2.4rem;--swui-button-icon-height-large-icon-only: 2.4rem;--swui-button-icon-height-larger: 3.2rem;--swui-button-icon-height-larger-icon-only: 3.2rem;--swui-button-padding-vertical: 6px;--swui-button-padding-horizontal: 16px;box-sizing:border-box;min-height:var(--swui-button-height-medium);height:var(--swui-button-height-medium);letter-spacing:var(--swui-field-letter-spacing);text-decoration:none;padding:var(--swui-button-padding-vertical) var(--swui-button-padding-horizontal);border-radius:var(--swui-max-border-radius);outline:none;font-size:var(--swui-font-size-medium);line-height:var(--swui-line-height);font-weight:var(--swui-font-weight-text-bold);font-family:var(--swui-font-buttons);cursor:pointer;-webkit-user-select:none;user-select:none;display:inline-flex;align-items:center;justify-content:center;--current-icon-height: var(--swui-button-icon-height-medium)}._button_5nfpd_1._roundButton_5nfpd_44{padding:var(--swui-button-padding-vertical);flex:none;width:var(--swui-button-height-medium);height:var(--swui-button-height-medium);justify-content:center;align-items:center;display:flex}._button_5nfpd_1._roundButton_5nfpd_44._small_5nfpd_54{width:var(--swui-button-height-small);height:var(--swui-button-height-small);--current-icon-height: var(--swui-button-icon-height-small-icon-only)}._button_5nfpd_1._roundButton_5nfpd_44._medium_5nfpd_60{width:var(--swui-button-height-medium);height:var(--swui-button-height-medium);--current-icon-height: var(--swui-button-icon-height-medium-icon-only)}._button_5nfpd_1._roundButton_5nfpd_44._large_5nfpd_66{width:var(--swui-button-height-large);height:var(--swui-button-height-large);--current-icon-height: var(--swui-button-icon-height-large-icon-only)}._button_5nfpd_1._roundButton_5nfpd_44._larger_5nfpd_72{width:var(--swui-button-height-larger);height:var(--swui-button-height-larger);--current-icon-height: var(--swui-button-icon-height-larger-icon-only)}._button_5nfpd_1._small_5nfpd_54{--swui-button-padding-vertical: 3px;font-size:1.2rem;min-height:var(--swui-button-height-small);height:var(--swui-button-height-small);--current-icon-height: var(--swui-button-icon-height-small);--swui-button-padding-horizontal: 8px}._button_5nfpd_1._large_5nfpd_66{--swui-button-padding-vertical: 8px;font-size:1.8rem;min-height:var(--swui-button-height-large);height:var(--swui-button-height-large);--current-icon-height: var(--swui-button-icon-height-large)}._button_5nfpd_1._larger_5nfpd_72{--swui-button-padding-vertical: 8px;min-height:var(--swui-button-height-larger);height:var(--swui-button-height-larger);font-size:2rem;--current-icon-height: var(--swui-button-icon-height-larger);--swui-button-padding-horizontal: 40px}._button_5nfpd_1:focus:not(:focus-visible){outline:0}._button_5nfpd_1:disabled{cursor:not-allowed}._buttonContent_u48in_1{display:flex;flex-direction:row}._iconLeft_u48in_6,._iconRight_u48in_7{color:var(--current-icon-color);font-size:var(--current-icon-height)}._leftWrapper_u48in_12,._rightWrapper_u48in_13{display:flex;align-items:center;justify-content:center}@media (max-width: 768px){._responsiveIconOnly_u48in_19._leftWrapper_u48in_12{margin-right:0}._responsiveIconOnly_u48in_19._label_u48in_25,._responsiveIconOnly_u48in_19._rightWrapper_u48in_13{display:none}}._spinnerLeft_u48in_32{display:flex;align-items:center}._label_u48in_25{white-space:nowrap}._flatButton_3cffo_1{color:var(--swui-text-action-color);background:transparent;border:1px solid transparent}._flatButton_3cffo_1:hover{background:var(--lhds-color-blue-100)}._flatButton_3cffo_1:focus-visible{outline:var(--swui-focus-outline);background:transparent}._flatButton_3cffo_1:active{background:var(--lhds-color-blue-200)}._flatButton_3cffo_1:disabled{background-color:transparent;border:1px solid var(--swui-primary-action-color-disabled);color:var(--swui-text-disabled-color)}._flatButton_3cffo_1._danger_3cffo_28:not(:disabled){color:var(--lhds-color-red-500)}._flatButton_3cffo_1._danger_3cffo_28:not(:disabled):hover{background:var(--snackskal-light)}._flatButton_3cffo_1._danger_3cffo_28:not(:disabled):focus-visible{outline:var(--swui-focus-outline-width) solid var(--lhds-color-red-600)}._flatButton_3cffo_1._danger_3cffo_28:not(:disabled):active{background:var(--lhds-color-red-100)}._flatButton_3cffo_1._success_3cffo_44:not(:disabled){color:var(--lhds-color-green-800)}._flatButton_3cffo_1._success_3cffo_44:not(:disabled):hover{background:var(--lhds-color-green-50)}._flatButton_3cffo_1._success_3cffo_44:not(:disabled):focus-visible{outline:var(--swui-focus-outline-width) solid var(--lhds-color-green-700)}._flatButton_3cffo_1._success_3cffo_44:not(:disabled):active{background:var(--lhds-color-green-100)}._primaryButton_lo2p8_1{border:1px solid var(--swui-primary-action-color);background-color:var(--swui-primary-action-color);color:var(--swui-white)}._primaryButton_lo2p8_1:hover{background-color:var(--swui-primary-action-color-hover);border:1px solid var(--swui-primary-action-color-hover)}._primaryButton_lo2p8_1:focus-visible{background-color:var(--swui-primary-action-color-focus);border:1px solid var(--swui-primary-action-color-focus);outline:var(--swui-focus-outline);outline-offset:2px}._primaryButton_lo2p8_1:active{background-color:var(--swui-primary-action-color-active);border:1px solid var(--swui-primary-action-color-active)}._primaryButton_lo2p8_1:disabled{background-color:var(--swui-primary-action-color-disabled);border:1px solid var(--swui-primary-action-color-disabled);color:var(--swui-text-disabled-color)}._primaryButton_lo2p8_1._danger_lo2p8_32:not(:disabled){background-color:var(--lhds-color-red-500);border:1px solid var(--lhds-color-red-500)}._primaryButton_lo2p8_1._danger_lo2p8_32:not(:disabled):hover{background-color:var(--lhds-color-red-600);border:1px solid var(--lhds-color-red-600)}._primaryButton_lo2p8_1._danger_lo2p8_32:not(:disabled):focus-visible{background-color:var(--lhds-color-red-700);border:1px solid var(--lhds-color-red-700);outline:var(--swui-focus-outline-width) solid var(--lhds-color-red-700);outline-offset:2px}._primaryButton_lo2p8_1._danger_lo2p8_32:not(:disabled):active{background-color:var(--lhds-color-red-900);border:1px solid var(--lhds-color-red-900)}._primaryButton_lo2p8_1._success_lo2p8_54:not(:disabled){background-color:var(--lhds-color-green-600);border:1px solid var(--lhds-color-green-600)}._primaryButton_lo2p8_1._success_lo2p8_54:not(:disabled):hover{background-color:var(--lhds-color-green-700);border:1px solid var(--lhds-color-green-700)}._primaryButton_lo2p8_1._success_lo2p8_54:not(:disabled):focus-visible{background-color:var(--lhds-color-green-800);border:1px solid var(--lhds-color-green-800);outline:var(--swui-focus-outline-width) solid var(--lhds-color-green-800);outline-offset:2px}._primaryButton_lo2p8_1._success_lo2p8_54:not(:disabled):active{background-color:var(--lhds-color-green-900);border:1px solid var(--lhds-color-green-900)}._secondaryButton_16omp_1{border:1px solid var(--lhds-color-blue-600);background-color:var(--swui-white);color:var(--swui-text-action-color)}._secondaryButton_16omp_1:hover{background-color:var(--lhds-color-blue-50);border:1px solid var(--lhds-color-blue-600)}._secondaryButton_16omp_1:focus-visible{background-color:var(--swui-white);border:1px solid transparent;outline:var(--swui-focus-outline)}._secondaryButton_16omp_1:active{background-color:var(--lhds-color-blue-100);border:1px solid var(--lhds-color-blue-500)}._secondaryButton_16omp_1:disabled{background-color:var(--lhds-color-ui-300);border:1px solid var(--lhds-color-ui-300);color:var(--swui-text-disabled-color)}._secondaryButton_16omp_1._danger_16omp_31:not(:disabled){border:1px solid var(--lhds-color-red-500);color:var(--lhds-color-red-600)}._secondaryButton_16omp_1._danger_16omp_31:not(:disabled):hover{background-color:var(--snackskal-light);border:1px solid var(--lhds-color-red-400)}._secondaryButton_16omp_1._danger_16omp_31:not(:disabled):focus-visible{border:1px solid transparent;outline:var(--swui-focus-outline-width) solid var(--lhds-color-red-600)}._secondaryButton_16omp_1._danger_16omp_31:not(:disabled):active{background-color:var(--lhds-color-red-100);border:1px solid var(--lhds-color-red-500)}._secondaryButton_16omp_1._success_16omp_51:not(:disabled){border:1px solid var(--lhds-color-green-500);color:var(--lhds-color-green-800)}._secondaryButton_16omp_1._success_16omp_51:not(:disabled):hover{background-color:var(--lhds-color-green-50);border:1px solid var(--lhds-color-green-500)}._secondaryButton_16omp_1._success_16omp_51:not(:disabled):focus-visible{border:1px solid transparent;outline:var(--swui-focus-outline-width) solid var(--lhds-color-green-700)}._secondaryButton_16omp_1._success_16omp_51:not(:disabled):active{background-color:var(--lhds-color-green-100);border:1px solid var(--lhds-color-green-600)}._textInputButton_rl087_1._textInputButton_rl087_1{--swui-button-height-small: 20px;--swui-button-height-medium: 30px;--swui-button-height-large: 42px;--swui-button-height-larger: 66px;--current-background: transparent;outline:none;width:auto;padding:0;aspect-ratio:1;display:flex;border-radius:var(--swui-border-radius-small);justify-content:center;align-items:center;background:var(--current-background);cursor:pointer;border:1px solid var(--border-color, var(--current-background))}._textInputButton_rl087_1._textInputButton_rl087_1 ._icon_rl087_20{width:var(--current-icon-height)}._textInputButton_rl087_1._textInputButton_rl087_1._normal_rl087_24{--current-background: var(--himmel-lighter)}._textInputButton_rl087_1._textInputButton_rl087_1._normal_rl087_24:hover:not(._textInputButton_rl087_1._textInputButton_rl087_1._normal_rl087_24:active){--current-background: var(--himmel-light)}._textInputButton_rl087_1._textInputButton_rl087_1._normal_rl087_24:active{--border-color: var(--core-blue)}._textInputButton_rl087_1._textInputButton_rl087_1._normal_rl087_24 ._icon_rl087_20{color:var(--core-blue)}._textInputButton_rl087_1._textInputButton_rl087_1._error_rl087_40{--current-background: var(--snackskal-light)}._textInputButton_rl087_1._textInputButton_rl087_1._error_rl087_40:hover:not(._textInputButton_rl087_1._textInputButton_rl087_1._error_rl087_40:active){--current-background: var(--snackskal)}._textInputButton_rl087_1._textInputButton_rl087_1._error_rl087_40:active{--border-color: var(--modern-red)}._textInputButton_rl087_1._textInputButton_rl087_1._error_rl087_40 ._icon_rl087_20{color:var(--modern-red)}._textInputButton_rl087_1._textInputButton_rl087_1._warning_rl087_56{--current-background: var(--lhds-color-orange-100)}._textInputButton_rl087_1._textInputButton_rl087_1._warning_rl087_56:hover:not(._textInputButton_rl087_1._textInputButton_rl087_1._warning_rl087_56:active){--current-background: var(--lhds-color-orange-200)}._textInputButton_rl087_1._textInputButton_rl087_1._warning_rl087_56:active{--border-color: var(--lhds-color-orange-600)}._textInputButton_rl087_1._textInputButton_rl087_1._warning_rl087_56 ._icon_rl087_20{color:var(--tjara)}._textInputButton_rl087_1._textInputButton_rl087_1._success_rl087_72{--current-background: var(--lhds-color-green-100)}._textInputButton_rl087_1._textInputButton_rl087_1._success_rl087_72:hover:not(._textInputButton_rl087_1._textInputButton_rl087_1._success_rl087_72:active){--current-background: var(--lhds-color-green-200)}._textInputButton_rl087_1._textInputButton_rl087_1._success_rl087_72:active{--border-color: var(--lhds-color-green-600)}._textInputButton_rl087_1._textInputButton_rl087_1._success_rl087_72 ._icon_rl087_20{color:var(--tjara)}._textInputButton_rl087_1._textInputButton_rl087_1:focus-visible{outline:var(--swui-focus-outline)}._menuButton_vd51h_1{--swui-menu-button-item-height: 40px;--swui-menu-button-separator-color: var(--swui-white);--swui-menu-button-text-color: var(--lhds-color-ui-900);--swui-menu-button-icon-color: var(--lhds-color-ui-900);--swui-menu-button-background-color: transparent;--swui-menu-button-background-color-hover: var(--lhds-color-ui-300);--swui-menu-button-background-color-focus: var(--lhds-color-ui-300);--swui-menu-button-background-color-active: var(--lhds-color-ui-400);--swui-menu-button-background-selected: var(--lhds-color-blue-100);--swui-menu-button-background-selected-hover: var(--lhds-color-blue-200);--swui-menu-button-background-selected-focus: var(--lhds-color-blue-200);--swui-menu-button-background-selected-active: var(--lhds-color-blue-100);--current-separator-color: var(--swui-menu-button-separator-color);--current-text-color: var(--swui-menu-button-text-color);--current-icon-color: var(--swui-menu-button-icon-color);--current-background-color: var(--swui-menu-button-background-color);--current-background-color-hover: var( --swui-menu-button-background-color-hover );--current-background-color-focus: var( --swui-menu-button-background-color-focus );--current-background-color-active: var( --swui-menu-button-background-color-active );--current-background-selected: var(--swui-menu-button-background-selected);--current-background-selected-hover: var( --swui-menu-button-background-selected-hover );--current-background-selected-focus: var( --swui-menu-button-background-selected-focus );--current-background-selected-active: var( --swui-menu-button-background-selected-active );background-color:var(--current-background-color)}._menuButton_vd51h_1 ._label_vd51h_44{text-align:start;flex:1;font-size:var(--current-text-size, var(--swui-font-size-medium))}._menuButton_vd51h_1 ._buttonLink_vd51h_50{text-decoration:none}._menuButton_vd51h_1 ._button_vd51h_50{display:inline-flex;align-items:center;justify-content:space-between;gap:var(--swui-metrics-indent);border:0;cursor:pointer;border-radius:var(--swui-max-border-radius);background:var(--current-background-color);min-height:var(--swui-menu-button-item-height);min-width:var(--swui-menu-button-item-height);padding:0 calc(1 * var(--swui-metrics-indent))}._menuButton_vd51h_1 ._button_vd51h_50._hasLabel_vd51h_69{padding:0 calc(2 * var(--swui-metrics-indent))}._menuButton_vd51h_1 ._button_vd51h_50._success_vd51h_73{--current-text-color: var(--swui-menu-button-text-color);--current-background-color-hover: var(--lhds-color-green-100);--current-background-color-focus: var(--lhds-color-green-100);--current-background-color-active: var(--lhds-color-ui-200)}._menuButton_vd51h_1 ._button_vd51h_50._danger_vd51h_80{--current-text-color: var(--lhds-color-red-600);--current-background-color-hover: var(--lhds-color-red-100);--current-background-color-focus: var(--lhds-color-red-100);--current-background-color-active: var(--lhds-color-ui-200)}._menuButton_vd51h_1 ._button_vd51h_50._disabled_vd51h_87{--current-text-color: var(--lhds-color-ui-500);--current-background-color-hover: var( --swui-menu-button-background-color );--current-background-color-focus: var( --swui-menu-button-background-color );--current-background-color-active: var( --swui-menu-button-background-color )}[data-collapsed] [aria-expanded=true] ._menuButton_vd51h_1 ._button_vd51h_50,._menuButton_vd51h_1 ._button_vd51h_50:hover{background:var(--current-background-color-hover)}._menuButton_vd51h_1 ._button_vd51h_50:focus:not(:focus-visible){outline:none}._menuButton_vd51h_1 ._button_vd51h_50:focus-visible{background:var(--current-background-color-focus);outline:var(--swui-focus-outline);outline-offset:var(--swui-focus-outline-width)}._menuButton_vd51h_1 ._button_vd51h_50:active{background:var(--current-background-color-active)}._menuButton_vd51h_1 ._button_vd51h_50._iconOnly_vd51h_119{aspect-ratio:1;justify-content:center}._menuButton_vd51h_1 ._button_vd51h_50._selected_vd51h_124{background:var(--current-background-selected)}._menuButton_vd51h_1 ._button_vd51h_50._selected_vd51h_124:hover{background:var(--current-background-selected-hover)}._menuButton_vd51h_1 ._button_vd51h_50._selected_vd51h_124:focus-visible{background:var(--current-background-selected-focus)}._menuButton_vd51h_1 ._button_vd51h_50._selected_vd51h_124:active{background:var(--current-background-selected-active)}._menuButtonGroupBox_164qh_1{background:var(--lhds-color-ui-200);border-radius:var(--swui-border-radius);gap:var(--swui-metrics-space);display:flex;flex-direction:column;padding:var(--swui-metrics-space);--current-text-size: var(--swui-font-size-small)}._contentMenuButton_c906v_1{--current-outline: none;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;border-radius:var(--swui-max-border-radius);min-height:40px;padding:4px 0;outline:none}._contentMenuButton_c906v_1:hover{background:var(--lhds-color-ui-400)}._contentMenuButton_c906v_1:focus{background:var(--lhds-color-ui-500)}._contentMenuButton_c906v_1:active{background:var(--lhds-color-ui-500)}._buttonLink_1wbp2_1{text-decoration:none}._buttonGroup_1a3xe_1{display:inline-flex;flex-direction:row;padding:2px;gap:4px;border:2px solid var(--lhds-color-ui-300);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;border-radius:12px}._upDownButtons_1688z_1{--swui-stepper-button-width: 25px;align-self:stretch}._upDownButtons_1688z_1 ._button_1688z_5{width:var(--swui-stepper-button-width);border:none;cursor:pointer;flex:1}._upDownButtons_1688z_1 ._button_1688z_5:focus{outline:none}._upDownButtons_1688z_1 ._button_1688z_5:focus-visible{outline:var(--swui-focus-outline)}._upDownButtons_1688z_1 ._button_1688z_5:disabled{background-color:var(--swui-textinput-bg-color-disabled)}._cardy_voxad_1._cardy_voxad_1{border-radius:24px;padding-top:32px;padding-bottom:32px}@media (max-width: 768px){._cardy_voxad_1._cardy_voxad_1{padding-top:24px;padding-bottom:24px}}._cardyIndent_voxad_12._cardyIndent_voxad_12{padding-left:32px;padding-right:32px}@media (max-width: 768px){._cardyIndent_voxad_12._cardyIndent_voxad_12{padding-left:16px;padding-right:16px}}._chip_1k9u8_1{--swui-chip-font-size: var(--swui-font-size-small);--swui-chip-line-height: var(--swui-line-height-small);--swui-chip-font-weight: var(--swui-font-weight-text-bold);--swui-chip-font-family: var(--swui-font-primary);--swui-chip-letter-spacing: var(--swui-text-letter-spacing);--swui-chip-height: 24px;--swui-chip-border-radius: 99rem;--current-text-color: var(--swui-white);--current-bg-color: var(--lhds-color-blue-50);--current-bg-color-hover: var(--lhds-color-blue-600);--current-bg-color-focus: var(--lhds-color-blue-700);--current-bg-color-active: var(--lhds-color-blue-800);box-sizing:border-box;display:inline-flex;flex-direction:row;border-radius:var(--swui-chip-border-radius);background-color:var(--current-bg-color)}._chip_1k9u8_1 ._chipCell_1k9u8_25{font-family:var(--swui-chip-font-family);font-size:var(--swui-chip-font-size);font-weight:var(--swui-chip-font-weight);line-height:var(--swui-chip-line-height);color:var(--current-text-color);min-height:var(--swui-chip-height);display:flex;align-items:center}._chip_1k9u8_1 ._label_1k9u8_36{white-space:nowrap;padding:0 calc(var(--swui-metrics-space) * 2)}._chip_1k9u8_1 ._label_1k9u8_36._removable_1k9u8_40{padding:0 6px 0 var(--swui-metrics-indent)}._chip_1k9u8_1 button{background:transparent;border:none;cursor:pointer;-webkit-user-select:none;user-select:none}._chip_1k9u8_1 button:hover{background-color:var(--current-bg-color-hover)}._chip_1k9u8_1 button:focus{background-color:var(--current-bg-color-focus);outline:none}._chip_1k9u8_1 button:focus-visible{outline:var(--swui-focus-outline)}._chip_1k9u8_1 button:active{background-color:var(--current-bg-color-active)}._chip_1k9u8_1 button:first-child{border-top-left-radius:var(--swui-chip-border-radius);border-bottom-left-radius:var(--swui-chip-border-radius)}._chip_1k9u8_1 button:last-child{border-top-right-radius:var(--swui-chip-border-radius);border-bottom-right-radius:var(--swui-chip-border-radius)}._chip_1k9u8_1 ._close_1k9u8_79{padding-left:2px;padding-right:2px}._chip_1k9u8_1 ._close_1k9u8_79 ._circle_1k9u8_83{display:flex;align-items:center;justify-content:center;background:var(--lhds-color-ui-50);border-radius:var(--swui-max-border-radius);width:20px;height:20px}._chip_1k9u8_1 ._close_1k9u8_79 svg{color:var(--modern-blue)}._chip_1k9u8_1 ._close_1k9u8_79:hover svg{color:var(--core-blue)}._chip_1k9u8_1._primary_1k9u8_104{--current-bg-color: var(--himmel-light);--current-text-color: var(--black);--current-bg-color-hover: var(--himmel);--current-bg-color-focus: var(--himmel);--current-bg-color-active: var(--lhds-color-blue-300)}._chip_1k9u8_1._secondary_1k9u8_112{--current-bg-color: var(--silver-ui);--current-text-color: var(--black);--current-bg-color-hover: var(--silver-light);--current-bg-color-focus: var(--silver-light);--current-bg-color-active: var(--silver)}._badge_1b6e7_1{--swui-badge-notification-bg-color: var(--swui-primary-action-color);--swui-badge-warning-bg-color: var(--swui-state-alert-color);--swui-badge-error-bg-color: var(--swui-state-error-color);--swui-badge-text-color: var(--swui-white);--swui-badge-size: 18px;display:flex;overflow:hidden;border-radius:calc(var(--swui-badge-size) / 2);border-width:0;min-width:var(--swui-badge-size);height:var(--swui-badge-size);align-items:center;justify-content:center}._badge_1b6e7_1._info_1b6e7_17{background:var(--swui-badge-notification-bg-color)}._badge_1b6e7_1._warning_1b6e7_21{background:var(--swui-badge-warning-bg-color)}._badge_1b6e7_1._error_1b6e7_25{background:var(--swui-badge-error-bg-color)}._badge_1b6e7_1 ._label_1b6e7_29{line-height:var(--swui-badge-size);color:var(--swui-badge-text-color)}._toggleButton_ei1l4_1{--swui-toggle-button-height: 32px;--swui-toggle-button-background: var(--swui-white);--swui-toggle-button-background-selected: var(--lhds-color-blue-200);--swui-toggle-button-background-hover: var(--lhds-color-ui-200);--swui-toggle-button-background-focus: var(--lhds-color-blue-100);--swui-toggle-button-background-focus-selected: var(--lhds-color-blue-300);--swui-toggle-button-background-active: var(--lhds-color-blue-100);--swui-toggle-button-background-disabled: var(--lhds-color-ui-500);--swui-toggle-button-text-color: var(--black);--swui-toggle-button-text-color-disabled: var(--lhds-color-ui-50);--current-background: var(--swui-toggle-button-background)}._toggleButton_ei1l4_1 label{background:var(--current-background);border-radius:var(--swui-border-radius);cursor:pointer;height:var(--swui-toggle-button-height);min-width:var(--swui-toggle-button-height);padding:0 calc(var(--swui-metrics-space) * 1);display:flex;flex-direction:row;align-items:center;justify-content:center;box-sizing:border-box;font-family:var(--swui-font-primary);font-weight:var(--swui-font-weight-text);font-size:var(--swui-font-size-medium);color:var(--swui-toggle-button-text-color);-webkit-user-select:none;user-select:none}._toggleButton_ei1l4_1 input{position:absolute;left:-100vw}._toggleButton_ei1l4_1 input:focus-visible~label{--current-background: var(--swui-toggle-button-background-focus);outline:var(--swui-focus-outline)}._toggleButton_ei1l4_1._selected_ei1l4_50 input:focus-visible~label{--current-background: var(--swui-toggle-button-background-focus-selected)}._toggleButton_ei1l4_1._disabled_ei1l4_56 label{color:var(--swui-toggle-button-text-color-disabled)}._toggleButton_ei1l4_1._small_ei1l4_62{--swui-toggle-button-height: 24px}._toggleButton_ei1l4_1._small_ei1l4_62 label{font-size:var(--swui-font-size-small)}._toggleButton_ei1l4_1._medium_ei1l4_69{--swui-toggle-button-height: 32px}._toggleButton_ei1l4_1._large_ei1l4_73{--swui-toggle-button-height: 40px;padding:0 calc(2 * var(--swui-metrics-space))}._toggleButton_ei1l4_1:not(._disabled_ei1l4_56):hover{--current-background: var(--swui-toggle-button-background-hover)}._toggleButton_ei1l4_1:not(._disabled_ei1l4_56):active{--current-background: var(--swui-toggle-button-background-active)}._toggleButton_ei1l4_1:not(._disabled_ei1l4_56)._selected_ei1l4_50{--current-background: var(--swui-toggle-button-background-selected);z-index:1}._toggleButton_ei1l4_1._disabled_ei1l4_56{--current-background: var(--swui-toggle-button-background-disabled);cursor:not-allowed}._tab_9rve8_1{--swui-tab-height: 40px;--swui-tab-border-radius: 0;--swui-tab-border-color-hover: var(--lhds-color-ui-300);--swui-tab-border-color-focus: var(--lhds-color-ui-300);--swui-tab-border-color-selected: var(--lhds-color-blue-600);--swui-tab-background: var(--lhds-color-ui-200);--swui-tab-background-hover: var(--lhds-color-ui-400);--swui-tab-background-focus: var(--lhds-color-blue-100);--swui-tab-background-selected: var(--lhds-color-blue-200);--swui-tab-label-color: var(--lhds-color-ui-900);--swui-tab-label-color-hover: var(--lhds-color-blue-900);--swui-tab-label-color-selected: var(--lhds-color-blue-600);--swui-tab-label-color-selected-hover: var(--lhds-color-blue-600);--current-outer-border-bottom-color: transparent;--current-inset-shadow: none;--current-label-color: var(--swui-tab-label-color);min-height:var(--swui-tab-height);outline:none;border-radius:var(--swui-tab-border-radius);padding:5px calc(var(--swui-metrics-indent) * 3);display:flex;align-items:center;justify-content:center;box-sizing:border-box;font-size:var(--swui-font-size-medium);font-family:var(--swui-font-buttons);font-weight:var(--swui-font-weight-text-bold);border:none;cursor:pointer;border-bottom:2px solid var(--current-outer-border-bottom-color);background-color:transparent;color:var(--current-label-color)}._tab_9rve8_1:focus-visible{outline:var(--swui-focus-outline);--current-outer-border-bottom-color: var(--swui-tab-border-color-focus);padding-bottom:4px}._tab_9rve8_1._selected_9rve8_50{--current-outer-border-bottom-color: var(--swui-tab-border-color-selected);--current-label-color: var(--swui-tab-label-color-selected)}._tab_9rve8_1:hover._selected_9rve8_50{color:var(--swui-tab-label-color-selected-hover)}._tab_9rve8_1:hover:not(._selected_9rve8_50){--current-outer-border-bottom-color: var(--swui-tab-border-color-hover);color:var(--swui-tab-label-color-hover)}._tabMenu_vtxe7_1{--swui-tab-menu-border-color: var(--lhds-color-ui-200);gap:calc(var(--swui-metrics-indent) * 2);display:flex}._tabMenu_vtxe7_1._withBorder_vtxe7_10{border-bottom:1px solid var(--swui-tab-menu-border-color)}._tag_1rqyd_1{font-family:var(--swui-font-primary);font-size:var(--swui-font-size-small);font-weight:500;letter-spacing:var(--swui-text-letter-spacing);line-height:var(--swui-line-height-small);box-sizing:border-box;display:inline-flex;flex-direction:row;white-space:nowrap;border-radius:var(--swui-border-radius-small);min-height:24px;align-items:center;padding:0 calc(var(--swui-metrics-indent) * 2);gap:var(--swui-metrics-indent)}._tag_1rqyd_1 ._icon_1rqyd_18{font-size:1.6rem}._tag_1rqyd_1._medium_1rqyd_22._withIcon_1rqyd_23{padding-left:var(--swui-metrics-indent)}._tag_1rqyd_1._small_1rqyd_28{min-height:16px;padding:0 var(--swui-metrics-indent)}._tag_1rqyd_1._small_1rqyd_28 ._icon_1rqyd_18{font-size:1.4rem}._tag_1rqyd_1._info_1rqyd_37{background-color:var(--lhds-color-blue-100);color:var(--black)}._tag_1rqyd_1._error_1rqyd_42{background-color:var(--lhds-color-red-100);color:var(--black)}._tag_1rqyd_1._warning_1rqyd_47{background-color:var(--lhds-color-orange-100);color:var(--black)}._tag_1rqyd_1._success_1rqyd_52{background-color:var(--lhds-color-green-100);color:var(--black)}._tag_1rqyd_1._passive_1rqyd_57{background-color:var(--silver-lighter);color:var(--black)}._tag_1rqyd_1._info-strong_1rqyd_62{background-color:var(--modern-blue);color:var(--moln)}._tag_1rqyd_1._error-strong_1rqyd_67{background-color:var(--lhds-color-red-500);color:var(--moln)}._tag_1rqyd_1._warning-strong_1rqyd_72{background-color:var(--lhds-color-orange-400);color:var(--black)}._tag_1rqyd_1._success-strong_1rqyd_77{background-color:var(--lhds-color-green-600);color:var(--moln)}._valueTable_14pft_1{--swui-value-table-height: 40px;width:100%}._valueTable_14pft_1._withBorder_14pft_8 ._row_14pft_8:not(:first-child) td{border-top:1px solid var(--lhds-color-ui-300)}._relaxed_14pft_13{--swui-value-table-height: 48px}._condensed_14pft_17{--swui-value-table-height: 32px}._compact_14pft_21{--swui-value-table-height: 24px}._routeLeg_um7oj_1{position:relative}._routeLeg_um7oj_1 ._selectedIcon_um7oj_4{position:absolute;top:0;right:0}._routeLeg_um7oj_1 ._grid_um7oj_10{display:grid;grid-template-columns:auto 1fr;column-gap:calc(3 * var(--swui-metrics-indent));row-gap:calc(2 * var(--swui-metrics-indent))}._timeTag_1srws_1{--current-icon-color: var(--lhds-color-ui-500)}._timeTag_1srws_1 ._icon_1srws_4{color:var(--current-icon-color)}._timeTag_1srws_1._waiting_1srws_8{--current-icon-color: var(--lhds-color-orange-600)}._timeTag_1srws_1._total_1srws_12{--current-icon-color: var(--lhds-color-blue-500)}._shimmerBox_73hsi_1{display:inline-block;position:relative;overflow:hidden;background-color:#dddbdd}._shimmerBox_73hsi_1:after{position:absolute;top:0;right:0;bottom:0;left:0;transform:translate(-100%);background-image:linear-gradient(90deg,#fff0 0,#fff3 20%,#ffffff80 60%,#fff0);animation:_shimmer_73hsi_1 2s infinite;content:""}@keyframes _shimmer_73hsi_1{to{transform:translate(100%)}}._line_vg53u_1{--swui-step-indicator-line-height: 4px;--swui-step-indicator-line-active-color: var(--lhds-color-blue-600);--swui-step-indicator-line-inactive-color: var(--lhds-color-ui-300);--swui-step-indicator-line-border-radius: var(--swui-border-radius);--swui-step-indicator-line-passed-color: var(--lhds-color-blue-600);--current-background-color: var(--swui-step-indicator-line-inactive-color)}._line_vg53u_1._currentStep_vg53u_13{--current-background-color: var(--swui-step-indicator-line-active-color)}._line_vg53u_1._passedStep_vg53u_17{--current-background-color: var(--swui-step-indicator-line-passed-color)}._line_vg53u_1{height:var(--swui-step-indicator-line-height);border-radius:var(--swui-step-indicator-line-border-radius);background-color:var(--current-background-color)}._text_17tbt_1{--swui-step-indicator-text-active-color: var(--lhds-color-blue-600);--swui-step-indicator-text-inactive-color: var(--swui-text-primary-color);--swui-step-indicator-text-passed-color: var(--lhds-color-blue-600);--current-color: var(--swui-step-indicator-text-inactive-color)}._text_17tbt_1._currentStep_17tbt_11{--current-color: var(--swui-step-indicator-text-active-color)}._text_17tbt_1._passedStep_17tbt_15{--current-color: var(--swui-step-indicator-text-passed-color)}._text_17tbt_1{text-align:center;color:var(--current-color);font-size:var(--swui-font-size-medium);line-height:var(--swui-line-height-large);font-family:var(--swui-font-buttons);font-weight:var(--swui-font-weight-text-bold)}._item_17tbt_30{flex:1;word-break:break-word;display:flex;flex-direction:column}._list_1s4t8_1{list-style-type:none;display:flex;padding:0;margin:0;gap:var(--swui-metrics-space)}')),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import * as y from "react";
import { forwardRef as f, Children as a1, useState as T1, useCallback as D, useId as V1, useContext as D1, useMemo as F1 } from "react";
import { jsx as C, jsxs as r, Fragment as B } from "react/jsx-runtime";
import { Box as p, getDataProps as H, Column as x, Row as u, Heading as X, Text as $, Space as I, Indent as s1, exhaustSwitchCaseElseThrow as y1, useForwardedRef as j1, Spacing as E1, SeparatorLine as O1, Txt as S, ScreenReaderOnlyText as P1 } from "@stenajs-webui/core";
import { FontAwesomeIcon as T } from "@fortawesome/react-fontawesome";
import l from "classnames";
import { keyframes as U1, ClassNames as W1 } from "@emotion/react";
import { cssColor as z } from "@stenajs-webui/theme";
import { FocusScope as q1, useFocusManager as G1 } from "@react-aria/focus";
const K1 = ({
  title: n,
  titleId: L,
  ...e
}, i) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 550 370", ref: i, "aria-labelledby": L, ...e }, n ? /* @__PURE__ */ y.createElement("title", { id: L }, n) : null, /* @__PURE__ */ y.createElement("path", { d: "M21.6 368s19.3-7.2 28.2-10.3c7.8-2.8 24.3-8.7 47.3-8.9 18.1-.1 31.3 6.5 49.3 4 11.7-1.5 33.9-8.1 55.3-8 24.2.2 27.6 4.4 48 1.8 19.2-2.5 36.6-5.7 57.6 4.9 20.1 10.2 48.4 5.6 61 3 13-2.7 37.1-3.8 59-3 20.9.7 45.8 7.8 66 8 18.1.1 48.1-2.1 53.7-3.9 1.2-28.7-4.8-53.9-5.3-58.1-4.3-23.6-6.2-52-5.8-65 .4-9.5 4.4-58.3 5.8-67.4 1.1-9.8 4.8-49.7 4.7-86.5-.1-22.1-3.9-57.5-7.2-66.9 0 0-12.9 5.3-31.9 7.4-27.9 2.8-42.7 0-55.1-2.8-14.8-3.3-49.2-2.4-79.3 1-32.2 3.8-40.3 1.4-47.5.3-17.6-2.7-30.3-12.9-56.4-12.4-8.2.1-24.7 1.6-31.6 1.9-11.8.4-31.8-4.7-43.4-5.1-7-.2-13.8 1.3-21 2.7-7.5 1.4-19.7 4.1-37 4.7-17.4.7-24.3-.6-32.6-1.9C94.1 6.2 78 4.6 61.5 5.3c-22 .8-58.7 10-58.7 10 4 11.5 17.2 50.8 22.1 75.8 3.1 16.2 9 43.6 11 64.2 1.8 19.3 3.7 41.9 2.7 62-.2 7.6-.7 17.9-1.2 25.4-1 17.9-3.4 37.1-5 49-2 15.1-7.8 61.8-10.8 76.3", fill: "#fff" }), /* @__PURE__ */ y.createElement("path", { fill: "#e41f1f", d: "M489.8 64.8c-17.4.1-42.4-5.4-53.4-6.7-9.7-1.3-44.2-1.3-53.9-.2-13.7 1.5-36.3 4-53.4 2.3-16.8-1.6-35.9-10.9-48.8-13.4-10.2-1.8-31.4 1-43 2-11.7 1-30.4-4.3-46.1-4.1-23.4.3-40.5 7.4-58.7 7.2-13.6-.1-29.1-2.6-36.6-3.6-18.4-2.7-30.1-1.7-45.1.3a264 264 0 0 0-22.3 4.2c3.8 12.7 7.9 27.8 10.6 40.7 3.3 15.7 7.9 43.1 9.8 63.1 1.9 18.7 3.7 40.6 2.8 60.3-.3 7.2-.7 17.2-1.3 24.6-1.1 17.4-2.9 32.5-4.3 44.1-.7 5.4-1.5 15.3-2.6 27.1 6.8-2 19-5.3 25.7-6.4 9.4-1.3 29.5-4.5 39.6-3.2 7.6.8 18.1 4.3 33.6 4.3 15.4 0 36.6-5.2 50.2-6.3 14.9-1.5 23.9-.9 37.2.8 6.8.8 18.6.2 24.9-.5 7.4-1 24.4-4 37.1-1.5 16.4 3.3 31 12.3 46.7 12.3 12.5 0 19.9-.2 31.6-1.7 11.6-1.5 34.3-5.4 53.9-4.6 19.8.6 42.9 6 66 8.3 21.7 2.1 35.4-.1 40.8-1.4-.7-4.7-1.6-9.3-2.4-13.4-4-22.9-5.3-58.1-4.7-68.3.4-9.2 4.9-57.2 6.2-65.8 1.2-9.6 4.9-47.9 3.9-83.6-.3-8.6-.6-16-.9-22.4-6.9 1.8-22.7 5.2-43.1 5.5z" }), /* @__PURE__ */ y.createElement("path", { fill: "#004b91", d: "M49.4 34.5c16.8-2.5 36.8-2.3 46.2-1.1 7.3.9 20.4 3.9 33.9 4.1 20 .7 47.4-6.7 60.7-7.2 15.9-.6 32 4.5 44.7 4.3 11.6-.4 32.7-3.6 43.2-2.1 13.6 2.1 31.1 11.4 50 14.1 17.6 2.5 40.2-.7 49.9-1.8 14.7-1.8 46.6-2.7 57-1.1 11 1.8 35 6.7 52.3 6.5 24.3-.1 38.4-3.3 44.2-5.1-1.1-10.5-2.2-15.5-2.2-15.5s-10.2 2.9-28.7 4.9c-27.2 2.8-42.2-1.8-54.2-4.5-14.4-3.3-47.9-2.5-77.2.9-31.3 3.7-39.6.7-46.6-.4-17.2-2.8-29.5-12.5-55.1-12.1-7.9.1-24.1 1.6-30.7 1.8-11.6.4-31-4.6-42.2-4.8-6.8-.2-13.4 1.1-20.5 2.5s-19.1 4-35.8 4.5c-16.8.6-23.7-.5-31.8-1.8-9.2-1.3-26.6-3.2-42.7-2.2C46 19.4 20 25.1 20 25.1s2 5.9 4.6 14.6c4.8-1.4 13.7-3.7 24.8-5.2zm439 294.5c-25.6-2-48.6-7.1-66.2-8-20.7-1.1-41.8 2.4-53.6 4-13.1 1.7-20.5 1.4-33.1 1.4-15.8 0-25.6-7.7-42-11.1-12.7-2.6-31.5-.2-39 .8-6.2.9-19.3 1.2-26 .4-13.3-1.6-17.2-2.2-32-1.3-20.1 1.2-37 7.1-52.6 7.1-15.6 0-24.6-3.5-36.8-4.4-12.4-.9-29.4 1.8-38.8 3.2-8.1 1.2-20.2 4.9-26.7 7.2-1.2 9.2-2.4 17.7-2.4 17.7s7.7-2.7 15.2-5.4c7.5-2.9 26.6-6.9 45.7-7 17.5 0 29.3 6.7 46.8 4.2 11.3-1.5 33.4-8.3 54.2-8.2 23.5.1 26.9 4.4 46.6 1.8 18.5-2.4 42.5-4.8 62.6 5.3 19.3 9.7 42.8 4.6 54.2 3.4 11.1-1.3 37.5-4.6 56.7-4 20.1.5 46.3 7.2 65.6 8 17.5.7 41.6-1.3 46.5-2.2.5-4.3.1-9.5-.3-15-4.1.9-19.5 4-44.6 2.1z" }), /* @__PURE__ */ y.createElement("path", { d: "M295.5 126.8s14.2 0 18.1.2c4 .2 20.1.3 20.1.3s0-18.4-.5-21.4-2-14.1-11.6-19.9c-7.6-4.8-26.5-7.5-44.6-7.5-13.1 0-30.5 2.4-40.1 8.9-4.6 2.9-8.7 6.5-11.4 15.2-3.2 10.2-2.6 26-2.4 29.3.1 3.4.6 12.5 3.8 18.2 4.6 7.8 10.4 11.4 21.1 18 10.6 6.5 32.3 17.9 37.4 20.7 5.1 2.8 7.7 7.3 8.1 12 .4 3.6 1.2 19 .5 26.2-.5 7.2-1.6 11.2-5.2 12.8-4.1 1.9-10.8 1.9-16.6.7-7.1-1.5-7.4-8.3-7.5-12.5 0-4.4-.2-13.2-.2-13.2l-42.6.2s.2 22.1.5 25.8c.3 3.4 1.3 14.9 7.9 22.2 6.7 7.4 13.3 11.7 26.3 11.1 12.8-.6 19-1.7 25.2-1.6 8.5.2 14.9 2.9 23.8 1.6 9-1.1 20.5-5 26.4-18.1 4.5-9.6 4.1-17.5 4.5-23.5.4-5.9.5-31.5.5-34.8-.3-11.4-2.8-18.4-10.6-25.3-12.5-10.8-49.3-28.2-55.8-35.1-4-4.1-4.4-10.2-4.3-13.6.2-4.4-.2-10.5 5.7-12.4 6.9-2.4 16.3-1.3 19.2.6 3 2.1 3.2 5 3.6 7 .7 1.8.7 7.9.7 7.9z", fill: "#fff" })), N3 = f(K1), z3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.71 11.29L12.27 15.86 16.84 11.29C17.23 10.9 17.86 10.9 18.25 11.29 18.64 11.68 18.64 12.32 18.25 12.71L13.01 17.95C12.83 18.13 12.59 18.23 12.36 18.24L12.18 18.24C11.95 18.23 11.72 18.13 11.54 17.95L6.29 12.71C5.9 12.32 5.9 11.68 6.29 11.29 6.68 10.9 7.32 10.9 7.71 11.29ZM7.71 5.29L12.27 9.86 16.84 5.29C17.23 4.9 17.86 4.9 18.25 5.29 18.64 5.68 18.64 6.32 18.25 6.71L13.01 11.95C12.83 12.13 12.59 12.23 12.36 12.24L12.18 12.24C11.95 12.23 11.72 12.13 11.54 11.95L6.29 6.71C5.9 6.32 5.9 5.68 6.29 5.29 6.68 4.9 7.32 4.9 7.71 5.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, w1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.54 14.96C11.93 15.35 12.57 15.35 12.96 14.96L17.71 10.21C18.1 9.82 18.1 9.18 17.71 8.79 17.32 8.4 16.68 8.4 16.29 8.79L12.25 12.84 8.21 8.79C7.82 8.4 7.18 8.4 6.79 8.79 6.4 9.18 6.4 9.82 6.79 10.21L11.54 14.96Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, g3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.54 6.79C11.93 6.4 12.57 6.4 12.96 6.79L12.99 6.83C13.35 7.23 13.33 7.83 12.96 8.21L8.91 12.25 12.96 16.29C13.35 16.68 13.35 17.32 12.96 17.71 12.57 18.1 11.93 18.1 11.54 17.71L6.79 12.96C6.4 12.57 6.4 11.93 6.79 11.54L11.54 6.79ZM16.29 6.79C16.68 6.4 17.32 6.4 17.71 6.79L17.74 6.83C18.1 7.23 18.08 7.83 17.71 8.21L13.66 12.25 17.71 16.29C18.1 16.68 18.1 17.32 17.71 17.71 17.32 18.1 16.68 18.1 16.29 17.71L11.54 12.96C11.15 12.57 11.15 11.93 11.54 11.54L16.29 6.79Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, b3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M14.96 6.79C14.57 6.4 13.93 6.4 13.54 6.79L8.79 11.54C8.4 11.93 8.4 12.57 8.79 12.96L13.54 17.71C13.93 18.1 14.57 18.1 14.96 17.71 15.35 17.32 15.35 16.68 14.96 16.29L10.91 12.25 14.96 8.21C15.33 7.83 15.35 7.23 14.99 6.83L14.96 6.79Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, y3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.96 6.79L17.71 11.54C18.1 11.93 18.1 12.57 17.71 12.96L12.96 17.71C12.57 18.1 11.93 18.1 11.54 17.71 11.15 17.32 11.15 16.68 11.54 16.29L15.59 12.25 11.54 8.21C11.17 7.83 11.15 7.23 11.51 6.83L11.54 6.79C11.93 6.4 12.57 6.4 12.96 6.79ZM8.21 6.79L12.96 11.54C13.35 11.93 13.35 12.57 12.96 12.96L8.21 17.71C7.82 18.1 7.18 18.1 6.79 17.71 6.4 17.32 6.4 16.68 6.79 16.29L10.84 12.25 6.79 8.21C6.42 7.83 6.4 7.23 6.76 6.83L6.79 6.79C7.18 6.4 7.82 6.4 8.21 6.79Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, w3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.79 6.79C9.18 6.4 9.82 6.4 10.21 6.79L14.96 11.54C15.35 11.93 15.35 12.57 14.96 12.96L10.21 17.71C9.82 18.1 9.18 18.1 8.79 17.71 8.4 17.32 8.4 16.68 8.79 16.29L12.84 12.25 8.79 8.21C8.42 7.83 8.4 7.23 8.76 6.83L8.79 6.79Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, S3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.71 11.95L12.27 7.38 16.84 11.95C17.23 12.34 17.86 12.34 18.25 11.95 18.64 11.56 18.64 10.92 18.25 10.53L13.01 5.29C12.83 5.11 12.59 5.01 12.36 5L12.18 5C11.95 5.01 11.72 5.11 11.54 5.29L6.29 10.53C5.9 10.92 5.9 11.56 6.29 11.95 6.68 12.34 7.32 12.34 7.71 11.95ZM7.71 17.95L12.27 13.38 16.84 17.95C17.23 18.34 17.86 18.34 18.25 17.95 18.64 17.56 18.64 16.92 18.25 16.53L13.01 11.29C12.83 11.11 12.59 11.01 12.36 11L12.18 11C11.95 11.01 11.72 11.11 11.54 11.29L6.29 16.53C5.9 16.92 5.9 17.56 6.29 17.95 6.68 18.34 7.32 18.34 7.71 17.95Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, S1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.54 8.79C11.93 8.4 12.57 8.4 12.96 8.79L17.71 13.54C18.1 13.93 18.1 14.57 17.71 14.96 17.32 15.35 16.68 15.35 16.29 14.96L12.25 10.91 8.21 14.96C7.82 15.35 7.18 15.35 6.79 14.96 6.4 14.57 6.4 13.93 6.79 13.54L11.54 8.79Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, B3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12.15 6.35C12.71 6.35 13.15 6.79 13.15 7.35L13.15 14.39 15.45 12.13C15.82 11.77 16.4 11.75 16.8 12.07L16.86 12.13C17.25 12.5 17.25 13.11 16.86 13.48L12.86 17.37C12.47 17.75 11.84 17.75 11.45 17.37L7.45 13.48C7.06 13.11 7.06 12.5 7.45 12.13 7.84 11.75 8.47 11.75 8.86 12.13L11.15 14.39 11.15 7.35C11.15 6.79 11.6 6.35 12.15 6.35Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, v3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM10.67 7.29C11.05 6.9 11.65 6.9 12.03 7.29L12.08 7.36C12.4 7.75 12.38 8.34 12.03 8.71L9.77 11 16.81 11C17.36 11 17.81 11.45 17.81 12 17.81 12.55 17.36 13 16.81 13L9.77 13 12.03 15.29C12.4 15.68 12.4 16.32 12.03 16.71 11.65 17.1 11.05 17.1 10.67 16.71L6.78 12.71C6.41 12.32 6.41 11.68 6.78 11.29L10.67 7.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, k3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM13.63 7.29L17.53 11.29C17.9 11.68 17.9 12.32 17.53 12.71L13.63 16.71C13.26 17.1 12.65 17.1 12.28 16.71 11.91 16.32 11.91 15.68 12.28 15.29L14.54 13 7.5 13C6.95 13 6.5 12.55 6.5 12 6.5 11.45 6.95 11 7.5 11L14.54 11 12.28 8.71C11.93 8.34 11.91 7.75 12.22 7.36L12.28 7.29C12.65 6.9 13.26 6.9 13.63 7.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, $3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12.86 6.63L16.86 10.52C17.25 10.89 17.25 11.5 16.86 11.87 16.47 12.25 15.84 12.25 15.45 11.87L13.15 9.61 13.15 16.65C13.15 17.21 12.71 17.65 12.15 17.65 11.6 17.65 11.15 17.21 11.15 16.65L11.15 9.65 11.16 9.61 8.86 11.87C8.49 12.23 7.9 12.25 7.51 11.93L7.45 11.87C7.06 11.5 7.06 10.89 7.45 10.52L11.45 6.63C11.84 6.25 12.47 6.25 12.86 6.63Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, A3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.61 18.23L7.61 22.12C7.22 22.5 6.59 22.5 6.2 22.12L2.2 18.23C1.81 17.86 1.81 17.25 2.2 16.88 2.59 16.5 3.22 16.5 3.61 16.88L5.9 19.14 5.9 8.6C5.9 8.04 6.35 7.6 6.9 7.6 7.46 7.6 7.9 8.04 7.9 8.6L7.9 19.14 10.2 16.88C10.57 16.52 11.15 16.5 11.55 16.82L11.61 16.88C12 17.25 12 17.86 11.61 18.23ZM21.61 5.77C22 6.14 22 6.75 21.61 7.12L21.55 7.18C21.15 7.5 20.57 7.48 20.2 7.12L17.9 4.86 17.9 15.4C17.9 15.96 17.46 16.4 16.9 16.4 16.35 16.4 15.9 15.96 15.9 15.4L15.9 4.86 13.61 7.12C13.22 7.5 12.59 7.5 12.2 7.12 11.81 6.75 11.81 6.14 12.2 5.77L16.2 1.88C16.59 1.5 17.22 1.5 17.61 1.88L21.61 5.77Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, I3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.13 12.29L22.03 16.29C22.4 16.68 22.4 17.32 22.03 17.71L18.13 21.71C17.76 22.1 17.15 22.1 16.78 21.71 16.41 21.32 16.41 20.68 16.78 20.29L19.04 18 8.5 18C7.95 18 7.5 17.55 7.5 17 7.5 16.45 7.95 16 8.5 16L19 16 19.04 16 16.78 13.71C16.43 13.34 16.41 12.75 16.72 12.36L16.78 12.29C17.15 11.9 17.76 11.9 18.13 12.29ZM5.67 2.29C6.05 1.9 6.65 1.9 7.03 2.29L7.08 2.36C7.4 2.75 7.38 3.34 7.03 3.71L4.77 6 4.81 6 15.31 6C15.86 6 16.31 6.45 16.31 7 16.31 7.55 15.86 8 15.31 8L4.77 8 7.03 10.29C7.4 10.68 7.4 11.32 7.03 11.71 6.65 12.1 6.05 12.1 5.67 11.71L1.78 7.71C1.41 7.32 1.41 6.68 1.78 6.29L5.67 2.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, H3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 5.5C13 4.95 12.55 4.5 12 4.5 11.45 4.5 11 4.95 11 5.5L11 16.19 11 16.23 8.71 13.97C8.34 13.62 7.75 13.6 7.36 13.92L7.29 13.97C6.9 14.35 6.9 14.95 7.29 15.33L11.29 19.22C11.68 19.59 12.32 19.59 12.71 19.22L16.71 15.33C17.1 14.95 17.1 14.35 16.71 13.97 16.32 13.6 15.68 13.6 15.29 13.97L13 16.23 13 5.5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, R3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.31 13C18.86 13 19.31 12.55 19.31 12 19.31 11.45 18.86 11 18.31 11L7.81 11 7.77 11 10.03 8.71C10.38 8.34 10.4 7.75 10.08 7.36L10.03 7.29C9.65 6.9 9.05 6.9 8.67 7.29L4.78 11.29C4.41 11.68 4.41 12.32 4.78 12.71L8.67 16.71C9.05 17.1 9.65 17.1 10.03 16.71 10.4 16.32 10.4 15.68 10.03 15.29L7.77 13 18.31 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, T3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M9 1C10.66 1 12 2.34 12 4L12 6C12 6.04 12 6.08 11.99 6.12 13.72 6.57 15 8.13 15 10 15 12.21 13.21 14 11 14 8.79 14 7 12.21 7 10 7 8.13 8.28 6.57 10.01 6.12L10 6 10 4C10 3.45 9.55 3 9 3L4.03 3C3.47 3 3.02 3.45 3.02 4L3.02 17C3.02 17.55 3.47 18 4.03 18L19.7 18 18.43 16.71C18.07 16.34 18.05 15.75 18.37 15.36L18.43 15.29C18.81 14.9 19.42 14.9 19.8 15.29L22.72 18.29C23.09 18.68 23.09 19.32 22.72 19.71L19.8 22.71C19.42 23.1 18.81 23.1 18.43 22.71 18.05 22.32 18.05 21.68 18.43 21.29L19.7 20 4.03 20C2.36 20 1 18.66 1 17L1 4C1 2.34 2.36 1 4.03 1L9 1ZM11 8C9.9 8 9 8.9 9 10 9 11.1 9.9 12 11 12 12.1 12 13 11.1 13 10 13 8.9 12.1 8 11 8Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, V3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5.5 12L18.54 12 16.28 9.71C15.93 9.34 15.91 8.75 16.22 8.36L16.28 8.29C16.65 7.9 17.26 7.9 17.63 8.29L21.53 12.29C21.9 12.68 21.9 13.32 21.53 13.71L17.63 17.71C17.26 18.1 16.65 18.1 16.28 17.71 15.91 17.32 15.91 16.68 16.28 16.29L18.54 14 5.5 14C3.95 14 3 13.05 3 11.5L3 6C3 5.45 3.45 5 4 5 4.55 5 5 5.45 5 6L5 11.57C5.01 11.95 5.08 12 5.5 12Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, D3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5.5 13C4.95 13 4.5 12.55 4.5 12 4.5 11.45 4.95 11 5.5 11L16 11 16.04 11 13.78 8.71C13.43 8.34 13.41 7.75 13.72 7.36L13.78 7.29C14.15 6.9 14.76 6.9 15.13 7.29L19.03 11.29C19.4 11.68 19.4 12.32 19.03 12.71L15.13 16.71C14.76 17.1 14.15 17.1 13.78 16.71 13.41 16.32 13.41 15.68 13.78 15.29L16.04 13 5.5 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, F3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.9 7.1C10.9 6.54 11.35 6.1 11.9 6.1 12.46 6.1 12.9 6.54 12.9 7.1L12.9 14.64 15.2 12.38C15.57 12.02 16.15 12 16.55 12.32L16.61 12.38C17 12.75 17 13.36 16.61 13.73L12.61 17.62C12.22 18 11.59 18 11.2 17.62L7.2 13.73C6.81 13.36 6.81 12.75 7.2 12.38 7.59 12 8.22 12 8.61 12.38L10.9 14.64 10.9 7.1Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, j3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M16.81 13C17.36 13 17.81 12.55 17.81 12 17.81 11.45 17.36 11 16.81 11L9.27 11 11.53 8.71C11.88 8.34 11.9 7.75 11.58 7.36L11.53 7.29C11.15 6.9 10.55 6.9 10.17 7.29L6.28 11.29C5.91 11.68 5.91 12.32 6.28 12.71L10.17 16.71C10.55 17.1 11.15 17.1 11.53 16.71 11.9 16.32 11.9 15.68 11.53 15.29L9.27 13 16.81 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, E3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L14.5 11 14.54 11 12.28 8.71C11.93 8.34 11.91 7.75 12.22 7.36L12.28 7.29C12.65 6.9 13.26 6.9 13.63 7.29L17.53 11.29C17.9 11.68 17.9 12.32 17.53 12.71L13.63 16.71C13.26 17.1 12.65 17.1 12.28 16.71 11.91 16.32 11.91 15.68 12.28 15.29L14.54 13 7 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, O3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.9 16.9C10.9 17.46 11.35 17.9 11.9 17.9 12.46 17.9 12.9 17.46 12.9 16.9L12.9 9.36 15.2 11.62C15.57 11.98 16.15 12 16.55 11.68L16.61 11.62C17 11.25 17 10.64 16.61 10.27L12.61 6.38C12.22 6 11.59 6 11.2 6.38L7.2 10.27C6.81 10.64 6.81 11.25 7.2 11.62 7.59 12 8.22 12 8.61 11.62L10.9 9.36 10.9 16.9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, P3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 18.5C13 19.05 12.55 19.5 12 19.5 11.45 19.5 11 19.05 11 18.5L11 7.81 11 7.77 8.71 10.03C8.34 10.38 7.75 10.4 7.36 10.08L7.29 10.03C6.9 9.65 6.9 9.05 7.29 8.67L11.29 4.78C11.68 4.41 12.32 4.41 12.71 4.78L16.71 8.67C17.1 9.05 17.1 9.65 16.71 10.03 16.32 10.4 15.68 10.4 15.29 10.03L13 7.77 13 18.5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, U3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 1.51C13 0.95 12.55 0.5 12 0.5 11.45 0.5 11 0.95 11 1.51L11 20.2 8.71 17.93C8.34 17.57 7.75 17.55 7.36 17.87L7.29 17.93C6.9 18.3 6.9 18.91 7.29 19.29L11.29 23.22C11.68 23.59 12.32 23.59 12.71 23.22L16.71 19.29C17.1 18.91 17.1 18.3 16.71 17.93 16.32 17.55 15.68 17.55 15.29 17.93L13 20.21 13 1.51Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, W3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.31 13C22.86 13 23.31 12.55 23.31 12 23.31 11.45 22.86 11 22.31 11L3.81 11 3.77 11 6.03 8.71C6.38 8.34 6.4 7.75 6.08 7.36L6.03 7.29C5.65 6.9 5.05 6.9 4.67 7.29L0.78 11.29C0.41 11.68 0.41 12.32 0.78 12.71L4.67 16.71C5.05 17.1 5.65 17.1 6.03 16.71 6.4 16.32 6.4 15.68 6.03 15.29L3.77 13 22.31 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, q3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M1.5 13C0.95 13 0.5 12.55 0.5 12 0.5 11.45 0.95 11 1.5 11L20 11 20.04 11 17.78 8.71C17.43 8.34 17.41 7.75 17.72 7.36L17.78 7.29C18.15 6.9 18.76 6.9 19.13 7.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L19.13 16.71C18.76 17.1 18.15 17.1 17.78 16.71 17.41 16.32 17.41 15.68 17.78 15.29L20.04 13 1.5 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, G3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 22.49C13 23.05 12.55 23.5 12 23.5 11.45 23.5 11 23.05 11 22.49L11 3.84 11 3.8 8.71 6.07C8.34 6.43 7.75 6.45 7.36 6.13L7.29 6.07C6.9 5.7 6.9 5.09 7.29 4.71L11.29 0.78C11.68 0.41 12.32 0.41 12.71 0.78L16.71 4.71C17.1 5.09 17.1 5.7 16.71 6.07 16.32 6.45 15.68 6.45 15.29 6.07L13 3.79 13 22.49Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, K3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 11C13.45 11 13 10.55 13 10L13 5C13 4.45 13.45 4 14 4 14.55 4 15 4.45 15 5L15 7.64 22.31 0.29C22.7-0.1 23.33-0.1 23.71 0.29 24.1 0.67 24.1 1.3 23.71 1.69L16.36 9 19 9C19.55 9 20 9.45 20 10 20 10.55 19.55 11 19 11L14 11ZM10 13C10.55 13 11 13.45 11 14L11 19C11 19.55 10.55 20 10 20 9.45 20 9 19.55 9 19L9 16.36 1.69 23.71C1.3 24.1 0.67 24.1 0.29 23.71-0.1 23.33-0.1 22.7 0.29 22.31L7.63 15 5 15C4.45 15 4 14.55 4 14 4 13.45 4.45 13 5 13L10 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, X3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M2 16C2 15.45 2.45 15 3 15 3.55 15 4 15.45 4 16L4 18.64 10.31 12.29C10.7 11.9 11.33 11.9 11.71 12.29 12.1 12.67 12.1 13.3 11.71 13.69L5.36 20 8 20C8.55 20 9 20.45 9 21 9 21.55 8.55 22 8 22L3 22C2.45 22 2 21.55 2 21L2 16ZM21 2C21.55 2 22 2.45 22 3L22 8C22 8.55 21.55 9 21 9 20.45 9 20 8.55 20 8L20 5.36 13.69 11.71C13.3 12.1 12.67 12.1 12.29 11.71 11.9 11.33 11.9 10.7 12.29 10.31L18.64 4 16 4C15.45 4 15 3.55 15 3 15 2.45 15.45 2 16 2L21 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Q3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M9 0C10.66 0 12 1.34 12 3L12 9C12 10.32 12.65 10.99 13.96 11L20 11 20.04 11 18.78 9.71C18.43 9.34 18.41 8.75 18.72 8.36L18.78 8.29C19.15 7.9 19.76 7.9 20.13 8.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L20.13 15.71C19.76 16.1 19.15 16.1 18.78 15.71 18.41 15.32 18.41 14.68 18.78 14.29L20.04 13 14 13C12.73 13 12.06 13.61 12 14.82L12 15 12 21C12 22.66 10.66 24 9 24L2 24C1.45 24 1 23.55 1 23 1 22.45 1.45 22 2 22L9 22C9.55 22 10 21.55 10 21L10 3C10 2.45 9.55 2 9 2L2 2C1.45 2 1 1.55 1 1 1 0.45 1.45 0 2 0L9 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, J3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.35 12.76L4.93 14.4C5.28 14.76 5.28 15.36 4.93 15.73 4.58 16.09 4.02 16.09 3.68 15.73L0.76 12.66C0.41 12.3 0.41 11.7 0.76 11.34L3.68 8.27C3.83 8.11 4.03 8.02 4.23 8L4.3 8C4.53 8 4.76 8.09 4.93 8.27L4.98 8.33C5.28 8.7 5.26 9.26 4.93 9.6L3.35 11.24 20.65 11.24 19.07 9.6C18.72 9.24 18.72 8.64 19.07 8.27 19.42 7.91 19.98 7.91 20.32 8.27L23.24 11.34C23.59 11.7 23.59 12.3 23.24 12.66L20.32 15.73C20.17 15.89 19.97 15.98 19.77 16L19.7 16C19.47 16 19.24 15.91 19.07 15.73L19.02 15.67C18.72 15.3 18.74 14.74 19.07 14.4L20.65 12.76 3.35 12.76Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Y3 = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.57 4.29C9.95 4.68 9.95 5.32 9.57 5.71L8.3 7 20.97 7C22.64 7 24 8.34 24 10L24 21C24 22.66 22.64 24 20.97 24L11 24C9.34 24 8 22.66 8 21L8 20C8 19.45 8.45 19 9 19 9.51 19 9.94 19.39 9.99 19.88L10 20 10 21C10 21.55 10.45 22 11 22L20.97 22C21.53 22 21.98 21.55 21.98 21L21.98 10C21.98 9.45 21.53 9 20.97 9L8.3 9 9.57 10.29C9.93 10.66 9.95 11.25 9.63 11.64L9.57 11.71C9.19 12.1 8.58 12.1 8.2 11.71L5.28 8.71C4.91 8.32 4.91 7.68 5.28 7.29L8.2 4.29C8.58 3.9 9.19 3.9 9.57 4.29ZM13 0C14.66 0 16 1.34 16 3L16 4C16 4.55 15.55 5 15 5 14.45 5 14 4.55 14 4L14 3C14 2.45 13.55 2 13 2L3 2C2.45 2 2 2.45 2 3L2 14C2 14.55 2.45 15 3 15L15.54 15 14.28 13.71C13.93 13.34 13.91 12.75 14.22 12.36L14.28 12.29C14.65 11.9 15.26 11.9 15.63 12.29L18.53 15.29C18.9 15.68 18.9 16.32 18.53 16.71L15.63 19.71C15.26 20.1 14.65 20.1 14.28 19.71 13.91 19.32 13.91 18.68 14.28 18.29L15.54 17 3 17C1.34 17 0 15.66 0 14L0 3C0 1.34 1.34 0 3 0L13 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, C6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.48 0C22.86 0 24 1.1 24 2.5L23.98 20.65 23.96 20.79C23.69 22.64 22.08 24 20.19 24L3.5 24C1.57 24 0 22.43 0 20.5L0 17 5 17 5 2.5C5 1.16 6.05 0.09 7.35 0.01L7.52 0 21.48 0ZM16 19L2 19 2 20.5C2 21.33 2.67 22 3.5 22L16.51 22C16.19 21.5 16 20.89 16 20.25L16 19ZM18 20C18 21.1 18.9 22 20 22 21.1 22 22 21.1 22 20L22 2.5C22 2.22 21.77 2 21.48 2L7.52 2C7.23 2 7 2.22 7 2.5L7 17 18 17 18 20Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, L6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.63 0 22 1.34 22 3L22 21C22 22.66 20.63 24 19 24L5 24C3.37 24 2 22.66 2 21L2 3C2 1.34 3.37 0 5 0L19 0ZM19 2L5 2C4.46 2 4 2.45 4 3L4 21C4 21.55 4.46 22 5 22L19 22C19.54 22 20 21.55 20 21L20 3C20 2.45 19.54 2 19 2Z M14.11 6.55C14.35 6.06 14.95 5.86 15.45 6.11 15.94 6.35 16.14 6.95 15.89 7.45 15.06 9.11 13.73 10 12 10 10.27 10 8.94 9.11 8.11 7.45 7.86 6.95 8.06 6.35 8.55 6.11 9.05 5.86 9.65 6.06 9.89 6.55 10.4 7.56 11.06 8 12 8 12.94 8 13.6 7.56 14.11 6.55Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, e6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 3C22.66 3 24 4.34 24 6L24 18C24 19.66 22.66 21 21 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM22 10L2 10 2 18C2 18.55 2.45 19 3 19L21 19C21.55 19 22 18.55 22 18L22 10ZM19 15C19.55 15 20 15.45 20 16 20 16.55 19.55 17 19 17L16 17C15.45 17 15 16.55 15 16 15 15.45 15.45 15 16 15L19 15ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, n6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.42-0.1C21.9 0.11 23 1.37 23 2.87L22 16.29C22 17.24 21.55 18.13 20.79 18.69L13.79 23.16C12.73 23.95 11.27 23.95 10.21 23.16L3.21 18.69C2.45 18.13 2 17.24 2 16.29L1 2.87C1 1.37 2.1 0.11 3.58-0.1L20.42-0.1ZM20.14 1.88L3.86 1.88C3.37 1.95 3 2.37 3 2.87L4 16.29C4 16.6 4.15 16.9 4.4 17.09L11.4 21.56C11.72 21.79 12.15 21.82 12.49 21.63L19.6 17.09C19.85 16.9 20 16.6 20 16.29L21 2.87C21 2.37 20.63 1.95 20.14 1.88ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM12 5C12.55 5 13 5.45 13 6L13 12C13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12L11 6C11 5.45 11.45 5 12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, i6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.66 0 22 1.34 22 3L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 3C2 1.34 3.34 0 5 0L19 0ZM19 2L5 2C4.45 2 4 2.45 4 3L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 3C20 2.45 19.55 2 19 2ZM17 18C17.55 18 18 18.45 18 19 18 19.55 17.55 20 17 20L15 20C14.45 20 14 19.55 14 19 14 18.45 14.45 18 15 18L17 18ZM13 8C13.55 8 14 8.45 14 9 14 9.55 13.55 10 13 10L7 10C6.45 10 6 9.55 6 9 6 8.45 6.45 8 7 8L13 8ZM13 4C13.55 4 14 4.45 14 5 14 5.55 13.55 6 13 6L7 6C6.45 6 6 5.55 6 5 6 4.45 6.45 4 7 4L13 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, o6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.66 0 22 1.34 22 3L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 3C2 1.34 3.34 0 5 0L19 0ZM19 2L5 2C4.45 2 4 2.45 4 3L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 3C20 2.45 19.55 2 19 2ZM15 17C15.83 17 16.5 17.67 16.5 18.5 16.5 19.33 15.83 20 15 20 14.17 20 13.5 19.33 13.5 18.5 13.5 17.67 14.17 17 15 17ZM15 9C15.55 9 16 9.39 16 9.88L16 15.13C16 15.61 15.55 16 15 16 14.45 16 14 15.61 14 15.13L14 9.88C14 9.39 14.45 9 15 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, t6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.98 0.68C21.18 1 22.12 1.94 22.44 3.14 22.76 4.34 22.42 5.62 21.54 6.5L6.94 21.1C6.81 21.23 6.65 21.32 6.48 21.36L1.8 22.53C1.07 22.71 0.41 22.05 0.59 21.32L1.76 16.65C1.8 16.47 1.89 16.31 2.02 16.18L16.62 1.58C17.5 0.7 18.78 0.36 19.98 0.68ZM21 20.12C21.55 20.12 22 20.57 22 21.12 22 21.67 21.55 22.12 21 22.12L12 22.12C11.45 22.12 11 21.67 11 21.12 11 20.57 11.45 20.12 12 20.12L21 20.12ZM18.04 2.99L3.63 17.4 2.93 20.19 5.72 19.49 20.13 5.08C20.46 4.75 20.62 4.27 20.54 3.81L20.51 3.66C20.37 3.15 19.98 2.75 19.47 2.61 18.96 2.47 18.41 2.62 18.04 2.99Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, a6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23.68 14.32C24.11 14.76 24.11 15.46 23.68 15.89L17.01 22.68C16.78 22.91 16.47 23.02 16.16 23 15.86 23.02 15.54 22.91 15.31 22.68L10.82 18.11C10.39 17.68 10.39 16.97 10.82 16.54 11.24 16.11 11.93 16.11 12.36 16.54L16.16 20.41 22.14 14.32C22.57 13.89 23.26 13.89 23.68 14.32ZM21 3C22.66 3 24 4.34 24 6L24 11C24 11.55 23.55 12 23 12 22.45 12 22 11.55 22 11L22 10 2 10 2 18C2 18.55 2.45 19 3 19L8 19C8.55 19 9 19.45 9 20 9 20.55 8.55 21 8 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, s6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 12C21.31 12 24 14.69 24 18 24 21.31 21.31 24 18 24 17.45 24 17 23.55 17 23 17 22.45 17.45 22 18 22 20.21 22 22 20.21 22 18 22 15.79 20.21 14 18 14 15.79 14 14 15.79 14 18 14 18.55 13.55 19 13 19 12.45 19 12 18.55 12 18 12 14.69 14.69 12 18 12ZM21 3C22.66 3 24 4.34 24 6L24 11C24 11.55 23.55 12 23 12 22.45 12 22 11.55 22 11L22 10 2 10 2 18C2 18.55 2.45 19 3 19L9 19C9.55 19 10 19.45 10 20 10 20.55 9.55 21 9 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, c6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 12C18.55 12 19 12.45 19 13L19 17 23 17C23.55 17 24 17.45 24 18 24 18.55 23.55 19 23 19L19 19 19 23C19 23.55 18.55 24 18 24 17.45 24 17 23.55 17 23L17 19 13 19C12.45 19 12 18.55 12 18 12 17.45 12.45 17 13 17L17 17 17 13C17 12.45 17.45 12 18 12ZM24 12C24 12.55 23.55 13 23 13 22.45 13 22 12.55 22 12L22 10 2 10 2 18C2 18.55 2.45 19 3 19L9 19C9.55 19 10 19.45 10 20 10 20.55 9.55 21 9 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3C22.66 3 24 4.34 24 6L24 12ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, r6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.57 8.22L15.77 10.32C16.08 10.62 16.08 11.1 15.77 11.4 15.45 11.7 14.95 11.7 14.63 11.4L13.8 10.6 13.8 22.2C13.8 22.64 13.44 23 13 23 12.56 23 12.2 22.64 12.2 22.2L12.2 10.63 12.2 10.6 11.37 11.4C11.07 11.68 10.6 11.7 10.29 11.44L10.23 11.4C9.92 11.1 9.92 10.62 10.23 10.32L12.43 8.22C12.75 7.93 13.25 7.93 13.57 8.22ZM18.76 1.4L23 3.86C23.62 4.22 24 4.9 24 5.63L23.98 10.59C23.97 11.67 23.41 12.66 22.49 13.2L17.45 16.13C16.97 16.41 16.36 16.24 16.08 15.77 15.8 15.29 15.97 14.68 16.45 14.4L21.48 11.45C21.79 11.27 21.98 10.94 21.98 10.58L22 5.6 17.76 3.13C17.46 2.95 17.08 2.96 16.77 3.14L2.5 11.55C2.02 11.82 1.86 12.44 2.13 12.93L5.85 19.49C6.12 19.98 6.73 20.14 7.2 19.86L9.57 18.48C10.05 18.2 10.66 18.37 10.93 18.85 11.21 19.32 11.05 19.94 10.57 20.21L8.19 21.59C6.77 22.43 4.94 21.93 4.12 20.49L0.4 13.93C-0.42 12.48 0.07 10.63 1.49 9.8L15.79 1.41C16.71 0.87 17.84 0.86 18.76 1.4ZM18.5 6C19.33 6 20 6.67 20 7.5 20 8.33 19.33 9 18.5 9 17.67 9 17 8.33 17 7.5 17 6.67 17.67 6 18.5 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, m6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.05 1.1C10.33 1.18 10.6 1.3 10.85 1.47L11.03 1.6C11.58 2.04 12.35 2.05 12.88 1.67L12.96 1.61C14.15 0.66 15.88 0.84 16.83 2.03 17.01 2.26 17.16 2.52 17.26 2.8L17.33 3.01C17.51 3.69 18.13 4.16 18.8 4.16L18.89 4.16C20.41 4.09 21.7 5.25 21.76 6.77 21.78 7.07 21.74 7.37 21.66 7.65L21.59 7.86C21.35 8.52 21.57 9.26 22.1 9.65L22.18 9.7C23.45 10.54 23.81 12.24 22.97 13.51 22.81 13.76 22.61 13.98 22.37 14.16L22.19 14.29C21.61 14.68 21.35 15.41 21.56 16.04L21.59 16.13C22.12 17.55 21.41 19.14 19.99 19.67 19.71 19.78 19.42 19.83 19.12 19.84L18.9 19.84C18.2 19.81 17.56 20.26 17.36 20.89L17.33 20.97C16.93 22.44 15.42 23.31 13.95 22.9 13.67 22.82 13.4 22.7 13.15 22.53L12.97 22.4C12.42 21.96 11.65 21.95 11.12 22.33L11.04 22.39C9.85 23.34 8.12 23.16 7.17 21.97 6.99 21.74 6.84 21.48 6.74 21.2L6.67 20.99C6.49 20.31 5.87 19.84 5.2 19.84L5.11 19.84C3.59 19.91 2.3 18.75 2.24 17.23 2.22 16.93 2.26 16.63 2.34 16.35L2.41 16.14C2.65 15.48 2.43 14.74 1.9 14.35L1.82 14.3C0.55 13.46 0.19 11.76 1.03 10.49 1.19 10.24 1.39 10.02 1.63 9.84L1.81 9.71C2.39 9.32 2.65 8.59 2.44 7.96L2.41 7.87C1.88 6.45 2.59 4.86 4.01 4.33 4.29 4.22 4.58 4.17 4.88 4.16L5.1 4.16C5.8 4.19 6.44 3.74 6.64 3.11L6.67 3.01 6.72 2.86C7.19 1.5 8.64 0.71 10.05 1.1ZM8.6 3.56L8.56 3.69C8.07 5.21 6.61 6.23 5.01 6.15 4.91 6.15 4.81 6.17 4.72 6.2 4.33 6.35 4.14 6.77 4.29 7.17L4.33 7.3C4.83 8.83 4.25 10.5 2.91 11.38 2.82 11.44 2.75 11.51 2.7 11.59 2.47 11.93 2.57 12.39 2.92 12.63L3.04 12.71C4.33 13.65 4.84 15.34 4.28 16.84 4.25 16.94 4.23 17.04 4.23 17.14 4.25 17.55 4.6 17.86 5.02 17.84L5.16 17.84C6.76 17.84 8.17 18.91 8.6 20.46 8.63 20.55 8.67 20.64 8.74 20.72 8.99 21.04 9.46 21.09 9.79 20.83L9.91 20.74C11.2 19.8 12.97 19.84 14.22 20.84 14.3 20.9 14.39 20.95 14.49 20.97 14.88 21.08 15.29 20.85 15.4 20.44L15.44 20.31C15.93 18.79 17.39 17.77 18.99 17.85 19.09 17.85 19.19 17.83 19.28 17.8 19.67 17.65 19.86 17.23 19.71 16.83L19.67 16.7C19.17 15.17 19.75 13.5 21.09 12.62 21.18 12.56 21.25 12.49 21.3 12.41 21.53 12.07 21.43 11.61 21.08 11.37L20.96 11.29C19.67 10.35 19.16 8.66 19.72 7.16 19.75 7.06 19.77 6.96 19.77 6.86 19.75 6.45 19.4 6.14 18.98 6.16L18.84 6.16C17.24 6.16 15.83 5.09 15.4 3.54 15.37 3.45 15.33 3.36 15.26 3.28 15.01 2.96 14.54 2.91 14.21 3.17L14.09 3.26C12.8 4.2 11.03 4.16 9.78 3.16 9.7 3.1 9.61 3.05 9.51 3.03 9.12 2.92 8.71 3.15 8.6 3.56ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, l6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0.61C19.48 0.88 19.64 1.5 19.37 1.97L6.37 23.03C6.09 23.5 5.48 23.67 5 23.39 4.52 23.12 4.36 22.5 4.63 22.03L17.63 0.97C17.91 0.5 18.52 0.33 19 0.61ZM14.04 3L12.89 5 3 5C2.45 5 2 5.45 2 6L2 9 10.58 9 9.42 11 2 11 2 18C2 18.55 2.45 19 3 19L4.8 19 3.65 21 3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L14.04 3ZM21 3C22.66 3 24 4.34 24 6L24 18C24 19.66 22.66 21 21 21L9.96 21 11.11 19 21 19C21.55 19 22 18.55 22 18L22 11 15.73 11 16.89 9 22 9 22 6C22 5.45 21.55 5 21 5L19.2 5 20.35 3 21 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, d6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.59 14.17L19 17.59 22.41 14.17C22.8 13.78 23.44 13.78 23.83 14.17 24.22 14.56 24.22 15.2 23.83 15.59L20.41 19 23.83 22.41C24.22 22.8 24.22 23.44 23.83 23.83 23.44 24.22 22.8 24.22 22.41 23.83L19 20.41 15.59 23.83C15.2 24.22 14.56 24.22 14.17 23.83 13.78 23.44 13.78 22.8 14.17 22.41L17.59 19 14.17 15.59C13.78 15.2 13.78 14.56 14.17 14.17 14.56 13.78 15.2 13.78 15.59 14.17ZM21 3C22.66 3 24 4.34 24 6L24 11C24 11.55 23.55 12 23 12 22.45 12 22 11.55 22 11L22 10 2 10 2 18C2 18.55 2.45 19 3 19L10.2 19 10.2 19.02C10.66 19.11 11 19.52 11 20 11 20.55 10.55 21 10 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, M6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.17 0.18L19.11 6 19.51 6C20.92 6 22 7.16 22 8.52L22 12 23 12C23.55 12 24 12.45 24 13L24 17C24 17.55 23.55 18 23 18L22 18 22 20.48C22 21.84 20.92 23 19.51 23L2.49 23C1.08 23 0 21.84 0 20.48L0 8.52C0 7.16 1.08 6 2.49 6L5.53 6 17.17 0.18ZM19.51 8L2.49 8C2.22 8 2 8.23 2 8.52L2 20.48C2 20.77 2.22 21 2.49 21L19.51 21C19.78 21 20 20.77 20 20.48L20 18C18.34 18 17 16.66 17 15 17 13.4 18.25 12.1 19.82 12.01L20 12 20 8.52C20 8.23 19.78 8 19.51 8ZM22 14L20 14C19.45 14 19 14.45 19 15 19 15.55 19.45 16 20 16L22 16 22 14ZM16 3L10 6 17 6 16 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Z6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L15 24C14.45 24 14 23.55 14 23 14 22.45 14.45 22 15 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM1 14C1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L9 22C9.55 22 10 22.45 10 23 10 23.55 9.55 24 9 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14ZM15 14C16.66 14 18 15.34 18 17L18 19C18 19.55 17.55 20 17 20 16.45 20 16 19.55 16 19L16 17C16 16.45 15.55 16 15 16L9 16C8.45 16 8 16.45 8 17L8 19C8 19.55 7.55 20 7 20 6.45 20 6 19.55 6 19L6 17C6 15.34 7.34 14 9 14L15 14ZM12 4C14.21 4 16 5.79 16 8 16 10.21 14.21 12 12 12 9.79 12 8 10.21 8 8 8 5.79 9.79 4 12 4ZM9 0C9.55 0 10 0.45 10 1 10 1.55 9.55 2 9 2L3 2C2.45 2 2 2.45 2 3L2 9C2 9.55 1.55 10 1 10 0.45 10 0 9.55 0 9L0 3C0 1.34 1.34 0 3 0L9 0ZM12 6C10.9 6 10 6.9 10 8 10 9.1 10.9 10 12 10 13.1 10 14 9.1 14 8 14 6.9 13.1 6 12 6ZM21 0C22.66 0 24 1.34 24 3L24 9C24 9.55 23.55 10 23 10 22.45 10 22 9.55 22 9L22 3C22 2.45 21.55 2 21 2L15 2C14.45 2 14 1.55 14 1 14 0.45 14.45 0 15 0L21 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, u6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.89 1.94L21.97 3.68C22.55 4.61 22.27 5.85 21.33 6.43L21.03 6.62 21.1 6.82C22.82 11.96 22.33 16.34 19.87 19.38L19.68 19.6C17.79 21.8 14.99 23 12.04 23 9.1 23 6.29 21.8 4.4 19.6 1.78 16.55 1.23 12.07 2.99 6.8L3.06 6.62 2.75 6.43C1.86 5.87 1.56 4.73 2.03 3.82L2.12 3.68 3.2 1.94C3.78 1.01 5.01 0.72 5.95 1.3L9.23 3.33C10.11 3.88 10.43 5 9.97 5.93 8.03 9.81 7.91 12.74 9.04 14.51 9.7 15.56 10.82 16.14 12.04 16.14 13.26 16.14 14.38 15.56 15.05 14.51 16.18 12.74 16.05 9.81 14.12 5.93 13.66 5 13.98 3.88 14.86 3.33L18.14 1.3C19.08 0.72 20.31 1.01 20.89 1.94ZM19.19 3L15.91 5.03C18.33 9.9 18.11 13.42 16.74 15.58 15.65 17.29 13.85 18.14 12.04 18.14 10.24 18.14 8.44 17.29 7.35 15.58 5.97 13.42 5.75 9.9 8.18 5.03L4.89 3 3.81 4.73 5.29 5.66C5.42 5.73 5.47 5.89 5.41 6.03 3.07 11.78 3.83 15.86 5.92 18.3 7.47 20.1 9.75 21 12.04 21 14.33 21 16.62 20.1 18.17 18.3 20.26 15.86 21.02 11.79 18.68 6.05 18.61 5.91 18.66 5.74 18.79 5.66L20.27 4.73 19.19 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, f6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 1C22.66 1 24 2.34 24 4L24 9C24 10.66 22.66 12 21 12L19.23 12 19.98 20.72C20.08 21.88 19.23 22.89 18.07 22.99L17.89 23 6.11 23C4.95 23 4.01 22.06 4.01 20.9L4.02 20.72 4.76 12 3 12C1.34 12 0 10.66 0 9L0 4C0 2.34 1.34 1 3 1L21 1ZM7.29 7C7.24 7 7.2 7.04 7.19 7.09L6.01 20.89C6.01 20.94 6.03 20.97 6.06 20.99 6.08 21 6.09 21 6.11 21L14 21 13 7 7.29 7ZM21 3L3 3C2.45 3 2 3.45 2 4L2 9C2 9.55 2.45 10 3 10L4.93 10 5.2 6.92C5.29 5.83 6.2 5 7.29 5L16.71 5C17.8 5 18.71 5.83 18.8 6.92L19.06 10 21 10C21.55 10 22 9.55 22 9L22 4C22 3.45 21.55 3 21 3ZM16 21L17.89 21C17.95 20.99 18 20.95 17.99 20.89L16.81 7.09C16.8 7.05 16.78 7.02 16.75 7.01L16.71 7 15 7 16 21Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, p6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 5C21.66 5 23 6.34 23 8L23 17C23 18.66 21.66 20 20 20L9.23 20C8.59 20 7.97 19.8 7.46 19.42L1.84 15.29C1.65 15.16 1.48 15 1.33 14.82 0.25 13.56 0.41 11.66 1.67 10.59L7.4 5.71C7.94 5.25 8.63 5 9.35 5L20 5ZM20 7L9.35 7C9.11 7 8.88 7.08 8.7 7.24L2.96 12.11C2.54 12.47 2.49 13.1 2.85 13.52 2.9 13.58 2.96 13.64 3.02 13.68L8.64 17.81C8.81 17.93 9.02 18 9.23 18L20 18C20.55 18 21 17.55 21 17L21 8C21 7.45 20.55 7 20 7ZM13.71 9.29L15.66 11.24 17.61 9.29C18 8.9 18.63 8.9 19.02 9.29 19.41 9.68 19.41 10.32 19.02 10.71L17.07 12.66 19.02 14.61C19.41 15 19.41 15.63 19.02 16.02 18.63 16.41 18 16.41 17.61 16.02L15.66 14.07 13.71 16.02C13.32 16.41 12.68 16.41 12.29 16.02 11.9 15.63 11.9 15 12.29 14.61L14.24 12.66 12.29 10.71C11.9 10.32 11.9 9.68 12.29 9.29 12.68 8.9 13.32 8.9 13.71 9.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, x6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM2 12C2 17.52 6.48 22 12 22 14.4 22 16.6 21.15 18.33 19.74L4.26 5.67C2.85 7.39 2 9.6 2 12ZM12 2C9.6 2 7.39 2.85 5.67 4.26L19.74 18.33C21.15 16.6 22 14.4 22 12 22 6.48 17.52 2 12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, h6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 12.93C7.61 12.44 5 9.53 5 6L5 1 19 1 19 6C19 9.53 16.39 12.44 13 12.93L13 21 16 21C16.55 21 17 21.45 17 22 17 22.55 16.55 23 16 23L8 23C7.45 23 7 22.55 7 22 7 21.45 7.45 21 8 21L11 21 11 12.93ZM17 3L7 3 7 6C7 8.69 9.12 10.88 11.78 11L12 11C14.76 11 17 8.76 17 6L17 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, _6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.74 0 19.88 3.7 20 8.72L20 9C20 10.99 20.37 12.74 21.03 14.49L21.13 14.75 21.79 16.31C21.88 16.52 21.94 16.65 21.93 16.62 22.36 17.69 21.7 18.11 20.61 18.39 20.09 18.53 19.36 18.64 18.43 18.73 16.74 18.89 14.42 18.97 12 18.97L10.97 18.97C8.93 18.95 7.02 18.86 5.57 18.73 4.64 18.64 3.91 18.53 3.39 18.39 2.35 18.12 1.7 17.72 2.02 16.76L2.09 16.58C2.15 16.45 2.31 16.08 2.49 15.67L2.87 14.74C2.91 14.65 2.94 14.56 2.97 14.49 3.58 12.88 3.94 11.26 3.99 9.45L4 9C4 3.84 7.17 0 12 0ZM14.11 20.55C14.35 20.06 14.95 19.86 15.45 20.11 15.94 20.35 16.14 20.95 15.89 21.45 15.06 23.11 13.73 24 12 24 10.27 24 8.94 23.11 8.11 21.45 7.86 20.95 8.06 20.35 8.55 20.11 9.05 19.86 9.65 20.06 9.89 20.55 10.4 21.56 11.06 22 12 22 12.94 22 13.6 21.56 14.11 20.55Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, N6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.83 0 20 3.84 20 9 20 10.99 20.37 12.74 21.03 14.49 21.1 14.68 21.21 14.95 21.33 15.24L21.45 15.53C21.7 16.11 21.95 16.67 21.93 16.62 22.36 17.69 21.7 18.11 20.61 18.39 20.09 18.53 19.36 18.64 18.43 18.73 16.74 18.89 14.42 18.97 12 18.97 9.58 18.97 7.26 18.89 5.57 18.73 4.64 18.64 3.91 18.53 3.39 18.39 2.3 18.11 1.64 17.69 2.07 16.62 2.06 16.67 2.26 16.2 2.49 15.67L2.61 15.38C2.75 15.04 2.89 14.71 2.97 14.49 3.63 12.74 4 10.99 4 9 4 3.84 7.17 0 12 0ZM12 2C8.37 2 6 4.87 6 9 6 11.25 5.58 13.24 4.84 15.2 4.73 15.5 4.52 16 4.33 16.45L4.29 16.54 4.37 16.56C4.67 16.61 5.05 16.66 5.49 16.71L5.76 16.73C7.38 16.89 9.64 16.97 12 16.97 14.36 16.97 16.62 16.89 18.24 16.73 18.8 16.68 19.26 16.62 19.63 16.56L19.71 16.54 19.67 16.45C19.65 16.41 19.63 16.36 19.61 16.32L19.5 16.04C19.36 15.72 19.24 15.41 19.16 15.2 18.42 13.24 18 11.25 18 9 18 4.87 15.63 2 12 2ZM14.11 20.55C14.35 20.06 14.95 19.86 15.45 20.11 15.94 20.35 16.14 20.95 15.89 21.45 15.06 23.11 13.73 24 12 24 10.27 24 8.94 23.11 8.11 21.45 7.86 20.95 8.06 20.35 8.55 20.11 9.05 19.86 9.65 20.06 9.89 20.55 10.4 21.56 11.06 22 12 22 12.94 22 13.6 21.56 14.11 20.55Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, z6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1C19.66 1 21 2.34 21 4L21 20.91C21 22.29 19.88 23.41 18.5 23.41 17.9 23.41 17.33 23.2 16.87 22.81L12 18.63 7.13 22.81C6.12 23.67 4.64 23.6 3.72 22.67L3.6 22.54C3.21 22.09 3 21.51 3 20.91L3 4C3 2.34 4.34 1 6 1L18 1ZM18 3L6 3C5.45 3 5 3.45 5 4L5 20.91C5 21.03 5.04 21.15 5.12 21.24 5.3 21.45 5.62 21.47 5.83 21.29L11.35 16.56C11.72 16.24 12.28 16.24 12.65 16.56L18.17 21.29C18.27 21.37 18.38 21.41 18.5 21.41 18.78 21.41 19 21.19 19 20.91L19 4C19 3.45 18.55 3 18 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, g6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 19L6 19C4.8 19 4.03 18.25 4 17.06 3.33 11.04 3 5.38 3 4 3 3.22 2.78 3 2 3 1.45 3 1 2.55 1 2 1 1.45 1.45 1 2 1 3.89 1 5 2.11 5 4L22 4C22.29 4 22.57 4.13 22.76 4.35 22.95 4.58 23.03 4.87 22.98 5.16 21.86 10.93 20.86 13.88 20 14L5.88 15.88 5.99 16.89 6 17 19 17C19.55 17 20 17.45 20 18 20 18.55 19.55 19 19 19ZM5.67 13.89L19 12C19.29 11.96 19.89 9.96 20.82 6L5.11 6C5.21 7.39 5.4 11.36 5.67 13.89ZM7.25 22.8C6.79 23.07 6.21 23.07 5.75 22.8 5.29 22.53 5 22.04 5 21.5 5 20.67 5.67 20 6.5 20 7.33 20 8 20.67 8 21.5 8 22.04 7.71 22.53 7.25 22.8ZM20 21.5C20 20.67 19.33 20 18.5 20 17.67 20 17 20.67 17 21.5 17 22.33 17.67 23 18.5 23 19.33 23 20 22.33 20 21.5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, b6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.5 9C22.43 9 24 10.57 24 12.5 24 14.43 22.43 16 20.5 16L20 16C20 18.39 18.95 20.54 17.29 22L21 22C21.55 22 22 22.45 22 23 22 23.51 21.61 23.94 21.12 23.99L21 24 3 24C2.45 24 2 23.55 2 23 2 22.45 2.45 22 3 22L6.71 22C5.05 20.54 4 18.39 4 16L4 9 20.5 9ZM18 11L6 11 6 16C6 19.31 8.69 22 12 22 15.31 22 18 19.31 18 16L18 11ZM20.5 11L20 11 20 14 20.5 14C21.33 14 22 13.33 22 12.5 22 11.67 21.33 11 20.5 11ZM9.75 2.47C10.23 2.75 10.39 3.36 10.12 3.83L8.12 7.3C7.84 7.78 7.23 7.94 6.75 7.67 6.27 7.39 6.11 6.78 6.38 6.3L8.38 2.83C8.66 2.36 9.27 2.19 9.75 2.47ZM13.75 2.47C14.23 2.75 14.39 3.36 14.12 3.83L12.12 7.3C11.84 7.78 11.23 7.94 10.75 7.67 10.27 7.39 10.11 6.78 10.38 6.3L12.38 2.83C12.66 2.36 13.27 2.19 13.75 2.47ZM17.75 2.47C18.23 2.75 18.39 3.36 18.12 3.83L16.12 7.3C15.84 7.78 15.23 7.94 14.75 7.67 14.27 7.39 14.11 6.78 14.38 6.3L16.38 2.83C16.66 2.36 17.27 2.19 17.75 2.47Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, y6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 1C21.66 1 23 2.34 23 4L23 20C23 21.66 21.66 23 20 23L4 23C2.34 23 1 21.66 1 20L1 4C1 2.34 2.34 1 4 1L20 1ZM20 3L4 3C3.45 3 3 3.45 3 4L3 20C3 20.55 3.45 21 4 21L20 21C20.55 21 21 20.55 21 20L21 4C21 3.45 20.55 3 20 3ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM17 11C17.55 11 18 11.45 18 12 18 12.55 17.55 13 17 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L17 11ZM12 7C12.55 7 13 7.45 13 8 13 8.55 12.55 9 12 9 11.45 9 11 8.55 11 8 11 7.45 11.45 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, w6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, S6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM18.54 14.23C18.93 14.62 18.93 15.26 18.54 15.65L14.42 19.77C14.21 19.98 13.92 20.08 13.64 20.06 13.36 20.08 13.07 19.98 12.85 19.77L10.73 17.65C10.34 17.26 10.34 16.62 10.73 16.23 11.12 15.84 11.76 15.84 12.15 16.23L13.64 17.72 17.13 14.23C17.52 13.84 18.15 13.84 18.54 14.23ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, B6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM12 12C12.55 12 13 12.45 13 13L13 16.41 14.12 15.29C14.48 14.93 15.05 14.9 15.44 15.21L15.54 15.29C15.93 15.68 15.93 16.32 15.54 16.71L12.71 19.54C12.32 19.93 11.68 19.93 11.29 19.54L8.46 16.71C8.07 16.32 8.07 15.68 8.46 15.29 8.85 14.9 9.49 14.9 9.88 15.29L11 16.41 11 13C11 12.45 11.45 12 12 12ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, v6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM12.71 12.46L15.54 15.29C15.93 15.68 15.93 16.32 15.54 16.71 15.15 17.1 14.51 17.1 14.12 16.71L13 15.59 13 19C13 19.55 12.55 20 12 20 11.45 20 11 19.55 11 19L11 15.59 9.88 16.71C9.49 17.1 8.85 17.1 8.46 16.71 8.07 16.32 8.07 15.68 8.46 15.29L11.29 12.46C11.68 12.07 12.32 12.07 12.71 12.46ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, k6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, $6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.59 16.17L20 18.59 22.41 16.17C22.8 15.78 23.44 15.78 23.83 16.17 24.22 16.56 24.22 17.2 23.83 17.59L21.41 20 23.83 22.41C24.22 22.8 24.22 23.44 23.83 23.83 23.44 24.22 22.8 24.22 22.41 23.83L20 21.41 17.59 23.83C17.2 24.22 16.56 24.22 16.17 23.83 15.78 23.44 15.78 22.8 16.17 22.41L18.59 20 16.17 17.59C15.78 17.2 15.78 16.56 16.17 16.17 16.56 15.78 17.2 15.78 17.59 16.17ZM15 1C15.33 1 15.65 1.17 15.83 1.45L17.54 4 20 4C21.6 4 22.9 5.25 22.99 6.82L23 7 23 13 21 13 21 7C21 6.45 20.55 6 20 6L17 6C16.67 6 16.35 5.83 16.17 5.55L14.46 3 9.54 3 7.83 5.55C7.67 5.8 7.41 5.96 7.12 5.99L7 6 4 6C3.45 6 3 6.45 3 7L3 18C3 18.55 3.45 19 4 19L14 19 14 21 4 21C2.34 21 1 19.66 1 18L1 7C1 5.34 2.34 4 4 4L6.46 4 8.17 1.45C8.33 1.2 8.59 1.04 8.88 1.01L9 1 15 1ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, A6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23.68 16.32C24.11 16.76 24.11 17.46 23.68 17.89L18.01 23.68C17.78 23.91 17.47 24.02 17.16 24 16.86 24.02 16.54 23.91 16.31 23.68L12.82 20.11C12.39 19.68 12.39 18.97 12.82 18.54 13.24 18.11 13.93 18.11 14.36 18.54L17.16 21.41 22.14 16.32C22.57 15.89 23.26 15.89 23.68 16.32ZM15 1C15.33 1 15.65 1.17 15.83 1.45L17.54 4 20 4C21.6 4 22.9 5.25 22.99 6.82L23 7 23 14 21 14 21 7C21 6.45 20.55 6 20 6L17 6C16.67 6 16.35 5.83 16.17 5.55L14.46 3 9.54 3 7.83 5.55C7.67 5.8 7.41 5.96 7.12 5.99L7 6 4 6C3.45 6 3 6.45 3 7L3 18C3 18.55 3.45 19 4 19L10 19 10 21 4 21C2.34 21 1 19.66 1 18L1 7C1 5.34 2.34 4 4 4L6.46 4 8.17 1.45C8.33 1.2 8.59 1.04 8.88 1.01L9 1 15 1ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, I6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 1C15.76 1 18 3.24 18 6L18 8C18 9.6 16.75 10.9 15.18 10.99L15 11 15 12.28 14.56 13.79 15.06 16.05 14.57 17.82 15.25 20.29 11.5 23.7 8 20.52 8 11 7.82 10.99C6.25 10.9 5 9.6 5 8L5 6C5 3.24 7.24 1 10 1L13 1ZM13 11L10 11 10 19.64 11.5 21 13 19.64 12.5 17.82 13 16 12.5 13.73 13 12 13 11ZM13 3L10 3C8.34 3 7 4.34 7 6L7 8C7 8.55 7.45 9 8 9L15 9C15.55 9 16 8.55 16 8L16 6C16 4.34 14.66 3 13 3ZM13 5C13.55 5 14 5.45 14 6 14 6.55 13.55 7 13 7L10 7C9.45 7 9 6.55 9 6 9 5.45 9.45 5 10 5L13 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, H6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.5 0.68L11.3 4.47C12.1 5.28 12.1 6.38 11.6 7.28L11.6 10.57 13.9 8.28C14.3 7.88 15 7.97 15.2 8.38L15.3 8.47 17.3 12.68 18 14.47 21.8 22.68C22.1 23.38 21.4 24.07 20.7 23.88L20.6 23.88 6.5 17.27C6 16.98 5.8 16.27 6.3 15.88L7.44 14.56 9.6 12.57 9.6 8.57C9.1 8.57 8.5 8.38 8.1 8.07L5 5C3.8 3.83 3 2 4 1L4.4 0.68C5 0 6.7-0.23 7.5 0.68ZM14.1 10.28L11.8 12.57 14 14.78C14.3 15.07 14.3 15.57 14.1 15.88L14 15.97C13.7 16.27 13.2 16.27 12.9 16.07L10.6 13.78 8.3 16.07 19.2 21.18 14.1 10.28ZM5.5 1.88C5.3 2.08 5.3 2.38 5.5 2.58L9.3 6.38C9.5 6.58 9.8 6.58 10 6.38 10.2 6.17 10.2 5.88 10 5.67L6.2 1.88C6 1.68 5.7 1.68 5.5 1.88Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, R6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.11 0C20.87 0 21.27 0.92 20.79 1.44L16.45 5.58 16.45 7.45 20.11 7.45C20.78 7.45 21.16 8.16 20.91 8.68L20.86 8.77 20.81 8.86 20.71 9 10.54 18.76C10.4 18.91 10.19 19 9.97 19L0.85 19C0.14 19-0.27 18.13 0.2 17.55L0.25 17.49 4.51 13.39 4.51 11.51 0.85 11.51C0.18 11.51-0.23 10.73 0.14 10.14L0.2 10.05 0.25 10 10.42 0.24C10.57 0.09 10.73 0.02 10.92 0L10.97 0 20.11 0ZM4.51 15.8L3.03 17.22 4.51 17.22 4.51 15.8ZM17.93 9.22L15.94 9.22 7.57 17.22 9.56 17.22 17.93 9.22ZM14.7 7.49L14.7 7.27 10.54 11.27C10.44 11.38 10.32 11.45 10.18 11.48 10.09 11.5 10.03 11.51 9.93 11.51L6.27 11.51 6.27 16.08 14.71 8.01 14.7 7.49ZM17.93 1.78L11.4 1.78 3.03 9.78 9.56 9.78 17.93 1.78Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, T6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 1C22.21 1 24 2.79 24 5L24 15C24 19.42 20.42 23 16 23L8 23C3.67 23 0.14 19.55 0 15.25L0 14.8 0 5C0 2.79 1.79 1 4 1L20 1ZM3 14C2.66 14 2.32 14.03 2 14.08L2 15C2 18.31 4.69 21 8 21L8.92 21C8.97 20.68 9 20.34 9 20 9 16.69 6.31 14 3 14ZM21 14C17.68 14 15 16.69 15 20 15 20.34 15.03 20.68 15.08 21L16 21C19.31 21 22 18.31 22 15L22 14.08C21.67 14.03 21.34 14 21 14ZM20 3L4 3C2.9 3 2 3.9 2 5L2 7 6 7C6.55 7 7 7.45 7 8 7 8.55 6.55 9 6 9L2 9 2 12.06C2.33 12.02 2.66 12 3 12 7.42 12 11 15.58 11 20 11 20.34 10.98 20.67 10.94 21L13.06 21C13.02 20.67 13 20.34 13 20 13 15.58 16.58 12 21 12 21.34 12 21.67 12.02 22 12.06L22 9 18 9C17.45 9 17 8.55 17 8 17 7.45 17.45 7 18 7L22 7 22 5C22 3.9 21.1 3 20 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, V6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM17.54 9.23C17.15 8.84 16.52 8.84 16.13 9.23L11.64 13.72 9.15 11.23C8.76 10.84 8.12 10.84 7.73 11.23 7.34 11.62 7.34 12.26 7.73 12.65L10.85 15.77C11.07 15.98 11.36 16.08 11.64 16.06 11.92 16.08 12.21 15.98 12.42 15.77L17.54 10.65C17.93 10.26 17.93 9.62 17.54 9.23Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, X1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM17.54 9.23C17.93 9.62 17.93 10.26 17.54 10.65L12.42 15.77C12.21 15.98 11.92 16.08 11.64 16.06 11.36 16.08 11.07 15.98 10.85 15.77L7.73 12.65C7.34 12.26 7.34 11.62 7.73 11.23 8.12 10.84 8.76 10.84 9.15 11.23L11.64 13.72 16.13 9.23C16.52 8.84 17.15 8.84 17.54 9.23Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, D6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.95 5.29C22.34 5.68 22.34 6.32 21.95 6.71L10.05 18.61C9.87 18.79 9.64 18.88 9.4 18.9L9.18 18.9C8.95 18.88 8.72 18.79 8.54 18.61L2.29 12.36C1.9 11.97 1.9 11.34 2.29 10.95 2.68 10.56 3.32 10.56 3.71 10.95L9.29 16.54 20.54 5.29C20.93 4.9 21.56 4.9 21.95 5.29ZM14.95 5.29C15.34 5.68 15.34 6.32 14.95 6.71L10.05 11.61C9.87 11.79 9.64 11.88 9.4 11.9L9.18 11.9C8.95 11.88 8.72 11.79 8.54 11.61L5.29 8.36C4.9 7.97 4.9 7.34 5.29 6.95 5.68 6.56 6.32 6.56 6.71 6.95L9.29 9.54 13.54 5.29C13.93 4.9 14.56 4.9 14.95 5.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, F6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.5 13L9.15 18.65C9.34 18.84 9.66 18.84 9.85 18.65L21 7.5C21.55 6.95 21.55 6.05 21 5.5 20.45 4.95 19.55 4.95 19 5.5L9.5 15 5.5 11C4.95 10.45 4.05 10.45 3.5 11 2.95 11.55 2.95 12.45 3.5 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, F = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.54 17.61L4.29 13.36C3.9 12.97 3.9 12.34 4.29 11.95 4.68 11.56 5.32 11.56 5.71 11.95L9.29 15.54 18.54 6.29C18.93 5.9 19.56 5.9 19.95 6.29 20.34 6.68 20.34 7.32 19.95 7.71L10.05 17.61C9.87 17.79 9.64 17.88 9.4 17.9L9.18 17.9C8.95 17.88 8.72 17.79 8.54 17.61Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, j6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M16.27 2.98L22.03 8.74C23.2 9.91 23.2 11.81 22.03 12.98L13.3 21.71C13.12 21.89 12.86 22 12.6 22L7.1 22C6.84 22 6.58 21.89 6.39 21.71L1.97 17.28C0.8 16.11 0.8 14.21 1.97 13.04L12.03 2.98C13.2 1.81 15.1 1.81 16.27 2.98ZM9.71 8.13L3.39 14.46C2.99 14.85 2.99 15.48 3.39 15.87L7.22 19.71C7.41 19.89 7.66 20 7.93 20L11.77 20C12.03 20 12.29 19.89 12.48 19.71L16.88 15.3 9.71 8.13ZM13.44 4.4L11.13 6.71 18.3 13.88 20.61 11.57C21.01 11.18 21.01 10.54 20.61 10.15L14.86 4.4C14.47 4.01 13.83 4.01 13.44 4.4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, E6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 3C19.66 3 21 4.34 21 6L21 18C21 19.66 19.66 21 18 21L6 21C4.34 21 3 19.66 3 18L3 6C3 4.34 4.34 3 6 3L18 3ZM18 5L6 5C5.45 5 5 5.45 5 6L5 18C5 18.55 5.45 19 6 19L18 19C18.55 19 19 18.55 19 18L19 6C19 5.45 18.55 5 18 5ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13L8 13C7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11L16 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, O6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 1C21.66 1 23 2.34 23 4L23 20C23 21.66 21.66 23 20 23L4 23C2.34 23 1 21.66 1 20L1 4C1 2.34 2.34 1 4 1L20 1ZM20 3L4 3C3.45 3 3 3.45 3 4L3 20C3 20.55 3.45 21 4 21L20 21C20.55 21 21 20.55 21 20L21 4C21 3.45 20.55 3 20 3ZM17 11C17.55 11 18 11.45 18 12 18 12.55 17.55 13 17 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L17 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, P6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5ZM12 5C11.45 5 11 5.45 11 6L11 13C11 13.27 11.11 13.52 11.29 13.71L14.29 16.71C14.68 17.1 15.32 17.1 15.71 16.71L15.79 16.61C16.1 16.22 16.07 15.65 15.71 15.29L13 12.59 13 6C13 5.45 12.55 5 12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Q1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 5C12.55 5 13 5.45 13 6L13 12.59 15.71 15.29C16.07 15.65 16.1 16.22 15.79 16.61L15.71 16.71C15.32 17.1 14.68 17.1 14.29 16.71L11.29 13.71C11.11 13.52 11 13.27 11 13L11 6C11 5.45 11.45 5 12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, U6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.29 21.73C12.68 22.09 13.32 22.09 13.71 21.73L16.71 18.94C17.1 18.58 17.1 17.99 16.71 17.62L16.64 17.57C16.25 17.26 15.66 17.28 15.29 17.62L14 18.82 14 18.78 14 11.97C14 11.44 13.55 11 13 11 12.45 11 12 11.44 12 11.97L12 18.82 10.71 17.62C10.32 17.26 9.68 17.26 9.29 17.62 8.9 17.99 8.9 18.58 9.29 18.94L12.29 21.73ZM9 3C12.45 3 15.5 4.95 17.01 7.89L17.07 8.02 17.18 8.01 17.5 8C21.09 8 24 10.91 24 14.5 24 18.09 22 21 19 21 18.88 21 18.76 21 18.64 20.99 18.6 21 18.55 21 18.5 21 17.95 21 17.5 20.55 17.5 20 17.5 19.45 17.95 19 18.5 19L18.5 18.97C18.66 18.99 18.83 19 19 19 21 19 22 16.99 22 14.5 22 12.01 19.99 10 17.5 10 16.9 10 16.32 10.12 15.8 10.33 15.05 7.27 12.29 5 9 5 5.13 5 2 7 2 12 2 16.89 4.87 18.91 6.65 18.99L7 19C7.55 19 8 19.45 8 20 8 20.51 7.61 20.94 7.12 20.99L7 21C4 21 0 18 0 12 0 6 4.03 3 9 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, W6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.78 20.59L19.59 20.66 19.27 20.76 18.98 20.83 18.75 20.88 18.64 20.9C18.37 20.95 18.09 20.98 17.82 20.99L17.5 21 17.35 21 17.04 20.98 17 20.98 17 21 9 21C4.03 21 0 16.97 0 12 0 7.03 4.03 3 9 3 12.45 3 15.5 4.95 17.01 7.89L17.07 8.01C17.26 8 17.46 8 17.65 8L17.98 8.02 18.29 8.05 18.55 8.09C19.41 8.22 20.21 8.53 20.92 8.97L21.1 9.09C21.67 9.46 22.18 9.93 22.62 10.49L22.74 10.65C22.82 10.76 22.89 10.87 22.97 10.99L23.01 11.05C23.28 11.49 23.51 11.96 23.67 12.46L23.79 12.84 23.85 13.11 23.86 13.17C23.99 13.75 24.02 14.34 23.99 14.92L23.97 15.11 23.95 15.3 23.92 15.53C23.8 16.25 23.57 16.93 23.24 17.54L23.04 17.9 23.02 17.93C22.68 18.48 22.25 18.99 21.74 19.43L21.43 19.68 21.18 19.86 21.13 19.89C20.8 20.11 20.46 20.3 20.09 20.46L19.78 20.59ZM17.97 10.02L17.72 10 17.68 10C17.62 10 17.56 10 17.5 10L17.25 10.01 16.97 10.03 16.84 10.05 16.57 10.1C16.45 10.12 16.33 10.15 16.21 10.19L16.03 10.25C15.95 10.27 15.88 10.3 15.8 10.33L15.65 10.4C15.51 10.46 15.38 10.53 15.25 10.6L14.82 10.85C14.34 11.13 13.73 10.97 13.45 10.49 13.17 10.01 13.34 9.4 13.82 9.12L14.53 8.73 14.81 8.58C14.9 8.54 14.96 8.51 14.98 8.51L15.05 8.48C13.84 6.4 11.58 5 9 5 5.13 5 2 8.13 2 12 2 15.87 5.13 19 9 19L17 19 17 18.97C17.16 18.99 17.33 19 17.5 19 18.1 19 18.67 18.88 19.19 18.67L19.41 18.57 19.56 18.5 19.77 18.39 19.96 18.27C20.39 17.99 20.77 17.64 21.08 17.23L21.22 17.03 21.33 16.86 21.43 16.69 21.48 16.61C21.75 16.1 21.92 15.54 21.98 14.96 21.99 14.81 22 14.66 22 14.5 22 14.22 21.97 13.95 21.93 13.68 21.89 13.5 21.85 13.31 21.79 13.13L21.69 12.86 21.61 12.66C21.55 12.53 21.48 12.39 21.41 12.26L21.34 12.15 21.2 11.93 21.27 12.04C21.02 11.67 20.72 11.33 20.38 11.04L20.15 10.86 19.96 10.73 19.78 10.62 19.61 10.52 19.51 10.47 19.25 10.35 19.19 10.33C18.89 10.21 18.57 10.12 18.26 10.06L17.97 10.02Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, q6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 0C14.1 0 15 0.9 15 2L15 2.98C15.34 3.1 15.67 3.23 15.99 3.38L16.3 3.53 16.98 2.84C17.72 2.1 18.9 2.06 19.68 2.72L19.81 2.84 21.16 4.19C21.94 4.97 21.94 6.24 21.16 7.02L20.47 7.7 20.62 8.01C20.77 8.33 20.9 8.66 21.01 9L22 9C23.05 9 23.92 9.82 23.99 10.85L24 11 24 13C24 14.1 23.1 15 22 15L21.02 15C20.9 15.34 20.77 15.67 20.62 15.99L20.47 16.3 21.16 16.98C21.9 17.72 21.94 18.9 21.28 19.68L21.16 19.81 19.81 21.16C19.03 21.94 17.76 21.94 16.98 21.16L16.3 20.47 15.99 20.62C15.67 20.77 15.34 20.9 15 21.01L15 22C15 23.05 14.18 23.92 13.15 23.99L13 24 11 24C9.9 24 9 23.1 9 22L9 21.02C8.66 20.9 8.33 20.77 8.01 20.62L7.7 20.47 7.02 21.16C6.28 21.9 5.1 21.94 4.32 21.28L4.19 21.16 2.84 19.81C2.06 19.03 2.06 17.76 2.84 16.98L3.53 16.3 3.38 15.99C3.23 15.67 3.1 15.34 2.99 15L2 15C0.95 15 0.08 14.18 0.01 13.15L0 13 0 11C0 9.9 0.9 9 2 9L2.98 9C3.1 8.66 3.23 8.33 3.38 8.01L3.53 7.7 2.84 7.02C2.1 6.28 2.06 5.1 2.72 4.32L2.84 4.19 4.19 2.84C4.97 2.06 6.24 2.06 7.02 2.84L7.7 3.53 8.01 3.38C8.33 3.23 8.66 3.1 9 2.99L9 2C9 0.95 9.82 0.08 10.85 0.01L11 0 13 0ZM13 2L11 2 11 4.57C9.66 4.74 8.43 5.28 7.41 6.07L5.6 4.26 4.26 5.6 6.07 7.41C5.28 8.43 4.74 9.66 4.57 11L2 11 2 13 4.57 13C4.74 14.34 5.28 15.57 6.07 16.59L4.26 18.4 5.6 19.74 7.41 17.93C8.43 18.72 9.66 19.26 11 19.43L11 22 13 22 13 19.43C14.34 19.26 15.57 18.72 16.59 17.93L18.4 19.74 19.74 18.4 17.93 16.59C18.72 15.57 19.26 14.34 19.43 13L22 13 22 11 19.43 11C19.26 9.66 18.72 8.43 17.93 7.41L19.74 5.6 18.4 4.26 16.59 6.07C15.57 5.28 14.34 4.74 13 4.57L13 2ZM12 8C14.21 8 16 9.79 16 12 16 14.21 14.21 16 12 16 9.79 16 8 14.21 8 12 8 9.79 9.79 8 12 8ZM12 10C10.9 10 10 10.9 10 12 10 13.1 10.9 14 12 14 13.1 14 14 13.1 14 12 14 10.9 13.1 10 12 10Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, G6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 3C6.66 3 8 4.34 8 6 8 7.31 7.17 8.42 6 8.83L6 16C6 16.55 6.45 17 7 17L9.73 17 8.47 15.71C8.1 15.32 8.1 14.68 8.47 14.29 8.85 13.9 9.45 13.9 9.83 14.29L12.72 17.29C13.09 17.68 13.09 18.32 12.72 18.71L9.83 21.71C9.45 22.1 8.85 22.1 8.47 21.71L8.42 21.64C8.1 21.25 8.12 20.66 8.47 20.29L9.73 19 7 19C5.34 19 4 17.66 4 16L4 8.83C2.83 8.42 2 7.31 2 6 2 4.34 3.34 3 5 3ZM15.03 2.29L15.08 2.36C15.4 2.75 15.38 3.34 15.03 3.71L13.77 5 17 5C18.66 5 20 6.34 20 8L20 15.17C21.17 15.58 22 16.69 22 18 22 19.66 20.66 21 19 21 17.34 21 16 19.66 16 18 16 16.69 16.83 15.58 18 15.17L18 8C18 7.45 17.55 7 17 7L13.77 7 15.03 8.29C15.4 8.68 15.4 9.32 15.03 9.71 14.65 10.1 14.05 10.1 13.67 9.71L10.78 6.71C10.41 6.32 10.41 5.68 10.78 5.29L13.67 2.29C14.05 1.9 14.65 1.9 15.03 2.29ZM19 17C18.45 17 18 17.45 18 18 18 18.55 18.45 19 19 19 19.55 19 20 18.55 20 18 20 17.45 19.55 17 19 17ZM5 5C4.45 5 4 5.45 4 6 4 6.55 4.45 7 5 7 5.55 7 6 6.55 6 6 6 5.45 5.55 5 5 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, K6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 12C3 16.97 7.03 21 12 21 12.62 21 13.12 20.5 13.12 19.88 13.12 19.25 12.62 18.75 12 18.75 8.27 18.75 5.25 15.73 5.25 12 5.25 8.27 8.27 5.25 12 5.25 15.73 5.25 18.75 8.27 18.75 12L18.75 15.38C18.75 16 18.25 16.5 17.62 16.5 17 16.5 16.5 16 16.5 15.38L16.5 12C16.5 10.18 15.4 8.54 13.72 7.84 12.04 7.15 10.11 7.53 8.82 8.82 7.53 10.11 7.15 12.04 7.84 13.72 8.54 15.4 10.18 16.5 12 16.5 12.81 16.5 13.61 16.27 14.3 15.85 14.54 17.6 16.1 18.87 17.87 18.74 19.64 18.62 21 17.15 21 15.38L21 12C21 7.03 16.97 3 12 3 7.03 3 3 7.03 3 12ZM12 14C10.9 14 10 13.1 10 12 10 10.9 10.9 10 12 10 13.1 10 14 10.9 14 12 14 13.1 13.1 14 12 14Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, X6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C13.22 0 14.36 0.59 15.04 1.53L15.27 1.87C15.67 2.39 16.36 2.63 17.07 2.45L17.34 2.39C18.51 2.22 19.7 2.6 20.57 3.45 21.26 4.16 21.64 5.1 21.64 6.12L21.63 6.35C21.62 6.49 21.6 6.63 21.58 6.75L21.52 7.01 21.5 7.24 21.49 7.38C21.49 7.91 21.75 8.4 22.2 8.73L22.57 8.98C23.16 9.42 23.61 10.02 23.87 10.74 24 11.12 24.07 11.52 24.07 11.93 24.07 13.15 23.48 14.29 22.52 14.98L22.18 15.21C21.68 15.58 21.43 16.19 21.52 16.84L21.6 17.27C21.78 18.45 21.4 19.64 20.55 20.5 19.84 21.19 18.89 21.57 17.9 21.57 17.61 21.57 17.33 21.54 17 21.47 16.88 21.44 16.75 21.42 16.62 21.42 16.09 21.42 15.6 21.68 15.28 22.11L15.19 22.24C14.5 23.34 13.29 24 12 24 11.05 24 10.13 23.64 9.41 22.97 9.26 22.82 9.12 22.66 9.01 22.5L8.79 22.18C8.64 21.98 8.46 21.82 8.24 21.7 7.99 21.57 7.72 21.49 7.45 21.49 7.37 21.49 7.29 21.5 7.24 21.5L6.98 21.56 6.67 21.61C6.51 21.63 6.34 21.64 6.16 21.64 5.29 21.64 4.44 21.34 3.73 20.76L3.5 20.55C2.81 19.84 2.43 18.9 2.43 17.9 2.43 17.62 2.46 17.33 2.53 17 2.56 16.88 2.58 16.75 2.58 16.62 2.58 16.09 2.32 15.6 1.89 15.28L1.76 15.19C0.66 14.5 0 13.29 0 12 0 11.86 0.01 11.72 0.02 11.58 0.12 10.68 0.54 9.85 1.2 9.24 1.37 9.08 1.56 8.94 1.75 8.81 2.02 8.64 2.24 8.39 2.36 8.12L2.4 8.04 2.46 7.84C2.53 7.56 2.53 7.27 2.45 6.94L2.4 6.69 2.37 6.5 2.36 6.4 2.36 6.16C2.36 5.17 2.74 4.23 3.45 3.51 4.32 2.65 5.55 2.27 6.72 2.47L7.12 2.55C7.79 2.65 8.45 2.35 8.83 1.72L8.99 1.49C9.71 0.55 10.82 0 12 0ZM12 2C11.44 2 10.92 2.26 10.61 2.67L10.51 2.81C9.74 4.08 8.28 4.75 6.78 4.52L6.51 4.47C5.91 4.33 5.29 4.5 4.86 4.92 4.54 5.25 4.36 5.7 4.36 6.13L4.36 6.3 4.37 6.36 4.4 6.49C4.55 7.1 4.55 7.74 4.38 8.39L4.28 8.71 4.2 8.91C3.91 9.56 3.43 10.11 2.83 10.5 2.73 10.56 2.65 10.63 2.57 10.7 2.26 10.99 2.06 11.38 2.01 11.8 2 11.87 2 11.93 2 12 2 12.61 2.31 13.17 2.81 13.49 3.9 14.15 4.57 15.33 4.58 16.62 4.58 16.92 4.54 17.22 4.48 17.46 4.45 17.61 4.43 17.76 4.43 17.91 4.43 18.37 4.61 18.82 4.89 19.11L5.03 19.24C5.35 19.5 5.75 19.64 6.15 19.64L6.33 19.63C6.35 19.63 6.37 19.63 6.39 19.63L6.6 19.59 6.85 19.54C7.05 19.51 7.25 19.49 7.46 19.49 8.08 19.49 8.68 19.66 9.21 19.95 9.67 20.21 10.08 20.56 10.42 21.02L10.57 21.24C10.64 21.36 10.72 21.46 10.79 21.53 11.12 21.83 11.55 22 12 22 12.61 22 13.17 21.69 13.49 21.19 14.15 20.1 15.33 19.43 16.62 19.42 16.92 19.42 17.22 19.46 17.46 19.52 17.61 19.55 17.76 19.57 17.91 19.57 18.37 19.57 18.82 19.39 19.14 19.08 19.53 18.68 19.71 18.12 19.63 17.61L19.6 17.42C19.26 15.98 19.81 14.48 21.03 13.58L21.24 13.43C21.76 13.1 22.07 12.54 22.07 11.93 22.07 11.74 22.04 11.55 21.99 11.4 21.87 11.08 21.66 10.8 21.41 10.62L21.26 10.51C20.17 9.85 19.5 8.67 19.49 7.38 19.49 7.27 19.49 7.16 19.51 7.05L19.54 6.72 19.6 6.44C19.62 6.35 19.63 6.27 19.64 6.24L19.64 6.09C19.64 5.63 19.46 5.18 19.15 4.86 18.75 4.47 18.19 4.29 17.68 4.36L17.51 4.4C16.08 4.77 14.58 4.25 13.66 3.05L13.5 2.83C13.17 2.31 12.61 2 12 2ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM8 11C8.55 11 9 11.45 9 12 9 12.55 8.55 13 8 13 7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13 15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11ZM12 7C12.55 7 13 7.45 13 8 13 8.55 12.55 9 12 9 11.45 9 11 8.55 11 8 11 7.45 11.45 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Q6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 3C22.66 3 24 4.34 24 6L24 21C24 22.66 22.66 24 21 24L10 24C8.34 24 7 22.66 7 21L7 6C7 4.34 8.34 3 10 3L21 3ZM21 5L10 5C9.45 5 9 5.45 9 6L9 21C9 21.55 9.45 22 10 22L21 22C21.55 22 22 21.55 22 21L22 6C22 5.45 21.55 5 21 5ZM14.2 18C14.75 18 15.2 18.45 15.2 19 15.2 19.55 14.75 20 14.2 20L12 20C11.45 20 11 19.55 11 19 11 18.45 11.45 18 12 18L14.2 18ZM15.6 14C16.15 14 16.6 14.45 16.6 15 16.6 15.55 16.15 16 15.6 16L12 16C11.45 16 11 15.55 11 15 11 14.45 11.45 14 12 14L15.6 14ZM17 10C17.55 10 18 10.45 18 11 18 11.55 17.55 12 17 12L12 12C11.45 12 11 11.55 11 11 11 10.45 11.45 10 12 10L17 10ZM3 22C1.34 22 0 20.66 0 19L0 3C0 1.34 1.34 0 3 0L5 0 5 2 3 2C2.45 2 2 2.45 2 3L2 19C2 19.55 2.45 20 3 20L4 20C4.55 20 5 20.45 5 21 5 21.55 4.55 22 4 22L3 22Z M5 0H7A1 1 0 0 1 8 1V1A1 1 0 0 1 7 2H5A1 1 0 0 1 4 1V1A1 1 0 0 1 5 0z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, J6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 7C22.66 7 24 8.34 24 10L24 21C24 22.66 22.66 24 21 24L10 24C8.34 24 7 22.66 7 21L7 10C7 8.34 8.34 7 10 7L21 7ZM21 9L10 9C9.45 9 9 9.45 9 10L9 21C9 21.55 9.45 22 10 22L21 22C21.55 22 22 21.55 22 21L22 10C22 9.45 21.55 9 21 9ZM14 0C15.66 0 17 1.34 17 3L17 4C17 4.55 16.55 5 16 5 15.45 5 15 4.55 15 4L15 3C15 2.45 14.55 2 14 2L3 2C2.45 2 2 2.45 2 3L2 14C2 14.55 2.45 15 3 15L4 15C4.55 15 5 15.45 5 16 5 16.55 4.55 17 4 17L3 17C1.34 17 0 15.66 0 14L0 3C0 1.34 1.34 0 3 0L14 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Y6 = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 0C15.31 0 16.42 0.83 16.83 2L19 2C20.66 2 22 3.34 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 5C2 3.34 3.34 2 5 2L7.17 2C7.58 0.83 8.69 0 10 0L14 0ZM7.17 4L5 4C4.45 4 4 4.45 4 5L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 5C20 4.45 19.55 4 19 4L16.83 4C16.42 5.17 15.31 6 14 6L10 6C8.69 6 7.58 5.17 7.17 4ZM13 18C13.55 18 14 18.45 14 19 14 19.55 13.55 20 13 20L7 20C6.45 20 6 19.55 6 19 6 18.45 6.45 18 7 18L13 18ZM13 14C13.55 14 14 14.45 14 15 14 15.55 13.55 16 13 16L7 16C6.45 16 6 15.55 6 15 6 14.45 6.45 14 7 14L13 14ZM14 2L10 2C9.45 2 9 2.45 9 3 9 3.55 9.45 4 10 4L14 4C14.55 4 15 3.55 15 3 15 2.45 14.55 2 14 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, C9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 1C12.55 1 13 1.45 13 2L13 4C13 4.04 13 4.08 12.99 4.12 14.72 4.57 16 6.13 16 8 16 9.08 15.57 10.06 14.87 10.78L18.34 16.79C19.3 15.91 20.04 14.76 20.4 13.41 20.54 12.88 21.09 12.56 21.62 12.71 22.16 12.85 22.47 13.4 22.33 13.93 21.82 15.81 20.76 17.4 19.36 18.55L21.12 21.59C21.39 22.07 21.23 22.68 20.75 22.96 20.61 23.04 20.47 23.08 20.32 23.09L20.21 23.09C19.88 23.08 19.56 22.9 19.38 22.59L17.68 19.64C15.78 20.6 13.53 20.89 11.31 20.29 10.77 20.15 10.46 19.6 10.6 19.07 10.74 18.54 11.29 18.22 11.82 18.36 13.51 18.81 15.22 18.61 16.68 17.91L13.17 11.83C12.8 11.94 12.41 12 12 12 11.75 12 11.51 11.98 11.27 11.93L5.12 22.59C4.96 22.87 4.69 23.04 4.4 23.08L4.29 23.09C4.11 23.1 3.92 23.06 3.75 22.96 3.27 22.68 3.11 22.07 3.38 21.59L9.45 11.08C8.56 10.35 8 9.24 8 8 8 6.13 9.28 4.57 11.01 4.12L11 4.06 11 2C11 1.45 11.45 1 12 1ZM12 6C10.9 6 10 6.9 10 8 10 9.1 10.9 10 12 10 13.1 10 14 9.1 14 8 14 6.9 13.1 6 12 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, L9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, e9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M24 12A12 12 0 0 1 12 24 12 12 0 0 1 0 12 12 12 0 0 1 24 12z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, n9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 19.5C14 18.4 13.1 17.5 12 17.5 10.9 17.5 10 18.4 10 19.5 10 20.6 10.9 21.5 12 21.5 13.1 21.5 14 20.6 14 19.5ZM14 12C14 10.9 13.1 10 12 10 10.9 10 10 10.9 10 12 10 13.1 10.9 14 12 14 13.1 14 14 13.1 14 12ZM14 4.5C14 3.4 13.1 2.5 12 2.5 10.9 2.5 10 3.4 10 4.5 10 5.6 10.9 6.5 12 6.5 13.1 6.5 14 5.6 14 4.5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, i9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4.5 14C5.6 14 6.5 13.1 6.5 12 6.5 10.9 5.6 10 4.5 10 3.4 10 2.5 10.9 2.5 12 2.5 13.1 3.4 14 4.5 14ZM12 14C13.1 14 14 13.1 14 12 14 10.9 13.1 10 12 10 10.9 10 10 10.9 10 12 10 13.1 10.9 14 12 14ZM19.5 14C20.6 14 21.5 13.1 21.5 12 21.5 10.9 20.6 10 19.5 10 18.4 10 17.5 10.9 17.5 12 17.5 13.1 18.4 14 19.5 14Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, o9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.27 0 17.52 0.11 17.71 0.29L21.71 4.29C21.89 4.48 22 4.73 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 2C2 0.9 2.9 0 4 0L17 0ZM15 2L4 2 4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 7 16 7 15.88 6.99C15.39 6.94 15 6.51 15 6L15 2ZM10.8 8L10.88 8C11.41 8.03 12.02 8.35 12.17 9.19 12.37 10.13 12.16 11.15 11.96 12.03L11.87 12.4C12.32 13.59 12.95 14.39 13.91 14.97 15.87 14.73 17.13 14.86 17.65 15.37 18 15.73 18.1 16.39 17.89 16.92 17.76 17.22 17.43 17.72 16.58 17.72 15.73 17.72 14.47 17.34 13.37 16.75 12.47 16.91 11.47 17.23 10.5 17.56L10.21 17.65C9.98 17.74 9.74 17.81 9.52 17.89 8.02 20.44 6.91 21 6.22 21 6.06 21 5.91 20.97 5.8 20.92 5.53 20.82 5.3 20.61 5.15 20.33 5.02 20.09 4.97 19.81 5.02 19.6 5.25 18.43 6.8 17.5 7.96 16.91 8.59 15.81 9.43 13.97 9.97 12.7L9.87 12.3C9.51 10.85 9.33 9.7 9.57 8.84 9.7 8.35 10.21 8.01 10.8 8ZM10.9 14C10.69 14.56 10.37 15.33 10 16L10.17 15.93 10.34 15.86C10.84 15.66 11.4 15.43 12 15.29 11.58 14.97 11.2 14.52 10.9 14ZM17 2.63L17 5 19.37 5 17 2.63Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, t9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14 1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM12 0C12.55 0 13 0.45 13 1L13 13.54 14.29 12.28C14.68 11.91 15.32 11.91 15.71 12.28 16.1 12.65 16.1 13.26 15.71 13.63L12.71 16.53C12.32 16.9 11.68 16.9 11.29 16.53L8.29 13.63C7.9 13.26 7.9 12.65 8.29 12.28L8.36 12.22C8.75 11.91 9.34 11.93 9.71 12.28L11 13.54 11 1C11 0.45 11.45 0 12 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, a9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 9L20 9C20.55 9 21 9.45 21 10 21 10.55 20.55 11 20 11L4 11C3.45 11 3 10.55 3 10 3 9.45 3.45 9 4 9ZM4 13L20 13C20.55 13 21 13.45 21 14 21 14.55 20.55 15 20 15L4 15C3.45 15 3 14.55 3 14 3 13.45 3.45 13 4 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, s9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM6 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L6 22 6 2ZM21 2L8 2 8 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM16 18C16.55 18 17 18.45 17 19 17 19.55 16.55 20 16 20L11 20C10.45 20 10 19.55 10 19 10 18.45 10.45 18 11 18L16 18ZM16 14C16.55 14 17 14.45 17 15 17 15.55 16.55 16 16 16L11 16C10.45 16 10 15.55 10 15 10 14.45 10.45 14 11 14L16 14ZM16 10C16.55 10 17 10.45 17 11 17 11.55 16.55 12 16 12L11 12C10.45 12 10 11.55 10 11 10 10.45 10.45 10 11 10L16 10Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, c9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M10 0C10.55 0 11 0.45 11 1 11 1.51 10.61 1.94 10.12 1.99L10 2 3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 14C22 13.45 22.45 13 23 13 23.51 13 23.94 13.39 23.99 13.88L24 14 24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L10 0ZM20.81 1.11C21.89 1.4 22.73 2.24 23.01 3.31 23.3 4.39 23 5.54 22.21 6.33L12.71 15.83C12.58 15.96 12.42 16.05 12.24 16.09L8.24 17.09C7.51 17.27 6.85 16.61 7.03 15.88L8.03 11.88C8.07 11.7 8.16 11.54 8.29 11.41L17.79 1.91C18.58 1.13 19.73 0.82 20.81 1.11ZM19.21 3.33L9.9 12.63 9.37 14.75 11.49 14.22 20.79 4.91C21.04 4.66 21.16 4.31 21.11 3.96L21.08 3.83C20.98 3.44 20.68 3.14 20.29 3.04 19.9 2.93 19.49 3.05 19.21 3.33Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, r9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 1C17.55 1 18 1.45 18 2L18 4 19 4C20.1 4 21 4.9 21 6L21 16.53 21 16.69C20.9 19.65 18.47 22 15.5 22L8.47 22 8.31 22C5.35 21.9 3 19.47 3 16.5L3 6C3 4.9 3.9 4 5 4L6 4 6 2C6 1.45 6.45 1 7 1 7.55 1 8 1.45 8 2L8 4 16 4 16 2C16 1.45 16.45 1 17 1ZM19 6L5 6 5 16.5C5 18.39 6.5 19.93 8.38 20L8.5 20 15.5 20C17.39 20 18.93 18.5 19 16.62L19 16.5 19 6ZM12.38 8.08C12.89 8.29 13.14 8.87 12.92 9.38L11.83 12 15.17 12 12.92 17.38C12.71 17.89 12.13 18.14 11.62 17.92 11.11 17.71 10.86 17.13 11.08 16.62L12.17 14 8.83 14 11.08 8.62C11.29 8.11 11.87 7.86 12.38 8.08Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, m9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 4C19.76 4 20.45 4.43 20.79 5.11L23.79 9.11C23.93 9.38 24 9.69 24 10L24 18C24 19.1 23.1 20 22 20L2 20C0.9 20 0 19.1 0 18L0 10C0 9.69 0.07 9.38 0.21 9.11L3.21 5.11C3.55 4.43 4.24 4 5 4L19 4ZM22 12L16 12C15.52 13.84 14.02 15 12.04 15 10.05 15 8.49 13.84 8 12L2 12 2 18 22 18 22 12ZM19 6L5 6 2 10 8.6 10.01C9.09 10.01 9.49 10.39 9.49 10.87 9.49 12.22 10.61 13.28 12.04 13.28 13.46 13.28 14.58 12.22 14.58 10.87 14.58 10.39 14.98 10.01 15.47 10.01L22 10 19 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, l9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5ZM12 15.5C11.17 15.5 10.5 16.17 10.5 17 10.5 17.83 11.17 18.5 12 18.5 12.83 18.5 13.5 17.83 13.5 17 13.5 16.17 12.83 15.5 12 15.5ZM12 6C11.47 6 11.04 6.41 11 6.93L11 7 11 13C11 13.55 11.45 14 12 14 12.53 14 12.96 13.59 13 13.07L13 13 13 7C13 6.45 12.55 6 12 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, J1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 16C12.83 16 13.5 16.67 13.5 17.5 13.5 18.33 12.83 19 12 19 11.17 19 10.5 18.33 10.5 17.5 10.5 16.67 11.17 16 12 16ZM12 5C12.55 5 13 5.5 13 6.13L13 12.88C13 13.5 12.55 14 12 14 11.45 14 11 13.5 11 12.88L11 6.13C11 5.5 11.45 5 12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, d9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.97 2.29C13.21 2.44 13.41 2.65 13.56 2.89L13.62 2.99 22.73 18.9C23.27 19.87 22.98 21.13 22.08 21.71 21.82 21.88 21.52 21.98 21.22 22L21.11 22 2.89 22C1.85 22 1 21.08 1 19.95 1 19.63 1.07 19.31 1.21 19.02L1.27 18.9 10.38 2.99C10.91 2.02 12.08 1.71 12.97 2.29ZM12 16C11.17 16 10.5 16.67 10.5 17.5 10.5 18.33 11.17 19 12 19 12.83 19 13.5 18.33 13.5 17.5 13.5 16.67 12.83 16 12 16ZM12 7C11.45 7 11 7.45 11 8L11 14C11 14.55 11.45 15 12 15 12.55 15 13 14.55 13 14L13 8C13 7.45 12.55 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, t1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.36 0.34C13.7 0.57 13.98 0.88 14.17 1.21L23.67 18.13 23.74 18.25 23.77 18.31 23.81 18.42C24.26 19.53 23.89 20.84 22.86 21.52 22.46 21.79 21.99 21.93 21.51 21.93L2.49 21.93 2.37 21.93 2.18 21.91C0.9 21.75 0 20.64 0 19.38 0 18.95 0.11 18.53 0.33 18.13L9.88 1.14 9.97 0.99 10.07 0.86 10.15 0.77C10.95-0.15 12.31-0.35 13.36 0.34ZM11.65 2.09L11.61 2.14 11.58 2.19 2.07 19.11C2.02 19.19 2 19.29 2 19.38 2 19.66 2.19 19.89 2.44 19.93L2.49 19.93 21.51 19.93C21.6 19.93 21.68 19.9 21.76 19.85 21.98 19.71 22.06 19.41 21.96 19.17L21.93 19.11 12.42 2.19C12.38 2.12 12.32 2.05 12.25 2.01 12.05 1.87 11.8 1.92 11.65 2.09ZM12 15C12.83 15 13.5 15.67 13.5 16.5 13.5 17.33 12.83 18 12 18 11.17 18 10.5 17.33 10.5 16.5 10.5 15.67 11.17 15 12 15ZM12 7C12.55 7 13 7.39 13 7.88L13 13.13C13 13.61 12.55 14 12 14 11.45 14 11 13.61 11 13.13L11 7.88C11 7.39 11.45 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, M9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 4C14.55 4 15 4.45 15 5 15 5.55 14.55 6 14 6L3 6C2.45 6 2 6.45 2 7L2 21C2 21.55 2.45 22 3 22L17 22C17.55 22 18 21.55 18 21L18 11C18 10.45 18.45 10 19 10 19.55 10 20 10.45 20 11L20 21C20 22.66 18.66 24 17 24L3 24C1.34 24 0 22.66 0 21L0 7C0 5.34 1.34 4 3 4L14 4ZM23 0C23.55 0 24 0.45 24 1L24 6C24 6.55 23.55 7 23 7 22.45 7 22 6.55 22 6L22 3.71 8.96 16.79C8.56 17.19 7.93 17.19 7.54 16.8 7.15 16.41 7.15 15.77 7.54 15.38L20.96 2 18 2C17.45 2 17 1.55 17 1 17 0.45 17.45 0 18 0L23 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Z9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.19 0.93L20.26 1 20.34 1.09C20.79 1.65 21.01 2.32 20.99 3L21.02 3C21.73 2.99 22.44 3.24 23 3.74L23.14 3.87 23.21 3.94 23.27 4.02 23.34 4.09C24.24 5.2 24.22 6.79 23.24 7.94L23.12 8.07 19.25 11.93 23.2 15.88 23.27 15.95 23.34 16.04C24.3 17.22 24.2 18.93 23.12 20 22.53 20.58 21.76 20.87 20.99 20.86L20.86 20.85 20.86 21.02C20.87 21.73 20.61 22.44 20.11 23L19.98 23.14C18.9 24.21 17.19 24.29 16.01 23.32L15.93 23.24 15.8 23.12 11.93 19.25 8.05 23.13 7.98 23.2 7.84 23.33C6.65 24.3 4.92 24.21 3.85 23.11 3.31 22.57 3.03 21.86 3.01 21.14L3.01 21 2.97 21C2.26 21 1.55 20.75 0.99 20.25L0.85 20.11C-0.22 19.02-0.29 17.3 0.76 16.06L0.88 15.93 4.74 12.07 0.87 8.19 0.79 8.11 0.73 8.04 0.66 7.96C-0.3 6.77-0.2 5.05 0.89 3.98 1.48 3.41 2.26 3.12 3.03 3.14L3.14 3.15 3.14 2.97C3.14 2.25 3.39 1.54 3.89 0.98L4.03 0.85C5.12-0.22 6.84-0.29 8.08 0.76L8.2 0.88 12.07 4.75 16.02 0.8 16.09 0.73 16.17 0.66C17.35-0.29 19.06-0.21 20.19 0.93ZM21.72 5.28C21.37 4.93 20.82 4.9 20.43 5.22L20.36 5.28 5.29 20.35 5.23 20.42C4.91 20.8 4.93 21.36 5.28 21.71 5.62 22.07 6.18 22.1 6.57 21.78L6.64 21.72 11.93 16.43 17.21 21.7 17.29 21.78C17.67 22.09 18.23 22.07 18.58 21.72 18.93 21.37 18.96 20.82 18.65 20.43L18.58 20.36 13.29 15.07 15.07 13.29 20.35 18.57 20.43 18.64C20.81 18.95 21.36 18.93 21.71 18.58 22.07 18.24 22.1 17.68 21.79 17.3L21.72 17.22 16.43 11.93 21.71 6.65 21.77 6.58C22.07 6.23 22.08 5.71 21.79 5.36L21.72 5.28ZM6.72 2.23C6.34 1.91 5.78 1.93 5.43 2.27 5.07 2.62 5.04 3.18 5.35 3.56L5.42 3.64 10.71 8.93 8.93 10.71 3.65 5.43 3.58 5.36C3.2 5.05 2.64 5.07 2.29 5.41 1.93 5.76 1.9 6.32 2.21 6.7L2.28 6.78 7.57 12.07 2.29 17.35 2.23 17.42C1.91 17.8 1.93 18.36 2.28 18.71 2.62 19.07 3.18 19.1 3.57 18.78L3.64 18.72 18.71 3.65 18.77 3.58C19.07 3.23 19.08 2.71 18.79 2.35L18.72 2.28C18.37 1.93 17.82 1.9 17.43 2.22L17.36 2.28 12.07 7.57 6.79 2.29 6.72 2.23Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, u9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.01 16L13.01 13.97C15.28 13.83 17.18 13.2 18.68 12.08L20.31 13.71C20.7 14.09 21.32 14.08 21.71 13.69 22.09 13.31 22.1 12.69 21.72 12.29L20.13 10.7C20.91 9.77 21.52 8.64 21.96 7.32 22.07 6.98 22 6.6 21.76 6.34 21.52 6.07 21.16 5.95 20.81 6.02 20.46 6.09 20.18 6.35 20.06 6.68 18.87 10.26 16.26 12 12.01 12 7.76 12 5.15 10.26 3.96 6.68 3.79 6.16 3.22 5.88 2.7 6.05 2.17 6.23 1.89 6.79 2.06 7.32 2.5 8.64 3.12 9.77 3.9 10.7L2.31 12.29C2.05 12.54 1.94 12.92 2.03 13.27 2.12 13.62 2.4 13.89 2.75 13.98 3.1 14.07 3.47 13.97 3.72 13.71L5.35 12.08C6.85 13.2 8.74 13.83 11.01 13.97L11.01 16C11.01 16.55 11.46 17 12.01 17 12.56 17 13.01 16.55 13.01 16Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, f9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.73 1.27C23.12 1.66 23.12 2.3 22.73 2.69L2.93 22.49C2.54 22.88 1.91 22.88 1.51 22.49 1.12 22.09 1.12 21.46 1.51 21.07L5.02 17.56C4.37 17.08 3.75 16.53 3.15 15.92 2.28 15.05 1.53 14.12 0.89 13.19 0.51 12.63 0.25 12.19 0.11 11.92-0.04 11.66-0.04 11.34 0.11 11.08L0.22 10.87 0.37 10.62C0.5 10.39 0.68 10.12 0.89 9.81 1.53 8.88 2.28 7.95 3.15 7.08 5.66 4.54 8.62 3 12 3 14.13 3 16.09 3.61 17.88 4.7L21.31 1.27C21.7 0.88 22.34 0.88 22.73 1.27ZM20.85 7.08C21.72 7.95 22.47 8.88 23.11 9.81 23.49 10.37 23.75 10.81 23.89 11.08 24.04 11.34 24.04 11.66 23.89 11.92L23.78 12.13 23.63 12.38C23.5 12.61 23.32 12.88 23.11 13.19 22.47 14.12 21.72 15.05 20.85 15.92 18.34 18.46 15.38 20 12 20 10.64 20 9.35 19.75 8.13 19.29L9.63 17.78C10.4 18 11.19 18.11 12 18.11 14.75 18.11 17.22 16.82 19.4 14.63 20.17 13.85 20.85 13.01 21.43 12.17 21.53 12.02 21.62 11.88 21.71 11.75L21.86 11.5 21.83 11.45C21.75 11.32 21.66 11.19 21.57 11.05L21.43 10.83C20.85 9.99 20.17 9.15 19.4 8.37L19.22 8.2 20.59 6.82 20.85 7.08ZM12 4.89C9.25 4.89 6.78 6.18 4.6 8.37 3.83 9.15 3.15 9.99 2.57 10.83 2.47 10.98 2.38 11.12 2.29 11.25L2.14 11.5 2.17 11.55C2.25 11.68 2.34 11.81 2.43 11.95L2.57 12.17C3.15 13.01 3.83 13.85 4.6 14.63 5.18 15.21 5.78 15.73 6.4 16.18L8.18 14.4C7.44 13.62 7 12.61 7 11.5 7 9.01 9.24 7 12 7 13.04 7 14.01 7.29 14.81 7.78L16.48 6.1C15.08 5.32 13.59 4.89 12 4.89ZM12 8.8C10.34 8.8 9 10.01 9 11.5 9 12.07 9.2 12.61 9.54 13.04L13.45 9.14C13.02 8.92 12.53 8.8 12 8.8Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, p9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.01 2C12.56 2 13.01 2.45 13.01 3L13.01 5.05C14.87 5.22 16.58 5.86 18.17 6.88L20.31 5.29C20.56 5.03 20.93 4.93 21.28 5.02 21.63 5.11 21.9 5.38 21.99 5.73 22.08 6.08 21.98 6.46 21.72 6.71L19.93 8.21C20.25 8.48 20.55 8.77 20.85 9.08 21.72 9.95 22.47 10.88 23.11 11.81 23.49 12.37 23.75 12.81 23.89 13.08 24.04 13.34 24.04 13.66 23.89 13.92L23.78 14.13C23.63 14.39 23.4 14.76 23.11 15.19 22.47 16.12 21.72 17.05 20.85 17.92 18.34 20.46 15.38 22 12 22 8.62 22 5.66 20.46 3.15 17.92 2.28 17.05 1.53 16.12 0.89 15.19 0.51 14.63 0.25 14.19 0.11 13.92-0.04 13.66-0.04 13.34 0.11 13.08L0.22 12.87C0.37 12.61 0.6 12.24 0.89 11.81 1.53 10.88 2.28 9.95 3.15 9.08 3.45 8.77 3.75 8.48 4.07 8.21L2.31 6.71C1.93 6.31 1.93 5.69 2.32 5.31 2.7 4.92 3.33 4.91 3.72 5.29L5.83 6.88C7.42 5.86 9.15 5.21 11.01 5.04L11.01 3C11.01 2.45 11.46 2 12.01 2ZM12 6.89C9.25 6.89 6.78 8.18 4.6 10.37 3.83 11.15 3.15 11.99 2.57 12.83 2.47 12.98 2.38 13.12 2.29 13.25L2.14 13.5 2.17 13.55C2.25 13.68 2.34 13.81 2.43 13.95L2.57 14.17C3.15 15.01 3.83 15.85 4.6 16.63 6.78 18.82 9.25 20.11 12 20.11 14.75 20.11 17.22 18.82 19.4 16.63 20.17 15.85 20.85 15.01 21.43 14.17 21.53 14.02 21.62 13.88 21.71 13.75L21.86 13.5 21.83 13.45C21.75 13.32 21.66 13.19 21.57 13.05L21.43 12.83C20.85 11.99 20.17 11.15 19.4 10.37 17.22 8.18 14.75 6.89 12 6.89ZM12 9C14.76 9 17 11.01 17 13.5 17 15.99 14.76 18 12 18 9.24 18 7 15.99 7 13.5 7 11.01 9.24 9 12 9ZM12 10.8C10.34 10.8 9 12.01 9 13.5 9 14.99 10.34 16.2 12 16.2 13.66 16.2 15 14.99 15 13.5 15 12.01 13.66 10.8 12 10.8Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, x9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.01 4C14.87 4.17 16.58 4.82 18.17 5.83L19.93 7.17C20.25 7.44 20.55 7.73 20.85 8.03 21.72 8.9 22.47 9.83 23.11 10.76 23.49 11.32 23.75 11.77 23.89 12.03 24.04 12.3 24.04 12.61 23.89 12.88L23.78 13.08C23.63 13.35 23.4 13.71 23.11 14.15 22.47 15.08 21.72 16.01 20.85 16.88 18.34 19.41 15.38 20.96 12 20.96 8.62 20.96 5.66 19.41 3.15 16.88 2.28 16.01 1.53 15.08 0.89 14.15 0.51 13.59 0.25 13.14 0.11 12.88-0.04 12.61-0.04 12.3 0.11 12.03L0.22 11.83C0.37 11.56 0.6 11.2 0.89 10.76 1.53 9.83 2.28 8.9 3.15 8.03 3.45 7.73 3.75 7.44 4.07 7.16L5.83 5.83C7.42 4.81 9.15 4.17 11.01 4L13.01 4ZM12 5.84C9.25 5.84 6.78 7.14 4.6 9.32 3.83 10.11 3.15 10.95 2.57 11.79 2.47 11.93 2.38 12.08 2.29 12.21L2.14 12.46 2.17 12.5C2.25 12.63 2.34 12.77 2.43 12.91L2.57 13.12C3.15 13.96 3.83 14.81 4.6 15.59 6.78 17.78 9.25 19.07 12 19.07 14.75 19.07 17.22 17.78 19.4 15.59 20.17 14.81 20.85 13.96 21.43 13.12 21.53 12.98 21.62 12.84 21.71 12.7L21.86 12.46 21.83 12.41C21.75 12.28 21.66 12.14 21.57 12L21.43 11.79C20.85 10.95 20.17 10.11 19.4 9.32 17.22 7.14 14.75 5.84 12 5.84ZM12 7.96C14.76 7.96 17 9.97 17 12.46 17 14.94 14.76 16.96 12 16.96 9.24 16.96 7 14.94 7 12.46 7 9.97 9.24 7.96 12 7.96ZM12 9.76C10.34 9.76 9 10.96 9 12.46 9 13.95 10.34 15.16 12 15.16 13.66 15.16 15 13.95 15 12.46 15 10.96 13.66 9.76 12 9.76Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, h9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.12 1.77C11.38 1.22 12.03 0.98 12.58 1.24 12.81 1.35 13 1.53 13.11 1.77L15.92 7.75 22.18 8.7C22.74 8.79 23.14 9.28 23.12 9.84L23.11 9.96C23.07 10.19 22.97 10.4 22.8 10.56L18.24 15.24 19.32 21.86C19.41 22.42 19.06 22.95 18.53 23.09L18.41 23.12C18.16 23.16 17.92 23.12 17.7 23L12.11 19.91 6.53 23C6.03 23.27 5.42 23.12 5.1 22.67L5.04 22.57C4.92 22.35 4.87 22.1 4.91 21.86L5.99 15.24 1.42 10.56C1.03 10.16 1.01 9.53 1.36 9.1L1.44 9C1.61 8.84 1.82 8.74 2.05 8.7L8.31 7.75 11.12 1.77ZM12.11 4.35L9.92 9.03C9.76 9.36 9.45 9.6 9.09 9.65L4.08 10.42 7.74 14.17C7.95 14.39 8.06 14.68 8.05 14.99L8.04 15.11 7.18 20.35 11.58 17.92C11.87 17.76 12.22 17.74 12.52 17.86L12.65 17.92 17.04 20.35 16.19 15.11C16.14 14.81 16.22 14.51 16.4 14.27L16.49 14.17 20.15 10.42 15.14 9.65C14.82 9.6 14.55 9.42 14.38 9.15L14.31 9.03 12.11 4.35Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, _9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 0C2.9 0 2 0.9 2 2L2 13C2 13.55 2.45 14 3 14 3.55 14 4 13.55 4 13L4 2 15 2 15 6C15 6.51 15.39 6.94 15.88 6.99L16 7 20 7 20 13C20 13.55 20.45 14 21 14 21.55 14 22 13.55 22 13L22 4.59 17.41 0 4 0ZM17 2.63L19.37 5 17 5 17 2.63ZM11.91 16C12.73 16.01 13.52 16.31 14.15 16.84 14.57 17.19 14.62 17.82 14.26 18.25 13.93 18.64 13.37 18.71 12.96 18.44L12.85 18.36C12.58 18.13 12.24 18 11.89 18 11.5 18 11.32 18.14 11.29 18.46L11.29 18.56C11.29 18.61 11.28 18.61 11.31 18.63L11.35 18.65C11.46 18.73 11.62 18.79 11.92 18.89L12.28 19C13.95 19.49 14.71 20.01 14.71 21.44 14.71 23.15 13.53 24 11.88 24 11.06 23.99 10.27 23.69 9.64 23.16 9.22 22.81 9.17 22.18 9.52 21.75 9.85 21.37 10.41 21.29 10.83 21.56L10.93 21.64C11.2 21.87 11.55 22 11.89 22 12.54 22 12.71 21.87 12.71 21.44 12.71 21.28 12.61 21.2 12.02 21.01L11.66 20.9C10 20.41 9.29 19.94 9.29 18.56 9.29 17.05 10.38 16 11.91 16ZM20.93 16.63C21.13 16.12 21.71 15.87 22.22 16.07 22.74 16.27 22.99 16.85 22.79 17.37L20.43 23.37C20.1 24.21 18.9 24.21 18.57 23.37L16.21 17.37C16.01 16.85 16.26 16.27 16.78 16.07 17.29 15.87 17.87 16.12 18.07 16.63L19.5 20.27 20.93 16.63ZM4.93 16C5.67 16 6.4 16.23 7 16.65 7.46 16.97 7.56 17.59 7.25 18.05 6.95 18.46 6.4 18.59 5.96 18.36L5.85 18.29C5.58 18.1 5.26 18 4.93 18 3.96 18 3.14 18.88 3.14 20 3.14 21.12 3.96 22 4.93 22 5.21 22 5.48 21.93 5.71 21.8L5.85 21.71C6.31 21.39 6.93 21.5 7.25 21.95 7.56 22.41 7.46 23.03 7 23.35 6.4 23.77 5.67 24 4.93 24 2.82 24 1.14 22.2 1.14 20 1.14 17.8 2.82 16 4.93 16Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, N9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 0C21.1 0 22 0.9 22 2L22 22C22 23.1 21.1 24 20 24L4 24 3.85 23.99C2.82 23.92 2 23.05 2 22L2 4.59 6.58 0 20 0ZM20 2L9 2 9 7 4 7 4 22 20 22 20 2ZM12 18C12.55 18 13 18.45 13 19 13 19.55 12.55 20 12 20L7 20C6.45 20 6 19.55 6 19 6 18.45 6.45 18 7 18L12 18ZM7 2.63L4.63 5 7 5 7 2.63Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, z9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.78 16C5.55 16 7 17.4 7 19.14 7 20.89 5.55 22.29 3.78 22.29L3 22.29 3 23C3 23.51 2.61 23.94 2.12 23.99L2 24C1.45 24 1 23.55 1 23L1 17C1 16.45 1.45 16 2 16L3.78 16ZM3 20.29L3.78 20.29C4.46 20.29 5 19.77 5 19.14 5 18.52 4.46 18 3.78 18L3 18 3 20.29ZM11.82 16C14.12 16 16 17.78 16 20 16 22.22 14.12 24 11.82 24L10 24C9.45 24 9 23.55 9 23L9 17C9 16.45 9.45 16 10 16L11.82 16ZM11 22L11.82 22C13.04 22 14 21.09 14 20 14 18.91 13.04 18 11.82 18L11 18 11 22ZM22 16C22.55 16 23 16.45 23 17 23 17.55 22.55 18 22 18L20 18 20 23C20 23.51 19.61 23.94 19.12 23.99L19 24C18.45 24 18 23.55 18 23L18 17C18 16.45 18.45 16 19 16L22 16ZM4 0C2.9 0 2 0.9 2 2L2 13C2 13.55 2.45 14 3 14 3.55 14 4 13.55 4 13L4 2 15 2 15 6C15 6.51 15.39 6.94 15.88 6.99L16 7 20 7 20 13C20 13.55 20.45 14 21 14 21.55 14 22 13.55 22 13L22 4.59 17.41 0 4 0ZM17 2.63L19.37 5 17 5 17 2.63Z M21 19C21.55 19 22 19.45 22 20 22 20.55 21.55 21 21 21L19 21C18.45 21 18 20.55 18 20 18 19.45 18.45 19 19 19L21 19Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, g9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 0C21.1 0 22 0.9 22 2L22 22C22 23.1 21.1 24 20 24L4 24 3.85 23.99C2.82 23.92 2 23.05 2 22L2 4.59 6.58 0 20 0ZM20 2L9 2 9 7 4 7 4 22 20 22 20 2ZM14.5 13C16.43 13 18 14.57 18 16.5 18 18.43 16.43 20 14.5 20 12.57 20 11 18.43 11 16.5 11 14.57 12.57 13 14.5 13ZM14.5 15C13.67 15 13 15.67 13 16.5 13 17.33 13.67 18 14.5 18 15.33 18 16 17.33 16 16.5 16 15.67 15.33 15 14.5 15ZM7 2.63L4.63 5 7 5 7 2.63Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, b9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 0C2.9 0 2 0.9 2 2L2 13C2 13.55 2.45 14 3 14 3.55 14 4 13.55 4 13L4 2 15 2 15 6C15 6.51 15.39 6.94 15.88 6.99L16 7 20 7 20 13C20 13.55 20.45 14 21 14 21.55 14 22 13.55 22 13L22 4.59 17.41 0 4 0ZM17 2.63L19.37 5 17 5 17 2.63ZM11 16C11.55 16 12 16.45 12 17L12 22 15 22C15.51 22 15.94 22.39 15.99 22.88L16 23C16 23.55 15.55 24 15 24L11 24C10.45 24 10 23.55 10 23L10 17C10 16.45 10.45 16 11 16ZM19.19 16C20.01 16.01 20.8 16.31 21.43 16.84 21.85 17.19 21.91 17.82 21.55 18.25 21.22 18.63 20.66 18.71 20.24 18.44L20.14 18.36C19.87 18.13 19.52 18 19.18 18 18.79 18 18.61 18.14 18.58 18.46L18.57 18.56C18.57 18.62 18.56 18.61 18.63 18.65 18.75 18.73 18.9 18.79 19.21 18.89L19.57 19C21.24 19.49 22 20.01 22 21.44 22 23.15 20.81 24 19.17 24 18.34 23.99 17.55 23.69 16.93 23.16 16.5 22.81 16.45 22.18 16.81 21.75 17.14 21.37 17.7 21.29 18.12 21.56L18.22 21.64C18.49 21.87 18.83 22 19.18 22 19.78 22 19.97 21.89 20 21.52L20 21.44C20 21.28 19.9 21.2 19.31 21.01L18.95 20.9C17.29 20.41 16.57 19.94 16.57 18.56 16.57 17.05 17.66 16 19.19 16ZM7.87 16.19C8.32 16.51 8.42 17.13 8.1 17.58L6.37 20 8.1 22.42C8.42 22.87 8.32 23.49 7.87 23.81 7.42 24.13 6.79 24.03 6.47 23.58L5.14 21.72 3.81 23.58C3.49 24.03 2.87 24.13 2.42 23.81 1.97 23.49 1.87 22.87 2.19 22.42L3.91 20 2.19 17.58C1.87 17.13 1.97 16.51 2.42 16.19 2.87 15.87 3.49 15.97 3.81 16.42L5.14 18.28 6.47 16.42C6.79 15.97 7.42 15.87 7.87 16.19Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, y9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 0C21.1 0 22 0.9 22 2L22 22C22 23.1 21.1 24 20 24L4 24 3.85 23.99C2.82 23.92 2 23.05 2 22L2 4.59 6.58 0 20 0ZM20 2L9 2 9 7 4 7 4 22 20 22 20 2ZM16 14C16.55 14 17 14.45 17 15L17 19C17 19.55 16.55 20 16 20L8 20 7.88 19.99C7.39 19.94 7 19.51 7 19L7 15 7.01 14.88C7.06 14.39 7.49 14 8 14L16 14ZM11 16L9 16 9 18 11 18 11 16ZM15 16L13 16 13 18 15 18 15 16ZM7 2.63L4.63 5 7 5 7 2.63Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, w9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 0L16 11 16 23 9 18 9 11 1 0 23 0ZM19 2L5 2 11 10 11 17 14 19 14 10 19 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, S9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C12.51 2 12.94 2.39 12.99 2.88L13 3 13 7C13 9.42 11.28 11.44 9 11.9L9 12 9 21C9 21.55 8.55 22 8 22 7.45 22 7 21.55 7 21L7 12 7 11.9C4.72 11.44 3 9.42 3 7L3 3C3 2.45 3.45 2 4 2 4.51 2 4.94 2.39 4.99 2.88L5 3 5 7C5 8.66 6.34 10 8 10 9.66 10 11 8.66 11 7L11 3C11 2.45 11.45 2 12 2ZM8 2C8.55 2 9 2.45 9 3L9 7C9 7.55 8.55 8 8 8 7.45 8 7 7.55 7 7L7 3C7 2.45 7.45 2 8 2ZM21 21C21 21.55 20.55 22 20 22 19.45 22 19 21.55 19 21L19 13C16.79 13 15 11.21 15 9L15 6C15 3.79 16.79 2 19 2L21 2 21 21ZM19 4L18.85 4.01C17.82 4.08 17 4.95 17 6L17 9C17 10.1 17.9 11 19 11L19 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, B9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 5L18 5C18.55 5 19 5.45 19 6 19 6.55 18.55 7 18 7L3 7C2.45 7 2 6.55 2 6 2 5.45 2.45 5 3 5ZM3 11L21 11C21.55 11 22 11.45 22 12 22 12.55 21.55 13 21 13L3 13C2.45 13 2 12.55 2 12 2 11.45 2.45 11 3 11ZM3 17L13 17C13.55 17 14 17.45 14 18 14 18.55 13.55 19 13 19L3 19C2.45 19 2 18.55 2 18 2 17.45 2.45 17 3 17Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, v9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 2C16 3.1 15.11 4 14 4 12.9 4 12 3.1 12 2 12 0.9 12.9 0 14 0 15.11 0 16 0.9 16 2ZM12 5C12.29 5 12.57 5.12 12.76 5.34 12.95 5.56 13.03 5.85 13 6.13L12.97 6.24 11.29 14 18.01 14C18.39 14 18.75 14.22 18.91 14.58L18.95 14.68 20.95 20.68C21.12 21.19 20.87 21.73 20.37 21.93 19.88 22.12 19.33 21.9 19.1 21.42L19.06 21.32 17.28 16 10 16C9.72 16 9.44 15.88 9.25 15.66 9.06 15.44 8.98 15.15 9.01 14.87L9.03 14.76 10.72 7 9.67 7C9.5 7 9.33 7.04 9.18 7.13L9.07 7.2 5.6 9.8C5.18 10.12 4.58 10.06 4.24 9.65 3.9 9.25 3.93 8.65 4.31 8.28L4.4 8.2 7.87 5.6C8.33 5.25 8.88 5.05 9.46 5.01L9.67 5 12 5ZM6.87 11.66C6.62 11.58 6.34 11.61 6.11 11.74 3.86 12.98 2.65 15.52 3.1 18.06 3.55 20.59 5.57 22.55 8.11 22.93 10.66 23.31 13.16 22.03 14.34 19.75 14.52 19.43 14.5 19.04 14.31 18.73 14.12 18.42 13.77 18.24 13.41 18.26 13.04 18.29 12.72 18.5 12.56 18.83 11.78 20.35 10.11 21.21 8.41 20.95 6.72 20.7 5.37 19.39 5.07 17.7 4.77 16.02 5.57 14.32 7.08 13.49 7.31 13.37 7.48 13.15 7.56 12.9 7.63 12.64 7.6 12.37 7.47 12.13 7.34 11.9 7.13 11.73 6.87 11.66Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, k9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.2 15C20.47 15.48 20.31 16.09 19.83 16.37L14 19.73 17.29 21.63C17.77 21.91 17.94 22.52 17.66 23 17.38 23.48 16.77 23.64 16.29 23.37L12 20.89 7.71 23.37C7.23 23.64 6.62 23.48 6.34 23 6.06 22.52 6.23 21.91 6.71 21.63L10 19.73 4.17 16.37C3.69 16.09 3.53 15.48 3.8 15 4.08 14.52 4.69 14.36 5.17 14.63L12 18.58 18.83 14.63C19.31 14.36 19.92 14.52 20.2 15ZM12 0C15.87 0 19 3.09 19 6.9 19 8.92 18.11 10.81 16.57 12.12L16.5 12.18 16.5 13C16.5 14.6 15.25 15.9 13.68 15.99L13.5 16 11 16C9.34 16 8 14.66 8 13L8 12.56 7.96 12.53C6.18 11.29 5.09 9.32 5.01 7.17L5 6.9C5 3.09 8.13 0 12 0ZM12 2C9.21 2 7 4.22 7 6.9 7 8.56 7.85 10.09 9.26 11L9.54 11.18C9.83 11.36 10 11.68 10 12.02L10 13C10 13.51 10.39 13.94 10.88 13.99L11 14 13.5 14C14.05 14 14.5 13.55 14.5 13L14.5 11.7C14.5 11.39 14.64 11.1 14.88 10.91L15.12 10.73C16.31 9.79 17 8.4 17 6.9 17 4.22 14.79 2 12 2ZM10 6C10.55 6 11 6.45 11 7 11 7.55 10.55 8 10 8 9.45 8 9 7.55 9 7 9 6.45 9.45 6 10 6ZM14 6C14.55 6 15 6.45 15 7 15 7.55 14.55 8 14 8 13.45 8 13 7.55 13 7 13 6.45 13.45 6 14 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, $9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C14.87 0 17.5 1.01 19.56 2.68L19.61 2.64 21.02 4.05 21 4.07C22.87 6.18 24 8.96 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM8.33 16.74L5.48 19.59C7.23 21.09 9.51 22 12 22 14.4 22 16.61 21.15 18.33 19.74L15.48 16.89C14.5 17.59 13.3 18 12 18 10.62 18 9.34 17.53 8.33 16.74ZM19.59 5.49L16.74 8.33C17.53 9.34 18 10.62 18 12 18 13.3 17.59 14.5 16.89 15.48L19.74 18.33C21.15 16.61 22 14.4 22 12 22 9.51 21.09 7.24 19.59 5.49ZM2 12C2 14.31 2.79 16.44 4.1 18.14L6.97 15.27C6.36 14.33 6 13.21 6 12 6 10.7 6.41 9.5 7.11 8.52L4.26 5.67C2.85 7.39 2 9.6 2 12ZM12 8C9.79 8 8 9.79 8 12 8 14.21 9.79 16 12 16 14.21 16 16 14.21 16 12 16 9.79 14.21 8 12 8ZM12 2C9.6 2 7.39 2.85 5.67 4.26L8.52 7.11C9.5 6.41 10.7 6 12 6 13.21 6 14.33 6.36 15.27 6.97L18.14 4.1C16.44 2.79 14.31 2 12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, A9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1.61C23.74 4.92 25.71 12.26 22.39 18 19.08 23.74 11.74 25.71 6 22.39 5.52 22.12 5.36 21.5 5.63 21.03 5.91 20.55 6.52 20.38 7 20.66 11.78 23.42 17.9 21.78 20.66 17 23.42 12.22 21.78 6.1 17 3.34 12.22 0.58 6.1 2.22 3.34 7L5 7C5.55 7 6 7.45 6 8 6 8.55 5.55 9 5 9L1 9C0.45 9 0 8.55 0 8L0 4C0 3.45 0.45 3 1 3 1.55 3 2 3.45 2 4L2 5.37C5.47 0.12 12.48-1.58 18 1.61ZM12 5C12.55 5 13 5.45 13 6L13 13.59 15.71 16.29C16.07 16.65 16.1 17.22 15.79 17.61L15.71 17.71C15.32 18.1 14.68 18.1 14.29 17.71L11.29 14.71C11.11 14.52 11 14.27 11 14L11 6C11 5.45 11.45 5 12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, I9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1C19.66 1 21 2.34 21 4L21 11C22.66 11 24 12.34 24 14L24 24 22 24 22 19 2 19 2 24 0 24 0 14C0 12.34 1.34 11 3 11L3 4C3 2.34 4.34 1 6 1L18 1ZM21 13L3 13C2.45 13 2 13.45 2 14L2 17 22 17 22 14C22 13.45 21.55 13 21 13ZM18 3L6 3C5.45 3 5 3.45 5 4L5 11 7 11 7 10C7 8.34 8.34 7 10 7L12 7C13.66 7 15 8.34 15 10L15 11 19 11 19 4C19 3.45 18.55 3 18 3ZM12 9L10 9C9.45 9 9 9.45 9 10L9 11 13 11 13 10C13 9.45 12.55 9 12 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, H9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M14.91 1.05C14.97 1.18 15 1.32 15 1.46L15 8.6 22.55 13.63C22.83 13.82 23 14.13 23 14.46L23 23C23 23.55 22.55 24 22 24L2 24C1.45 24 1 23.55 1 23L1 6.17 13.59 0.54C14.1 0.32 14.69 0.55 14.91 1.05ZM13 3L3 7.47 3 22 13 22 13 3ZM15 11L15 22 21 22 21 15 15 11ZM10 17C10.55 17 11 17.45 11 18 11 18.55 10.55 19 10 19L6 19C5.45 19 5 18.55 5 18 5 17.45 5.45 17 6 17L10 17ZM10 13C10.55 13 11 13.45 11 14 11 14.55 10.55 15 10 15L6 15C5.45 15 5 14.55 5 14 5 13.45 5.45 13 6 13L10 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, R9 = {
  icon: [
    32,
    24,
    [],
    "",
    "M16 0C22.63 0 28 5.37 28 12 28 18.63 22.63 24 16 24 9.37 24 4 18.63 4 12 4 5.37 9.37 0 16 0ZM16 2C10.48 2 6 6.48 6 12 6 17.52 10.48 22 16 22 21.52 22 26 17.52 26 12 26 6.48 21.52 2 16 2ZM21.75 15.34C22.12 15.75 22.08 16.39 21.66 16.75 18.25 19.75 13.75 19.75 10.34 16.75 9.92 16.39 9.88 15.75 10.25 15.34 10.61 14.92 11.25 14.88 11.66 15.25 14.31 17.58 17.69 17.58 20.34 15.25 20.75 14.88 21.39 14.92 21.75 15.34ZM20.56 8.44C20.99 8.87 21.12 9.52 20.88 10.08 20.65 10.64 20.1 11 19.49 11 18.67 11 18 10.33 18 9.51 18 8.9 18.36 8.35 18.92 8.12 19.48 7.88 20.13 8.01 20.56 8.44ZM13.56 8.44C13.99 8.87 14.12 9.52 13.88 10.08 13.65 10.64 13.1 11 12.49 11 11.67 11 11 10.33 11 9.51 11 8.9 11.36 8.35 11.92 8.12 12.48 7.88 13.13 8.01 13.56 8.44Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, T9 = {
  icon: [
    32,
    24,
    [],
    "",
    "M16 0C22.63 0 28 5.37 28 12 28 18.63 22.63 24 16 24 9.37 24 4 18.63 4 12 4 5.37 9.37 0 16 0ZM16 2C10.48 2 6 6.48 6 12 6 17.52 10.48 22 16 22 21.52 22 26 17.52 26 12 26 6.48 21.52 2 16 2ZM10.34 16.25C13.75 13.25 18.25 13.25 21.66 16.25 22.08 16.61 22.12 17.25 21.75 17.66 21.39 18.08 20.75 18.12 20.34 17.75 17.69 15.42 14.31 15.42 11.66 17.75 11.25 18.12 10.61 18.08 10.25 17.66 9.88 17.25 9.92 16.61 10.34 16.25ZM20.56 8.44C20.99 8.87 21.12 9.52 20.88 10.08 20.65 10.64 20.1 11 19.49 11 18.67 11 18 10.33 18 9.51 18 8.9 18.36 8.35 18.92 8.12 19.48 7.88 20.13 8.01 20.56 8.44ZM13.56 8.44C13.99 8.87 14.12 9.52 13.88 10.08 13.65 10.64 13.1 11 12.49 11 11.67 11 11 10.33 11 9.51 11 8.9 11.36 8.35 11.92 8.12 12.48 7.88 13.13 8.01 13.56 8.44Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, V9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5ZM12 10C11.48 10 11.05 10.3 11 10.69L11 10.75 11 16.25C11 16.66 11.45 17 12 17 12.52 17 12.95 16.7 13 16.31L13 16.25 13 10.75C13 10.34 12.55 10 12 10ZM12 7C11.45 7 11 7.45 11 8 11 8.55 11.45 9 12 9 12.55 9 13 8.55 13 8 13 7.45 12.55 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, f1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 11C12.55 11 13 11.39 13 11.88L13 18.13C13 18.61 12.55 19 12 19 11.45 19 11 18.61 11 18.13L11 11.88C11 11.39 11.45 11 12 11ZM12 5C12.55 5 13 5.39 13 5.88L13 7.13C13 7.61 12.55 8 12 8 11.45 8 11 7.61 11 7.13L11 5.88C11 5.39 11.45 5 12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Y1 = {
  icon: [
    24,
    24,
    [],
    "",
    "M24 0.01L24 22.2 20.54 19.63 19.84 19.11C18.04 17.79 17.43 17.4 16.71 17.09 15.99 16.77 15.23 16.63 13.87 16.59L13.5 16.58 13.5 20.76C13.5 22.49 12.14 23.9 10.43 23.99L10.25 24C8.46 24 7 22.55 7 20.76L7 20.01 6.79 19.99C3.11 19.6 0 16.59 0 13 0 9.3 3.08 6.25 6.87 6L8.89 6 9.33 5.96C14.55 5.4 18.29 4.25 20.53 2.6L24 0.01ZM9 20.76C9 21.45 9.56 22 10.25 22 10.94 22 11.5 21.45 11.5 20.76L11.5 15.31C11.5 14.9 11.84 14.57 12.25 14.57L13.25 14.57 13.28 14.57 13.6 14.58 14.22 14.6C17.28 14.73 18.23 15.44 21.73 18.02L22 18.22 22 4 21.73 4.2C19.06 6.17 14.82 7.44 9 8L9 20.76ZM7 8C4.26 8.18 2 10.36 2 13 2 15.57 4.37 17.72 7 18L7 8Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, D9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 3C21.66 3 23 4.34 23 6L23 17C23 18.66 21.66 20 20 20L5.96 20 2.58 22.38C2.12 22.7 1.5 22.59 1.18 22.14 1.06 21.97 1 21.77 1 21.56L1 6C1 4.34 2.34 3 4 3L20 3ZM20 5L4 5C3.45 5 3 5.45 3 6L3 20 5.42 18 20 18C20.55 18 21 17.55 21 17L21 6C21 5.45 20.55 5 20 5ZM12 13C12.83 13 13.5 13.67 13.5 14.5 13.5 15.33 12.83 16 12 16 11.17 16 10.5 15.33 10.5 14.5 10.5 13.67 11.17 13 12 13ZM12 7C12.55 7 13 7.42 13 7.94L13 11.06C13 11.58 12.55 12 12 12 11.45 12 11 11.58 11 11.06L11 7.94C11 7.42 11.45 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, C2 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 3C21.66 3 23 4.34 23 6L23 17C23 18.66 21.66 20 20 20L5.96 20 2.58 22.38C2.12 22.7 1.5 22.59 1.18 22.14 1.06 21.97 1 21.77 1 21.56L1 6C1 4.34 2.34 3 4 3L20 3ZM20 5L4 5C3.45 5 3 5.45 3 6L3 20 5.42 18 20 18C20.55 18 21 17.55 21 17L21 6C21 5.45 20.55 5 20 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, F9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 16C14.21 16 16 17.79 16 20 16 22.21 14.21 24 12 24 9.79 24 8 22.21 8 20 8 17.79 9.79 16 12 16ZM12 18C10.9 18 10 18.9 10 20 10 21.1 10.9 22 12 22 13.1 22 14 21.1 14 20 14 18.9 13.1 18 12 18ZM12 7C12.55 7 13 7.45 13 8L13 13C13 13.55 12.55 14 12 14 11.45 14 11 13.55 11 13L11 8C11 7.45 11.45 7 12 7ZM4 0C6.21 0 8 1.79 8 4 8 6.21 6.21 8 4 8 1.79 8 0 6.21 0 4 0 1.79 1.79 0 4 0ZM20 0C22.21 0 24 1.79 24 4 24 6.21 22.21 8 20 8 17.79 8 16 6.21 16 4 16 1.79 17.79 0 20 0ZM4 2C2.9 2 2 2.9 2 4 2 5.1 2.9 6 4 6 5.1 6 6 5.1 6 4 6 2.9 5.1 2 4 2ZM20 2C18.9 2 18 2.9 18 4 18 5.1 18.9 6 20 6 21.1 6 22 5.1 22 4 22 2.9 21.1 2 20 2ZM17 3C17.55 3 18 3.45 18 4 18 4.55 17.55 5 17 5L7 5C6.45 5 6 4.55 6 4 6 3.45 6.45 3 7 3L17 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, j9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C12.55 0 13 0.45 13 1L13 5 21 5C22.66 5 24 6.34 24 8L24 17C24 18.66 22.66 20 21 20L3 20C1.34 20 0 18.66 0 17L0 8C0 6.34 1.34 5 3 5L11 5 11 1C11 0.45 11.45 0 12 0ZM21 7L3 7C2.45 7 2 7.45 2 8L2 17C2 17.55 2.45 18 3 18L21 18C21.55 18 22 17.55 22 17L22 8C22 7.45 21.55 7 21 7ZM16.5 14C16.78 14 17 14.22 17 14.5L17 15.5C17 15.78 16.78 16 16.5 16L15.5 16C15.22 16 15 15.78 15 15.5L15 14.5C15 14.22 15.22 14 15.5 14L16.5 14ZM13.5 14C13.78 14 14 14.22 14 14.5L14 15.5C14 15.78 13.78 16 13.5 16L12.5 16C12.22 16 12 15.78 12 15.5L12 14.5C12 14.22 12.22 14 12.5 14L13.5 14ZM19.5 14C19.78 14 20 14.22 20 14.5L20 15.5C20 15.78 19.78 16 19.5 16L18.5 16C18.22 16 18 15.78 18 15.5L18 14.5C18 14.22 18.22 14 18.5 14L19.5 14ZM16.5 11C16.78 11 17 11.22 17 11.5L17 12.5C17 12.78 16.78 13 16.5 13L15.5 13C15.22 13 15 12.78 15 12.5L15 11.5C15 11.22 15.22 11 15.5 11L16.5 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, E9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C19.21 0 21 1.79 21 4L21 20C21 22.21 19.21 24 17 24L7 24C4.79 24 3 22.21 3 20L3 4C3 1.79 4.79 0 7 0L17 0ZM17 2L7 2C5.9 2 5 2.9 5 4L5 20C5 21.1 5.9 22 7 22L17 22C18.1 22 19 21.1 19 20L19 4C19 2.9 18.1 2 17 2ZM12 8C13.66 8 15 9.34 15 11 15 12.31 14.16 13.43 12.99 13.83 13 13.89 13 13.94 13 14L13 15 14 15C14.55 15 15 15.45 15 16 15 16.55 14.55 17 14 17L13 17 13 18 14 18C14.55 18 15 18.45 15 19 15 19.55 14.55 20 14 20L12 20C11.45 20 11 19.55 11 19L11 14C11 13.94 11 13.89 11.01 13.83 9.84 13.43 9 12.31 9 11 9 9.34 10.34 8 12 8ZM12 10C11.45 10 11 10.45 11 11 11 11.55 11.45 12 12 12 12.55 12 13 11.55 13 11 13 10.49 12.61 10.06 12.12 10.01L12 10ZM12.22 4.17C12.32 4.22 12.4 4.3 12.45 4.39L13.14 5.78C13.26 6.02 13.16 6.32 12.91 6.45 12.85 6.48 12.77 6.5 12.69 6.5L11.31 6.5C11.03 6.5 10.81 6.28 10.81 6 10.81 5.92 10.83 5.85 10.86 5.78L11.55 4.39C11.68 4.15 11.98 4.05 12.22 4.17Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, O9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.5 0C19.43 0 21 1.57 21 3.5L21 20.5C21 22.43 19.43 24 17.5 24L6.5 24C4.57 24 3 22.43 3 20.5L3 3.5C3 1.57 4.57 0 6.5 0L17.5 0ZM17.5 2L6.5 2C5.67 2 5 2.67 5 3.5L5 20.5C5 21.33 5.67 22 6.5 22L17.5 22C18.33 22 19 21.33 19 20.5L19 3.5C19 2.67 18.33 2 17.5 2ZM12.01 16C12.56 16 13.01 16.45 13.01 17 13.01 17.51 12.62 17.94 12.13 17.99L12 18C11.45 18 11 17.55 11 17 11 16.49 11.39 16.06 11.88 16.01L12.01 16ZM14.74 13.91C15.11 14.32 15.08 14.95 14.67 15.32 14.27 15.7 13.63 15.67 13.26 15.26 12.55 14.49 11.45 14.49 10.74 15.26 10.37 15.67 9.73 15.7 9.33 15.32 8.92 14.95 8.89 14.32 9.26 13.91 10.76 12.27 13.24 12.27 14.74 13.91ZM12 9.59C13.78 9.59 15.49 10.36 16.74 11.72 17.11 12.13 17.08 12.76 16.67 13.14 16.27 13.51 15.63 13.48 15.26 13.07 14.39 12.12 13.22 11.59 12 11.59 10.78 11.59 9.61 12.12 8.74 13.07 8.37 13.48 7.73 13.51 7.33 13.14 6.92 12.76 6.89 12.13 7.26 11.72 8.51 10.36 10.22 9.59 12 9.59ZM12.22 4.17C12.32 4.22 12.4 4.3 12.45 4.39L13.14 5.78C13.26 6.02 13.16 6.32 12.91 6.45 12.85 6.48 12.77 6.5 12.69 6.5L11.31 6.5C11.03 6.5 10.81 6.28 10.81 6 10.81 5.92 10.83 5.85 10.86 5.78L11.55 4.39C11.68 4.15 11.98 4.05 12.22 4.17Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, P9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C19.21 0 21 1.79 21 4L21 20C21 22.21 19.21 24 17 24L7 24C4.79 24 3 22.21 3 20L3 4C3 1.79 4.79 0 7 0L17 0ZM17 2L7 2C5.9 2 5 2.9 5 4L5 20C5 21.1 5.9 22 7 22L17 22C18.1 22 19 21.1 19 20L19 4C19 2.9 18.1 2 17 2ZM12 6C13.66 6 15 7.34 15 9 15 10.31 14.16 11.43 12.99 11.83 13 11.89 13 11.94 13 12L13 13 14 13C14.55 13 15 13.45 15 14 15 14.55 14.55 15 14 15L13 15 13 16 14 16C14.55 16 15 16.45 15 17 15 17.55 14.55 18 14 18L12 18C11.45 18 11 17.55 11 17L11 12C11 11.94 11 11.89 11.01 11.83 9.84 11.43 9 10.31 9 9 9 7.34 10.34 6 12 6ZM12 8C11.45 8 11 8.45 11 9 11 9.55 11.45 10 12 10 12.55 10 13 9.55 13 9 13 8.49 12.61 8.06 12.12 8.01L12 8Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, U9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM16.98 13L7.02 13C7.28 18.05 9.41 22 12 22 14.59 22 16.72 18.05 16.98 13ZM21.95 13L18.98 13C18.85 15.99 18.12 18.71 16.94 20.7 19.6 19.18 21.5 16.48 21.91 13.32L21.95 13ZM5.02 13L2.05 13C2.38 16.3 4.31 19.13 7.06 20.7 5.94 18.81 5.23 16.27 5.05 13.47L5.02 13ZM7.06 3.3L6.88 3.41C4.23 4.99 2.37 7.77 2.05 11L5.02 11C5.15 8.01 5.88 5.29 7.06 3.3ZM12 2C9.41 2 7.28 5.95 7.02 11L16.98 11C16.73 6.05 14.68 2.16 12.16 2L12 2ZM16.94 3.3L17.03 3.46C18.16 5.43 18.85 8.09 18.98 11L21.95 11C21.62 7.7 19.69 4.87 16.94 3.3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, W9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 13.06C19 14.95 18.26 16.71 16.94 18.03 16.01 18.92 15.5 21.06 15.5 22.26L15.5 22.56C15.5 23.41 14.85 24.06 14 24.06L10 24.06C9.15 24.06 8.5 23.41 8.5 22.56L8.5 22.46C8.5 21.18 7.95 18.92 6.99 17.92 5.68 16.6 4.94 14.77 5 12.89 5.06 9.22 8.02 6.18 11.7 6.01 15.72 5.83 19 9.03 19 13.06ZM12.01 8L11.79 8.01C9.17 8.13 7.04 10.31 7 12.94 6.96 14.28 7.48 15.57 8.42 16.52 9.59 17.74 10.32 20.26 10.47 21.86L10.49 22.06 13.5 22.06 13.51 21.97C13.58 20.42 14.23 17.95 15.33 16.81L15.54 16.6C16.48 15.67 17 14.41 17 13.06 17 10.31 14.89 8.11 12.22 8.01L12.01 8ZM22.27 3.23C22.66 3.62 22.66 4.26 22.27 4.65L20.15 6.77C19.76 7.16 19.12 7.16 18.73 6.77 18.34 6.38 18.34 5.74 18.73 5.35L20.85 3.23C21.24 2.84 21.88 2.84 22.27 3.23ZM3.15 3.23L5.27 5.35C5.66 5.74 5.66 6.38 5.27 6.77 4.88 7.16 4.24 7.16 3.85 6.77L1.73 4.65C1.34 4.26 1.34 3.62 1.73 3.23 2.12 2.84 2.76 2.84 3.15 3.23ZM12 0C12.55 0 13 0.45 13 1L13 3C13 3.55 12.55 4 12 4 11.45 4 11 3.55 11 3L11 1C11 0.45 11.45 0 12 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, q9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.75 0C16.39 0 16.86 0.59 16.73 1.22L15 9 19 9C19.77 9 20.24 9.82 19.88 10.47L19.82 10.57 10.82 23.57C10.23 24.42 8.9 23.92 9.01 22.89L10.06 13 5.26 13C4.66 13 4.2 12.47 4.27 11.89L4.29 11.78 6.83 0.78C6.93 0.32 7.33 0 7.8 0L15.75 0ZM14.5 2L8.6 2 6.52 11 11.17 11C11.72 11 12.16 11.45 12.17 11.99L12.16 12.11 11.41 19.21 17.09 11 13.75 11C13.15 11 12.7 10.48 12.75 9.9L12.77 9.78 14.5 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, G9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 11C4.55 11 5 11.45 5 12 5 12.55 4.55 13 4 13 3.45 13 3 12.55 3 12 3 11.45 3.45 11 4 11ZM12 11C12.55 11 13 11.45 13 12 13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11ZM20 11C20.55 11 21 11.45 21 12 21 12.55 20.55 13 20 13 19.45 13 19 12.55 19 12 19 11.45 19.45 11 20 11ZM8 11C8.55 11 9 11.45 9 12 9 12.55 8.55 13 8 13 7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13 15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, L2 = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 5.07C16.48 5.35 16.64 5.96 16.37 6.44L9.37 18.56C9.09 19.04 8.48 19.2 8 18.93 7.52 18.65 7.36 18.04 7.63 17.56L14.63 5.44C14.91 4.96 15.52 4.8 16 5.07Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, K9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 11H20A1 1 0 0 1 21 12V12A1 1 0 0 1 20 13H4A1 1 0 0 1 3 12V12A1 1 0 0 1 4 11z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, X9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.67 10.03C9.11 10.47 9.11 11.18 8.67 11.62L6.02 14.27C4.99 15.29 4.99 16.96 6.02 17.98 7.04 19.01 8.71 19.01 9.73 17.98L12.38 15.33C12.82 14.89 13.53 14.89 13.97 15.33 14.41 15.77 14.41 16.48 13.97 16.92L11.32 19.57C9.42 21.48 6.33 21.48 4.43 19.57 2.52 17.67 2.52 14.58 4.43 12.68L7.08 10.03C7.52 9.59 8.23 9.59 8.67 10.03ZM19.57 4.43C21.48 6.33 21.48 9.42 19.57 11.32L16.92 13.97C16.48 14.41 15.77 14.41 15.33 13.97 14.89 13.53 14.89 12.82 15.33 12.38L17.98 9.73C19.01 8.71 19.01 7.04 17.98 6.02 16.96 4.99 15.29 4.99 14.27 6.02L11.62 8.67C11.18 9.11 10.47 9.11 10.03 8.67 9.59 8.23 9.59 7.52 10.03 7.08L12.68 4.43C14.58 2.52 17.67 2.52 19.57 4.43Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Q9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C14.76 0 17 2.24 17 5L17 9 18 9C19.66 9 21 10.34 21 12L21 21C21 22.66 19.66 24 18 24L6 24C4.34 24 3 22.66 3 21L3 12C3 10.34 4.34 9 6 9L7 9 7 5C7 2.31 9.12 0.12 11.78 0L12 0ZM18 11L6 11C5.45 11 5 11.45 5 12L5 21C5 21.55 5.45 22 6 22L18 22C18.55 22 19 21.55 19 21L19 12C19 11.45 18.55 11 18 11ZM12 2C10.34 2 9 3.34 9 5L9 9 15 9 15 5C15 3.34 13.66 2 12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, J9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.5 0C14.91 0 16.88 1.9 17 4.29L17 4.53C17 5.08 16.55 5.53 16 5.53 15.49 5.53 15.06 5.14 15.01 4.65L15 4.5C15 3.12 13.88 2 12.5 2 11.12 2 10 3.12 10 4.5L10 9 18 9C19.66 9 21 10.34 21 12L21 21C21 22.66 19.66 24 18 24L6 24C4.34 24 3 22.66 3 21L3 12C3 10.34 4.34 9 6 9L8 9 8 4.5C8 2.01 10.01 0 12.5 0ZM18 11L6 11C5.45 11 5 11.45 5 12L5 21C5 21.55 5.45 22 6 22L18 22C18.55 22 19 21.55 19 21L19 12C19 11.45 18.55 11 18 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Y9 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.99 11L16 11C15.45 11 15 11.45 15 12L15.01 12.12C15.06 12.61 15.49 13 16 13L21.99 13 21.99 12 21.99 11ZM16 9L21.27 9C21.2 8.93 21.14 8.86 21.07 8.8 20.58 8.38 19.95 8.16 19.3 8.18L17.45 8.18C17 8.13 16.57 7.92 16.27 7.58 15.96 7.24 15.79 6.8 15.79 6.34L15.79 4.65C15.79 3.94 15.51 3.27 15.01 2.77 14.52 2.28 13.84 2 13.14 2L10.8 2C10.1 2 9.42 2.28 8.93 2.77 8.43 3.27 8.15 3.94 8.15 4.65L8.15 6.35C8.15 6.8 7.98 7.23 7.69 7.57 7.39 7.91 6.98 8.12 6.53 8.18L4.65 8.18C3.95 8.18 3.28 8.46 2.78 8.95 2.28 9.45 2 10.12 2 10.83L2 13.17C2 13.88 2.28 14.55 2.78 15.05 3.28 15.54 3.95 15.82 4.65 15.82L6.53 15.82C6.98 15.88 7.39 16.09 7.69 16.43 7.98 16.77 8.15 17.2 8.15 17.65L8.15 19.35C8.15 20.06 8.43 20.73 8.93 21.23 9.42 21.72 10.1 22 10.8 22L13.14 22C13.84 22 14.52 21.72 15.01 21.23 15.51 20.73 15.79 20.06 15.79 19.35L15.79 17.66C15.79 17.2 15.96 16.76 16.27 16.42 16.57 16.08 17 15.87 17.45 15.82L19.3 15.82C19.95 15.84 20.58 15.62 21.07 15.2 21.14 15.14 21.2 15.07 21.27 15L16 15C14.34 15 13 13.66 13 12 13 10.34 14.34 9 16 9ZM22 13L23.25 13 23.28 13C23.67 13.03 23.96 13.37 23.93 13.76 23.79 14.91 23.24 15.96 22.37 16.71L22.18 16.87C21.41 17.46 20.46 17.8 19.49 17.82L17.79 17.82 17.79 19.35C17.79 20.59 17.3 21.77 16.43 22.64 15.55 23.51 14.37 24 13.14 24L10.8 24C9.57 24 8.39 23.51 7.51 22.64L7.34 22.46C6.58 21.61 6.15 20.51 6.15 19.36L6.15 17.82 4.65 17.82C3.42 17.82 2.24 17.33 1.37 16.46 0.49 15.59 0 14.41 0 13.18L0 10.82C0 9.59 0.49 8.41 1.37 7.54 2.24 6.67 3.42 6.18 4.65 6.18L6.15 6.18 6.15 4.64C6.15 3.49 6.58 2.39 7.34 1.54L7.51 1.36C8.39 0.49 9.57 0 10.8 0L13.14 0C14.37 0 15.55 0.49 16.43 1.36 17.3 2.23 17.79 3.41 17.79 4.65L17.79 6.18 19.24 6.18C20.31 6.15 21.34 6.49 22.18 7.13L22.37 7.29C23.24 8.04 23.79 9.09 23.93 10.24 23.96 10.63 23.67 10.97 23.28 11L23.22 11 22 11 22 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, C7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 2C14.66 2 16 3.34 16 5L16 8C16 8.55 15.55 9 15 9 14.45 9 14 8.55 14 8L14 5C14 4.45 13.55 4 13 4L4 4C3.45 4 3 4.45 3 5L3 19C3 19.55 3.45 20 4 20L13 20C13.55 20 14 19.55 14 19L14 16C14 15.45 14.45 15 15 15 15.55 15 16 15.45 16 16L16 19C16 20.66 14.66 22 13 22L4 22C2.34 22 1 20.66 1 19L1 5C1 3.34 2.34 2 4 2L13 2ZM20.13 8.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L20.13 15.71C19.76 16.1 19.15 16.1 18.78 15.71 18.41 15.32 18.41 14.68 18.78 14.29L20.04 13 7.5 13C6.95 13 6.5 12.55 6.5 12 6.5 11.45 6.95 11 7.5 11L20 11 20.04 11 18.78 9.71C18.43 9.34 18.41 8.75 18.72 8.36L18.78 8.29C19.15 7.9 19.76 7.9 20.13 8.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, L7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 3C22.66 3 24 4.34 24 6L24 18C24 19.66 22.66 21 21 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM2 18C2 18.55 2.45 19 3 19L21 19C21.55 19 22 18.55 22 18L22 9.19 13.57 14.38C12.61 14.97 11.39 14.97 10.43 14.38L2 9.19 2 18ZM2 6.85L11.48 12.68C11.8 12.88 12.2 12.88 12.52 12.68L22 6.84 22 6C22 5.45 21.55 5 21 5L3 5C2.45 5 2 5.45 2 6L2 6.85Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, e7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.63 1.07C7.85 0.98 8.09 0.98 8.32 1.05L15.97 4.94 21.63 3.07C21.94 2.95 22.29 2.99 22.56 3.17 22.84 3.36 23 3.67 23 4L23 20C23 20.41 22.75 20.78 22.37 20.93L16.37 22.93C16.15 23.02 15.91 23.02 15.68 22.95L8.03 19.06 2.37 20.93C2.06 21.05 1.71 21.01 1.44 20.83 1.16 20.64 1 20.33 1 20L1 4C1 3.59 1.25 3.22 1.63 3.07L7.63 1.07ZM9 3.39L9 17.28 15 20.61 15 6.72 9 3.39ZM21 5.48L17 6.68 17 20.52 21 19.32 21 5.48ZM7 3.48L3 4.68 3 18.52 7 17.32 7 3.48Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, n7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM17 11C17.55 11 18 11.45 18 12 18 12.55 17.55 13 17 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L17 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, i7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 11H19A1 1 0 0 1 20 12V12A1 1 0 0 1 19 13H5A1 1 0 0 1 4 12V12A1 1 0 0 1 5 11z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, o7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C18.66 0 20 1.34 20 3L20 21C20 22.66 18.66 24 17 24L7 24C5.34 24 4 22.66 4 21L4 3C4 1.34 5.34 0 7 0L17 0ZM17 2L7 2C6.45 2 6 2.45 6 3L6 21C6 21.55 6.45 22 7 22L17 22C17.55 22 18 21.55 18 21L18 3C18 2.45 17.55 2 17 2ZM12 18C12.55 18 13 18.45 13 19 13 19.55 12.55 20 12 20 11.45 20 11 19.55 11 19 11 18.45 11.45 18 12 18Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, t7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.42 0 20 3.58 20 8L20 16C20 20.42 16.42 24 12 24 7.58 24 4 20.42 4 16L4 8C4 3.58 7.58 0 12 0ZM12 2C8.69 2 6 4.69 6 8L6 16C6 19.31 8.69 22 12 22 15.31 22 18 19.31 18 16L18 8C18 4.69 15.31 2 12 2ZM12 4C12.55 4 13 4.45 13 5L13 9C13 9.55 12.55 10 12 10 11.45 10 11 9.55 11 9L11 5C11 4.45 11.45 4 12 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, a7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM6 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L6 22 6 2ZM21 2L8 2 8 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM14.53 8.29C14.9 8.68 14.9 9.32 14.53 9.71L13.27 11 18.81 11C19.36 11 19.81 11.45 19.81 12 19.81 12.55 19.36 13 18.81 13L13.27 13 14.53 14.29C14.88 14.66 14.9 15.25 14.58 15.64L14.53 15.71C14.15 16.1 13.55 16.1 13.17 15.71L10.28 12.71C9.91 12.32 9.91 11.68 10.28 11.29L13.17 8.29C13.55 7.9 14.15 7.9 14.53 8.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, s7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM16 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L16 22 16 2ZM21 2L18 2 18 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM10.63 8.29L13.53 11.29C13.9 11.68 13.9 12.32 13.53 12.71L10.63 15.71C10.26 16.1 9.65 16.1 9.28 15.71 8.91 15.32 8.91 14.68 9.28 14.29L10.54 13 5 13C4.45 13 4 12.55 4 12 4 11.45 4.45 11 5 11L10.5 11 10.54 11 9.28 9.71C8.93 9.34 8.91 8.75 9.22 8.36L9.28 8.29C9.65 7.9 10.26 7.9 10.63 8.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, c7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 13L4.27 13 5.53 14.29C5.87 14.65 5.9 15.22 5.61 15.61L5.53 15.71C5.15 16.1 4.55 16.1 4.17 15.71L1.28 12.71C0.91 12.32 0.91 11.68 1.28 11.29L4.17 8.29C4.55 7.9 5.15 7.9 5.53 8.29L5.58 8.36C5.9 8.75 5.88 9.34 5.53 9.71L4.27 11 11 11 11 4.11 9.71 5.38C9.34 5.74 8.75 5.76 8.36 5.44L8.29 5.38C7.9 5 7.9 4.39 8.29 4.01L11.29 1.09C11.68 0.71 12.32 0.71 12.71 1.09L15.71 4.01C16.1 4.39 16.1 5 15.71 5.38 15.32 5.76 14.68 5.76 14.29 5.38L13 4.11 13 11 19.54 11 18.28 9.71C17.93 9.34 17.91 8.75 18.22 8.36L18.28 8.29C18.65 7.9 19.26 7.9 19.63 8.29L22.53 11.29C22.9 11.68 22.9 12.32 22.53 12.71L19.63 15.71C19.26 16.1 18.65 16.1 18.28 15.71 17.91 15.32 17.91 14.68 18.28 14.29L19.54 13 13 13 13 19.51 14.29 18.24C14.65 17.89 15.22 17.86 15.61 18.16L15.71 18.24C16.1 18.61 16.1 19.23 15.71 19.6L12.71 22.52C12.32 22.9 11.68 22.9 11.29 22.52L8.29 19.6C7.9 19.23 7.9 18.61 8.29 18.24L8.36 18.18C8.75 17.86 9.34 17.88 9.71 18.24L11 19.51 11 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, r7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.98 4.76C22.99 4.88 23 5.01 23 5.14L23 18.86C23 20.52 21.66 21.86 20 21.86 19.87 21.86 19.75 21.86 19.62 21.84L3.62 19.81C2.12 19.62 1 18.34 1 16.83L1 7.17C1 5.66 2.12 4.38 3.62 4.19L19.62 2.16C21.27 1.95 22.77 3.11 22.98 4.76ZM19.99 4.13L19.87 4.14 3.87 6.17C3.37 6.24 3 6.66 3 7.17L3 16.83C3 17.34 3.37 17.76 3.87 17.83L19.87 19.86C19.92 19.86 19.96 19.86 20 19.86 20.55 19.86 21 19.42 21 18.86L21 5.14C21 5.09 21 5.05 20.99 5.01 20.93 4.54 20.56 4.19 20.1 4.14L19.99 4.13ZM11.5 10.31C11.58 10.31 11.65 10.33 11.72 10.36L14.11 11.55C14.35 11.68 14.45 11.98 14.33 12.22 14.28 12.32 14.2 12.4 14.11 12.45L11.72 13.64C11.48 13.76 11.18 13.66 11.05 13.41 11.02 13.35 11 13.27 11 13.19L11 10.81C11 10.53 11.22 10.31 11.5 10.31Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, m7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 24C3.34 24 2 22.66 2 21L2 4C2 1.79 3.79 0 6 0L20 0C21.1 0 22 0.9 22 2L22 19 21.5 19C20.67 19 20 19.67 20 20.5 20 21.33 20.67 22 21.5 22L22 22 22 23C22 23.55 21.55 24 21 24L5 24ZM18.34 19L5.5 19C4.67 19 4 19.67 4 20.5 4 21.33 4.67 22 5.5 22L18.34 22C18.12 21.55 18 21.04 18 20.5 18 19.96 18.12 19.45 18.34 19ZM20 2L6 2C4.9 2 4 2.9 4 4L4 17.34C4.45 17.12 4.96 17 5.5 17L20 17 20 2ZM12 5C12.55 5 13 5.45 13 6 13 6.55 12.55 7 12 7L7 7C6.45 7 6 6.55 6 6 6 5.45 6.45 5 7 5L12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, l7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.65 0.49L21.63 5.72C22.49 6.27 23 7.23 23 8.25L23 20.98C23 22.65 21.65 24 19.99 24L4.01 24C2.35 24 1 22.65 1 20.98L1 8.25C1 7.23 1.51 6.27 2.37 5.72L10.35 0.49C11.35-0.16 12.65-0.16 13.65 0.49ZM11.45 2.16L3.46 7.4C3.17 7.58 3 7.9 3 8.24L3 20.99C3 21.55 3.45 22 4.01 22L19.99 22C20.55 22 21 21.55 21 20.99L21 8.24C21 7.9 20.83 7.58 20.54 7.4L12.55 2.16C12.22 1.95 11.78 1.95 11.45 2.16ZM13.48 9C15.34 9 16.7 10.34 16.7 12.09 16.7 13.84 15.34 15.22 13.48 15.22L10.99 15.22 10.99 18.52 9 18.52 9 9 13.48 9ZM13.19 10.72L10.99 10.72 10.99 13.49 13.19 13.49C13.97 13.49 14.71 13.1 14.71 12.11 14.71 11.13 13.97 10.72 13.19 10.72Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, d7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.42 1.12C21.62 1.44 22.56 2.38 22.88 3.58 23.2 4.78 22.86 6.06 21.98 6.94L7.38 21.54C7.25 21.67 7.09 21.76 6.92 21.8L2.24 22.97C1.51 23.15 0.85 22.49 1.03 21.76L2.2 17.08C2.24 16.91 2.33 16.75 2.46 16.62L17.06 2.02C17.94 1.14 19.22 0.8 20.42 1.12ZM15.75 6.16L4.07 17.84 3.37 20.63 6.16 19.93 17.84 8.25 15.75 6.16ZM18.48 3.43L17.16 4.75 19.25 6.84 20.57 5.52C20.9 5.19 21.06 4.71 20.98 4.25L20.95 4.1C20.81 3.59 20.42 3.19 19.91 3.05 19.4 2.91 18.85 3.06 18.48 3.43Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, M7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.63 3.87C21.02 4.26 21.02 4.89 20.63 5.28L5.08 20.84C4.68 21.23 4.05 21.23 3.66 20.84 3.27 20.45 3.27 19.82 3.66 19.42L19.22 3.87C19.61 3.48 20.24 3.48 20.63 3.87ZM18 14C19.66 14 21 15.34 21 17 21 18.66 19.66 20 18 20 16.34 20 15 18.66 15 17 15 15.34 16.34 14 18 14ZM18 16C17.45 16 17 16.45 17 17 17 17.55 17.45 18 18 18 18.55 18 19 17.55 19 17 19 16.49 18.61 16.06 18.12 16.01L18 16ZM7 4C8.66 4 10 5.34 10 7 10 8.66 8.66 10 7 10 5.34 10 4 8.66 4 7 4 5.34 5.34 4 7 4ZM7 6C6.45 6 6 6.45 6 7 6 7.55 6.45 8 7 8 7.55 8 8 7.55 8 7 8 6.49 7.61 6.06 7.12 6.01L7 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Z7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM19.67 7.75C19.94 8.23 19.78 8.84 19.3 9.12L14.98 11.61C14.99 11.74 15 11.87 15 12 15 13.66 13.66 15 12 15 10.34 15 9 13.66 9 12 9 10.34 10.34 9 12 9 12.8 9 13.53 9.31 14.07 9.83L18.3 7.38C18.78 7.11 19.39 7.27 19.67 7.75ZM12 4C12.55 4 13 4.45 13 5 13 5.55 12.55 6 12 6 8.69 6 6 8.69 6 12 6 12.55 5.55 13 5 13 4.45 13 4 12.55 4 12 4 7.58 7.58 4 12 4ZM12 11C11.45 11 11 11.45 11 12 11 12.55 11.45 13 12 13 12.55 13 13 12.55 13 12 13 11.49 12.61 11.06 12.12 11.01L12 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, u7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.47 0.29L14.47 1.28C14.46 1.29 14.46 1.29 14.45 1.3L11 4.71 10.9 4.79C10.73 4.93 10.51 5 10.29 5L3.46 5 1.73 3.29 1.63 3.21C1.21 2.89 0.61 2.94 0.25 3.34-0.1 3.74-0.08 4.33 0.3 4.71L2.03 6.41 2.03 11.59 0.89 12.71 0.75 12.85C0.27 13.4 0 14.1 0 14.83L0 21 0.01 21.12C0.07 21.64 0.54 22.03 1.07 22 1.61 21.97 2.02 21.53 2.03 21L2.03 14.83 2.03 14.7C2.06 14.48 2.16 14.28 2.32 14.12L3.46 13 3.58 12.87C3.88 12.51 4.05 12.06 4.05 11.59L4.05 7 10.29 7 10.49 6.99C11.22 6.94 11.91 6.64 12.44 6.12L15.25 3.34 18.72 6.08 18.38 6.42 18.29 6.5C18.02 6.71 17.67 6.77 17.35 6.66L16.46 6.37 16.31 6.32C15.28 6.07 14.23 6.64 13.9 7.63L13.24 10.59C13.17 10.89 13.17 11.19 13.24 11.49L13.58 13 6.26 13 6.09 13.01 5.93 13.03C5.4 13.11 4.92 13.41 4.61 13.84 4.3 14.27 4.17 14.81 4.26 15.33L5.08 21.16 5.1 21.28C5.25 21.79 5.78 22.09 6.3 21.98 6.82 21.86 7.16 21.36 7.07 20.84L6.26 15 14.03 15 15.2 21.22 15.23 21.33C15.41 21.83 15.95 22.1 16.46 21.96 16.98 21.81 17.29 21.3 17.18 20.78L15.21 11.05 15.82 8.26 16.71 8.56 16.9 8.61C17.94 8.88 19.05 8.59 19.82 7.83L20.56 7.1 20.66 6.99C21.15 6.39 21.11 5.52 20.56 4.98 20.49 4.92 20.49 4.92 20.43 4.87L16.69 1.92 16.9 1.71 16.99 1.61C17.3 1.21 17.27 0.65 16.9 0.29 16.51-0.1 15.87-0.1 15.47 0.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, f7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 1L6.99 1C8.49 0.99 9.78 2.09 9.99 3.59 10.11 4.47 10.32 5.34 10.63 6.18 11.05 7.27 10.78 8.51 9.96 9.35L9.24 10.06 9.31 10.18C10.46 11.94 11.95 13.43 13.71 14.57L13.82 14.65 14.54 13.93C15.33 13.15 16.47 12.87 17.51 13.19L17.71 13.25C18.54 13.57 19.41 13.78 20.31 13.9 21.82 14.11 22.93 15.42 22.89 16.94L22.89 16.92 22.89 19.92C22.89 20.76 22.54 21.57 21.92 22.14 21.29 22.71 20.46 22.99 19.6 22.91 16.37 22.56 13.26 21.46 10.54 19.69 8 18.08 5.85 15.93 4.24 13.39 2.46 10.65 1.36 7.53 1.01 4.27 0.94 3.43 1.22 2.6 1.78 1.98 2.35 1.36 3.15 1 4 1ZM4 3C3.72 3 3.45 3.12 3.26 3.33 3.07 3.53 2.98 3.81 3 4.07 3.31 7.01 4.31 9.83 5.92 12.31 7.38 14.61 9.32 16.55 11.62 18.01 14.09 19.61 16.89 20.61 19.8 20.92 20.08 20.95 20.36 20.86 20.56 20.66 20.77 20.47 20.89 20.21 20.89 19.92L20.89 16.9C20.9 16.39 20.53 15.95 20.04 15.88 19 15.74 17.99 15.49 17.01 15.13 16.64 14.99 16.23 15.08 15.96 15.35L14.69 16.62C14.37 16.94 13.88 17 13.48 16.78 10.82 15.27 8.62 13.06 7.11 10.4 6.89 10.01 6.95 9.52 7.27 9.2L8.54 7.94C8.81 7.66 8.9 7.25 8.76 6.88 8.4 5.9 8.14 4.89 8.01 3.86 7.94 3.36 7.51 2.99 7 3L4 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, p7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.6 1C21.03 1 23 2.97 23 5.4L23 18.6C23 21.03 21.03 23 18.6 23L5.4 23C2.97 23 1 21.03 1 18.6L1 5.4C1 2.97 2.97 1 5.4 1L18.6 1ZM18.75 3L5.25 3C4.01 3 3 4.01 3 5.25L3 18.75C3 19.99 4.01 21 5.25 21L18.75 21C19.99 21 21 19.99 21 18.75L21 5.25C21 4.01 19.99 3 18.75 3ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9ZM17.5 5C18.33 5 19 5.67 19 6.5 19 7.33 18.33 8 17.5 8 16.67 8 16 7.33 16 6.5 16 5.67 16.67 5 17.5 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, x7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 16C3.55 16 4 16.45 4 17L4 18C4 19.13 4.87 20 6 20L7 20C7.55 20 8 20.45 8 21 8 21.55 7.55 22 7 22L6 22C3.8 22 2 20.2 2 18L2 17C2 16.45 2.45 16 3 16ZM21 16C21.55 16 22 16.45 22 17L22 18C22 20.2 20.2 22 18 22L17 22C16.45 22 16 21.55 16 21 16 20.45 16.45 20 17 20L18 20C19.13 20 20 19.13 20 18L20 17C20 16.45 20.45 16 21 16ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9ZM7 2C7.55 2 8 2.45 8 3 8 3.55 7.55 4 7 4L6 4C4.87 4 4 4.87 4 6L4 7C4 7.55 3.55 8 3 8 2.45 8 2 7.55 2 7L2 6C2 3.8 3.8 2 6 2L7 2ZM18 2C20.2 2 22 3.8 22 6L22 7C22 7.55 21.55 8 21 8 20.45 8 20 7.55 20 7L20 6C20 4.87 19.13 4 18 4L17 4C16.45 4 16 3.55 16 3 16 2.45 16.45 2 17 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, h7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C15.31 2 18 4.69 18 8 18 10.97 15.84 13.44 13 13.92L13 13.96 13 21C13 21.55 12.55 22 12 22 11.45 22 11 21.55 11 21L11 14 11 13.92C8.16 13.44 6 10.97 6 8 6 4.69 8.69 2 12 2ZM12 4C9.79 4 8 5.79 8 8 8 10.21 9.79 12 12 12 14.21 12 16 10.21 16 8 16 5.79 14.21 4 12 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, _7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C12.55 0 13 0.45 13 1L13 4 14 4C15.1 4 16 4.9 16 6L16 11.53 16 11.69C15.9 14.65 13.47 17 10.5 17L10 17 10 23C10 23.55 9.55 24 9 24 8.45 24 8 23.55 8 23L8 17 7.47 17 7.31 17C4.35 16.9 2 14.47 2 11.5L2 6C2 4.9 2.9 4 4 4L5 4 5 1C5 0.45 5.45 0 6 0 6.55 0 7 0.45 7 1L7 4 11 4 11 1C11 0.45 11.45 0 12 0ZM21.54 16.23C21.93 16.62 21.93 17.26 21.54 17.65L17.42 21.77C17.21 21.98 16.92 22.08 16.64 22.06 16.36 22.08 16.07 21.98 15.85 21.77L13.73 19.65C13.34 19.26 13.34 18.62 13.73 18.23 14.12 17.84 14.76 17.84 15.15 18.23L16.64 19.72 20.13 16.23C20.52 15.84 21.15 15.84 21.54 16.23ZM14 6L4 6 4 11.5C4 13.39 5.5 14.93 7.38 15L7.5 15 10.5 15C12.39 15 13.93 13.5 14 11.62L14 11.5 14 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, N7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 0C15.55 0 16 0.45 16 1L16 4 17 4C18.1 4 19 4.9 19 6L19 11.53 19 11.69C18.9 14.65 16.47 17 13.5 17L13 17 13 23C13 23.55 12.55 24 12 24 11.45 24 11 23.55 11 23L11 17 10.47 17 10.31 17C7.35 16.9 5 14.47 5 11.5L5 6C5 4.9 5.9 4 7 4L8 4 8 1C8 0.45 8.45 0 9 0 9.55 0 10 0.45 10 1L10 4 14 4 14 1C14 0.45 14.45 0 15 0ZM17 6L7 6 7 11.5C7 13.39 8.5 14.93 10.38 15L10.5 15 13.5 15C15.39 15 16.93 13.5 17 11.62L17 11.5 17 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, z7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 5.83C12.55 5.83 13 6.28 13 6.83L13 11 17.17 11C17.72 11 18.17 11.45 18.17 12 18.17 12.55 17.72 13 17.17 13L13 13 13 17.17C13 17.72 12.55 18.17 12 18.17 11.45 18.17 11 17.72 11 17.17L11 13 6.83 13C6.28 13 5.83 12.55 5.83 12 5.83 11.45 6.28 11 6.83 11L11 11 11 6.83C11 6.28 11.45 5.83 12 5.83Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, g7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 4L13 11 20 11C20.55 11 21 11.45 21 12 21 12.55 20.55 13 20 13L13 13 13 20C13 20.55 12.55 21 12 21 11.45 21 11 20.55 11 20L11 13 4 13C3.45 13 3 12.55 3 12 3 11.45 3.45 11 4 11L11 11 11 4C11 3.45 11.45 3 12 3 12.55 3 13 3.45 13 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, b7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 0C19.1 0 20 0.9 20 2L20 7 21 7C22.66 7 24 8.34 24 10L24 16C24 17.66 22.66 19 21 19L20 19 20 22C20 23.1 19.1 24 18 24L6 24C4.9 24 4 23.1 4 22L4 19 3 19C1.34 19 0 17.66 0 16L0 10C0 8.34 1.34 7 3 7L4 7 4 2C4 0.9 4.9 0 6 0L18 0ZM18 16L6 16 6 22 18 22 18 16ZM21 9L3 9C2.45 9 2 9.45 2 10L2 16C2 16.55 2.45 17 3 17L4 17 4 16C4 14.9 4.9 14 6 14L18 14C19.1 14 20 14.9 20 16L20 17 21 17C21.55 17 22 16.55 22 16L22 10C22 9.45 21.55 9 21 9ZM18 2L6 2 6 7 18 7 18 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, y7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 2C21.66 2 23 3.34 23 5L23 17C23 18.66 21.66 20 20 20L6.96 20 1 23.49 1 5C1 3.34 2.34 2 4 2L20 2ZM20 4L4 4C3.45 4 3 4.45 3 5L3 20 6.42 18 20 18C20.55 18 21 17.55 21 17L21 5C21 4.45 20.55 4 20 4ZM12 14C12.55 14 13 14.45 13 15 13 15.55 12.55 16 12 16 11.45 16 11 15.55 11 15 11 14.45 11.45 14 12 14ZM12 6C13.66 6 15 7.34 15 9 15 10.31 14.17 11.42 13 11.83L13 12C13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12L11 11C11 10.49 11.39 10.06 11.88 10.01L12 10C12.55 10 13 9.55 13 9 13 8.45 12.55 8 12 8 11.49 8 11.06 8.39 11.01 8.88L11 9C11 9.55 10.55 10 10 10 9.45 10 9 9.55 9 9 9 7.34 10.34 6 12 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, w7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 17C12.55 17 13 17.45 13 18 13 18.55 12.55 19 12 19 11.45 19 11 18.55 11 18 11 17.45 11.45 17 12 17ZM12 5C14.21 5 16 6.79 16 9 16 10.86 14.73 12.43 13 12.87L13 14C13 14.55 12.55 15 12 15 11.45 15 11 14.55 11 14L11 12C11 11.49 11.39 11.06 11.88 11.01L12 11C13.1 11 14 10.1 14 9 14 7.9 13.1 7 12 7 10.9 7 10 7.9 10 9 10 9.55 9.55 10 9 10 8.45 10 8 9.55 8 9 8 6.79 9.79 5 12 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, S7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 3C4.6 3 3.45 4.2 3.15 5.6L2.05 11.5C1.75 12.9 2.75 14.3 4.15 14.6L8.25 15.4 8.25 19.2C8.25 20 8.55 20.7 9.05 21.3 9.45 21.8 10.15 22 10.75 22L11.15 22C11.95 21.9 12.65 21.3 13.05 20.5L16.05 14 19.75 14C20.55 14 21.15 13.4 21.15 12.6L21.15 4.6C21.15 3.8 20.7 3 20 3L6 3ZM11.45 19.8C11.35 20.1 11.15 20.2 10.95 20.2 10.85 20.2 10.65 20.2 10.45 20 10.25 19.8 10.15 19.5 10.15 19.1L10.15 15.4C10.15 14.6 9.55 13.8 8.75 13.6L4.55 12.7C4.05 12.6 3.85 12.2 3.85 11.7L4.95 5.8C5.05 5.4 5.45 5 6.05 5L14.95 5 14.95 12.3 11.45 19.8ZM17 12L17 5 19 5 19 12 17 12Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, B7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 22C4.6 22 3.45 20.8 3.15 19.4L2.05 13.5C1.75 12.1 2.75 10.7 4.15 10.4L8.25 9.6 8.25 5.8C8.25 5 8.55 4.3 9.05 3.7 9.45 3.2 10.15 3 10.75 3L11.15 3C11.95 3.1 12.65 3.7 13.05 4.5L16.05 11 19.75 11C20.55 11 21.15 11.6 21.15 12.4L21.15 20.4C21.15 21.2 20.7 22 20 22L6 22ZM11.45 5.2C11.35 4.9 11.15 4.8 10.95 4.8 10.85 4.8 10.65 4.8 10.45 5 10.25 5.2 10.15 5.5 10.15 5.9L10.15 9.6C10.15 10.4 9.55 11.2 8.75 11.4L4.55 12.3C4.05 12.4 3.85 12.8 3.85 13.3L4.95 19.2C5.05 19.6 5.45 20 6.05 20L14.95 20 14.95 12.7 11.45 5.2ZM17 13L17 20 19 20 19 13 17 13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, v7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 1C18.63 1 24 6.37 24 13 24 16.64 22.96 19.34 20.88 21L23 21C23.55 21 24 21.45 24 22 24 22.55 23.55 23 23 23L18 23C17.45 23 17 22.55 17 22L17 17C17 16.45 17.45 16 18 16 18.55 16 19 16.45 19 17L19 19.87C20.99 18.69 22 16.45 22 13 22 7.48 17.52 3 12 3 6.48 3 2 7.48 2 13 2 13.55 1.55 14 1 14 0.45 14 0 13.55 0 13 0 6.37 5.37 1 12 1Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, k7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 0C7.21 0 9 1.79 9 4 9 5.12 8.54 6.13 7.8 6.86 9.13 7.75 10 9.28 10 11L10 18 8 19 8 23C8 23.55 7.55 24 7 24L3 24C2.45 24 2 23.55 2 23L2 19 0 18 0 11C0 9.28 0.87 7.75 2.2 6.86L2.04 6.69C1.39 5.98 1 5.04 1 4 1 1.79 2.79 0 5 0ZM5 8C3.34 8 2 9.34 2 11L2 16.76 4 17.76 4 22 6 22 6 17.76 8 16.76 8 11C8 9.4 6.75 8.1 5.18 8.01L5 8ZM5 2C3.9 2 3 2.9 3 4 3 5.1 3.9 6 5 6 6.1 6 7 5.1 7 4 7 2.9 6.1 2 5 2ZM18 0C20.21 0 22 1.79 22 4 22 5.14 21.52 6.17 20.75 6.9 21.72 7.61 22.41 8.69 22.61 9.95L23.82 17.85C23.91 18.39 23.53 18.9 22.99 18.99 22.94 19 22.89 19 22.83 19L21.78 19C21.32 19 20.92 19.31 20.81 19.76L20 23C20 23.55 19.55 24 19 24L17 24C16.45 24 16 23.55 16 23L15.19 19.76C15.08 19.31 14.68 19 14.22 19L13.17 19C12.61 19 12.17 18.55 12.17 18 12.17 17.95 12.17 17.9 12.18 17.85L13.39 9.95C13.59 8.69 14.28 7.61 15.25 6.9L15.36 7C14.52 6.27 14 5.2 14 4 14 1.79 15.79 0 18 0ZM18 8C16.69 8 15.57 8.96 15.37 10.26L14.33 17 14.4 17.01C15.64 17.08 16.71 17.91 17.08 19.1L17.13 19.27 17.81 22 18.19 22 18.87 19.27C19.19 17.99 20.3 17.08 21.6 17.01L21.67 17 20.63 10.26C20.44 9.02 19.41 8.08 18.17 8.01L18 8ZM18 2C16.9 2 16 2.9 16 4 16 5.1 16.9 6 18 6 19.1 6 20 5.1 20 4 20 2.9 19.1 2 18 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, $7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 4C21.76 4 24 6.24 24 9L24 17C24 19.76 21.76 22 19 22L5 22C2.24 22 0 19.76 0 17L0 9C0 6.24 2.24 4 5 4L19 4ZM19 6L5 6C3.34 6 2 7.34 2 9L2 17C2 18.66 3.34 20 5 20L19 20C20.66 20 22 18.66 22 17L22 9C22 7.34 20.66 6 19 6ZM14 17C14.55 17 15 17.45 15 18 15 18.51 14.61 18.94 14.12 18.99L14 19 10 19C9.45 19 9 18.55 9 18 9 17.45 9.45 17 10 17L14 17ZM7 8C8.66 8 10 9.34 10 11 10 12.66 8.66 14 7 14 5.34 14 4 12.66 4 11 4 9.34 5.34 8 7 8ZM17 8C18.66 8 20 9.34 20 11 20 12.66 18.66 14 17 14 15.34 14 14 12.66 14 11 14 9.34 15.34 8 17 8ZM7 10C6.45 10 6 10.45 6 11 6 11.55 6.45 12 7 12 7.55 12 8 11.55 8 11 8 10.49 7.61 10.06 7.12 10.01L7 10ZM17 10C16.45 10 16 10.45 16 11 16 11.55 16.45 12 17 12 17.55 12 18 11.55 18 11 18 10.49 17.61 10.06 17.12 10.01L17 10ZM12 1C13.86 1 15.43 2.27 15.87 4L13.73 4C13.39 3.4 12.74 3 12 3 11.26 3 10.61 3.4 10.27 4L8.13 4C8.57 2.27 10.14 1 12 1Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, A7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.93 5L13.99 5 14.13 5.01 14.26 5.03 14.39 5.08 14.5 5.14 14.61 5.21 14.71 5.29 14.78 5.38 14.87 5.51 16.45 8.66 19.55 7.11C20.01 6.88 20.56 7.03 20.84 7.45L20.89 7.55C21.14 8.05 20.94 8.65 20.45 8.89L16.45 10.89C15.95 11.14 15.35 10.94 15.11 10.45L14.26 8.75 13.12 12.71 16.71 16.29C16.83 16.41 16.91 16.56 16.96 16.71L16.99 16.84 17.99 22.84C18.08 23.38 17.71 23.9 17.16 23.99 16.62 24.08 16.1 23.71 16.01 23.16L15.07 17.48 11.29 13.71C11.06 13.48 10.96 13.16 11.01 12.84L11.04 12.73 12.59 7.3 9.82 7.86 8.97 11.24C8.85 11.74 8.37 12.06 7.87 11.99L7.76 11.97C7.22 11.84 6.9 11.29 7.03 10.76L8.03 6.76C8.12 6.38 8.43 6.1 8.8 6.02L13.85 5.01 13.93 5ZM11.45 15.11C11.94 15.35 12.14 15.95 11.89 16.45L9.89 20.45C9.76 20.72 9.5 20.92 9.2 20.98L4.2 21.98C3.65 22.09 3.13 21.74 3.02 21.2 2.91 20.65 3.26 20.13 3.8 20.02L8.32 19.11 10.11 15.55C10.35 15.06 10.95 14.86 11.45 15.11ZM16 4C17.1 4 18 3.1 18 2 18 0.9 17.1 0 16 0 14.9 0 14 0.9 14 2 14 3.1 14.9 4 16 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, I7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 22C20 23.1 19.1 24 18 24L16 24C14.9 24 14 23.1 14 22L14 21 10 21 10 22C10 23.1 9.1 24 8 24L6 24C4.9 24 4 23.1 4 22L4 19 4.02 19C3.38 18.17 3 17.13 3 16L3 7 2 7 2 8C2 8.55 1.55 9 1 9 0.45 9 0 8.55 0 8L0 6C0 5.45 0.45 5 1 5L3 5C3 2.24 5.29 0 8 0L16 0C18.71 0 21 2.24 21 5L23 5C23.55 5 24 5.45 24 6L24 8C24 8.55 23.55 9 23 9 22.45 9 22 8.55 22 8L22 7 21 7 21 16C21 17.13 20.62 18.17 19.98 19L20 19 20 22ZM18 20.57C17.45 20.82 16.84 20.97 16.21 21L16 21 16 22 18 22 18 20.57ZM6 20.57L6 22 8 22 8 21C7.29 21 6.62 20.85 6 20.57ZM19 13C16.67 13.67 14.33 14 12 14 9.67 14 7.33 13.67 5 13L5 16C5 17.66 6.38 19 8 19L16 19C17.62 19 19 17.66 19 16L19 13ZM9 15C9.55 15 10 15.45 10 16 10 16.55 9.55 17 9 17 8.45 17 8 16.55 8 16 8 15.45 8.45 15 9 15ZM15 15C15.55 15 16 15.45 16 16 16 16.55 15.55 17 15 17 14.45 17 14 16.55 14 16 14 15.45 14.45 15 15 15ZM16 2L8 2C6.38 2 5 3.34 5 5L5 11C7.33 11.67 9.67 12 12 12 14.33 12 16.67 11.67 19 11L19 5C19 3.34 17.62 2 16 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, H7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.29 2C19.61 2 20.77 2.89 21.13 4.18L21.8 7.12C22.01 7.04 22.25 7 22.5 7 23.33 7 24 7.45 24 8 24 8.55 23.33 9 22.5 9 22.41 9 22.31 8.99 22.22 8.98L22.29 9.29C23.3 9.78 24 10.81 24 12L24 19.92C24 21.05 23.12 22 22 22L19 22C17.88 22 17 21.05 17 19.92L17 19 7 19 7 19.92C7 21.05 6.12 22 5 22L2 22C0.88 22 0 21.05 0 19.92L0 12C0 10.87 0.63 9.88 1.55 9.37L1.64 8.99 1.5 9C0.72 9 0.08 8.61 0.01 8.1L0 8C0 7.45 0.67 7 1.5 7 1.71 7 1.9 7.03 2.08 7.08L2.74 4.18C2.79 4.02 2.85 3.87 2.91 3.72 3 3.54 3.1 3.38 3.21 3.22 3.33 3.06 3.46 2.91 3.64 2.75L3.82 2.6 4 2.47 4.26 2.32 4.43 2.24 4.6 2.18 4.83 2.1 5.02 2.06 5.17 2.03C5.3 2.01 5.43 2 5.56 2L18.29 2ZM22 18.23L21.89 18.29C20.99 18.74 20.01 18.98 19 19L19 19.92C19 19.98 19.02 20 19 20L22 20C21.98 20 22 19.98 22 19.92L22 18.23ZM2 18.24L2 19.92C2 19.98 2.02 20 2 20L5 20C4.98 20 5 19.98 5 19.92L5 19 4.77 18.99C3.84 18.94 2.94 18.7 2.11 18.29L2 18.24ZM21 11L3 11C2.45 11 2 11.45 2 12L2 15.38C2 15.76 2.21 16.11 2.55 16.28L3 16.5C3.66 16.83 4.38 17 5.12 17L18.88 17C19.62 17 20.34 16.83 21 16.5L21.45 16.28C21.79 16.11 22 15.76 22 15.38L22 12C22 11.45 21.55 11 21 11ZM5 13C5.55 13 6 13.45 6 14 6 14.55 5.55 15 5 15 4.45 15 4 14.55 4 14 4 13.45 4.45 13 5 13ZM19 13C19.55 13 20 13.45 20 14 20 14.55 19.55 15 19 15 18.45 15 18 14.55 18 14 18 13.45 18.45 13 19 13ZM18.28 4L5.58 4 5.49 4 5.43 4.01 5.38 4.02 5.29 4.05 5.21 4.08 5.1 4.14 5.05 4.17 4.96 4.25C4.91 4.29 4.87 4.34 4.83 4.4 4.79 4.45 4.76 4.5 4.73 4.56 4.7 4.61 4.69 4.67 4.67 4.72L3.75 9 20.11 9 19.21 4.72C19.1 4.33 18.78 4.05 18.39 4.01L18.28 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, R7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.5 1C18.27 1 19.01 1.31 19.56 1.85L22.15 4.44C22.69 4.99 23 5.73 23 6.5L23 20.09C23 21.7 21.7 23 20.09 23L2.91 23C1.36 23 1.02 21.79 1 20.26L1 6.5C1 5.73 1.31 4.99 1.85 4.44L4.44 1.85C4.99 1.31 5.73 1 6.5 1L17.5 1ZM10 13L9.88 12.99C9.39 12.94 9 12.51 9 12L9 9 3 9 3 20.09C3 20.59 3.41 21 3.91 21L20.09 21C20.59 21 21 20.59 21 20.09L21 9 15 9 15 12C15 12.55 14.55 13 14 13L10 13ZM13 9L11 9 11 11 13 11 13 9ZM17.5 3L6.5 3C6.26 3 6.03 3.1 5.86 3.27L3.27 5.86C3.1 6.03 3 6.26 3 6.5L3 7 21 7 21 6.5C21 6.26 20.9 6.03 20.73 5.86L18.14 3.27C17.97 3.1 17.74 3 17.5 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, T7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.44 15C20.26 15 21.03 15.41 21.5 16.08L23.56 19.08C24.34 20.22 24.06 21.77 22.93 22.55 22.51 22.84 22.01 23 21.5 23L2.5 23C1.12 23 0 21.88 0 20.5 0 19.99 0.15 19.5 0.44 19.08L2.5 16.08C2.97 15.41 3.74 15 4.56 15L19.44 15ZM19.44 17L4.56 17C4.4 17 4.24 17.08 4.15 17.22L2.09 20.22C2.03 20.3 2 20.4 2 20.5 2 20.78 2.22 21 2.5 21L21.5 21C21.6 21 21.7 20.97 21.79 20.91 22.01 20.75 22.07 20.44 21.91 20.22L19.85 17.22C19.76 17.08 19.6 17 19.44 17ZM11 1C11 0.45 11.45 0 12 0 12.55 0 13 0.45 13 1L13 9.5 13 9.54 15.29 7.28C15.66 6.93 16.25 6.91 16.64 7.22L16.71 7.28C17.1 7.65 17.1 8.26 16.71 8.63L12.71 12.53C12.32 12.9 11.68 12.9 11.29 12.53L7.29 8.63C6.9 8.26 6.9 7.65 7.29 7.28 7.68 6.91 8.32 6.91 8.71 7.28L11 9.54 11 1Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, V7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 2C7.66 2 9 3.34 9 5L9 6 20 6C21.66 6 23 7.34 23 9L23 10C23 11.66 21.66 13 20 13L9 13 9 20C9 21.66 7.66 23 6 23L4 23C2.34 23 1 21.66 1 20L1 5C1 3.34 2.34 2 4 2L6 2ZM6 4L4 4C3.45 4 3 4.45 3 5L3 20C3 20.55 3.45 21 4 21L6 21C6.55 21 7 20.55 7 20L7 5C7 4.45 6.55 4 6 4ZM20 8L9 8 9 11 20 11C20.55 11 21 10.55 21 10L21 9C21 8.45 20.55 8 20 8Z M6 7A1 1 0 0 1 5 8 1 1 0 0 1 4 7 1 1 0 0 1 6 7z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, D7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 11L15 8C15 7.08 16.14 6.65 16.75 7.34L23.75 15.34C24.1 15.74 24.08 16.33 23.71 16.71L16.71 23.71 16.62 23.78C15.99 24.3 15 23.85 15 23L15 20 13 20C12.45 20 12 19.55 12 19 12 18.45 12.45 18 13 18L16 18 16.12 18.01C16.61 18.06 17 18.49 17 19L17 20.59 21.63 15.95 17 10.66 17 12C17 12.55 16.55 13 16 13L9 13 9 16C9 16.88 7.95 17.32 7.33 16.74L7.25 16.66 0.25 8.66C-0.1 8.26-0.08 7.67 0.29 7.29L7.29 0.29C7.92-0.34 9 0.11 9 1L9 4 11 4C11.51 4 11.94 4.39 11.99 4.88L12 5C12 5.55 11.55 6 11 6L8 6C7.45 6 7 5.55 7 5L7 3.41 2.37 8.05 7 13.34 7 12C7 11.49 7.39 11.06 7.88 11.01L8 11 15 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, F7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.6 0 20.33 3.73 20.33 8.33 20.33 11.2 18.18 15.24 13.89 20.82L12 23.26 10.42 21.23C5.93 15.43 3.67 11.27 3.67 8.33 3.67 3.73 7.4 0 12 0ZM12 2C8.5 2 5.67 4.84 5.67 8.33 5.67 10.67 7.78 14.55 12 20L12.59 19.23C16.42 14.19 18.33 10.55 18.33 8.33 18.33 4.84 15.5 2 12 2ZM12 5C13.66 5 15 6.34 15 8 15 9.66 13.66 11 12 11 10.34 11 9 9.66 9 8 9 6.34 10.34 5 12 5ZM12 7C11.45 7 11 7.45 11 8 11 8.55 11.45 9 12 9 12.55 9 13 8.55 13 8 13 7.49 12.61 7.06 12.12 7.01L12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, j7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.46 0.47L18.57 0.48C18.72 0.49 18.86 0.53 19 0.61 19.48 0.88 19.64 1.5 19.37 1.97L6.37 23.03C6.21 23.3 5.94 23.47 5.65 23.51L5.54 23.53C5.36 23.53 5.17 23.49 5 23.39 4.52 23.12 4.36 22.5 4.63 22.03L17.63 0.97C17.81 0.67 18.13 0.49 18.46 0.47ZM14.59 4L13.36 6 10 6 10 11.43 8 14.67 8 6 2 6 2 9C3.66 9 5 10.34 5 12 5 13.66 3.66 15 2 15L2 18 5.95 18 4.71 20 1.5 20C0.67 20 0 19.37 0 18.59L0 14 0.01 13.88C0.06 13.39 0.49 13 1 13L2 13C2.55 13 3 12.55 3 12 3 11.45 2.55 11 2 11L1 11 0.88 10.99C0.39 10.94 0 10.51 0 10L0 5.41C0 4.63 0.67 4 1.5 4L14.59 4ZM19.29 4L22.5 4C23.33 4 24 4.63 24 5.41L24 18.59C24 19.37 23.33 20 22.5 20L9.41 20 10.64 18 22 18 22 6 18.05 6 19.29 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, E7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, O7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.1 1C15.65 1 16.1 1.45 16.1 2L16.1 4 19.1 4C19.65 4 20.1 4.45 20.1 5L20.1 7 21.1 7C21.65 7 22.1 7.45 22.1 8L22.1 12.39 23.37 12.9C23.86 13.09 24.11 13.63 23.95 14.13L21.16 22 23 22C23.55 22 24 22.45 24 23 24 23.55 23.55 24 23 24L1 24C0.45 24 0 23.55 0 23L0 17C0 16.45 0.45 16 1 16 1.55 16 2 16.45 2 17L2 22 5.03 22 2.05 14.15C1.88 13.64 2.14 13.09 2.63 12.9L4.1 12.31 4.1 8C4.1 7.45 4.55 7 5.1 7 5.14 7 5.18 7 5.22 7.01L6.1 7 6.1 5 6.11 4.88C6.16 4.39 6.59 4 7.1 4 7.14 4 7.18 4 7.22 4.01L8.39 4.02 10.1 4.02 10.1 2C10.1 1.49 10.49 1.06 10.98 1.01L11.1 1 15.1 1ZM21.77 14.41L13 10.9 4.25 14.4 7.05 21.68C7.08 21.79 7.1 21.89 7.1 22L19.1 22C19.1 21.9 19.11 21.8 19.15 21.7L21.77 14.41ZM14.22 3L12.1 3 12.1 5C12.1 5.38 11.65 5.88 11.22 5.92L8.1 6 8.1 8C8.1 8.38 7.61 8.96 7.18 9L7.1 9 6.1 9 6.1 11.51 12.63 8.9 12.71 8.87 12.83 8.84 12.91 8.83 13 8.82 13.09 8.83 13.19 8.84 13.3 8.87 13.37 8.9 20.1 11.59 20.1 9 19.1 9C18.66 9 18.14 8.44 18.1 8.07L18.1 8 18.1 6 15.06 5.92C14.62 5.92 14.26 5.63 14.22 5.26L14.22 5.19 14.22 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, P7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5.37 0.29L3.47 2.29C3.1 2.68 3.1 3.32 3.47 3.71L5.37 5.71C5.74 6.1 6.35 6.1 6.72 5.71 7.09 5.32 7.09 4.68 6.72 4.29L6.46 4 21 4C21.55 4 22 4.45 22 5L20.66 5C19.73 5 18.91 5.62 18.64 6.51L17.92 9 11.07 9C10.18 9 9.38 9.56 9.07 10.44L8.83 11.17C8.5 12.11 7.98 13.05 7.25 14L1 14C0.33 14 0.21 14.34 0.64 15.01L4.99 20.43 4.77 20.55C4.51 20.68 4.25 20.82 3.95 20.99L2.93 21.59 2.65 21.74 2.44 21.85 2.27 21.93C2.22 21.95 2.18 21.96 2.14 21.97L2 21.99 1 22C0.45 22 0 22.45 0 23 0 23.55 0.45 24 1 24L2.11 24C2.27 23.99 2.41 23.98 2.55 23.94L2.7 23.9C3.2 23.78 3.7 23.52 4.38 23.09L5.05 22.66 5.32 22.5 5.56 22.36C6.02 22.14 6.39 22.03 6.73 22L6.82 22C7.27 22.02 7.66 22.19 8.41 22.66L9.08 23.09C10.04 23.7 10.93 23.95 11.76 23.99L11.93 24 12.07 24 12.24 23.99C13.07 23.95 13.97 23.7 14.93 23.09L15.59 22.66C16.29 22.22 16.68 22.05 17.09 22.01L17.2 22 17.25 22C17.6 22.02 17.96 22.13 18.43 22.35 18.58 22.44 18.75 22.54 18.95 22.66L19.62 23.09C20.25 23.49 20.72 23.73 21.18 23.87L21.32 23.9C21.48 23.96 21.63 23.98 21.8 23.99L22 24 23 24C23.55 24 24 23.55 24 23L24 11.1 24 11 24 5C24 3.34 22.66 2 21 2L6.46 2 6.72 1.71C7.07 1.34 7.09 0.75 6.78 0.36L6.72 0.29C6.35-0.1 5.74-0.1 5.37 0.29ZM11.07 11L21.91 11 21.94 11.01C21.97 11.02 22 11.06 22 11.1L22 22C21.95 21.99 21.91 21.98 21.87 21.98 21.69 21.93 21.43 21.8 20.9 21.49L20.27 21.12C19.88 20.89 19.54 20.7 19.21 20.54 18.5 20.15 17.98 20 17.27 20L17.15 20C16.27 20 15.62 20.24 14.36 20.9L13.66 21.28 13.26 21.49C12.76 21.74 12.41 21.88 12.1 21.95L12 21.97C11.59 21.9 11.12 21.69 10.34 21.28L9.65 20.9C8.56 20.33 7.93 20.07 7.21 20.01L4 16 8 16C8.66 16 9.65 15.02 10.97 11.07 10.99 11.03 11.02 11 11.07 11ZM14 14C13.45 14 13 14.45 13 15 13 15.55 13.45 16 14 16L18 16C18.55 16 19 15.55 19 15 19 14.45 18.55 14 18 14L14 14ZM20.66 7L22 7 22 9 20 9 20.56 7.07C20.58 7.03 20.62 7 20.66 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, U7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.63 0.29L20.53 2.29C20.9 2.68 20.9 3.32 20.53 3.71L18.63 5.71C18.26 6.1 17.65 6.1 17.28 5.71 16.91 5.32 16.91 4.68 17.28 4.29L17.54 4 3 4C2.45 4 2 4.45 2 5L3.34 5C4.27 5 5.09 5.62 5.36 6.51L6.08 9 12.93 9C13.82 9 14.62 9.56 14.93 10.44L15.17 11.17C15.5 12.11 16.02 13.05 16.75 14L23 14C23.67 14 23.79 14.34 23.36 15.01L19.01 20.43 19.23 20.55C19.49 20.68 19.75 20.82 20.05 20.99L21.07 21.59 21.35 21.74 21.56 21.85C21.69 21.92 21.78 21.95 21.86 21.97L22 21.99 23 22C23.55 22 24 22.45 24 23 24 23.55 23.55 24 23 24L21.89 24C21.73 23.99 21.59 23.98 21.45 23.94L21.3 23.9C20.8 23.78 20.3 23.52 19.62 23.09L18.95 22.66 18.68 22.5 18.44 22.36C17.98 22.14 17.61 22.03 17.27 22L17.18 22C16.73 22.02 16.34 22.19 15.59 22.66L14.92 23.09C13.96 23.7 13.07 23.95 12.24 23.99L12.07 24 11.93 24 11.76 23.99C10.93 23.95 10.03 23.7 9.07 23.09L8.41 22.66C7.71 22.22 7.32 22.05 6.91 22.01L6.8 22 6.75 22C6.4 22.02 6.04 22.13 5.57 22.35 5.42 22.44 5.25 22.54 5.05 22.66L4.38 23.09C3.75 23.49 3.28 23.73 2.82 23.87L2.68 23.9C2.52 23.96 2.37 23.98 2.2 23.99L2 24 1 24C0.45 24 0 23.55 0 23L0 11.1 0 11 0 5C0 3.34 1.34 2 3 2L17.54 2 17.28 1.71C16.93 1.34 16.91 0.75 17.22 0.36L17.28 0.29C17.65-0.1 18.26-0.1 18.63 0.29ZM12.93 11L2.1 11 2.06 11.01C2.03 11.02 2 11.06 2 11.1L2 22C2.05 21.99 2.09 21.98 2.13 21.98 2.31 21.93 2.57 21.8 3.1 21.49L3.73 21.12C4.12 20.89 4.46 20.7 4.79 20.54 5.5 20.15 6.02 20 6.73 20L6.85 20C7.73 20 8.38 20.24 9.64 20.9L10.34 21.28 10.74 21.49C11.24 21.74 11.59 21.88 11.9 21.95L12 21.97C12.41 21.9 12.88 21.69 13.66 21.28L14.35 20.9C15.44 20.33 16.07 20.07 16.79 20.01L20 16 16 16C15.34 16 14.35 15.02 13.03 11.07 13.01 11.03 12.98 11 12.93 11ZM10 14C10.55 14 11 14.45 11 15 11 15.55 10.55 16 10 16L6 16C5.45 16 5 15.55 5 15 5 14.45 5.45 14 6 14L10 14ZM3.34 7L2 7 2 9 4 9 3.44 7.07C3.42 7.03 3.38 7 3.34 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, W7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.34 2C4.27 2 5.09 2.62 5.36 3.51L6.08 6 12.93 6C13.82 6 14.62 6.56 14.93 7.44L15.17 8.17C15.66 9.58 16.09 10.67 16.46 11.44L16.61 11.73 16.75 12 23 12C23.67 12 23.79 12.34 23.36 13.01L19.01 18.43 19.23 18.55C19.49 18.68 19.75 18.82 20.05 18.99L21.07 19.59 21.35 19.74C21.59 19.87 21.74 19.94 21.86 19.97L22 19.99 23 20C23.55 20 24 20.45 24 21 24 21.55 23.55 22 23 22L21.98 22 21.89 22C21.73 21.99 21.59 21.98 21.45 21.94L21.3 21.9C20.8 21.78 20.3 21.52 19.62 21.09L18.95 20.66 18.68 20.5 18.44 20.36C17.98 20.14 17.61 20.03 17.27 20L17.18 20C16.73 20.02 16.34 20.19 15.59 20.66L14.92 21.09C13.96 21.7 13.07 21.95 12.24 21.99L12.07 22 11.93 22 11.76 21.99C10.93 21.95 10.03 21.7 9.07 21.09L8.41 20.66C7.71 20.22 7.32 20.05 6.91 20.01L6.8 20 6.75 20C6.4 20.02 6.04 20.13 5.57 20.35 5.42 20.44 5.25 20.54 5.05 20.66L4.38 21.09C3.75 21.49 3.28 21.73 2.82 21.87L2.68 21.9C2.52 21.96 2.37 21.98 2.2 21.99L2 22 1 22C0.45 22 0 21.55 0 21L0 8.1 0 8 0 2 3.34 2ZM12.93 8L2.1 8 2.06 8.01C2.03 8.02 2 8.06 2 8.1L2 20C2.05 19.99 2.09 19.98 2.13 19.98 2.31 19.93 2.57 19.8 3.1 19.49L3.73 19.12C4.12 18.89 4.46 18.7 4.79 18.54 5.5 18.15 6.02 18 6.73 18L6.85 18C7.73 18 8.38 18.24 9.64 18.9L10.34 19.28 10.74 19.49C11.24 19.74 11.59 19.88 11.9 19.95L12 19.97C12.41 19.9 12.88 19.69 13.66 19.28L14.35 18.9C15.44 18.33 16.07 18.07 16.79 18.01L20 14 16 14C15.34 14 14.35 12.02 13.03 8.07 13.01 8.03 12.98 8 12.93 8ZM10 10C10.55 10 11 10.45 11 11 11 11.55 10.55 12 10 12L6 12C5.45 12 5 11.55 5 11 5 10.45 5.45 10 6 10L10 10ZM3.34 4L2 4 2 6 4 6 3.44 4.07C3.42 4.03 3.38 4 3.34 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, q7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 4C16.42 4 20 7.58 20 12 20 16.42 16.42 20 12 20L11.75 20C7.45 19.86 4 16.33 4 12 4 7.58 7.58 4 12 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, G7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6.5 13C5.12 13 4 14.12 4 15.5 4 16.88 5.12 18 6.5 18L18.54 18 17.28 16.71C16.93 16.34 16.91 15.75 17.22 15.36L17.28 15.29C17.65 14.9 18.26 14.9 18.63 15.29L21.53 18.29C21.9 18.68 21.9 19.32 21.53 19.71L18.63 22.71C18.26 23.1 17.65 23.1 17.28 22.71 16.91 22.32 16.91 21.68 17.28 21.29L18.54 20 6.5 20C4.01 20 2 17.99 2 15.5 2 13.01 4.01 11 6.5 11L17.5 11C18.88 11 20 9.88 20 8.5 20 7.12 18.88 6 17.5 6L9.87 6C9.43 7.73 7.86 9 6 9 3.79 9 2 7.21 2 5 2 2.79 3.79 1 6 1 7.86 1 9.43 2.27 9.87 4L17.5 4C19.99 4 22 6.01 22 8.5 22 10.99 19.99 13 17.5 13L6.5 13ZM6 3C4.9 3 4 3.9 4 5 4 6.1 4.9 7 6 7 7.1 7 8 6.1 8 5 8 3.9 7.1 3 6 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, K7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM18.35 7.48L15.17 14.2C15.07 14.41 14.91 14.57 14.7 14.67L7.98 17.85C7.13 18.26 6.24 17.37 6.65 16.52L9.83 9.8C9.93 9.59 10.09 9.43 10.3 9.33L17.02 6.15C17.87 5.74 18.76 6.63 18.35 7.48ZM15.35 9.15L11.48 10.98 9.65 14.85 13.52 13.02 15.35 9.15Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, e2 = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 0C14.55 0 15 0.45 15 1L15 3 18 3C18.55 3 19 3.45 19 4L19 6 20 6C20.55 6 21 6.45 21 7L21 11.39 22.27 11.9C22.76 12.09 23.01 12.63 22.85 13.13L20.06 21 21.07 21.59C21.48 21.82 21.7 21.93 21.86 21.97L22 21.99 23 22C23.55 22 24 22.45 24 23 24 23.55 23.55 24 23 24L21.98 24 21.89 24C21.73 23.99 21.59 23.98 21.45 23.94L21.3 23.9C20.8 23.78 20.3 23.52 19.62 23.09L18.95 22.66 18.68 22.5 18.44 22.36C17.98 22.14 17.61 22.03 17.27 22L17.18 22C16.73 22.02 16.34 22.19 15.59 22.66L14.92 23.09C13.96 23.7 13.07 23.95 12.24 23.99L12.07 24 11.93 24 11.76 23.99C10.93 23.95 10.03 23.7 9.07 23.09L8.41 22.66C7.71 22.22 7.32 22.05 6.91 22.01L6.8 22 6.75 22C6.4 22.02 6.04 22.13 5.57 22.35 5.42 22.44 5.25 22.54 5.05 22.66L4.38 23.09C3.75 23.49 3.28 23.73 2.82 23.87L2.68 23.9C2.52 23.96 2.37 23.98 2.2 23.99L2 24 1 24C0.45 24 0 23.55 0 23 0 22.45 0.45 22 1 22L2 22C2.05 21.99 2.09 21.98 2.13 21.98 2.31 21.93 2.57 21.8 3.1 21.49L3.93 21 0.95 13.15C0.78 12.64 1.04 12.09 1.53 11.9L3 11.31 3 7C3 6.45 3.45 6 4 6 4.04 6 4.08 6 4.12 6.01L5 6 5 4 5.01 3.88C5.06 3.39 5.49 3 6 3 6.04 3 6.08 3 6.12 3.01L7.29 3.02 9 3.02 9 1C9 0.49 9.39 0.06 9.88 0.01L10 0 14 0ZM11.9 9.9L3.15 13.4 5.74 20.13C6.05 20.04 6.37 20 6.73 20L6.85 20C7.73 20 8.38 20.24 9.64 20.9L10.34 21.28 10.74 21.49C11.24 21.74 11.59 21.88 11.9 21.95L12 21.97C12.41 21.9 12.88 21.69 13.66 21.28L14.35 20.9C15.54 20.27 16.19 20.03 17 20L17.27 20C17.63 20 17.94 20.04 18.25 20.13L20.67 13.41 11.9 9.9ZM13.12 2L11 2 11 4C11 4.38 10.55 4.88 10.12 4.92L7 5 7 7C7 7.38 6.51 7.96 6.08 8L6 8 5 8 5 10.51 11.53 7.9 11.65 7.86 11.76 7.83 11.9 7.82 11.99 7.83 12.09 7.84 12.2 7.87 12.27 7.9 19 10.59 19 8 18 8C17.56 8 17.04 7.44 17 7.07L17 7 17 5 13.96 4.92C13.52 4.92 13.16 4.63 13.12 4.26L13.12 4.19 13.12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, X7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM13.01 4.06C16.96 4.31 20 7.92 20 12 20 16.07 16.96 19.68 13.03 19.93 12 20 12 20 12 19 12 13.51 12 7.86 12 5 12 4 12 4 13.01 4.06Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Q7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 0C15.4 0 15.77 0.24 15.92 0.62L16.92 3 18.29 3C19.61 3 20.77 3.89 21.13 5.18L21.8 8.12C22.01 8.04 22.25 8 22.5 8 23.33 8 24 8.45 24 9 24 9.55 23.33 10 22.5 10 22.41 10 22.31 9.99 22.22 9.98L22.29 10.29C23.3 10.78 24 11.81 24 13L24 20.92C24 22.05 23.12 23 22 23L19 23C17.88 23 17 22.05 17 20.92L17 20 7 20 7 20.92C7 22.05 6.12 23 5 23L2 23C0.88 23 0 22.05 0 20.92L0 13C0 11.87 0.63 10.88 1.55 10.37L1.64 9.99 1.5 10C0.72 10 0.08 9.61 0.01 9.1L0 9C0 8.45 0.67 8 1.5 8 1.71 8 1.9 8.03 2.08 8.08L2.74 5.18C2.79 5.02 2.85 4.87 2.91 4.72 3 4.54 3.1 4.38 3.21 4.22 3.33 4.06 3.46 3.91 3.64 3.75L3.82 3.6 4 3.47 4.26 3.32 4.43 3.24 4.6 3.18 4.83 3.1 5.02 3.06 5.17 3.03C5.3 3.01 5.43 3 5.56 3L7.05 3 7.06 2.95 8.08 0.6C8.24 0.24 8.6 0 9 0L15 0ZM22 19.23L21.89 19.29C20.99 19.74 20.01 19.98 19 20L19 20.92C19 20.98 19.02 21 19 21L22 21C21.98 21 22 20.98 22 20.92L22 19.23ZM2 19.24L2 20.92C2 20.98 2.02 21 2 21L5 21C4.98 21 5 20.98 5 20.92L5 20 4.77 19.99C3.84 19.94 2.94 19.7 2.11 19.29L2 19.24ZM21 12L3 12C2.45 12 2 12.45 2 13L2 16.38C2 16.76 2.21 17.11 2.55 17.28L3 17.5C3.66 17.83 4.38 18 5.12 18L18.88 18C19.62 18 20.34 17.83 21 17.5L21.45 17.28C21.79 17.11 22 16.76 22 16.38L22 13C22 12.45 21.55 12 21 12ZM5 14C5.55 14 6 14.45 6 15 6 15.55 5.55 16 5 16 4.45 16 4 15.55 4 15 4 14.45 4.45 14 5 14ZM19 14C19.55 14 20 14.45 20 15 20 15.55 19.55 16 19 16 18.45 16 18 15.55 18 15 18 14.45 18.45 14 19 14ZM18.28 5L5.58 5 5.49 5 5.43 5.01 5.38 5.02 5.29 5.05 5.21 5.08 5.1 5.14 5.05 5.17 4.96 5.25C4.91 5.29 4.87 5.34 4.83 5.4 4.79 5.45 4.76 5.5 4.73 5.56 4.7 5.61 4.69 5.67 4.67 5.72L3.75 10 20.11 10 19.21 5.72C19.1 5.33 18.78 5.05 18.39 5.01L18.28 5ZM14.33 2L9.65 2 9.22 3 14.75 3 14.33 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, J7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.5 5C22.33 5 23 5.67 23 6.5L23 18.5C23 19.33 22.33 20 21.5 20L2.5 20C1.67 20 1 19.33 1 18.5L1 15.04 1.63 14.78C2.93 14.26 3.5 13.58 3.5 12.5 3.5 11.42 2.93 10.74 1.63 10.22L1 9.96 1 6.5C1 5.67 1.67 5 2.5 5L21.5 5ZM9 7C8.45 7 8 7.45 8 8L8 17C8 17.55 8.45 18 9 18 9.55 18 10 17.55 10 17L10 8C10 7.45 9.55 7 9 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Y7 = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.5 4C23.33 4 24 4.63 24 5.41L24 18.59C24 19.37 23.33 20 22.5 20L1.5 20C0.67 20 0 19.37 0 18.59L0 14 0.01 13.88C0.06 13.39 0.49 13 1 13L2 13C2.55 13 3 12.55 3 12 3 11.45 2.55 11 2 11L1 11 0.88 10.99C0.39 10.94 0 10.51 0 10L0 5.41C0 4.63 0.67 4 1.5 4L22.5 4ZM8 6L2 6 2 9C3.66 9 5 10.34 5 12 5 13.66 3.66 15 2 15L2 18 8 18 8 6ZM22 6L10 6 10 18 22 18 22 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, C8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.5 3C22.88 3 24 4.12 24 5.5L24 15.5C24 16.88 22.88 18 21.5 18L15.24 18 15.07 18.34C14.59 19.3 13.64 19.92 12.58 19.99L12.38 20 10.87 20C10.78 20.35 10.64 20.7 10.45 21.02L10.35 21.19 10.28 21.29 10.19 21.41 10.09 21.54 9.97 21.68 9.86 21.8 9.75 21.91 9.64 22.01 9.53 22.1 9.39 22.2 9.24 22.31 9.1 22.4 8.97 22.48 8.84 22.55 8.7 22.62 8.56 22.68 8.41 22.74 8.29 22.79 8.08 22.85 7.93 22.89 7.76 22.93 7.58 22.96 7.41 22.98 7.25 22.99 7.23 22.99 7.17 23 7 23C6.89 23 6.78 23 6.61 22.98L6.41 22.96 6.15 22.91 5.99 22.87 5.83 22.82 5.67 22.77 5.53 22.72 5.38 22.66 5.24 22.59 5.08 22.51 4.92 22.41 4.77 22.32 4.65 22.24 4.53 22.14 4.4 22.04 4.31 21.96 4.15 21.81 4.06 21.71 3.97 21.61 3.89 21.52 3.8 21.4 3.69 21.25 3.61 21.13 3.54 21.01C3.36 20.69 3.22 20.35 3.13 20L0 20 0 5.5C0 4.12 1.12 3 2.5 3L21.5 3ZM7 17C6.94 17 6.88 17 6.81 17.01L6.69 17.02 6.54 17.05 6.33 17.11 6.13 17.2 6.05 17.24C5.96 17.29 5.88 17.34 5.8 17.4L5.65 17.52 5.53 17.65 5.42 17.77 5.36 17.86 5.27 18C5.1 18.29 5 18.64 5 19 5 19.37 5.1 19.71 5.27 20L5.32 20.08 5.43 20.24 5.51 20.33 5.6 20.43 5.67 20.5 5.8 20.6 5.92 20.68 6.08 20.78 6.23 20.85 6.37 20.9 6.54 20.95 6.69 20.98 6.75 20.99 6.91 21 7.09 21 7.17 20.99 7.13 20.99 7.25 20.99 7.43 20.95 7.58 20.91 7.67 20.89 7.81 20.83 7.95 20.76 8.08 20.68 8.23 20.57 8.35 20.48 8.45 20.37 8.57 20.23 8.66 20.12 8.71 20.03 8.73 20C8.9 19.71 9 19.37 9 19 9 18.72 8.94 18.45 8.84 18.21 8.81 18.14 8.77 18.07 8.73 18L8.68 17.91 8.58 17.77 8.43 17.61 8.33 17.51 8.28 17.46 8.2 17.4 8.08 17.32 7.92 17.22 7.77 17.15 7.63 17.1 7.46 17.05 7.31 17.02 7.17 17.01 7.08 17 7 17ZM21.5 5L2.5 5C2.22 5 2 5.22 2 5.5L2 18 3.13 18C3.22 17.64 3.37 17.28 3.58 16.93L3.67 16.79 3.75 16.67 3.81 16.58 3.9 16.47 4 16.35 4.12 16.23 4.24 16.1 4.38 15.98 4.52 15.86 4.59 15.81C4.75 15.69 4.92 15.58 5.13 15.46L5.22 15.42 5.36 15.35 5.56 15.27 5.76 15.2 5.97 15.14 6.15 15.09 6.3 15.06 6.44 15.04 6.63 15.02C6.75 15.01 6.88 15 7.04 15L7.21 15.01 7.29 15.01 7.55 15.04 7.7 15.06 7.85 15.09 8.01 15.13 8.17 15.18 8.33 15.23 8.47 15.28 8.62 15.34 8.76 15.41 8.92 15.49 9.08 15.59 9.23 15.68 9.35 15.76 9.45 15.84 9.64 15.99 9.71 16.06 9.82 16.16 9.94 16.29 10.08 16.45 10.2 16.61 10.31 16.75 10.38 16.87 10.46 17C10.64 17.31 10.78 17.65 10.87 18L12.38 18C12.76 18 13.11 17.79 13.28 17.45L13.72 16.55C13.89 16.21 14.24 16 14.62 16L21.5 16C21.78 16 22 15.78 22 15.5L22 5.5C22 5.22 21.78 5 21.5 5ZM16.9 7.1C17.46 7.1 17.9 7.54 17.9 8.1L17.9 10.64 18.2 10.38C18.57 10.02 19.15 10 19.55 10.32L19.61 10.38C20 10.75 20 11.36 19.61 11.73L17.61 13.62C17.22 14 16.59 14 16.2 13.62L14.2 11.73C13.81 11.36 13.81 10.75 14.2 10.38 14.59 10 15.22 10 15.61 10.38L15.9 10.64 15.9 8.1C15.9 7.54 16.35 7.1 16.9 7.1Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, L8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.5 3C22.88 3 24 4.12 24 5.5L24 15.5C24 16.88 22.88 18 21.5 18L15.24 18 15.07 18.34C14.59 19.3 13.64 19.92 12.58 19.99L12.38 20 10.87 20C10.78 20.35 10.64 20.7 10.45 21.02L10.35 21.19 10.28 21.29 10.19 21.41 10.09 21.54 9.97 21.68 9.86 21.8 9.75 21.91 9.64 22.01 9.53 22.1 9.39 22.2 9.24 22.31 9.1 22.4 8.97 22.48 8.84 22.55 8.7 22.62 8.56 22.68 8.41 22.74 8.29 22.79 8.08 22.85 7.93 22.89 7.76 22.93 7.58 22.96 7.41 22.98 7.25 22.99 7.23 22.99 7.17 23 7 23C6.89 23 6.78 23 6.61 22.98L6.41 22.96 6.15 22.91 5.99 22.87 5.83 22.82 5.67 22.77 5.53 22.72 5.38 22.66 5.24 22.59 5.08 22.51 4.92 22.41 4.77 22.32 4.65 22.24 4.53 22.14 4.4 22.04 4.31 21.96 4.15 21.81 4.06 21.71 3.97 21.61 3.89 21.52 3.8 21.4 3.69 21.25 3.61 21.13 3.54 21.01C3.36 20.69 3.22 20.35 3.13 20L0 20 0 5.5C0 4.12 1.12 3 2.5 3L21.5 3ZM7 17C6.94 17 6.88 17 6.81 17.01L6.69 17.02 6.54 17.05 6.33 17.11 6.13 17.2 6.05 17.24C5.96 17.29 5.88 17.34 5.8 17.4L5.65 17.52 5.53 17.65 5.42 17.77 5.36 17.86 5.27 18C5.1 18.29 5 18.64 5 19 5 19.37 5.1 19.71 5.27 20L5.32 20.08 5.43 20.24 5.51 20.33 5.6 20.43 5.67 20.5 5.8 20.6 5.92 20.68 6.08 20.78 6.23 20.85 6.37 20.9 6.54 20.95 6.69 20.98 6.75 20.99 6.91 21 7.09 21 7.17 20.99 7.13 20.99 7.25 20.99 7.43 20.95 7.58 20.91 7.67 20.89 7.81 20.83 7.95 20.76 8.08 20.68 8.23 20.57 8.35 20.48 8.45 20.37 8.57 20.23 8.66 20.12 8.71 20.03 8.73 20C8.9 19.71 9 19.37 9 19 9 18.72 8.94 18.45 8.84 18.21 8.81 18.14 8.77 18.07 8.73 18L8.68 17.91 8.58 17.77 8.43 17.61 8.33 17.51 8.28 17.46 8.2 17.4 8.08 17.32 7.92 17.22 7.77 17.15 7.63 17.1 7.46 17.05 7.31 17.02 7.17 17.01 7.08 17 7 17ZM21.5 5L2.5 5C2.22 5 2 5.22 2 5.5L2 18 3.13 18C3.22 17.64 3.37 17.28 3.58 16.93L3.67 16.79 3.75 16.67 3.81 16.58 3.9 16.47 4 16.35 4.12 16.23 4.24 16.1 4.38 15.98 4.52 15.86 4.59 15.81C4.75 15.69 4.92 15.58 5.13 15.46L5.22 15.42 5.36 15.35 5.56 15.27 5.76 15.2 5.97 15.14 6.15 15.09 6.3 15.06 6.44 15.04 6.63 15.02C6.75 15.01 6.88 15 7.04 15L7.21 15.01 7.29 15.01 7.55 15.04 7.7 15.06 7.85 15.09 8.01 15.13 8.17 15.18 8.33 15.23 8.47 15.28 8.62 15.34 8.76 15.41 8.92 15.49 9.08 15.59 9.23 15.68 9.35 15.76 9.45 15.84 9.64 15.99 9.71 16.06 9.82 16.16 9.94 16.29 10.08 16.45 10.2 16.61 10.31 16.75 10.38 16.87 10.46 17C10.64 17.31 10.78 17.65 10.87 18L12.38 18C12.76 18 13.11 17.79 13.28 17.45L13.72 16.55C13.89 16.21 14.24 16 14.62 16L21.5 16C21.78 16 22 15.78 22 15.5L22 5.5C22 5.22 21.78 5 21.5 5ZM16.2 7.38C16.59 7 17.22 7 17.61 7.38L19.61 9.27C20 9.64 20 10.25 19.61 10.62L19.55 10.68C19.15 11 18.57 10.98 18.2 10.62L17.9 10.36 17.9 12.9C17.9 13.46 17.46 13.9 16.9 13.9 16.35 13.9 15.9 13.46 15.9 12.9L15.9 10.36 15.61 10.62C15.22 11 14.59 11 14.2 10.62 13.81 10.25 13.81 9.64 14.2 9.27L16.2 7.38Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, e8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.5 3C22.88 3 24 4.12 24 5.5L24 15.5C24 16.88 22.88 18 21.5 18L15.24 18 15.07 18.34C14.59 19.3 13.64 19.92 12.58 19.99L12.38 20 10.87 20C10.78 20.35 10.64 20.7 10.45 21.02L10.35 21.19 10.28 21.29 10.19 21.41 10.09 21.54 9.97 21.68 9.86 21.8 9.75 21.91 9.64 22.01 9.53 22.1 9.39 22.2 9.24 22.31 9.1 22.4 8.97 22.48 8.84 22.55 8.7 22.62 8.56 22.68 8.41 22.74 8.29 22.79 8.08 22.85 7.93 22.89 7.76 22.93 7.58 22.96 7.41 22.98 7.25 22.99 7.23 22.99 7.17 23 7 23C6.89 23 6.78 23 6.61 22.98L6.41 22.96 6.15 22.91 5.99 22.87 5.83 22.82 5.67 22.77 5.53 22.72 5.38 22.66 5.24 22.59 5.08 22.51 4.92 22.41 4.77 22.32 4.65 22.24 4.53 22.14 4.4 22.04 4.31 21.96 4.15 21.81 4.06 21.71 3.97 21.61 3.89 21.52 3.8 21.4 3.69 21.25 3.61 21.13 3.54 21.01C3.36 20.69 3.22 20.35 3.13 20L0 20 0 5.5C0 4.12 1.12 3 2.5 3L21.5 3ZM7 17C6.94 17 6.88 17 6.81 17.01L6.69 17.02 6.54 17.05 6.33 17.11 6.13 17.2 6.05 17.24C5.96 17.29 5.88 17.34 5.8 17.4L5.65 17.52 5.53 17.65 5.42 17.77 5.36 17.86 5.27 18C5.1 18.29 5 18.64 5 19 5 19.37 5.1 19.71 5.27 20L5.32 20.08 5.43 20.24 5.51 20.33 5.6 20.43 5.67 20.5 5.8 20.6 5.92 20.68 6.08 20.78 6.23 20.85 6.37 20.9 6.54 20.95 6.69 20.98 6.75 20.99 6.91 21 7.1 21 7.25 20.99 7.43 20.95 7.58 20.91 7.67 20.89 7.81 20.83 7.95 20.76 8.08 20.68 8.23 20.57 8.35 20.48 8.45 20.37 8.57 20.23 8.66 20.12 8.71 20.03 8.73 20C8.9 19.71 9 19.37 9 19 9 18.64 8.9 18.29 8.73 18L8.68 17.91 8.58 17.77 8.43 17.61 8.33 17.51 8.28 17.46 8.2 17.4 8.08 17.32 7.92 17.22 7.77 17.15 7.63 17.1 7.46 17.05 7.31 17.02 7.17 17.01 7.08 17 7 17ZM21.5 5L2.5 5C2.22 5 2 5.22 2 5.5L2 18 3.13 18C3.22 17.64 3.37 17.28 3.58 16.93L3.67 16.79 3.75 16.67 3.81 16.58 3.9 16.47 4 16.35 4.12 16.23 4.24 16.1 4.38 15.98 4.52 15.86 4.59 15.81C4.75 15.69 4.92 15.58 5.13 15.46L5.22 15.42 5.36 15.35 5.56 15.27 5.76 15.2 5.97 15.14 6.15 15.09 6.3 15.06 6.44 15.04 6.63 15.02C6.75 15.01 6.88 15 7.04 15L7.21 15.01 7.29 15.01 7.55 15.04 7.7 15.06 7.85 15.09 8.01 15.13 8.17 15.18 8.33 15.23 8.47 15.28 8.62 15.34 8.76 15.41 8.92 15.49 9.08 15.59 9.23 15.68 9.35 15.76 9.45 15.84 9.64 15.99 9.71 16.06 9.82 16.16 9.94 16.29 10.08 16.45 10.2 16.61 10.31 16.75 10.38 16.87 10.46 17C10.64 17.31 10.78 17.65 10.87 18L12.38 18C12.76 18 13.11 17.79 13.28 17.45L13.72 16.55C13.89 16.21 14.24 16 14.62 16L21.5 16C21.78 16 22 15.78 22 15.5L22 5.5C22 5.22 21.78 5 21.5 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, n2 = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 0C18.71 0 21 2.24 21 5L21 15C21 17.05 19.74 18.8 17.99 19.58L19.95 21.54C20.34 21.93 20.34 22.56 19.95 22.95 19.56 23.34 18.93 23.34 18.54 22.95L15.71 20.12C15.67 20.08 15.63 20.04 15.6 20L9.05 20C9.02 20.04 8.99 20.08 8.95 20.12L6.12 22.95C5.73 23.34 5.1 23.34 4.71 22.95 4.32 22.56 4.32 21.93 4.71 21.54L6.48 19.76C4.49 19.11 3 17.23 3 15L3 5C3 2.24 5.29 0 8 0L16 0ZM19 7L5 7 5 15C5 16.66 6.38 18 8 18L16 18C17.62 18 19 16.66 19 15L19 7ZM15 14C15.55 14 16 14.45 16 15 16 15.55 15.55 16 15 16L9 16C8.45 16 8 15.55 8 15 8 14.45 8.45 14 9 14L15 14ZM16 2L8 2C6.38 2 5 3.34 5 5L19 5C19 3.34 17.62 2 16 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, n8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 3C17.71 3 20 5.24 20 8L20 16C20 18.05 18.74 19.8 16.99 20.58L18.95 22.54C19.34 22.93 19.34 23.56 18.95 23.95 18.56 24.34 17.93 24.34 17.54 23.95L14.71 21.12C14.67 21.08 14.63 21.04 14.6 21L10.05 21C10.02 21.04 9.99 21.08 9.95 21.12L7.12 23.95C6.73 24.34 6.1 24.34 5.71 23.95 5.32 23.56 5.32 22.93 5.71 22.54L7.48 20.76C5.49 20.11 4 18.23 4 16L4 8C4 5.24 6.29 3 9 3L15 3ZM18 10L6 10 6 16C6 17.66 7.38 19 9 19L15 19C16.62 19 18 17.66 18 16L18 10ZM9 15C9.55 15 10 15.45 10 16 10 16.55 9.55 17 9 17 8.45 17 8 16.55 8 16 8 15.45 8.45 15 9 15ZM15 15C15.55 15 16 15.45 16 16 16 16.55 15.55 17 15 17 14.45 17 14 16.55 14 16 14 15.45 14.45 15 15 15ZM15 5L9 5C7.38 5 6 6.34 6 8L18 8C18 6.34 16.62 5 15 5ZM10 0L14 0C14.55 0 15 0.45 15 1 15 1.55 14.55 2 14 2L10 2C9.45 2 9 1.55 9 1 9 0.45 9.45 0 10 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, i8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.19 0C10.68 0 12 1.15 12 2.71L12 6 17.38 6C18.54 6 19.63 6.59 20.23 7.59L23.72 13.45C23.9 13.76 24 14.11 24 14.47L24 19C24 20.05 23.18 20.92 22.15 20.99L22 21 20.96 21C20.72 22.7 19.26 24 17.5 24 15.74 24 14.28 22.7 14.04 21L0 21 0 19 10 19 10 2.71C10 2.32 9.64 2 9.19 2L0 2 0 0 9.19 0ZM17.5 19C16.68 19 16.01 19.66 16 20.48L16 20.52 16.01 20.64C16.08 21.41 16.72 22 17.5 22 18.33 22 19 21.33 19 20.5 19 19.67 18.33 19 17.5 19ZM17.38 8L12 8 12 19 14.34 19C14.9 17.82 16.1 17 17.5 17 18.9 17 20.1 17.82 20.66 19L22 19 22 15.02C22 14.66 21.9 14.31 21.72 14L18.51 8.61 18.51 8.61C18.28 8.24 17.85 8 17.38 8ZM17 10C17.55 10 18 10.45 18 11 18 11.55 17.55 12 17 12L15 12C14.45 12 14 11.55 14 11 14 10.45 14.45 10 15 10L17 10Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, o8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M10 0C11.31 0 12.42 0.83 12.83 2L17.81 2C19.68 2 21.29 3.29 21.71 5.11L22.44 8.3C22.95 10.57 23.17 12.89 23.09 15.22L23 18C23 20.21 21.21 22 19 22L18.46 22C17.77 23.2 16.48 24 15 24 13.52 24 12.23 23.2 11.54 22L1 22 1 0 10 0ZM15 18C13.9 18 13 18.9 13 20 13 21.1 13.9 22 15 22 16.1 22 17 21.1 17 20 17 18.95 16.18 18.08 15.15 18.01L15 18ZM11.54 18L3 18 3 20 11 20C11 19.27 11.19 18.59 11.54 18ZM18.46 18C18.77 18.53 18.96 19.15 19 19.8L19 20C20.1 20 21 19.1 21 18L18.46 18ZM17.81 4L13 4 13 16 21.07 16 21.1 15.15C21.16 13.21 21 11.27 20.62 9.37L20.49 8.74 19.76 5.56C19.55 4.65 18.74 4 17.81 4ZM10 2L3 2 3 16 11 16 11 2.99 10.99 2.88C10.94 2.39 10.51 2 10 2ZM18 8C18.55 8 19 8.45 19 9 19 9.55 18.55 10 18 10L15 10C14.45 10 14 9.55 14 9 14 8.45 14.45 8 15 8L18 8Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, t8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.66 0 22 1.34 22 3L22 8C22.55 8 23 8.45 23 9L23 11C23 11.55 22.55 12 22 12L22 18C22 18.89 21.61 19.69 21 20.24L21 22C21 23.1 20.1 24 19 24L17 24C15.9 24 15 23.1 15 22L15 21 9 21 9 22C9 23.1 8.1 24 7 24L5 24C3.9 24 3 23.1 3 22L3 20.24C2.39 19.69 2 18.89 2 18L2 12C1.45 12 1 11.55 1 11L1 9C1 8.45 1.45 8 2 8L2 3C2 1.34 3.34 0 5 0L19 0ZM19 21L17 21 17 22 19 22 19 21ZM7 21L5 21 5 22 7 22 7 21ZM20 13L4 13 4 18C4 18.55 4.45 19 5 19L19 19C19.55 19 20 18.55 20 18L20 13ZM14 15C14.55 15 15 15.45 15 16 15 16.55 14.55 17 14 17L10 17C9.45 17 9 16.55 9 16 9 15.45 9.45 15 10 15L14 15ZM19 6L5 6C4.45 6 4 6.45 4 7L4 11 20 11 20 7C20 6.45 19.55 6 19 6ZM19 2L5 2C4.45 2 4 2.45 4 3L4 4.17C4.31 4.06 4.65 4 5 4L19 4C19.35 4 19.69 4.06 20 4.17L20 3C20 2.45 19.55 2 19 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, a8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14 1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM12 0C12.55 0 13 0.45 13 1L13 13.54 14.29 12.28C14.68 11.91 15.32 11.91 15.71 12.28 16.1 12.65 16.1 13.26 15.71 13.63L12.71 16.53C12.32 16.9 11.68 16.9 11.29 16.53L8.29 13.63C7.9 13.26 7.9 12.65 8.29 12.28L8.36 12.22C8.75 11.91 9.34 11.93 9.71 12.28L11 13.54 11 1C11 0.45 11.45 0 12 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, s8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 3C16.97 3 21 7.03 21 12 21 14.13 20.26 16.08 19.03 17.62L19.09 17.67 22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L17.67 19.09 17.62 19.03C16.08 20.26 14.13 21 12 21 7.03 21 3 16.97 3 12 3 7.03 7.03 3 12 3ZM12 5C8.13 5 5 8.13 5 12 5 15.87 8.13 19 12 19 15.87 19 19 15.87 19 12 19 8.13 15.87 5 12 5ZM10.83 9.41L12.24 10.83 13.66 9.41C14.05 9.02 14.68 9.02 15.07 9.41 15.46 9.8 15.46 10.44 15.07 10.83L13.66 12.24 15.07 13.66C15.46 14.05 15.46 14.68 15.07 15.07 14.68 15.46 14.05 15.46 13.66 15.07L12.24 13.66 10.83 15.07C10.44 15.46 9.8 15.46 9.41 15.07 9.02 14.68 9.02 14.05 9.41 13.66L10.83 12.24 9.41 10.83C9.02 10.44 9.02 9.8 9.41 9.41 9.8 9.02 10.44 9.02 10.83 9.41Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, c8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 3C16.97 3 21 7.03 21 12 21 14.13 20.26 16.08 19.03 17.62L19.09 17.67 22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L17.67 19.09 17.62 19.03C16.08 20.26 14.13 21 12 21 7.03 21 3 16.97 3 12 3 7.03 7.03 3 12 3ZM12 5C8.13 5 5 8.13 5 12 5 15.87 8.13 19 12 19 15.87 19 19 15.87 19 12 19 8.13 15.87 5 12 5ZM15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L9 13C8.45 13 8 12.55 8 12 8 11.45 8.45 11 9 11L15 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, r8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 3C16.97 3 21 7.03 21 12 21 14.13 20.26 16.08 19.03 17.62L19.09 17.67 22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L17.67 19.09 17.62 19.03C16.08 20.26 14.13 21 12 21 7.03 21 3 16.97 3 12 3 7.03 7.03 3 12 3ZM12 5C8.13 5 5 8.13 5 12 5 15.87 8.13 19 12 19 15.87 19 19 15.87 19 12 19 8.13 15.87 5 12 5ZM13 9L13 11 15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L13 13 13 15C13 15.55 12.55 16 12 16 11.45 16 11 15.55 11 15L11 13 9 13C8.45 13 8 12.55 8 12 8 11.45 8.45 11 9 11L11 11 11 9C11 8.45 11.45 8 12 8 12.55 8 13 8.45 13 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, m8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C17.52 2 22 6.48 22 12 22 14.4 21.15 16.61 19.74 18.33L22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L18.33 19.74C16.61 21.15 14.4 22 12 22 6.48 22 2 17.52 2 12 2 6.48 6.48 2 12 2ZM12 4C7.58 4 4 7.58 4 12 4 16.42 7.58 20 12 20 16.42 20 20 16.42 20 12 20 7.58 16.42 4 12 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, l8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.94 2.33L15.94 22.33C15.64 23.19 14.45 23.23 14.09 22.41L10.24 13.76 1.59 9.91C0.81 9.56 0.81 8.47 1.55 8.1L1.67 8.06 21.67 1.06C22.46 0.78 23.22 1.54 22.94 2.33ZM20.37 3.63L4.71 9.11 10.78 11.81 15.29 7.29C15.68 6.9 16.32 6.9 16.71 7.29 17.1 7.68 17.1 8.32 16.71 8.71L12.19 13.22 14.89 19.29 20.37 3.63Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, d8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 22C23 22.55 22.55 23 22 23 21.45 23 21 22.55 21 22L21 17C21 16.45 20.55 16 20 16L4 16C3.45 16 3 16.45 3 17L3 22C3 22.55 2.55 23 2 23 1.45 23 1 22.55 1 22L1 17C1 15.34 2.34 14 4 14L5 14C5 11.79 6.79 10 9 10L15 10C17.21 10 19 11.79 19 14L20 14C21.66 14 23 15.34 23 17L23 22ZM18 18C18.55 18 19 18.45 19 19 19 19.55 18.55 20 18 20L16 20C15.45 20 15 19.55 15 19 15 18.45 15.45 18 16 18L18 18ZM15 12L9 12C7.9 12 7 12.9 7 14L17 14C17 12.9 16.1 12 15 12ZM12 1C14.21 1 16 2.79 16 5 16 7.21 14.21 9 12 9 9.79 9 8 7.21 8 5 8 2.79 9.79 1 12 1ZM12 3C10.9 3 10 3.9 10 5 10 6.1 10.9 7 12 7 13.1 7 14 6.1 14 5 14 3.9 13.1 3 12 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, M8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 9C6.55 9 7 9.45 7 10 7 10.51 6.61 10.94 6.12 10.99L6 11 4 11C3.45 11 3 11.45 3 12L3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 12C21 11.45 20.55 11 20 11L18 11C17.45 11 17 10.55 17 10 17 9.45 17.45 9 18 9L20 9C21.66 9 23 10.34 23 12L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 12C1 10.34 2.34 9 4 9L6 9ZM12.71 0.28L15.71 3.17C16.1 3.55 16.1 4.15 15.71 4.53 15.32 4.9 14.68 4.9 14.29 4.53L13 3.27 13 16.81C13 17.36 12.55 17.81 12 17.81 11.45 17.81 11 17.36 11 16.81L11 3.31 11 3.27 9.71 4.53C9.34 4.88 8.75 4.9 8.36 4.58L8.29 4.53C7.9 4.15 7.9 3.55 8.29 3.17L11.29 0.28C11.68-0.09 12.32-0.09 12.71 0.28Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Z8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.82L12.48 0.94 20.48 2.93 22.19 3.35 21.99 5.1 20.93 14.3C20.65 16.78 19.35 19.02 17.35 20.5L13.68 23.23 13.58 23.31 13.46 23.37C12.43 23.95 11.16 23.87 10.21 23.16L6.64 20.5C4.64 19.02 3.35 16.78 3.07 14.31L2.01 5.1 1.81 3.35 3.52 2.93 11.52 0.94 12 0.82ZM12 2.88L4 4.87 5.06 14.08C5.28 16 6.28 17.74 7.83 18.9L11.4 21.56C11.72 21.79 12.15 21.82 12.49 21.63L16.16 18.9C17.72 17.74 18.72 16 18.94 14.08L20 4.87 12 2.88Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, u8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 2C21.66 2 23 3.34 23 5L23 19C23 20.66 21.66 22 20 22L10 22C8.34 22 7 20.66 7 19L7 16C7 15.45 7.45 15 8 15 8.55 15 9 15.45 9 16L9 19C9 19.55 9.45 20 10 20L20 20C20.55 20 21 19.55 21 19L21 5C21 4.45 20.55 4 20 4L10 4C9.45 4 9 4.45 9 5L9 8C9 8.55 8.55 9 8 9 7.45 9 7 8.55 7 8L7 5C7 3.34 8.34 2 10 2L20 2ZM14.13 8.29L17.03 11.29C17.4 11.68 17.4 12.32 17.03 12.71L14.13 15.71C13.76 16.1 13.15 16.1 12.78 15.71 12.41 15.32 12.41 14.68 12.78 14.29L14.04 13 1.5 13C0.95 13 0.5 12.55 0.5 12 0.5 11.45 0.95 11 1.5 11L14 11 14.04 11 12.78 9.71C12.43 9.34 12.41 8.75 12.72 8.36L12.78 8.29C13.15 7.9 13.76 7.9 14.13 8.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, f8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 2C14.66 2 16 3.34 16 5L16 8C16 8.55 15.55 9 15 9 14.45 9 14 8.55 14 8L14 5C14 4.45 13.55 4 13 4L4 4C3.45 4 3 4.45 3 5L3 19C3 19.55 3.45 20 4 20L13 20C13.55 20 14 19.55 14 19L14 16C14 15.45 14.45 15 15 15 15.55 15 16 15.45 16 16L16 19C16 20.66 14.66 22 13 22L4 22C2.34 22 1 20.66 1 19L1 5C1 3.34 2.34 2 4 2L13 2ZM20.13 8.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L20.13 15.71C19.76 16.1 19.15 16.1 18.78 15.71 18.41 15.32 18.41 14.68 18.78 14.29L20.04 13 7.5 13C6.95 13 6.5 12.55 6.5 12 6.5 11.45 6.95 11 7.5 11L20 11 20.04 11 18.78 9.71C18.43 9.34 18.41 8.75 18.72 8.36L18.78 8.29C19.15 7.9 19.76 7.9 20.13 8.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, p8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 3C20.21 3 22 4.79 22 7 22 9.21 20.21 11 18 11 15.79 11 14 9.21 14 7 14 4.79 15.79 3 18 3ZM18 5C16.9 5 16 5.9 16 7 16 8.1 16.9 9 18 9 19.1 9 20 8.1 20 7 20 5.9 19.1 5 18 5ZM6 13C3.79 13 2 14.79 2 17 2 19.21 3.79 21 6 21 8.21 21 10 19.21 10 17 10 14.79 8.21 13 6 13ZM6 15C7.1 15 8 15.9 8 17 8 18.1 7.1 19 6 19 4.9 19 4 18.1 4 17 4 15.9 4.9 15 6 15ZM21 16L13 16C12.45 16 12 16.45 12 17 12 17.55 12.45 18 13 18L21 18C21.55 18 22 17.55 22 17 22 16.45 21.55 16 21 16ZM3 6L11 6C11.55 6 12 6.45 12 7 12 7.55 11.55 8 11 8L3 8C2.45 8 2 7.55 2 7 2 6.45 2.45 6 3 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, x8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 0C3.55 0 4 0.45 4 1L4 5.17C5.17 5.58 6 6.69 6 8 6 9.31 5.17 10.42 4 10.83L4 23C4 23.55 3.55 24 3 24 2.45 24 2 23.55 2 23L2 10.83C0.83 10.42 0 9.31 0 8 0 6.69 0.83 5.58 2 5.17L2 1C2 0.45 2.45 0 3 0ZM3 7C2.45 7 2 7.45 2 8 2 8.55 2.45 9 3 9 3.55 9 4 8.55 4 8 4 7.49 3.61 7.06 3.12 7.01L3 7ZM12 0C12.55 0 13 0.45 13 1L13 13.17C14.17 13.58 15 14.69 15 16 15 17.31 14.17 18.42 13 18.83L13 23C13 23.55 12.55 24 12 24 11.45 24 11 23.55 11 23L11 18.83C9.83 18.42 9 17.31 9 16 9 14.69 9.83 13.58 11 13.17L11 1C11 0.45 11.45 0 12 0ZM12 15C11.45 15 11 15.45 11 16 11 16.55 11.45 17 12 17 12.55 17 13 16.55 13 16 13 15.49 12.61 15.06 12.12 15.01L12 15ZM21 0C21.55 0 22 0.45 22 1L22 5.17C23.17 5.58 24 6.69 24 8 24 9.31 23.17 10.42 22 10.83L22 23C22 23.55 21.55 24 21 24 20.45 24 20 23.55 20 23L20 10.83C18.83 10.42 18 9.31 18 8 18 6.69 18.83 5.58 20 5.17L20 1C20 0.45 20.45 0 21 0ZM21 7C20.45 7 20 7.45 20 8 20 8.55 20.45 9 21 9 21.55 9 22 8.55 22 8 22 7.49 21.61 7.06 21.12 7.01L21 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, h8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 3C21.66 3 23 4.34 23 6L23 18C23 19.66 21.66 21 20 21L6.96 21 2.5 23.61C2.03 23.88 1.42 23.72 1.14 23.25 1.05 23.09 1 22.92 1 22.74L1 6C1 4.34 2.34 3 4 3L20 3ZM20 5L4 5C3.45 5 3 5.45 3 6L3 21 6.42 19 20 19C20.55 19 21 18.55 21 18L21 6C21 5.45 20.55 5 20 5ZM8 11C8.55 11 9 11.45 9 12 9 12.55 8.55 13 8 13 7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11ZM12 11C12.55 11 13 11.45 13 12 13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13 15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, _8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7 6L17 6C17.55 6 18 6.45 18 7 18 7.55 17.55 8 17 8L7 8C6.45 8 6 7.55 6 7 6 6.45 6.45 6 7 6ZM7 11L15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11ZM7 16L13 16C13.55 16 14 16.45 14 17 14 17.55 13.55 18 13 18L7 18C6.45 18 6 17.55 6 17 6 16.45 6.45 16 7 16Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, N8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 4.01C6 3.45 6.45 3 7 3 7.55 3 8 3.45 8 4.01L8 17.65 8 17.69 9.29 16.42C9.66 16.06 10.25 16.04 10.64 16.36L10.71 16.42C11.1 16.8 11.1 17.41 10.71 17.79L7.71 20.72C7.32 21.09 6.68 21.09 6.29 20.72L3.29 17.79C2.9 17.41 2.9 16.8 3.29 16.42 3.68 16.04 4.32 16.04 4.71 16.42L6 17.7 6 4.01ZM12 3L20 3C20.55 3 21 3.45 21 4 21 4.55 20.55 5 20 5L12 5C11.45 5 11 4.55 11 4 11 3.45 11.45 3 12 3ZM12 7L18 7C18.55 7 19 7.45 19 8 19 8.55 18.55 9 18 9L12 9C11.45 9 11 8.55 11 8 11 7.45 11.45 7 12 7ZM12 11L16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13L12 13C11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, z8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7 16L17 16C17.55 16 18 16.45 18 17 18 17.55 17.55 18 17 18L7 18C6.45 18 6 17.55 6 17 6 16.45 6.45 16 7 16ZM7 11L15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11ZM7 6L13 6C13.55 6 14 6.45 14 7 14 7.55 13.55 8 13 8L7 8C6.45 8 6 7.55 6 7 6 6.45 6.45 6 7 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, g8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 19.99C6 20.55 6.45 21 7 21 7.55 21 8 20.55 8 19.99L8 6.35 8 6.31 9.29 7.58C9.66 7.94 10.25 7.96 10.64 7.64L10.71 7.58C11.1 7.2 11.1 6.59 10.71 6.21L7.71 3.28C7.32 2.91 6.68 2.91 6.29 3.28L3.29 6.21C2.9 6.59 2.9 7.2 3.29 7.58 3.68 7.96 4.32 7.96 4.71 7.58L6 6.3 6 19.99ZM12 19L20 19C20.55 19 21 19.45 21 20 21 20.55 20.55 21 20 21L12 21C11.45 21 11 20.55 11 20 11 19.45 11.45 19 12 19ZM12 15L18 15C18.55 15 19 15.45 19 16 19 16.55 18.55 17 18 17L12 17C11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM12 11L16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13L12 13C11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, b8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.18 0.08L13.64 1.63C15.04 3.12 16.05 5.73 16.66 7.45 17.17 7.26 17.73 7.12 18.33 7.02L19.89 6.78 20.49 8.24C20.88 9.18 21.05 10.11 20.99 11 21.36 11.01 21.74 11.02 22.12 11.06L23.8 11.2 23.94 12.88C24.24 16.34 23.37 19.2 21.29 21.29 19.2 23.37 16.34 24.24 12.88 23.94L12 23.86 11.12 23.94C7.66 24.24 4.8 23.37 2.71 21.29 0.63 19.2-0.24 16.34 0.06 12.88L0.2 11.2 1.88 11.06C2.26 11.02 2.64 11.01 3.01 11 2.95 10.11 3.12 9.18 3.51 8.24L4.11 6.78 5.67 7.02C6.39 7.14 7.06 7.32 7.66 7.57L7.91 6.87C8.53 5.16 9.47 2.96 10.72 1.63L12.18 0.08ZM2.05 13.05C1.8 15.96 2.49 18.23 4.13 19.87 5.77 21.51 8.04 22.2 10.95 21.95 10.99 21.53 11 21.11 11 20.72L10.98 20.19 10.96 19.84 10.92 19.47C10.85 18.91 10.73 18.39 10.57 17.9L10.52 17.76 10.41 17.46 10.31 17.23 10.19 16.98 10.05 16.7 9.93 16.48 9.83 16.33 9.69 16.11 9.49 15.83 9.26 15.55 9.14 15.41 8.94 15.19 8.67 14.94 8.43 14.72 8.2 14.53 7.98 14.37 7.73 14.2 7.63 14.14 7.45 14.03C7.27 13.93 7.08 13.83 6.88 13.74L6.59 13.61 6.29 13.49 5.91 13.37 5.69 13.31 5.38 13.23 5.05 13.16 4.97 13.15C4.87 13.13 4.76 13.11 4.65 13.1 4.45 13.07 4.23 13.05 4.01 13.03L3.66 13.01 3.84 13.02C3.28 12.99 2.68 13 2.05 13.05ZM20.6 13L20.4 13.01 20.05 13.03C19.81 13.04 19.58 13.07 19.35 13.1L18.97 13.16 18.62 13.23 18.4 13.28 18.09 13.37 17.72 13.49 17.57 13.55 17.51 13.57C17.3 13.65 17.1 13.74 16.91 13.84L16.63 13.99 16.37 14.14 16.27 14.2 16 14.39 15.78 14.55 15.67 14.64 15.55 14.73 15.44 14.83C15.33 14.93 15.23 15.03 15.13 15.13L14.87 15.4 14.7 15.59 14.52 15.82 14.44 15.92C14.17 16.29 13.94 16.69 13.74 17.11L13.75 17.1C13.66 17.29 13.58 17.48 13.51 17.68L13.4 17.98 13.32 18.28 13.24 18.58 13.22 18.68 13.18 18.89C13.13 19.12 13.09 19.36 13.07 19.61L13.02 20.1 13.01 20.43 13 20.67 13 20.83C13 21.19 13.02 21.56 13.05 21.95 15.96 22.2 18.23 21.51 19.87 19.87 21.51 18.23 22.2 15.96 21.95 13.05 21.64 13.02 21.34 13.01 21.04 13L20.6 13ZM12.18 3C11.41 3.82 10.78 5 10.28 6.17L10.24 6.26C9.41 8.05 9 9.82 9 11.56 9 11.94 9.02 12.31 9.06 12.69 9.49 12.99 9.9 13.33 10.29 13.71 11 14.43 11.57 15.23 12 16.11 12.43 15.23 13 14.43 13.71 13.71 14.21 13.22 14.75 12.79 15.33 12.43L15.35 12.14 15.36 11.9 15.36 11.56C15.36 11.39 15.36 11.22 15.35 11.05L15.35 10.97C15.26 9.28 14.78 7.56 13.91 5.81 13.44 4.76 12.87 3.73 12.18 3ZM5.36 9C5.04 9.78 4.93 10.49 5.04 11.13 5.73 11.24 6.38 11.4 7 11.63L7 11.56C7 10.87 7.05 10.21 7.16 9.55 6.66 9.29 6.06 9.11 5.36 9ZM18.64 9C18.09 9.09 17.6 9.22 17.17 9.39 17.3 10.08 17.36 10.79 17.36 11.5 17.87 11.34 18.4 11.22 18.96 11.13 19.07 10.49 18.96 9.78 18.64 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, y8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.1 17.29C22.49 17.68 22.49 18.32 22.1 18.71L17.98 22.83C17.77 23.04 17.48 23.14 17.2 23.12 16.92 23.14 16.63 23.04 16.41 22.83L14.29 20.71C13.9 20.32 13.9 19.68 14.29 19.29 14.68 18.9 15.32 18.9 15.71 19.29L17.2 20.78 20.69 17.29C21.08 16.9 21.71 16.9 22.1 17.29ZM18 1C19.66 1 21 2.34 21 4L21 14C21 14.55 20.55 15 20 15 19.45 15 19 14.55 19 14L19 4C19 3.45 18.55 3 18 3L6 3C5.45 3 5 3.45 5 4L5 20C5 20.55 5.45 21 6 21L12 21C12.55 21 13 21.45 13 22 13 22.55 12.55 23 12 23L6 23C4.34 23 3 21.66 3 20L3 4C3 2.34 4.34 1 6 1L18 1ZM16 9C16.55 9 17 9.45 17 10 17 10.51 16.61 10.94 16.12 10.99L16 11 8 11C7.45 11 7 10.55 7 10 7 9.45 7.45 9 8 9L16 9ZM16 5C16.55 5 17 5.45 17 6 17 6.51 16.61 6.94 16.12 6.99L16 7 8 7C7.45 7 7 6.55 7 6 7 5.45 7.45 5 8 5L16 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, w8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1C19.66 1 21 2.34 21 4L21 20C21 21.66 19.66 23 18 23L6 23C4.34 23 3 21.66 3 20L3 4C3 2.34 4.34 1 6 1L18 1ZM18 3L6 3C5.45 3 5 3.45 5 4L5 20C5 20.55 5.45 21 6 21L18 21C18.55 21 19 20.55 19 20L19 4C19 3.45 18.55 3 18 3ZM16 17C16.55 17 17 17.45 17 18 17 18.51 16.61 18.94 16.12 18.99L16 19 8 19C7.45 19 7 18.55 7 18 7 17.45 7.45 17 8 17L16 17ZM16 13C16.55 13 17 13.45 17 14 17 14.51 16.61 14.94 16.12 14.99L16 15 8 15C7.45 15 7 14.55 7 14 7 13.45 7.45 13 8 13L16 13ZM16 9C16.55 9 17 9.45 17 10 17 10.51 16.61 10.94 16.12 10.99L16 11 8 11C7.45 11 7 10.55 7 10 7 9.45 7.45 9 8 9L16 9ZM16 5C16.55 5 17 5.45 17 6 17 6.51 16.61 6.94 16.12 6.99L16 7 8 7C7.45 7 7 6.55 7 6 7 5.45 7.45 5 8 5L16 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, S8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.12 1.77C11.38 1.22 12.03 0.98 12.58 1.24 12.81 1.35 13 1.53 13.11 1.77L15.92 7.75 22.18 8.7C22.74 8.79 23.14 9.28 23.12 9.84L23.11 9.96C23.07 10.19 22.97 10.4 22.8 10.56L18.24 15.24 19.32 21.86C19.41 22.42 19.06 22.95 18.53 23.09L18.41 23.12C18.16 23.16 17.92 23.12 17.7 23L12.11 19.91 6.53 23C6.03 23.27 5.42 23.12 5.1 22.67L5.04 22.57C4.92 22.35 4.87 22.1 4.91 21.86L5.99 15.24 1.42 10.56C1.03 10.16 1.01 9.53 1.36 9.1L1.44 9C1.61 8.84 1.82 8.74 2.05 8.7L8.31 7.75 11.12 1.77ZM12.11 4.35L9.92 9.03C9.76 9.36 9.45 9.6 9.09 9.65L4.08 10.42 7.74 14.17C7.95 14.39 8.06 14.68 8.05 14.99L8.04 15.11 7.18 20.35 11.58 17.92C11.87 17.76 12.22 17.74 12.52 17.86L12.65 17.92 17.04 20.35 16.19 15.11C16.14 14.81 16.22 14.51 16.4 14.27L16.49 14.17 20.15 10.42 15.14 9.65C14.82 9.6 14.55 9.42 14.38 9.15L14.31 9.03 12.11 4.35Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, B8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 12C5.55 12 6 12.45 6 13L6 23C6 23.55 5.55 24 5 24 4.45 24 4 23.55 4 23L4 13C4 12.45 4.45 12 5 12ZM12 7.2C12.55 7.2 13 7.65 13 8.2L13 23C13 23.55 12.55 24 12 24 11.45 24 11 23.55 11 23L11 8.2C11 7.65 11.45 7.2 12 7.2ZM19 0C19.55 0 20 0.45 20 1L20 23C20 23.55 19.55 24 19 24 18.45 24 18 23.55 18 23L18 1C18 0.45 18.45 0 19 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, v8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 4C23.55 4 24 4.45 24 5L24 10C24 10.55 23.55 11 23 11 22.45 11 22 10.55 22 10L22 7.41 12.71 16.71C12.32 17.1 11.68 17.1 11.29 16.71L8 13.41 1.71 19.71C1.35 20.07 0.78 20.1 0.39 19.79L0.29 19.71C-0.1 19.32-0.1 18.68 0.29 18.29L7.29 11.29C7.68 10.9 8.32 10.9 8.71 11.29L12 14.59 20.58 6 18 6C17.45 6 17 5.55 17 5 17 4.45 17.45 4 18 4L23 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, k8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM2 12C2 17.52 6.48 22 12 22 17.18 22 21.45 18.05 21.95 13L12 13C11.45 13 11 12.55 11 12L11 2.05C5.95 2.55 2 6.81 2 12ZM13 2.05L13 11 21.95 11C21.49 6.37 17.87 2.67 13.28 2.08L13 2.05Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, $8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, A8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.77 18.6L20.91 20.04C18.72 22.47 15.54 24 12 24 11.32 24 10.65 23.94 10 23.83L10 22 12 22C14.29 22 16.45 21.23 18.21 19.84L19.77 18.6ZM1.87 13.23L2.5 15.13C3.21 17.27 4.62 19.11 6.5 20.35L8.17 21.45 7.16 22.98C3.47 21.36 0.76 17.93 0.14 13.81L1.87 13.23ZM22.39 5.98C23.41 7.75 24 9.81 24 12 24 14.01 23.5 15.91 22.63 17.58L20.89 17.01 21.51 15.11C21.83 14.13 22 13.09 22 12.04 22 10.79 21.79 9.61 21.37 8.5L20.67 6.63 22.39 5.98ZM6.64 1.26L7.72 2.74 6.1 3.92C4.29 5.25 2.96 7.16 2.36 9.33L1.83 11.25 0.06 10.77C0.49 6.6 3.05 3.06 6.64 1.26ZM12 0C15.34 0 18.35 1.36 20.53 3.56L19.46 5.05 17.83 3.88C16.15 2.66 14.13 2 12 2 11.85 2 11.7 2 11.55 2.01L9.55 2.1 9.47 0.27C10.29 0.09 11.13 0 12 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, I8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 11H21A1 1 0 0 1 22 12V12A1 1 0 0 1 21 13H3A1 1 0 0 1 2 12V12A1 1 0 0 1 3 11z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, H8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, R8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM17.54 9.23C17.93 9.62 17.93 10.26 17.54 10.65L12.42 15.77C12.21 15.98 11.92 16.08 11.64 16.06 11.36 16.08 11.07 15.98 10.85 15.77L7.73 12.65C7.34 12.26 7.34 11.62 7.73 11.23 8.12 10.84 8.76 10.84 9.15 11.23L11.64 13.72 16.13 9.23C16.52 8.84 17.15 8.84 17.54 9.23Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, T8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.55 21.7C10.32 21.89 11.17 22 12 22L12 24C11.01 24 10 23.87 9.06 23.64L9.55 21.7ZM4.49 18.6C5.15 19.35 5.92 20.01 6.78 20.53L5.74 22.24C4.71 21.61 3.78 20.83 2.99 19.92L4.49 18.6ZM2.07 13.17C2.19 14.19 2.46 15.16 2.86 16.06L1.03 16.88C0.54 15.78 0.22 14.61 0.08 13.4L2.07 13.17ZM1.35 6.46L3.12 7.39C2.67 8.27 2.34 9.22 2.16 10.23L0.19 9.88C0.4 8.68 0.79 7.53 1.35 6.46ZM6.43 1.37L7.36 3.14C6.46 3.61 5.65 4.21 4.94 4.92L3.53 3.5C4.38 2.65 5.36 1.93 6.43 1.37ZM24 12C24 18.63 18.63 24 12 24L12 22C17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2 11.39 2 10.8 2.05 10.22 2.16L9.87 0.19C10.57 0.06 11.27 0 12 0 18.63 0 24 5.37 24 12Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, V8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.55 21.7C10.32 21.89 11.17 22 12 22L12 24C11.01 24 10 23.87 9.06 23.64L9.55 21.7ZM4.49 18.6C5.15 19.35 5.92 20.01 6.78 20.53L5.74 22.24C4.71 21.61 3.78 20.83 2.99 19.92L4.49 18.6ZM2.07 13.17C2.19 14.19 2.46 15.16 2.86 16.06L1.03 16.88C0.54 15.78 0.22 14.61 0.08 13.4L2.07 13.17ZM17.54 9.23C17.93 9.62 17.93 10.26 17.54 10.65L12.42 15.77C12.21 15.98 11.92 16.08 11.64 16.06 11.36 16.08 11.07 15.98 10.85 15.77L7.73 12.65C7.34 12.26 7.34 11.62 7.73 11.23 8.12 10.84 8.76 10.84 9.15 11.23L11.64 13.72 16.13 9.23C16.52 8.84 17.15 8.84 17.54 9.23ZM1.35 6.46L3.12 7.39C2.67 8.27 2.34 9.22 2.16 10.23L0.19 9.88C0.4 8.68 0.79 7.53 1.35 6.46ZM6.43 1.37L7.36 3.14C6.46 3.61 5.65 4.21 4.94 4.92L3.53 3.5C4.38 2.65 5.36 1.93 6.43 1.37ZM24 12C24 18.63 18.63 24 12 24L12 22C17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2 11.39 2 10.8 2.05 10.22 2.16L9.87 0.19C10.57 0.06 11.27 0 12 0 18.63 0 24 5.37 24 12Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, D8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 11.01 24 10 23.87 9.06 23.64L9.55 21.7C10.19 21.86 10.89 21.96 11.58 21.99L12 22C17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2 11.39 2 10.8 2.05 10.22 2.16L9.87 0.19C10.57 0.06 11.27 0 12 0ZM4.49 18.6C5.15 19.35 5.92 20.01 6.78 20.53L5.74 22.24C4.71 21.61 3.78 20.83 2.99 19.92L4.49 18.6ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM2.07 13.17C2.19 14.19 2.46 15.16 2.86 16.06L1.03 16.88C0.54 15.78 0.22 14.61 0.08 13.4L2.07 13.17ZM12 7C13.66 7 15 8.34 15 10 15 11.31 14.17 12.42 13 12.83L13 13C13 13.55 12.55 14 12 14 11.45 14 11 13.55 11 13L11 12C11 11.49 11.39 11.06 11.88 11.01L12 11C12.55 11 13 10.55 13 10 13 9.45 12.55 9 12 9 11.49 9 11.06 9.39 11.01 9.88L11 10C11 10.55 10.55 11 10 11 9.45 11 9 10.55 9 10 9 8.34 10.34 7 12 7ZM1.35 6.46L3.12 7.39C2.67 8.27 2.34 9.22 2.16 10.23L0.19 9.88C0.4 8.68 0.79 7.53 1.35 6.46ZM6.43 1.37L7.36 3.14C6.46 3.61 5.65 4.21 4.94 4.92L3.53 3.5C4.38 2.65 5.36 1.93 6.43 1.37Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, F8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM21.95 13L2.05 13C2.55 18.05 6.82 22 12 22 17.09 22 21.29 18.2 21.92 13.28L21.95 13ZM12 2C6.81 2 2.55 5.95 2.05 11L21.95 11C21.45 5.95 17.19 2 12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, j8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.77 18.6L20.91 20.04C18.72 22.47 15.54 24 12 24 11.32 24 10.65 23.94 10 23.83L10 22 12 22C14.29 22 16.45 21.23 18.21 19.84L19.77 18.6ZM1.87 13.23L2.5 15.13C3.21 17.27 4.62 19.11 6.5 20.35L8.17 21.45 7.16 22.98C3.47 21.36 0.76 17.93 0.14 13.81L1.87 13.23ZM22.39 5.98C23.41 7.75 24 9.81 24 12 24 14.01 23.5 15.91 22.63 17.58L20.89 17.01 21.51 15.11C21.83 14.13 22 13.09 22 12.04 22 10.79 21.79 9.61 21.37 8.5L20.67 6.63 22.39 5.98ZM16.1 9.29C16.49 9.68 16.49 10.32 16.1 10.71L11.98 14.83C11.77 15.04 11.48 15.14 11.2 15.12 10.92 15.14 10.63 15.04 10.41 14.83L8.29 12.71C7.9 12.32 7.9 11.68 8.29 11.29 8.68 10.9 9.32 10.9 9.71 11.29L11.2 12.78 14.69 9.29C15.08 8.9 15.71 8.9 16.1 9.29ZM6.64 1.26L7.72 2.74 6.1 3.92C4.29 5.25 2.96 7.16 2.36 9.33L1.83 11.25 0.06 10.77C0.49 6.6 3.05 3.06 6.64 1.26ZM12 0C15.34 0 18.35 1.36 20.53 3.56L19.46 5.05 17.83 3.88C16.15 2.66 14.13 2 12 2 11.85 2 11.7 2 11.55 2.01L9.55 2.1 9.47 0.27C10.29 0.09 11.13 0 12 0Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, E8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C17.52 0 22 4.48 22 10L22 12C22 16.5 19.03 20.3 14.95 21.56 14.69 22.95 13.47 24 12 24 10.34 24 9 22.66 9 21 9 19.34 10.34 18 12 18 13.13 18 14.12 18.63 14.63 19.56 16.86 18.78 18.63 17.05 19.47 14.86 19.16 14.95 18.84 15 18.5 15L18 15C16.34 15 15 13.66 15 12L15 10C15 8.34 16.34 7 18 7L18.5 7C18.84 7 19.16 7.05 19.47 7.14 18.32 4.13 15.41 2 12 2 8.59 2 5.68 4.13 4.53 7.14 4.84 7.05 5.16 7 5.5 7L6 7C7.66 7 9 8.34 9 10L9 12C9 13.66 7.66 15 6 15L5.5 15C3.57 15 2 13.43 2 11.5L2 10.5C2 10.39 2.01 10.28 2.02 10.17 2.01 10.12 2 10.06 2 10 2 4.48 6.48 0 12 0ZM12 20C11.45 20 11 20.45 11 21 11 21.55 11.45 22 12 22 12.55 22 13 21.55 13 21 13 20.62 12.79 20.3 12.49 20.13L12.4 20.08 12.32 20.05 12.23 20.03 12.17 20.01 12.09 20 12 20ZM6 9L5.5 9C4.67 9 4 9.67 4 10.5L4 11.5C4 12.33 4.67 13 5.5 13L6 13C6.55 13 7 12.55 7 12L7 10C7 9.45 6.55 9 6 9ZM18.5 9L18 9C17.45 9 17 9.45 17 10L17 12C17 12.55 17.45 13 18 13L18.5 13C19.33 13 20 12.33 20 11.5L20 10.5C20 9.67 19.33 9 18.5 9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, O8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.71 14.56L18.78 17.64 18.78 15C18.78 14.45 19.23 14 19.78 14 20.33 14 20.78 14.45 20.78 15L20.78 20C20.78 20.51 20.39 20.94 19.89 20.99L19.78 21 14.78 21C14.23 21 13.78 20.55 13.78 20 13.78 19.45 14.23 19 14.78 19L17.31 19 14.29 15.98C13.9 15.59 13.9 14.96 14.29 14.56 14.68 14.17 15.32 14.17 15.71 14.56ZM19.78 3C20.33 3 20.78 3.45 20.78 4L20.78 9C20.78 9.55 20.33 10 19.78 10 19.23 10 18.78 9.55 18.78 9L18.78 6.41 4.71 20.49C4.32 20.88 3.68 20.88 3.29 20.49 2.9 20.09 2.9 19.46 3.29 19.07L17.36 5 14.78 5C14.23 5 13.78 4.55 13.78 4 13.78 3.45 14.23 3 14.78 3L19.78 3ZM5 3.86L9.78 8.64C10.17 9.03 10.17 9.66 9.78 10.05 9.39 10.44 8.75 10.44 8.36 10.05L3.59 5.27C3.2 4.88 3.2 4.25 3.59 3.86 3.98 3.47 4.61 3.47 5 3.86Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, P8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.76 2.4L23 4.86C23.62 5.22 24 5.9 24 6.63L23.98 11.59C23.97 12.67 23.41 13.66 22.49 14.2L8.19 22.59C6.77 23.43 4.94 22.93 4.12 21.49L0.4 14.93C-0.42 13.48 0.07 11.63 1.49 10.8L15.79 2.41C16.71 1.87 17.84 1.86 18.76 2.4ZM16.77 4.14L2.5 12.55C2.02 12.82 1.86 13.44 2.13 13.93L5.85 20.49C6.12 20.98 6.73 21.14 7.2 20.86L21.48 12.45C21.79 12.27 21.98 11.94 21.98 11.58L22 6.6 17.76 4.13C17.46 3.95 17.08 3.96 16.77 4.14ZM18.5 7C19.33 7 20 7.67 20 8.5 20 9.33 19.33 10 18.5 10 17.67 10 17 9.33 17 8.5 17 7.67 17.67 7 18.5 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, U8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.89 0.4C19.96 0.44 20.03 0.48 20.1 0.53L23.37 2.97C23.88 3.35 24.18 3.95 24.18 4.59L24.16 8.51C24.15 9.44 23.71 10.31 22.99 10.87L22.98 13.51C22.98 14.54 22.43 15.49 21.54 16L8.68 23.42C7.3 24.22 5.53 23.75 4.73 22.37L1.39 16.57C0.59 15.19 1.06 13.42 2.45 12.62L3.5 12.01 3.32 11.66C2.64 10.3 3.08 8.65 4.33 7.82L4.48 7.73 16.91 0.4C17.83-0.13 18.97-0.13 19.89 0.4ZM20.99 12.08L10.25 18.41C8.82 19.24 6.98 18.75 6.15 17.31L6.1 17.21 4.39 13.8 3.45 14.35C3.02 14.6 2.87 15.14 3.12 15.57L6.47 21.37C6.71 21.79 7.26 21.94 7.68 21.69L20.54 14.27C20.81 14.11 20.98 13.82 20.98 13.5L20.99 12.08ZM17.91 2.13L5.5 9.45C5.06 9.71 4.88 10.25 5.08 10.71L7.88 16.31C8.06 16.62 8.38 16.8 8.71 16.81L8.82 16.81C8.97 16.8 9.11 16.76 9.25 16.68L21.66 9.36C21.96 9.18 22.15 8.86 22.16 8.5L22.18 4.57 18.9 2.13C18.59 1.96 18.21 1.96 17.91 2.13ZM18.5 5C19.33 5 20 5.67 20 6.5 20 7.33 19.33 8 18.5 8 17.67 8 17 7.33 17 6.5 17 5.67 17.67 5 18.5 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, W8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C14.21 2 16 3.79 16 6L16 11.53C17.23 12.63 18 14.22 18 16 18 19.31 15.31 22 12 22 8.69 22 6 19.31 6 16 6 14.22 6.77 12.63 8 11.53L8 6C8 3.79 9.79 2 12 2ZM12 4C10.9 4 10 4.9 10 6L10 12.42 9.33 13.02C8.49 13.77 8 14.85 8 16 8 18.21 9.79 20 12 20 14.21 20 16 18.21 16 16 16 14.85 15.51 13.77 14.67 13.02L14 12.42 14 6C14 4.9 13.1 4 12 4ZM12 14C13.1 14 14 14.9 14 16 14 17.1 13.1 18 12 18 10.9 18 10 17.1 10 16 10 14.9 10.9 14 12 14Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, q8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM9.05 7.64L12 10.59 14.95 7.64C15.34 7.25 15.97 7.25 16.36 7.64 16.75 8.03 16.75 8.66 16.36 9.05L13.41 12 16.36 14.95C16.75 15.34 16.75 15.97 16.36 16.36 15.97 16.75 15.34 16.75 14.95 16.36L12 13.41 9.05 16.36C8.66 16.75 8.03 16.75 7.64 16.36 7.25 15.97 7.25 15.34 7.64 14.95L10.59 12 7.64 9.05C7.25 8.66 7.25 8.03 7.64 7.64 8.03 7.25 8.66 7.25 9.05 7.64Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, G8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.17 7.76L12 10.58 14.83 7.76C15.22 7.37 15.85 7.37 16.24 7.76 16.63 8.15 16.63 8.78 16.24 9.17L13.41 12 16.24 14.83C16.63 15.22 16.63 15.85 16.24 16.24 15.85 16.63 15.22 16.63 14.83 16.24L12 13.41 9.17 16.24C8.78 16.63 8.15 16.63 7.76 16.24 7.37 15.85 7.37 15.22 7.76 14.83L10.58 12 7.76 9.17C7.37 8.78 7.37 8.15 7.76 7.76 8.15 7.37 8.78 7.37 9.17 7.76Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, i2 = {
  icon: [
    24,
    24,
    [],
    "",
    "M4.58 3.06L12 10.48 19.42 3.06C19.91 2.57 20.7 2.57 21.19 3.06 21.68 3.55 21.68 4.34 21.19 4.83L13.77 12.25 21.19 19.67C21.68 20.16 21.68 20.95 21.19 21.44 20.7 21.93 19.91 21.93 19.42 21.44L12 14.02 4.58 21.44C4.09 21.93 3.3 21.93 2.81 21.44 2.32 20.95 2.32 20.16 2.81 19.67L10.23 12.25 2.81 4.83C2.32 4.34 2.32 3.55 2.81 3.06 3.3 2.57 4.09 2.57 4.58 3.06Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, o2 = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.05 5.64L12 10.59 16.95 5.64C17.34 5.25 17.97 5.25 18.36 5.64 18.75 6.03 18.75 6.66 18.36 7.05L13.41 12 18.36 16.95C18.75 17.34 18.75 17.97 18.36 18.36 17.97 18.75 17.34 18.75 16.95 18.36L12 13.41 7.05 18.36C6.66 18.75 6.03 18.75 5.64 18.36 5.25 17.97 5.25 17.34 5.64 16.95L10.59 12 5.64 7.05C5.25 6.66 5.25 6.03 5.64 5.64 6.03 5.25 6.66 5.25 7.05 5.64Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, K8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM15 12C15.55 12 16 12.45 16 13L16 15 18 15C18.55 15 19 15.45 19 16 19 16.55 18.55 17 18 17L16 17 16 19C16 19.55 15.55 20 15 20 14.45 20 14 19.55 14 19L14 17 12 17C11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15L14 15 14 13C14 12.45 14.45 12 15 12ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, X8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 0C18.55 0 19 0.45 19 1L19 2C20.66 2 22 3.34 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 5C2 3.34 3.34 2 5 2L5 1C5 0.45 5.45 0 6 0 6.55 0 7 0.45 7 1L7 2 9 2 9 1C9 0.45 9.45 0 10 0 10.55 0 11 0.45 11 1L11 2 13 2 13 1C13 0.45 13.45 0 14 0 14.55 0 15 0.45 15 1L15 2 17 2 17 1C17 0.45 17.45 0 18 0ZM9 4L7 4 7 5C7 5.55 6.55 6 6 6 5.45 6 5 5.55 5 5L5 4C4.45 4 4 4.45 4 5L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 5C20 4.45 19.55 4 19 4L19 5C19 5.55 18.55 6 18 6 17.45 6 17 5.55 17 5L17 4 15 4 15 5C15 5.55 14.55 6 14 6 13.45 6 13 5.55 13 5L13 4 11 4 11 5C11 5.55 10.55 6 10 6 9.45 6 9 5.55 9 5L9 4ZM17.1 13.29C17.49 13.68 17.49 14.32 17.1 14.71L12.98 18.83C12.77 19.04 12.48 19.14 12.2 19.12 11.92 19.14 11.63 19.04 11.41 18.83L9.29 16.71C8.9 16.32 8.9 15.68 9.29 15.29 9.68 14.9 10.32 14.9 10.71 15.29L12.2 16.78 15.69 13.29C16.08 12.9 16.71 12.9 17.1 13.29Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Q8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 0C18.55 0 19 0.45 19 1L19 2C20.66 2 22 3.34 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 5C2 3.34 3.34 2 5 2L5 1C5 0.45 5.45 0 6 0 6.55 0 7 0.45 7 1L7 2 9 2 9 1C9 0.45 9.45 0 10 0 10.55 0 11 0.45 11 1L11 2 13 2 13 1C13 0.45 13.45 0 14 0 14.55 0 15 0.45 15 1L15 2 17 2 17 1C17 0.45 17.45 0 18 0ZM9 4L7 4 7 5C7 5.55 6.55 6 6 6 5.45 6 5 5.55 5 5L5 4C4.45 4 4 4.45 4 5L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 5C20 4.45 19.55 4 19 4L19 5C19 5.55 18.55 6 18 6 17.45 6 17 5.55 17 5L17 4 15 4 15 5C15 5.55 14.55 6 14 6 13.45 6 13 5.55 13 5L13 4 11 4 11 5C11 5.55 10.55 6 10 6 9.45 6 9 5.55 9 5L9 4ZM10 18C10.55 18 11 18.45 11 19 11 19.55 10.55 20 10 20L7 20C6.45 20 6 19.55 6 19 6 18.45 6.45 18 7 18L10 18ZM10 14C10.55 14 11 14.45 11 15 11 15.55 10.55 16 10 16L7 16C6.45 16 6 15.55 6 15 6 14.45 6.45 14 7 14L10 14Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, J8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.43 0L13.57 0 13.81 0.01 14.01 0.04C14.82 0.21 15.36 0.75 15.64 1.41L15.7 1.56 16.06 3 22 3C22.55 3 23 3.45 23 4 23 4.55 22.55 5 22 5L21 5 21 21C21 22.66 19.66 24 18 24L6 24C4.34 24 3 22.66 3 21L3 5 2 5C1.45 5 1 4.55 1 4 1 3.45 1.45 3 2 3L7.94 3 8.31 1.52 8.46 1.2C8.84 0.51 9.52 0 10.43 0ZM19 5L5 5 5 21C5 21.55 5.45 22 6 22L18 22C18.55 22 19 21.55 19 21L19 5ZM13.57 2L10.43 2C10.35 2 10.28 2.06 10.22 2.16L10.2 2.2 10 3 14 3 13.8 2.2C13.75 2.09 13.68 2.02 13.6 2L13.57 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Y8 = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.38 1C4.28 1 5.12 1.4 5.68 2.07L5.8 2.01C7.28 1.26 9.08 1.84 9.84 3.32 10.59 4.8 10 6.6 8.53 7.35L8.43 7.4 8.82 8.17 14.76 7.18C16.3 6.92 17.78 7.89 18.16 9.41L18.9 12.34 21.59 12.88C22.99 13.16 24 14.39 24 15.82L24 16C24 17.09 23.42 18.04 22.55 18.57L23.1 20.62C23.25 21.16 22.93 21.7 22.4 21.85 21.86 21.99 21.32 21.67 21.17 21.14L20.6 19 6.72 19C6.54 19 6.36 18.98 6.18 18.95L4.87 21.23C4.59 21.71 3.98 21.87 3.5 21.6 3.02 21.32 2.86 20.71 3.13 20.23L4.45 17.96C4.2 17.67 4 17.33 3.87 16.95L2.47 12.74C2.36 12.4 2.31 12.05 2.32 11.71 2.11 11.42 1.96 11.09 1.87 10.73L0.3 4.46C-0.07 2.97 0.84 1.46 2.33 1.08 2.55 1.03 2.77 1 3 1L3.38 1ZM15.21 9.14L15.09 9.15 5.15 10.81C5.1 10.82 5.05 10.83 5 10.85 4.48 11.02 4.2 11.59 4.37 12.11L5.77 16.32C5.91 16.72 6.29 17 6.72 17L18 17 16.22 9.9C16.12 9.47 15.75 9.17 15.32 9.14L15.21 9.14ZM19.43 14.49L20 17 21 17C21.55 17 22 16.55 22 16L22 15.82C22 15.34 21.66 14.93 21.2 14.84L19.43 14.49ZM3.38 3L3 3C2.94 3 2.87 3.01 2.81 3.02 2.39 3.13 2.14 3.55 2.24 3.97L3.59 9.34C3.82 9.18 4.08 9.04 4.37 8.95 4.52 8.9 4.67 8.86 4.83 8.83L6.76 8.51 4.28 3.55C4.11 3.21 3.76 3 3.38 3ZM6.71 3.79L6.65 3.82 7.54 5.61 7.62 5.57C8.11 5.32 8.31 4.72 8.05 4.23 7.8 3.73 7.2 3.54 6.71 3.79Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, C0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M6.34 4.93C6.73 5.32 6.73 5.95 6.34 6.34 3.22 9.47 3.22 14.53 6.34 17.66 9.47 20.78 14.53 20.78 17.66 17.66 20.78 14.53 20.78 9.47 17.66 6.34 17.27 5.95 17.27 5.32 17.66 4.93 18.05 4.54 18.68 4.54 19.07 4.93 22.98 8.83 22.98 15.17 19.07 19.07 15.17 22.98 8.83 22.98 4.93 19.07 1.02 15.17 1.02 8.83 4.93 4.93 5.32 4.54 5.95 4.54 6.34 4.93ZM12 2C12.55 2 13 2.45 13 3L13 9C13 9.55 12.55 10 12 10 11.45 10 11 9.55 11 9L11 3C11 2.45 11.45 2 12 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, L0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 1C18.63 1 24 6.37 24 13 24 13.55 23.55 14 23 14 22.45 14 22 13.55 22 13 22 7.48 17.52 3 12 3 6.48 3 2 7.48 2 13 2 16.45 3.01 18.69 5 19.87L5 17C5 16.45 5.45 16 6 16 6.55 16 7 16.45 7 17L7 22C7 22.51 6.61 22.94 6.12 22.99L5.98 23 1 23C0.45 23 0 22.55 0 22 0 21.45 0.45 21 1 21L3.12 21C1.04 19.34 0 16.64 0 13 0 6.37 5.37 1 12 1Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, e0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.17 11.59C8.53 11.95 8.56 12.52 8.25 12.91L8.17 13 5.34 15.83C4.56 16.61 4.56 17.88 5.34 18.66 6.12 19.44 7.39 19.44 8.17 18.66L11 15.83C11.39 15.44 12.02 15.44 12.41 15.83 12.8 16.22 12.8 16.85 12.41 17.24L9.59 20.07C8.02 21.63 5.49 21.63 3.93 20.07 2.37 18.51 2.37 15.98 3.93 14.41L6.76 11.59C7.15 11.2 7.78 11.2 8.17 11.59ZM7.05 5.64L18.36 16.95C18.75 17.34 18.75 17.97 18.36 18.36 17.97 18.75 17.34 18.75 16.95 18.36L5.64 7.05C5.25 6.66 5.25 6.03 5.64 5.64 6.03 5.25 6.66 5.25 7.05 5.64ZM20.07 3.93C21.63 5.49 21.63 8.02 20.07 9.59L17.24 12.41C16.85 12.8 16.22 12.8 15.83 12.41 15.44 12.02 15.44 11.39 15.83 11L18.66 8.17C19.44 7.39 19.44 6.12 18.66 5.34 17.88 4.56 16.61 4.56 15.83 5.34L13 8.17C12.61 8.56 11.98 8.56 11.59 8.17 11.2 7.78 11.2 7.15 11.59 6.76L14.41 3.93C15.98 2.37 18.51 2.37 20.07 3.93Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, n0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14 1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM12.71 0.28L15.71 3.17C16.1 3.55 16.1 4.15 15.71 4.53 15.32 4.9 14.68 4.9 14.29 4.53L13 3.27 13 15.81C13 16.36 12.55 16.81 12 16.81 11.45 16.81 11 16.36 11 15.81L11 3.27 9.71 4.53C9.34 4.88 8.75 4.9 8.36 4.58L8.29 4.53C7.9 4.15 7.9 3.55 8.29 3.17L11.29 0.28C11.68-0.09 12.32-0.09 12.71 0.28Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, i0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 1C12.66 1 14 2.34 14 4L14 5.34 13.96 5.36C14.6 5.13 15.28 5 16 5 19.31 5 22 7.69 22 11 22 14.31 19.31 17 16 17 15.39 17 14.79 16.91 14.24 16.74L14 16.66 14 20C14 21.66 12.66 23 11 23L5 23C3.34 23 2 21.66 2 20L2 4C2 2.34 3.34 1 5 1L11 1ZM11 3L5 3C4.45 3 4 3.45 4 4L4 20C4 20.55 4.45 21 5 21L11 21C11.55 21 12 20.55 12 20L12 15.47 12.01 15.48C10.78 14.38 10 12.78 10 11 10 9.31 10.7 7.78 11.82 6.69L12 6.53 12 4C12 3.45 11.55 3 11 3ZM8 6C8.55 6 9 6.45 9 7L9 17C9 17.51 8.61 17.94 8.12 17.99L8 18C7.45 18 7 17.55 7 17L7 7C7 6.45 7.45 6 8 6ZM16 7C13.79 7 12 8.79 12 11 12 13.21 13.79 15 16 15 18.21 15 20 13.21 20 11 20 8.79 18.21 7 16 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, o0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.65 0.49L21.63 5.72C22.49 6.27 23 7.23 23 8.25L23 20.98C23 22.65 21.65 24 19.99 24L4.01 24C2.35 24 1 22.65 1 20.98L1 8.25C1 7.23 1.51 6.27 2.37 5.72L10.35 0.49C11.35-0.16 12.65-0.16 13.65 0.49ZM11.45 2.16L3.46 7.4C3.17 7.58 3 7.9 3 8.24L3 20.99C3 21.55 3.45 22 4.01 22L9 22 9 18C9 16.34 10.34 15 12 15L15 15C16.66 15 18 16.34 18 18L18 22 19.99 22C20.55 22 21 21.55 21 20.99L21 8.24C21 7.9 20.83 7.58 20.54 7.4L12.55 2.16C12.22 1.95 11.78 1.95 11.45 2.16ZM15 17L12 17C11.45 17 11 17.45 11 18L11 22 16 22 16 18C16 17.45 15.55 17 15 17Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, t0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.57 6.47C23.24 7.44 23.81 9.58 22.85 11.25 22.1 12.55 21.09 13.13 19.26 13.18L19 13.18 2 13.18C1.45 13.18 1 12.74 1 12.18 1 11.63 1.45 11.18 2 11.18L19 11.18C20 11.18 20.7 10.97 21.12 10.25 21.53 9.53 21.28 8.62 20.57 8.2 19.89 7.81 19.04 8.01 18.6 8.63L18.52 8.75C18.24 9.23 17.63 9.39 17.15 9.12 16.67 8.84 16.51 8.23 16.79 7.75 17.75 6.08 19.89 5.5 21.57 6.47ZM12.57 2.47C14.24 3.44 14.81 5.58 13.85 7.25 13.1 8.55 12.09 9.13 10.26 9.18L10 9.18 2 9.18C1.45 9.18 1 8.74 1 8.18 1 7.63 1.45 7.18 2 7.18L10 7.18C11 7.18 11.7 6.97 12.12 6.25 12.53 5.53 12.28 4.62 11.57 4.2 10.89 3.81 10.04 4.01 9.6 4.63L9.52 4.75C9.24 5.23 8.63 5.39 8.15 5.12 7.67 4.84 7.51 4.23 7.79 3.75 8.75 2.08 10.89 1.5 12.57 2.47ZM2 15C1.45 15 1 15.45 1 16 1 16.55 1.45 17 2 17L15 17C16 17 16.7 17.22 17.12 17.93 17.53 18.65 17.28 19.57 16.57 19.98 15.89 20.37 15.04 20.18 14.6 19.55L14.52 19.43C14.24 18.95 13.63 18.79 13.15 19.07 12.67 19.34 12.51 19.95 12.79 20.43 13.75 22.11 15.89 22.68 17.57 21.71 19.24 20.75 19.81 18.61 18.85 16.93 18.1 15.63 17.09 15.05 15.26 15L15 15 2 15Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, a0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C14.21 2 16 3.79 16 6 16 6.73 15.8 7.41 15.46 8L16.97 8C18.38 8 19.59 8.98 19.9 10.35L21.68 18.35C22.04 19.97 21.02 21.57 19.4 21.93 19.19 21.98 18.97 22 18.75 22L5.25 22C3.59 22 2.25 20.66 2.25 19 2.25 18.78 2.27 18.56 2.32 18.35L4.1 10.35C4.41 8.98 5.63 8 7.03 8L8.54 8C8.2 7.41 8 6.73 8 6 8 3.79 9.79 2 12 2ZM16.97 10L7.03 10C6.56 10 6.16 10.33 6.06 10.78L4.27 18.78C4.26 18.85 4.25 18.93 4.25 19 4.25 19.55 4.7 20 5.25 20L18.75 20C18.83 20 18.9 19.99 18.97 19.98 19.51 19.86 19.85 19.32 19.73 18.78L17.95 10.78C17.85 10.33 17.44 10 16.97 10ZM12 4C10.9 4 10 4.9 10 6 10 7.1 10.9 8 12 8 13.1 8 14 7.1 14 6 14 4.9 13.1 4 12 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, s0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0.61C19.48 0.88 19.64 1.5 19.37 1.97L6.37 23.03C6.09 23.5 5.48 23.67 5 23.39 4.52 23.12 4.36 22.5 4.63 22.03L17.63 0.97C17.91 0.5 18.52 0.33 19 0.61ZM13.01 14.17C14.17 14.59 15 15.7 15 17 15 18.66 13.66 20 12 20 11.19 20 10.46 19.68 9.92 19.17L11.06 17.33C11.19 17.72 11.56 18 12 18 12.55 18 13 17.55 13 17 13 16.45 12.55 16 12 16 11.96 16 11.92 16 11.88 16.01L13.01 14.17ZM15.78 9.68C17.2 10.23 18.52 11.1 19.71 12.29 20.09 12.69 20.08 13.31 19.69 13.69 19.31 14.08 18.69 14.09 18.29 13.71 17.2 12.61 16.01 11.85 14.71 11.42L15.78 9.68ZM11.5 9.01L10.15 11.19C8.51 11.54 7.04 12.38 5.71 13.71 5.31 14.09 4.69 14.08 4.31 13.69 3.92 13.31 3.91 12.69 4.29 12.29 6.35 10.23 8.77 9.13 11.5 9.01ZM18.4 5.45C19.73 6.17 20.86 7.15 21.8 8.4 22.01 8.69 22.06 9.06 21.92 9.39 21.78 9.72 21.47 9.95 21.12 9.99 20.76 10.04 20.41 9.89 20.2 9.6 19.42 8.56 18.47 7.74 17.34 7.15L18.4 5.45ZM12 4C12.87 4 13.69 4.06 14.48 4.18L13.32 6.05C12.9 6.02 12.46 6 12 6 8.3 6 5.6 7.2 3.8 9.6 3.47 10.04 2.84 10.13 2.4 9.8 1.96 9.47 1.87 8.84 2.2 8.4 4.4 5.47 7.7 4 12 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, c0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.8 7.4C19.6 4.47 16.3 3 12 3 7.7 3 4.4 4.47 2.2 7.4 1.87 7.84 1.96 8.47 2.4 8.8 2.84 9.13 3.47 9.04 3.8 8.6 5.6 6.2 8.3 5 12 5 15.7 5 18.4 6.2 20.2 8.6 20.41 8.89 20.76 9.04 21.12 8.99 21.47 8.95 21.78 8.72 21.92 8.39 22.06 8.06 22.01 7.69 21.8 7.4ZM12 7C14.94 7 17.52 8.11 19.71 10.29 20.09 10.69 20.08 11.31 19.69 11.69 19.31 12.08 18.69 12.09 18.29 11.71 16.48 9.89 14.4 9 12 9 9.6 9 7.52 9.89 5.71 11.71 5.31 12.09 4.69 12.08 4.31 11.69 3.92 11.31 3.91 10.69 4.29 10.29 6.48 8.11 9.06 7 12 7ZM16.71 13.29C15.2 11.79 13.63 11 12 11 10.37 11 8.8 11.79 7.29 13.29 7.03 13.54 6.93 13.92 7.02 14.27 7.11 14.62 7.38 14.89 7.73 14.98 8.08 15.07 8.46 14.97 8.71 14.71 9.87 13.55 10.96 13 12 13 13.04 13 14.13 13.55 15.29 14.71 15.69 15.09 16.31 15.08 16.69 14.69 17.05 14.34 17.08 13.78 16.79 13.39L16.71 13.29ZM12 16C13.66 16 15 17.34 15 19 15 20.66 13.66 22 12 22 10.34 22 9 20.66 9 19 9 17.34 10.34 16 12 16ZM12 18C11.45 18 11 18.45 11 19 11 19.55 11.45 20 12 20 12.55 20 13 19.55 13 19 13 18.45 12.55 18 12 18Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, r0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M16 0C20.83 0 25.02 3.28 26.21 7.92L26.25 8.08C27.76 8.41 28.91 9.72 28.99 11.31L29 11.5C29 12.66 28.44 13.69 27.57 14.32L27.51 14.36 28.48 19.22C28.9 21.31 27.6 23.36 25.55 23.88L25.34 23.92C25.09 23.97 24.82 24 24.56 24L20 24C18.9 24 18 23.1 18 22L18 21 14 21 14 22C14 23.05 13.18 23.92 12.15 23.99L12 24 7.44 24C5.23 24 3.44 22.21 3.44 20 3.44 19.74 3.47 19.47 3.52 19.22L5.67 8.47C6.65 3.55 10.98 0 16 0ZM16 2C11.93 2 8.43 4.87 7.63 8.86L7.5 9.5 7.71 9.54C11.41 10.2 14.99 7.81 15.78 4.11 15.89 3.57 16.42 3.22 16.96 3.34 17.5 3.45 17.85 3.98 17.73 4.52 17.23 6.88 15.85 8.83 14 10.09 14.58 10.29 15 10.84 15 11.49 15 12.1 14.64 12.65 14.08 12.88 13.52 13.12 12.87 12.99 12.44 12.56 12.05 12.17 11.91 11.61 12.06 11.09 10.53 11.66 8.82 11.82 7.11 11.47L5.48 19.61C5.45 19.74 5.44 19.87 5.44 20 5.44 21.1 6.34 22 7.44 22L12 22 12 19.79C10.63 19.03 9.43 17.89 8.59 16.43 8.31 15.95 8.48 15.34 8.96 15.07 9.43 14.79 10.05 14.95 10.32 15.43 12.25 18.78 16.54 19.93 19.88 18 21.79 16.89 22.99 15.02 23.3 13L25.5 13C26.33 13 27 12.33 27 11.5 27 10.67 26.33 10 25.5 10 25.19 10 24.89 10.1 24.65 10.26L24.37 8.86C23.57 4.87 20.07 2 16 2ZM20.88 19.73C20.59 19.89 20.3 20.04 20 20.18L20 22 24.56 22C24.69 22 24.82 21.99 24.95 21.96 26.04 21.74 26.74 20.69 26.52 19.61L25.19 13.81C24.67 16.21 23.18 18.4 20.88 19.73ZM18.92 10.12C19.48 9.88 20.13 10.01 20.56 10.44 20.99 10.87 21.12 11.52 20.88 12.08 20.65 12.64 20.1 13 19.49 13 18.67 13 18 12.33 18 11.51 18 10.9 18.36 10.35 18.92 10.12Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, m0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M25 0C25.8 0 26.28 0.89 25.83 1.55 25.38 2.24 24.92 2.88 24.46 3.49 25.67 4.69 26.62 6.15 27.24 7.78L27.35 8.11 27.43 8.13C28.85 8.52 29.91 9.78 29.99 11.31L30 11.5C30 12.98 29.08 14.25 27.78 14.76L27.67 14.8 27.66 14.85C26.4 20.03 21.79 23.86 16.31 24L16 24C10.49 24 5.8 20.27 4.41 15.14L4.33 14.8 4.22 14.76C2.98 14.27 2.08 13.09 2.01 11.69L2 11.5C2 9.89 3.09 8.53 4.57 8.13L4.65 8.11 4.66 8.06C6.27 3.41 10.63 0.13 15.7 0L16 0 16 2C11.11 2 7.03 5.51 6.17 10.16 5.97 10.06 5.74 10 5.5 10 4.67 10 4 10.67 4 11.5 4 12.33 4.67 13 5.5 13 5.69 13 5.87 12.96 6.04 12.9 6.5 18 10.78 22 16 22 21.22 22 25.5 18 25.96 12.9 26.13 12.96 26.31 13 26.5 13 27.33 13 28 12.33 28 11.5 28 10.67 27.33 10 26.5 10 26.26 10 26.03 10.06 25.83 10.16 25.47 8.2 24.53 6.45 23.21 5.07 22.71 5.66 22.21 6.21 21.71 6.71 20.24 8.18 19 8.42 16.65 8.15L15.83 8.05C15.48 8.01 15.25 8 15 8 13.96 8 12.87 8.55 11.71 9.71 11.32 10.1 10.68 10.1 10.29 9.71 9.9 9.32 9.9 8.68 10.29 8.29 11.8 6.79 13.37 6 15 6L15.27 6C15.59 6.01 15.9 6.04 16.4 6.1L16.62 6.13C18.6 6.38 19.32 6.27 20.29 5.29 21.15 4.44 22.01 3.43 22.87 2.28L23.08 2 17 2C16.49 2 16.06 1.61 16.01 1.12L16 1C16 0.45 16.45 0 17 0L25 0ZM20.56 11.44C20.99 11.87 21.12 12.52 20.88 13.08 20.65 13.64 20.1 14 19.49 14 18.67 14 18 13.33 18 12.51 18 11.9 18.36 11.35 18.92 11.12 19.48 10.88 20.13 11.01 20.56 11.44ZM13.56 11.44C13.99 11.87 14.12 12.52 13.88 13.08 13.65 13.64 13.1 14 12.49 14 11.67 14 11 13.33 11 12.51 11 11.9 11.36 11.35 11.92 11.12 12.48 10.88 13.13 11.01 13.56 11.44Z M16 0L17 0 17 2 15 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, l0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M16 0C21.09 0 25.52 3.19 27.24 7.78L27.35 8.11 27.43 8.13C28.85 8.52 29.91 9.78 29.99 11.31L30 11.5C30 12.98 29.08 14.25 27.78 14.76L27.67 14.8 27.66 14.85C26.4 20.03 21.79 23.86 16.31 24L16 24C10.49 24 5.8 20.27 4.41 15.14L4.33 14.8 4.22 14.76C2.98 14.27 2.08 13.09 2.01 11.69L2 11.5C2 9.89 3.09 8.53 4.57 8.13L4.65 8.11 4.66 8.06C6.27 3.41 10.63 0.13 15.7 0L16 0ZM16 2C11.11 2 7.03 5.51 6.17 10.16 5.97 10.06 5.74 10 5.5 10 4.67 10 4 10.67 4 11.5 4 12.33 4.67 13 5.5 13 5.69 13 5.87 12.96 6.04 12.9 6.5 18 10.78 22 16 22 21.22 22 25.5 18 25.96 12.9 26.13 12.96 26.31 13 26.5 13 27.33 13 28 12.33 28 11.5 28 10.67 27.33 10 26.5 10 26.26 10 26.03 10.06 25.83 10.16 24.97 5.51 20.89 2 16 2ZM18.92 11.12C19.48 10.88 20.13 11.01 20.56 11.44 20.99 11.87 21.12 12.52 20.88 13.08 20.65 13.64 20.1 14 19.49 14 18.67 14 18 13.33 18 12.51 18 11.9 18.36 11.35 18.92 11.12ZM17.96 3.34C18.5 3.45 18.85 3.98 18.73 4.52 18.08 7.59 15.94 9.95 13.23 11.02L13.37 11.01 13.51 11C14.33 11 15 11.67 15 12.49 15 13.1 14.64 13.65 14.08 13.88 13.52 14.12 12.87 13.99 12.44 13.56 12.01 13.13 11.88 12.48 12.12 11.92 12.25 11.61 12.48 11.35 12.76 11.19 11.3 11.68 9.68 11.8 8.06 11.46 7.52 11.34 7.17 10.81 7.29 10.27 7.4 9.73 7.93 9.38 8.47 9.5 12.26 10.3 15.97 7.89 16.78 4.11 16.89 3.57 17.42 3.22 17.96 3.34Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, d0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M16.01 0C21.09 0 25.52 3.19 27.24 7.78L27.35 8.11 27.43 8.13C28.85 8.52 29.91 9.78 29.99 11.31L30 11.5C30 12.98 29.08 14.25 27.78 14.76L27.67 14.8 27.66 14.85C26.4 20.03 21.79 23.86 16.31 24L16 24C10.49 24 5.8 20.27 4.41 15.14L4.33 14.8 4.22 14.76C2.98 14.27 2.08 13.09 2.01 11.69L2 11.5C2 9.89 3.09 8.53 4.57 8.13L4.65 8.11 4.66 8.06C6.27 3.41 10.63 0.13 15.7 0L16.01 0ZM15.96 2C15.85 2 16 2 14.86 2.07 10.48 2.56 6.97 5.88 6.17 10.16 5.97 10.06 5.74 10 5.5 10 4.67 10 4 10.67 4 11.5 4 12.33 4.67 13 5.5 13 5.69 13 5.87 12.96 6.04 12.9 6.5 18 10.78 22 16 22 21.22 22 25.5 18 25.96 12.9 26.13 12.96 26.31 13 26.5 13 27.33 13 28 12.33 28 11.5 28 10.67 27.33 10 26.5 10 26.26 10 26.03 10.06 25.83 10.16 25.2 6.79 22.89 4.02 19.8 2.75L19.85 2.9C20.45 5.02 19.23 7.24 17.1 7.85 14.98 8.45 12.76 7.23 12.15 5.1 12 4.57 12.31 4.02 12.84 3.87 13.37 3.71 13.93 4.02 14.08 4.55 14.38 5.61 15.49 6.23 16.55 5.92 17.61 5.62 18.23 4.51 17.92 3.45 17.68 2.59 16.91 2.03 16.06 2L15.96 2ZM12.51 12C13.33 12 14 12.67 14 13.49 14 14.1 13.64 14.65 13.08 14.88 12.52 15.12 11.87 14.99 11.44 14.56 11.01 14.13 10.88 13.48 11.12 12.92 11.35 12.36 11.9 12 12.51 12ZM18.92 12.12C19.48 11.88 20.13 12.01 20.56 12.44 20.99 12.87 21.12 13.52 20.88 14.08 20.65 14.64 20.1 15 19.49 15 18.67 15 18 14.33 18 13.51 18 12.9 18.36 12.35 18.92 12.12Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, M0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M16 0C18.24 0 20.36 0.62 22.18 1.71L22.41 1.7C24.29 1.63 25.9 2.2 27.08 3.43 28.2 4.59 28.72 6.11 28.66 7.85L28.66 7.99C29.48 8.86 29.95 10.16 30 11.32L30 11.5C30 12.98 29.08 14.25 27.78 14.76L27.67 14.8 27.66 14.85C26.4 20.03 21.79 23.86 16.31 24L16 24C10.49 24 5.8 20.27 4.41 15.14L4.33 14.8 4.22 14.76C2.98 14.27 2.08 13.09 2.01 11.69L2 11.5C2 10.43 2.38 9.2 3.08 8.3L3.07 8.16C2.94 6.28 3.45 4.66 4.63 3.43 5.82 2.2 7.43 1.63 9.31 1.7L9.8 1.72C11.54 0.67 13.56 0.06 15.69 0L16 0ZM16 2C14.26 2 12.63 2.44 11.21 3.22L11.23 3.56C11.37 5.43 10.86 7.06 9.67 8.29 8.48 9.52 6.87 10.09 4.99 10.02L4.41 9.99C4.16 10.5 4 11.1 4 11.5 4 12.33 4.67 13 5.5 13 5.69 13 5.87 12.96 6.04 12.9 6.5 18 10.78 22 16 22 21.22 22 25.5 18 25.96 12.9 26.13 12.96 26.31 13 26.5 13 27.33 13 28 12.33 28 11.5 28 11.1 27.84 10.5 27.58 9.98L26.73 10.02C24.84 10.09 23.24 9.52 22.05 8.29 20.86 7.06 20.35 5.43 20.49 3.56L20.52 3.08C19.16 2.39 17.63 2 16 2ZM18.92 11.12C19.48 10.88 20.13 11.01 20.56 11.44 20.99 11.87 21.12 12.52 20.88 13.08 20.65 13.64 20.1 14 19.49 14 18.67 14 18 13.33 18 12.51 18 11.9 18.36 11.35 18.92 11.12ZM12.51 11C13.33 11 14 11.67 14 12.49 14 13.1 13.64 13.65 13.08 13.88 12.52 14.12 11.87 13.99 11.44 13.56 11.01 13.13 10.88 12.48 11.12 11.92 11.35 11.36 11.9 11 12.51 11ZM7.1 4.08L6.88 4.19 6.75 4.27C6.5 4.42 6.28 4.61 6.07 4.82 5.97 4.93 5.87 5.05 5.78 5.17L5.65 5.34 5.59 5.45 5.49 5.62 5.4 5.81 5.3 6.06 5.23 6.28 5.17 6.47 5.16 6.52C5.15 6.59 5.13 6.67 5.12 6.74 5.05 7.13 5.04 7.56 5.07 8.02 6.27 8.06 7.25 7.77 7.99 7.13 8.07 7.06 8.15 6.98 8.23 6.9L8.38 6.74C8.57 6.51 8.73 6.27 8.86 6L8.95 5.81 9.02 5.63 9.08 5.43 9.13 5.25 9.19 4.97 9.22 4.75 9.23 4.64C9.26 4.35 9.26 4.03 9.24 3.7 8.42 3.67 7.71 3.8 7.1 4.08ZM22.75 3.7L22.48 3.7C22.39 5.04 22.72 6.11 23.49 6.9 23.56 6.97 23.63 7.04 23.71 7.11L23.87 7.25 24.07 7.39 24.27 7.51 24.53 7.65 24.71 7.72 24.86 7.78 24.98 7.82 25.1 7.85C25.56 7.98 26.08 8.04 26.65 8.02 26.75 6.68 26.41 5.61 25.65 4.82 24.93 4.08 23.96 3.7 22.75 3.7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, Z0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M31 0L25.98 5.33C26.46 6.05 26.87 6.83 27.19 7.65L27.35 8.11 27.43 8.13C28.85 8.52 29.91 9.78 29.99 11.31L30 11.5C30 12.98 29.08 14.25 27.78 14.76L27.67 14.8 27.66 14.85C26.4 20.03 21.79 23.86 16.31 24L16 24C10.49 24 5.8 20.27 4.41 15.14L4.33 14.8 4.22 14.76C2.98 14.27 2.08 13.09 2.01 11.69L2 11.5C2 9.89 3.09 8.53 4.57 8.13L4.65 8.11 4.66 8.06C4.79 7.7 4.93 7.35 5.09 7L1 7 7.59 0 31 0ZM24.56 6.84L24.41 7 23 7 23 9C23 9.55 22.55 10 22 10 21.45 10 21 9.55 21 9L21 7 7.34 7C6.78 7.96 6.38 9.03 6.17 10.16 5.97 10.06 5.74 10 5.5 10 4.67 10 4 10.67 4 11.5 4 12.33 4.67 13 5.5 13 5.69 13 5.87 12.96 6.04 12.9 6.5 18 10.78 22 16 22 21.22 22 25.5 18 25.96 12.9 26.13 12.96 26.31 13 26.5 13 27.33 13 28 12.33 28 11.5 28 10.67 27.33 10 26.5 10 26.26 10 26.03 10.06 25.83 10.16 25.61 8.96 25.17 7.84 24.56 6.84ZM20.56 11.44C20.99 11.87 21.12 12.52 20.88 13.08 20.65 13.64 20.1 14 19.49 14 18.67 14 18 13.33 18 12.51 18 11.9 18.36 11.35 18.92 11.12 19.48 10.88 20.13 11.01 20.56 11.44ZM13.51 11C14.33 11 15 11.67 15 12.49 15 13.1 14.64 13.65 14.08 13.88 13.52 14.12 12.87 13.99 12.44 13.56 12.01 13.13 11.88 12.48 12.12 11.92 12.35 11.36 12.9 11 13.51 11ZM8.46 2L5.63 5 23.54 5 26.37 2 8.46 2Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, u0 = {
  icon: [
    80,
    80,
    [],
    "",
    "M32.3 36.9C32.4 36.9 32.5 36.9 32.6 36.8L42.6 32.8C43.1 32.6 43.3 32.1 43.1 31.6 42.9 31.2 42.4 30.9 42 31.1L32 35.1C31.5 35.3 31.3 35.8 31.5 36.3 31.6 36.6 31.9 36.9 32.3 36.9Z M63.3 53C63.2 51.2 61.7 49.7 59.9 49.5L53.2 48.8H53L52.1 42.6C51.9 40.8 50.9 39.2 49.4 38.1 48 37 46.2 36.6 44.4 36.9L30.2 39 26.4 26.7C28.9 25.9 30.3 23.3 29.6 20.8 28.8 18.3 26.2 16.9 23.7 17.6 23.5 17.7 23.2 17.8 23 17.9 22.2 17.2 21.1 16.9 20 17.1L18.2 17.4C17.4 17.6 16.8 18.4 16.9 19.2L20.4 42.3C20.1 43 20.1 43.8 20.3 44.6L23.2 56 20.6 61.2C20.4 61.6 20.6 62.2 21 62.4 21.1 62.5 21.3 62.5 21.4 62.5 21.7 62.5 22.1 62.3 22.2 62L24.7 57H61.9L62.3 61.7C62.3 62.2 62.7 62.5 63.2 62.5H63.3C63.8 62.5 64.2 62 64.1 61.5L63.3 53ZM25.5 19.5C27.1 19.9 28 21.6 27.6 23.2 27.4 24.1 26.8 24.8 26 25.1L24.4 19.9C24.4 19.8 24.3 19.7 24.3 19.5 24.7 19.4 25.1 19.4 25.5 19.5ZM18.8 19.3L20.4 19C21.4 18.8 22.4 19.4 22.7 20.4L28.6 39.4 23.6 40.2C23.1 40.3 22.6 40.5 22.1 40.7L18.8 19.3ZM22.1 44.4C22 43.8 22.1 43.2 22.4 42.8 22.7 42.3 23.2 42 23.8 41.9L44.8 38.7C46.1 38.5 47.4 38.8 48.5 39.6 49.6 40.4 50.3 41.6 50.5 42.9L52.2 55.2H24.8L22.1 44.4ZM53.9 55.2L53.2 50.6 59.7 51.3C60.7 51.4 61.4 52.2 61.5 53.1L61.7 55.2H53.9Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "xl"
}, f0 = {
  icon: [
    80,
    80,
    [],
    "",
    "M53.1 47.3C53.6 47.3 54 47.7 54 48.2V61.8C54 62.3 53.6 62.7 53.1 62.7 52.6 62.7 52.2 62.3 52.2 61.8V48.2C52.2 47.7 52.6 47.3 53.1 47.3ZM27.1 29C27.9 29 28.5 29.6 28.7 30.3L29.5 34.4 32 47.3H44.7C46.8 47.3 48.5 49 48.5 51.1V61.7C48.5 62.2 48.1 62.6 47.6 62.6 47.1 62.6 46.7 62.2 46.7 61.7V57.1H23.1V61.7C23.1 62.2 22.7 62.6 22.2 62.6 21.7 62.6 21.3 62.2 21.3 61.7V32.7C21.3 30.6 23 28.9 25.1 28.9H27.1V29ZM26.9 30.8H25.1C24 30.8 23.1 31.7 23.1 32.8V55.5H46.7V51.2C46.7 50.1 45.8 49.2 44.7 49.2H31.9C31.1 49.2 30.5 48.7 30.3 47.9L27.7 34.9 26.9 30.8ZM33.5 29.1C35.3 29.1 36.8 30.4 37.2 32.1L39.2 41.4C39.3 41.6 39.5 41.8 39.7 41.8L51.6 41C52.8 40.9 53.9 41.4 54.7 42.2L63.7 52.1C64 52.5 64 53 63.6 53.4 63.4 53.6 63.2 53.6 63 53.6 62.8 53.6 62.5 53.5 62.3 53.3L53.3 43.4C52.9 42.9 52.3 42.7 51.7 42.8L39.7 43.6C38.6 43.6 37.6 42.8 37.4 41.7L35.4 32.4C35.2 31.5 34.4 30.8 33.4 30.8H32.1C31.6 30.8 31.2 30.4 31.2 29.9 31.2 29.4 31.6 29 32.1 29H33.5V29.1ZM34.9 17.3C37.4 17.3 39.4 19.3 39.4 21.8 39.4 24.3 37.4 26.3 34.9 26.3 32.4 26.3 30.4 24.3 30.4 21.8 30.4 19.3 32.4 17.3 34.9 17.3ZM34.9 19.1C33.4 19.1 32.2 20.3 32.2 21.8 32.2 23.3 33.4 24.5 34.9 24.5 36.4 24.5 37.6 23.3 37.6 21.8 37.7 20.4 36.5 19.1 34.9 19.1Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "xl"
}, p0 = {
  icon: [
    80,
    80,
    [],
    "",
    "M53.3 13.3V65.7C53.3 66.2 52.9 66.6 52.4 66.6 51.9 66.6 51.5 66.2 51.5 65.7V39.7L48.4 38.3C46.5 37.5 45.3 35.5 45.3 33.4V20.7C45.3 16.6 48.5 13.4 52.4 13.4H53.3V13.3ZM35.6 14.3C36.1 14.3 36.5 14.7 36.5 15.2V29.1C36.5 30.1 36.1 31 35.3 31.7L35 31.8C33.8 32.7 32.4 33.3 31 33.5V65.8C31 66.3 30.6 66.7 30.1 66.7 29.6 66.7 29.2 66.3 29.2 65.8V33.5C27.6 33.4 26.1 32.7 24.9 31.6 24.4 31 24 30.1 24 29.1V15.1C24 14.6 24.4 14.2 24.9 14.2 25.4 14.2 25.8 14.6 25.8 15.1V29.1C25.8 29.5 26 29.9 26.3 30.2 28.3 32.1 31.5 32.2 34 30.3L34.2 30.2C34.5 29.9 34.7 29.5 34.7 29.1V15.2C34.7 14.7 35.1 14.3 35.6 14.3ZM51.6 15.2C49.1 15.6 47.1 17.9 47.1 20.7V33.4C47.1 34.8 47.9 36.1 49.2 36.6L51.6 37.7V15.2ZM30.2 14.3C30.7 14.3 31.1 14.7 31.1 15.2V28C31.1 28.5 30.7 28.9 30.2 28.9 29.7 28.9 29.3 28.5 29.3 28V15.2C29.3 14.7 29.7 14.3 30.2 14.3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "xl"
}, x0 = {
  icon: [
    80,
    80,
    [],
    "",
    "M14.67 28.47C14.88 28.47 15.08 28.55 15.23 28.68 15.39 28.82 15.49 29 15.52 29.21V33.8H23C24.58 33.81 26.12 34.32 27.4 35.25 28.68 36.18 29.63 37.5 30.12 39L30.22 39.31 31.32 43.18H64.47V40C64.47 39.55 64.3 39.12 64 38.79 63.7 38.46 63.29 38.25 62.84 38.21H36C35.77 38.21 35.55 38.12 35.38 37.96 35.22 37.79 35.13 37.57 35.13 37.34 35.13 37.13 35.21 36.93 35.34 36.78 35.48 36.62 35.67 36.52 35.87 36.49H62.67C63.57 36.49 64.43 36.83 65.09 37.45 65.74 38.06 66.13 38.9 66.19 39.8V50.67C66.21 50.9 66.13 51.12 65.98 51.3 65.83 51.47 65.62 51.57 65.39 51.59 65.16 51.61 64.94 51.53 64.76 51.38 64.59 51.23 64.49 51.02 64.47 50.79V44.87H15.53V50.67C15.54 50.78 15.52 50.9 15.49 51 15.45 51.11 15.39 51.21 15.32 51.3 15.25 51.38 15.16 51.45 15.05 51.5 14.95 51.55 14.84 51.58 14.73 51.59 14.62 51.6 14.5 51.58 14.4 51.55 14.29 51.51 14.19 51.45 14.1 51.38 14.02 51.31 13.95 51.22 13.9 51.11 13.85 51.01 13.82 50.9 13.81 50.79V29.33C13.81 29.22 13.83 29.1 13.88 29 13.92 28.89 13.98 28.8 14.07 28.72 14.15 28.64 14.24 28.58 14.35 28.53 14.45 28.49 14.57 28.47 14.68 28.47H14.67ZM15.53 43.13H29.53L28.53 39.74C28.2 38.57 27.5 37.54 26.55 36.79 25.6 36.04 24.44 35.6 23.23 35.54H15.53V43.13Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "xl"
}, h0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.88 13C21.64 13 23.88 15.24 23.88 18 23.88 20.76 21.64 23 18.88 23 16.11 23 13.88 20.76 13.88 18 13.88 15.24 16.11 13 18.88 13ZM5 13C7.76 13 10 15.24 10 18 10 20.76 7.76 23 5 23 2.24 23 0 20.76 0 18 0 15.24 2.24 13 5 13ZM18.88 15C17.22 15 15.88 16.34 15.88 18 15.88 19.66 17.22 21 18.88 21 20.53 21 21.88 19.66 21.88 18 21.88 16.34 20.53 15 18.88 15ZM5 15C3.34 15 2 16.34 2 18 2 19.66 3.34 21 5 21 6.66 21 8 19.66 8 18 8 16.34 6.66 15 5 15ZM13.6 5.2L17.33 8 19 8C19.51 8 19.94 8.39 19.99 8.88L20 9C20 9.55 19.55 10 19 10L17 10C16.78 10 16.57 9.93 16.4 9.8L13.03 7.27 8.81 10.79 13.45 13.11C13.8 13.28 14.02 13.66 14 14.05L13.99 14.16 12.99 20.16C12.9 20.71 12.38 21.08 11.84 20.99 11.29 20.9 10.92 20.38 11.01 19.84L11.89 14.56 6.55 11.89C5.95 11.59 5.82 10.79 6.27 10.32L6.36 10.23 12.36 5.23C12.72 4.94 13.23 4.92 13.6 5.2ZM16 1.5C17.1 1.5 18 2.4 18 3.5 18 4.6 17.1 5.5 16 5.5 14.9 5.5 14 4.6 14 3.5 14 2.4 14.9 1.5 16 1.5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, _0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M19.59 3C20.38 3 21.14 3.32 21.71 3.88L26.13 8.3 30.11 9.89C31.19 10.32 31.92 11.34 31.99 12.48L32 12.68 32 15C32 16.66 30.66 18 29 18L28.87 18C28.43 19.73 26.86 21 25 21 23.14 21 21.57 19.73 21.13 18L10.87 18C10.43 19.73 8.86 21 7 21 5.14 21 3.57 19.73 3.13 18L3 18C1.34 18 0 16.66 0 15L0 9.33C0 8.68 0.21 8.05 0.6 7.53L3.1 4.2C3.67 3.44 4.56 3 5.5 3L19.59 3ZM7 15C6.94 15 6.88 15 6.81 15.01L6.69 15.02 6.54 15.05 6.33 15.11 6.13 15.2 6.05 15.24 5.92 15.32 5.77 15.43 5.72 15.46 5.65 15.52 5.53 15.65 5.42 15.77 5.36 15.86 5.27 16C5.1 16.29 5 16.64 5 17 5 17.37 5.1 17.71 5.27 18L5.32 18.08 5.43 18.24 5.51 18.33 5.6 18.43 5.67 18.5 5.8 18.6 5.92 18.68 6.08 18.78 6.23 18.85 6.37 18.9 6.54 18.95 6.69 18.98 6.75 18.99 6.82 18.99C6.89 19 6.94 19 7 19 7.06 19 7.11 19 7.17 18.99L7 19 7.09 19 7.25 18.99 7.43 18.95 7.58 18.91 7.67 18.89 7.81 18.83 7.95 18.76 8.08 18.68 8.23 18.57 8.35 18.48 8.45 18.37 8.57 18.23 8.66 18.12 8.71 18.03 8.73 18C8.9 17.71 9 17.37 9 17 9 16.64 8.9 16.29 8.73 16L8.68 15.91 8.58 15.77 8.43 15.61 8.33 15.51 8.28 15.46 8.2 15.4 8.08 15.32 7.92 15.22 7.77 15.15 7.63 15.1 7.46 15.05 7.31 15.02 7.17 15.01C7.11 15 7.06 15 7 15ZM23.8 15.4L23.65 15.52 23.53 15.65 23.42 15.77 23.36 15.86 23.27 16C23.1 16.29 23 16.64 23 17 23 17.37 23.1 17.71 23.27 18L23.32 18.08 23.43 18.24 23.51 18.33 23.6 18.43 23.67 18.5 23.8 18.6 23.92 18.68 24.08 18.78 24.23 18.85 24.37 18.9 24.54 18.95 24.69 18.98 24.75 18.99 24.82 18.99C24.89 19 24.94 19 25 19 25.06 19 25.11 19 25.17 18.99L25 19 25.09 19 25.25 18.99 25.43 18.95 25.58 18.91 25.67 18.89 25.81 18.83 25.95 18.76 26.08 18.68 26.23 18.57 26.35 18.48 26.45 18.37 26.57 18.23 26.66 18.12 26.71 18.03 26.73 18C26.9 17.71 27 17.37 27 17 27 16.64 26.9 16.29 26.73 16L26.68 15.91 26.58 15.77 26.43 15.61 26.33 15.51 26.28 15.46 26.2 15.4 26.08 15.32 25.92 15.22 25.77 15.15 25.63 15.1 25.46 15.05 25.31 15.02 25.17 15.01 25.08 15 25 15C24.94 15 24.88 15 24.81 15.01L24.69 15.02 24.54 15.05 24.33 15.11 24.13 15.2 24.05 15.24C23.96 15.29 23.88 15.34 23.8 15.4ZM19.59 5L5.5 5C5.19 5 4.89 5.15 4.7 5.4L2.2 8.73C2.07 8.91 2 9.12 2 9.33L2 15C2 15.55 2.45 16 3 16L3.13 16C3.57 14.27 5.14 13 7 13 8.86 13 10.43 14.27 10.87 16L21.13 16C21.57 14.27 23.14 13 25 13 26.86 13 28.43 14.27 28.87 16L29 16C29.55 16 30 15.55 30 15L30 12.68C30 12.27 29.75 11.9 29.37 11.75L25.19 10.08C25.06 10.03 24.95 9.95 24.85 9.85L20.29 5.29C20.11 5.11 19.85 5 19.59 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, N0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M3 2.07L3.1 2.07 17.4 2.98C18.04 3.02 18.64 3.27 19.13 3.67L20.08 4.46C20.65 4.94 20.96 5.6 21 6.29 21.09 6.33 21.18 6.38 21.27 6.43L25.89 9.2 30.11 10.89C31.19 11.32 31.92 12.34 31.99 13.48L32 13.68 32 16C32 17.66 30.66 19 29 19L28.87 19C28.43 20.73 26.86 22 25 22 23.14 22 21.57 20.73 21.13 19L10.87 19C10.43 20.73 8.86 22 7 22 5.14 22 3.57 20.73 3.13 19L3 19C1.34 19 0 17.66 0 16L0 10.54C0 9.66 0.38 8.83 1.04 8.27 0.4 7.72 0 6.91 0 6L0 5.07C0 3.41 1.34 2.07 3 2.07ZM7 16L6.88 16 6.73 16.02 6.57 16.05 6.46 16.07 6.35 16.11 6.19 16.17 6.05 16.24 5.92 16.32 5.77 16.43 5.66 16.52 5.55 16.63 5.43 16.77 5.34 16.88 5.29 16.97 5.27 17C5.1 17.29 5 17.63 5 18 5 18.36 5.1 18.71 5.27 19L5.32 19.09 5.42 19.23 5.52 19.34 5.61 19.44 5.72 19.54 5.8 19.6 5.92 19.68 6.02 19.74 6.15 19.81 6.24 19.85 6.37 19.9 6.54 19.95 6.69 19.98 6.83 19.99C6.89 20 6.94 20 7 20 7.06 20 7.12 20 7.19 19.99L7.31 19.98 7.46 19.95 7.67 19.89 7.88 19.8C7.95 19.76 8.02 19.72 8.08 19.68L8.23 19.57 8.35 19.47 8.5 19.32 8.62 19.17 8.7 19.06 8.73 19C8.9 18.71 9 18.36 9 18 9 17.63 8.9 17.29 8.73 17L8.68 16.92 8.57 16.76 8.49 16.67 8.4 16.57 8.33 16.5 8.2 16.4 8.08 16.32 7.92 16.22 7.73 16.14 7.54 16.07 7.39 16.04 7.23 16.01 7.15 16.01C7.1 16 7.05 16 7 16ZM25 16L24.88 16 24.73 16.02 24.57 16.05 24.46 16.07 24.35 16.11 24.19 16.17 24.05 16.24 23.92 16.32 23.77 16.43 23.66 16.52 23.55 16.63 23.43 16.77 23.34 16.88 23.29 16.97 23.27 17C23.1 17.29 23 17.63 23 18 23 18.36 23.1 18.71 23.27 19L23.32 19.09 23.42 19.23 23.52 19.34 23.61 19.44 23.72 19.54 23.8 19.6 23.92 19.68 24.02 19.74 24.15 19.81 24.24 19.85 24.37 19.9 24.54 19.95 24.69 19.98 24.83 19.99C24.89 20 24.94 20 25 20 25.06 20 25.12 20 25.19 19.99L25.31 19.98 25.46 19.95 25.67 19.89 25.88 19.8C25.95 19.76 26.02 19.72 26.08 19.68L26.23 19.57 26.35 19.47 26.5 19.32 26.62 19.17 26.7 19.06 26.73 19C26.9 18.71 27 18.36 27 18 27 17.63 26.9 17.29 26.73 17L26.68 16.92 26.57 16.76 26.49 16.67 26.4 16.57 26.33 16.5 26.2 16.4 26.08 16.32 25.92 16.22 25.73 16.14 25.54 16.07 25.39 16.04 25.23 16.01 25.15 16.01C25.1 16 25.05 16 25 16ZM24.93 10.96L20.31 8.19 20.41 8.08C19.92 8.66 19.2 9 18.44 9L3.5 9 2.45 9.7C2.17 9.89 2 10.2 2 10.54L2 16C2 16.55 2.45 17 3 17L3.13 17C3.57 15.27 5.14 14 7 14 8.86 14 10.43 15.27 10.87 17L21.13 17C21.57 15.27 23.14 14 25 14 26.86 14 28.43 15.27 28.87 17L29 17C29.55 17 30 16.55 30 16L30 13.68C30 13.27 29.75 12.9 29.37 12.75L25.07 11.03C25.02 11.01 24.98 10.99 24.93 10.96ZM2.33 6.74L2.37 6.78 2.49 6.86 2.58 6.91 2.69 6.95 2.8 6.98 2.9 6.99 3 7 18.44 7C18.61 7 18.76 6.93 18.87 6.8 19.07 6.56 19.04 6.2 18.8 6L17.85 5.21C17.69 5.07 17.49 4.99 17.27 4.98L3.03 4.07 3 4.07C2.45 4.07 2 4.51 2 5.07L2 6C2 6.12 2.02 6.23 2.06 6.34 2.08 6.4 2.1 6.45 2.13 6.5 2.18 6.58 2.23 6.65 2.29 6.71L2.33 6.74Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, z0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M16.59 3C17.38 3 18.14 3.32 18.71 3.88L23.13 8.3 27.11 9.89C28.19 10.32 28.92 11.34 28.99 12.48L29 12.68 29 15C29 16.66 27.66 18 26 18L25.87 18C25.43 19.73 23.86 21 22 21 20.14 21 18.57 19.73 18.13 18L13.87 18C13.43 19.73 11.86 21 10 21 8.14 21 6.57 19.73 6.13 18L6 18C4.34 18 3 16.66 3 15L3 9.33C3 8.68 3.21 8.05 3.6 7.53L6.1 4.2C6.67 3.44 7.56 3 8.5 3L16.59 3ZM8.8 15.4L8.65 15.52 8.53 15.65 8.42 15.77 8.36 15.86 8.27 16C8.1 16.29 8 16.64 8 17 8 17.37 8.1 17.71 8.27 18L8.32 18.08 8.43 18.24 8.51 18.33 8.6 18.43 8.67 18.5 8.8 18.6 8.92 18.68 9.08 18.78 9.23 18.85 9.37 18.9 9.54 18.95 9.69 18.98 9.75 18.99 9.82 18.99C9.89 19 9.94 19 10 19 10.06 19 10.11 19 10.17 18.99L10 19 10.09 19 10.25 18.99 10.43 18.95 10.58 18.91 10.67 18.89 10.81 18.83 10.95 18.76 11.08 18.68 11.23 18.57 11.35 18.48 11.45 18.37 11.57 18.23 11.66 18.12 11.71 18.03 11.73 18C11.9 17.71 12 17.37 12 17 12 16.64 11.9 16.29 11.73 16L11.68 15.91 11.58 15.77 11.43 15.61 11.33 15.51 11.28 15.46 11.2 15.4 11.08 15.32 10.92 15.22 10.77 15.15 10.63 15.1 10.46 15.05 10.31 15.02 10.17 15.01 10.08 15 10 15C9.94 15 9.88 15 9.81 15.01L9.69 15.02 9.54 15.05 9.33 15.11 9.13 15.2 9.05 15.24C8.96 15.29 8.88 15.34 8.8 15.4ZM20.8 15.4L20.65 15.52 20.53 15.65 20.42 15.77 20.36 15.86 20.27 16C20.1 16.29 20 16.64 20 17 20 17.37 20.1 17.71 20.27 18L20.32 18.08 20.43 18.24 20.51 18.33 20.6 18.43 20.67 18.5 20.8 18.6 20.92 18.68 21.08 18.78 21.23 18.85 21.37 18.9 21.54 18.95 21.69 18.98 21.75 18.99 21.82 18.99C21.89 19 21.94 19 22 19 22.06 19 22.11 19 22.17 18.99L22 19 22.09 19 22.25 18.99 22.43 18.95 22.58 18.91 22.67 18.89 22.81 18.83 22.95 18.76 23.08 18.68 23.23 18.57 23.35 18.48 23.45 18.37 23.57 18.23 23.66 18.12 23.71 18.03 23.73 18C23.9 17.71 24 17.37 24 17 24 16.64 23.9 16.29 23.73 16L23.68 15.91 23.58 15.77 23.43 15.61 23.33 15.51 23.28 15.46 23.2 15.4 23.08 15.32 22.92 15.22 22.77 15.15 22.63 15.1 22.46 15.05 22.31 15.02 22.17 15.01 22.08 15 22 15C21.94 15 21.88 15 21.81 15.01L21.69 15.02 21.54 15.05 21.33 15.11 21.13 15.2 21.05 15.24C20.96 15.29 20.88 15.34 20.8 15.4ZM16.59 5L8.5 5C8.19 5 7.89 5.15 7.7 5.4L5.2 8.73C5.07 8.91 5 9.12 5 9.33L5 15C5 15.55 5.45 16 6 16L6.13 16C6.57 14.27 8.14 13 10 13 11.86 13 13.43 14.27 13.87 16L18.13 16C18.57 14.27 20.14 13 22 13 23.86 13 25.43 14.27 25.87 16L26 16C26.55 16 27 15.55 27 15L27 12.68C27 12.27 26.75 11.9 26.37 11.75L22.19 10.08C22.06 10.03 21.95 9.95 21.85 9.85L17.29 5.29C17.11 5.11 16.85 5 16.59 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, g0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M14.45 21.02L14.4 21.11 14.35 21.19 14.28 21.29 14.19 21.41 14.09 21.54 13.97 21.68 13.86 21.8 13.75 21.91 13.64 22.01 13.53 22.1 13.39 22.2 13.24 22.31 13.1 22.4 12.97 22.48 12.84 22.55 12.7 22.62 12.56 22.68 12.41 22.74 12.29 22.79 12.2 22.81 12.08 22.85 11.93 22.89 11.76 22.93 11.58 22.96 11.41 22.98 11.33 22.98 11.25 22.99 11.23 22.99 11.17 23 11.14 23 11.04 23 11 23C10.89 23 10.78 23 10.61 22.98L10.48 22.97 10.41 22.96 10.3 22.94 10.15 22.91 9.99 22.87 9.83 22.82 9.67 22.77 9.53 22.72 9.38 22.66 9.24 22.59 9.08 22.51 8.92 22.41 8.77 22.32 8.65 22.24 8.53 22.14 8.4 22.04 8.31 21.96 8.24 21.89 8.15 21.81 8.06 21.71 7.97 21.61 7.89 21.52 7.8 21.4 7.69 21.25 7.61 21.13 7.54 21.01C7.36 20.69 7.22 20.35 7.13 20L6 20C3.24 20 1 17.76 1 15L1 6.53C1 4 2.88 1.87 5.38 1.56 8.4 1.19 11.6 1 15 1 18.4 1 21.6 1.19 24.62 1.56 27.12 1.87 29 4 29 6.53L29 15C29 16.13 28.63 17.17 28 18L31 18C31.55 18 32 18.45 32 19 32 19.55 31.55 20 31 20L14.87 20C14.78 20.35 14.64 20.7 14.45 21.02ZM11 17C10.94 17 10.88 17 10.81 17.01L10.69 17.02 10.54 17.05 10.33 17.11 10.13 17.2 10.05 17.24C9.96 17.29 9.88 17.34 9.8 17.4L9.65 17.52 9.53 17.65 9.42 17.77 9.36 17.86 9.27 18C9.1 18.29 9 18.64 9 19 9 19.37 9.1 19.71 9.27 20L9.32 20.08 9.43 20.24 9.51 20.33 9.6 20.43 9.67 20.5 9.8 20.6 9.92 20.68 10.08 20.78 10.23 20.85 10.37 20.9 10.54 20.95 10.69 20.98 10.75 20.99 10.82 20.99C10.89 21 10.94 21 11 21L11.09 21 11.1 21 11.17 20.99 11.13 20.99 11.25 20.99 11.43 20.95 11.58 20.91 11.67 20.89 11.81 20.83 11.95 20.76 12.08 20.68 12.23 20.57 12.35 20.48 12.45 20.37 12.57 20.23 12.66 20.12 12.71 20.03 12.73 20C12.9 19.71 13 19.37 13 19 13 18.73 12.95 18.47 12.85 18.24 12.82 18.16 12.78 18.08 12.73 18L12.68 17.91 12.58 17.77 12.43 17.61 12.33 17.51 12.28 17.46 12.2 17.4 12.08 17.32 11.92 17.22 11.77 17.15 11.63 17.1 11.46 17.05 11.31 17.02 11.17 17.01 11.08 17 11 17ZM15 3C11.68 3 8.56 3.18 5.63 3.55 4.13 3.73 3 5.01 3 6.53L3 15C3 16.66 4.34 18 6 18L7.13 18C7.22 17.64 7.37 17.28 7.58 16.93L7.67 16.79 7.75 16.67 7.81 16.58 7.9 16.47 8 16.35 8.12 16.23 8.24 16.1 8.38 15.98 8.52 15.86 8.59 15.81C8.75 15.69 8.92 15.58 9.13 15.46L9.22 15.42 9.36 15.35 9.56 15.27 9.76 15.2 9.97 15.14 10.15 15.09 10.3 15.06 10.44 15.04 10.63 15.02C10.75 15.01 10.88 15 11.04 15L11.21 15.01 11.29 15.01 11.4 15.02 11.55 15.04 11.7 15.06 11.85 15.09 12.01 15.13 12.17 15.18 12.33 15.23 12.47 15.28 12.62 15.34 12.76 15.41 12.92 15.49 13.08 15.59 13.23 15.68 13.35 15.76 13.45 15.84 13.59 15.95 13.64 15.99 13.71 16.06 13.82 16.16 13.94 16.29 14.08 16.45 14.2 16.61 14.31 16.75 14.38 16.87 14.46 17C14.64 17.31 14.78 17.65 14.87 18L24 18C25.66 18 27 16.66 27 15L27 6.53C27 5.01 25.87 3.73 24.37 3.55 21.44 3.18 18.32 3 15 3ZM21 6C22.66 6 24 7.34 24 9L24 11C24 12.66 22.66 14 21 14L18 14C16.34 14 15 12.66 15 11L15 9C15 7.34 16.34 6 18 6L21 6ZM21 8L18 8C17.45 8 17 8.45 17 9L17 11C17 11.55 17.45 12 18 12L21 12C21.55 12 22 11.55 22 11L22 9C22 8.45 21.55 8 21 8Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, b0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M27.61 2.66C29.05 3.33 29.88 4.45 30 6L30 8C30 8.55 29.55 9 29 9 28.45 9 28 8.55 28 8L28 6.08C27.95 5.35 27.58 4.85 26.77 4.48 26.14 4.19 25.42 4.03 24.61 4L24.24 4 24.24 4.09C24.26 6.26 23.9 7.89 23.13 9L23 9.16C22.37 9.96 21.72 10.16 20.26 10.23L19.18 10.26C18.73 10.28 18.45 10.31 18.13 10.37 17.26 10.53 16.6 10.9 16.04 11.64 14.99 13.02 14.35 14.39 14.11 15.75L14.07 16 19.02 16C19.28 13.2 21.63 11 24.5 11 27.54 11 30 13.46 30 16.5 30 19.54 27.54 22 24.5 22 21.98 22 19.86 20.31 19.21 18L13.79 18C13.14 20.31 11.02 22 8.5 22 5.46 22 3 19.54 3 16.5 3 13.46 5.46 11 8.5 11 10.27 11 11.84 11.83 12.84 13.13 13.24 12.22 13.78 11.32 14.45 10.43 15.33 9.27 16.43 8.65 17.77 8.4 18.29 8.3 18.7 8.27 19.48 8.25L19.73 8.24C20.9 8.22 21.26 8.14 21.43 7.93 22.05 7.13 22.35 5.53 22.21 3.13 22.18 2.6 22.56 2.15 23.09 2.08 24.79 1.87 26.3 2.06 27.61 2.66ZM8.5 13C6.57 13 5 14.57 5 16.5 5 18.43 6.57 20 8.5 20 10.43 20 12 18.43 12 16.5 12 14.63 10.54 13.1 8.69 13.01L8.5 13ZM24.5 13C22.57 13 21 14.57 21 16.5 21 18.43 22.57 20 24.5 20 26.43 20 28 18.43 28 16.5 28 14.63 26.54 13.1 24.69 13.01L24.5 13ZM19.35 4.06C19.87 4.25 20.13 4.83 19.94 5.35 19.75 5.87 19.17 6.13 18.65 5.94 16.9 5.29 15.46 5.29 14.25 5.89 13.07 6.49 12.33 7.55 12.01 9.19 11.92 9.66 11.51 10 11.03 10L7.49 10C7.34 10 7.2 9.97 7.07 9.91L2.58 7.84C2.08 7.61 1.86 7.02 2.09 6.51 2.32 6.01 2.92 5.79 3.42 6.03L7.71 8 10.24 8 10.26 7.93C10.77 6.26 11.73 5.01 13.12 4.23L13.36 4.11C15.09 3.23 17.11 3.23 19.35 4.06Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, y0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M4.16 0.06L21.89 0.99C22.44 1.02 22.97 1.2 23.42 1.51L24.66 2.35C25.64 3.01 26.01 4.24 25.63 5.31L27.65 10.69 29.66 12.04C30.44 12.56 30.93 13.41 30.99 14.34L31 14.54 31 18C31 19.66 29.66 21 28 21L27.87 21C27.43 22.73 25.86 24 24 24 22.14 24 20.57 22.73 20.13 21L11.87 21C11.43 22.73 9.86 24 8 24 6.14 24 4.57 22.73 4.13 21L4 21C2.34 21 1 19.66 1 18L1 5C1 4.83 1.01 4.66 1.04 4.5 1.01 4.34 1 4.17 1 4L1 3.05C1 1.4 2.34 0.05 4 0.05L4.16 0.06ZM3 6.83L3 18C3 18.55 3.45 19 4 19L4.13 19C4.57 17.27 6.14 16 8 16 9.86 16 11.43 17.27 11.87 19L20.13 19C20.57 17.27 22.14 16 24 16 25.86 16 27.43 17.27 27.87 19L28 19C28.55 19 29 18.55 29 18L29 14.54C29 14.2 28.83 13.89 28.55 13.7L26.27 12.18C26.09 12.06 25.96 11.89 25.89 11.7L24.07 6.86C23.8 6.95 23.52 7 23.22 7L4 7C3.65 7 3.31 6.94 3 6.83ZM20 9C20.55 9 21 9.45 21 10L21 12C21 12.55 20.55 13 20 13 19.45 13 19 12.55 19 12L19 10C19 9.45 19.45 9 20 9ZM21.79 2.99L4 2.05C3.45 2.05 3 2.5 3 3.05L3 4C3 4.26 3.1 4.49 3.25 4.67L3.31 4.72 3.39 4.79 3.51 4.87 3.58 4.91C3.64 4.94 3.7 4.96 3.77 4.97 3.84 4.99 3.92 5 4 5L23.22 5 23.27 5 23.32 4.99 23.37 4.98C23.49 4.95 23.6 4.87 23.68 4.76 23.85 4.51 23.78 4.17 23.53 4L22.3 3.16C22.15 3.05 21.97 2.99 21.79 2.99ZM8.08 18L7.92 18 7.81 18.01 7.69 18.02 7.54 18.05 7.33 18.11 7.12 18.2 7.03 18.25 6.91 18.32 6.77 18.43 6.65 18.52 6.5 18.68 6.38 18.83 6.3 18.94 6.27 19C6.1 19.29 6 19.64 6 20 6 20.37 6.1 20.71 6.27 21L6.32 21.08 6.43 21.24 6.51 21.33 6.6 21.43 6.67 21.5 6.8 21.6 6.92 21.68 7.08 21.78 7.27 21.86 7.46 21.93 7.57 21.95 7.73 21.98 7.85 21.99 8 22 8.13 21.99 8.23 21.99 8.43 21.95 8.54 21.93 8.61 21.91 8.73 21.86 8.87 21.8 8.95 21.76 9.08 21.68 9.25 21.56 9.35 21.48 9.45 21.37 9.57 21.23 9.66 21.12 9.71 21.03 9.73 21C9.9 20.71 10 20.37 10 20 10 19.7 9.93 19.41 9.81 19.15L9.73 19 9.68 18.91 9.58 18.77 9.48 18.66 9.39 18.56 9.28 18.46 9.2 18.4C9.13 18.35 9.05 18.29 8.97 18.25L8.76 18.15 8.63 18.1 8.46 18.05 8.31 18.02 8.17 18.01 8.08 18ZM24.08 18L23.92 18 23.81 18.01 23.69 18.02 23.54 18.05 23.33 18.11 23.12 18.2 23.03 18.25 22.91 18.32 22.77 18.43 22.65 18.52 22.5 18.68 22.38 18.83 22.3 18.94 22.27 19C22.1 19.29 22 19.64 22 20 22 20.37 22.1 20.71 22.27 21L22.32 21.08 22.43 21.24 22.51 21.33 22.6 21.43 22.67 21.5 22.8 21.6 22.92 21.68 23.08 21.78 23.27 21.86 23.46 21.93 23.57 21.95 23.73 21.98 23.85 21.99 24 22 24.13 21.99 24.23 21.99 24.43 21.95 24.54 21.93 24.61 21.91 24.73 21.86 24.87 21.8 24.95 21.76 25.08 21.68 25.25 21.56 25.35 21.48 25.45 21.37 25.57 21.23 25.66 21.12 25.71 21.03 25.73 21C25.9 20.71 26 20.37 26 20 26 19.7 25.93 19.41 25.81 19.15L25.73 19 25.68 18.91 25.58 18.77 25.48 18.66 25.39 18.56 25.28 18.46 25.2 18.4C25.13 18.35 25.05 18.29 24.97 18.25L24.76 18.15 24.63 18.1 24.46 18.05 24.31 18.02 24.17 18.01 24.08 18Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, w0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M22.31 1C23.56 1 24.68 1.78 25.12 2.95L27.65 9.69 29.66 11.04C30.44 11.56 30.93 12.41 30.99 13.34L31 13.54 31 17C31 18.66 29.66 20 28 20L27.87 20C27.43 21.73 25.86 23 24 23 22.14 23 20.57 21.73 20.13 20L11.87 20C11.43 21.73 9.86 23 8 23 6.14 23 4.57 21.73 4.13 20L4 20C2.34 20 1 18.66 1 17L1 4C1 2.34 2.34 1 4 1L22.31 1ZM8 17C7.94 17 7.88 17 7.81 17.01L7.69 17.02 7.54 17.05 7.33 17.11 7.13 17.2 7.05 17.24 6.92 17.32 6.77 17.43 6.72 17.46 6.65 17.52 6.53 17.65 6.42 17.77 6.36 17.86 6.27 18C6.1 18.29 6 18.64 6 19 6 19.37 6.1 19.71 6.27 20L6.32 20.08 6.43 20.24 6.51 20.33 6.6 20.43 6.67 20.5 6.8 20.6 6.92 20.68 7.08 20.78 7.23 20.85 7.37 20.9 7.54 20.95 7.69 20.98 7.75 20.99 7.82 20.99C7.89 21 7.94 21 8 21L8.13 20.99 8.25 20.99 8.43 20.95 8.58 20.91 8.67 20.89 8.81 20.83 8.95 20.76 9.08 20.68 9.23 20.57 9.35 20.48 9.45 20.37 9.57 20.23 9.66 20.12 9.71 20.03 9.73 20C9.9 19.71 10 19.37 10 19 10 18.64 9.9 18.29 9.73 18L9.68 17.91 9.58 17.77 9.43 17.61 9.33 17.51 9.28 17.46 9.2 17.4 9.08 17.32 8.92 17.22 8.77 17.15 8.63 17.1 8.46 17.05 8.31 17.02 8.17 17.01C8.11 17 8.06 17 8 17ZM24 17C23.94 17 23.88 17 23.81 17.01L23.69 17.02 23.54 17.05 23.33 17.11 23.13 17.2 23.05 17.24C22.96 17.29 22.88 17.34 22.8 17.4L22.65 17.52 22.53 17.65 22.42 17.77 22.36 17.86 22.27 18C22.1 18.29 22 18.64 22 19 22 19.37 22.1 19.71 22.27 20L22.32 20.08 22.43 20.24 22.51 20.33 22.6 20.43 22.67 20.5 22.8 20.6 22.92 20.68 23.08 20.78 23.23 20.85 23.37 20.9 23.54 20.95 23.69 20.98 23.75 20.99 23.82 20.99C23.89 21 23.94 21 24 21L24.13 20.99 24.25 20.99 24.43 20.95 24.58 20.91 24.67 20.89 24.81 20.83 24.95 20.76 25.08 20.68 25.23 20.57 25.35 20.48 25.45 20.37 25.57 20.23 25.66 20.12 25.71 20.03 25.73 20C25.9 19.71 26 19.37 26 19 26 18.64 25.9 18.29 25.73 18L25.68 17.91 25.58 17.77 25.43 17.61 25.33 17.51 25.28 17.46 25.2 17.4 25.08 17.32 24.92 17.22 24.77 17.15 24.63 17.1 24.46 17.05 24.31 17.02 24.17 17.01 24.08 17 24 17ZM22.31 3L4 3C3.45 3 3 3.45 3 4L3 17C3 17.55 3.45 18 4 18L4.13 18C4.57 16.27 6.14 15 8 15 9.86 15 11.43 16.27 11.87 18L20.13 18C20.57 16.27 22.14 15 24 15 25.86 15 27.43 16.27 27.87 18L28 18C28.55 18 29 17.55 29 17L29 13.54C29 13.2 28.83 12.89 28.55 12.7L26.27 11.18C26.09 11.06 25.96 10.89 25.89 10.7L23.24 3.65C23.1 3.26 22.72 3 22.31 3ZM20 7C20.55 7 21 7.45 21 8L21 10C21 10.55 20.55 11 20 11 19.45 11 19 10.55 19 10L19 8C19 7.45 19.45 7 20 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, S0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M22.38 2C23.52 2 24.56 2.64 25.07 3.66L26.55 8.63 28.66 10.04C29.44 10.56 29.93 11.41 29.99 12.34L30 12.54 30 16C30 17.66 28.66 19 27 19L26.87 19C26.43 20.73 24.86 22 23 22 21.14 22 19.57 20.73 19.13 19L12.87 19C12.43 20.73 10.86 22 9 22 7.14 22 5.57 20.73 5.13 19L5 19C3.34 19 2 17.66 2 16L2 5C2 3.34 3.34 2 5 2L22.38 2ZM9 16C8.94 16 8.88 16 8.81 16.01L8.69 16.02 8.54 16.05 8.33 16.11 8.13 16.2 8.05 16.24 7.92 16.32 7.77 16.43 7.72 16.46 7.65 16.52 7.53 16.65 7.42 16.77 7.36 16.86 7.27 17C7.1 17.29 7 17.64 7 18 7 18.37 7.1 18.71 7.27 19L7.32 19.08 7.43 19.24 7.51 19.33 7.6 19.43 7.67 19.5 7.8 19.6 7.92 19.68 8.08 19.78 8.23 19.85 8.37 19.9 8.54 19.95 8.69 19.98 8.75 19.99 8.82 19.99C8.89 20 8.94 20 9 20L9.13 19.99 9.25 19.99 9.43 19.95 9.58 19.91 9.67 19.89 9.81 19.83 9.95 19.76 10.08 19.68 10.23 19.57 10.35 19.48 10.45 19.37 10.57 19.23 10.66 19.12 10.71 19.03 10.73 19C10.9 18.71 11 18.37 11 18 11 17.64 10.9 17.29 10.73 17L10.68 16.91 10.58 16.77 10.43 16.61 10.33 16.51 10.28 16.46 10.2 16.4 10.08 16.32 9.92 16.22 9.77 16.15 9.63 16.1 9.46 16.05 9.31 16.02 9.17 16.01C9.11 16 9.06 16 9 16ZM23 16C22.94 16 22.88 16 22.81 16.01L22.69 16.02 22.54 16.05 22.33 16.11 22.13 16.2 22.05 16.24C21.96 16.29 21.88 16.34 21.8 16.4L21.65 16.52 21.53 16.65 21.42 16.77 21.36 16.86 21.27 17C21.1 17.29 21 17.64 21 18 21 18.37 21.1 18.71 21.27 19L21.32 19.08 21.43 19.24 21.51 19.33 21.6 19.43 21.67 19.5 21.8 19.6 21.92 19.68 22.08 19.78 22.23 19.85 22.37 19.9 22.54 19.95 22.69 19.98 22.75 19.99 22.82 19.99C22.89 20 22.94 20 23 20L23.13 19.99 23.25 19.99 23.43 19.95 23.58 19.91 23.67 19.89 23.81 19.83 23.95 19.76 24.08 19.68 24.23 19.57 24.35 19.48 24.45 19.37 24.57 19.23 24.66 19.12 24.71 19.03 24.73 19C24.9 18.71 25 18.37 25 18 25 17.64 24.9 17.29 24.73 17L24.68 16.91 24.58 16.77 24.43 16.61 24.33 16.51 24.28 16.46 24.2 16.4 24.08 16.32 23.92 16.22 23.77 16.15 23.63 16.1 23.46 16.05 23.31 16.02 23.17 16.01 23.08 16 23 16ZM22.38 4L5 4C4.45 4 4 4.45 4 5L4 16C4 16.55 4.45 17 5 17L5.13 17C5.57 15.27 7.14 14 9 14 10.86 14 12.43 15.27 12.87 17L19.13 17C19.57 15.27 21.14 14 23 14 24.86 14 26.43 15.27 26.87 17L27 17C27.55 17 28 16.55 28 16L28 12.54C28 12.2 27.83 11.89 27.55 11.7L25.22 10.15C25.08 10.05 24.96 9.92 24.88 9.76L23.28 4.55C23.11 4.21 22.76 4 22.38 4ZM20 7C20.55 7 21 7.45 21 8L21 10C21 10.55 20.55 11 20 11 19.45 11 19 10.55 19 10L19 8C19 7.45 19.45 7 20 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, B0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M20.59 3C21.38 3 22.14 3.32 22.71 3.88L25.18 8.36 27.34 9.93C28.3 10.41 28.92 11.36 28.99 12.42L29 12.62 29 16C29 17.66 27.66 19 26 19L25.87 19C25.43 20.73 23.86 22 22 22 20.14 22 18.57 20.73 18.13 19L13.87 19C13.43 20.73 11.86 22 10 22 8.14 22 6.57 20.73 6.13 19L6 19C4.34 19 3 17.66 3 16L3 6C3 4.34 4.34 3 6 3L20.59 3ZM10 16C9.94 16 9.88 16 9.81 16.01L9.69 16.02 9.54 16.05 9.33 16.11 9.13 16.2 9.05 16.24 8.92 16.32 8.77 16.43 8.72 16.46 8.65 16.52 8.53 16.65 8.42 16.77 8.36 16.86 8.27 17C8.1 17.29 8 17.64 8 18 8 18.37 8.1 18.71 8.27 19L8.32 19.08 8.43 19.24 8.51 19.33 8.6 19.43 8.67 19.5 8.8 19.6 8.92 19.68 9.08 19.78 9.23 19.85 9.37 19.9 9.54 19.95 9.69 19.98 9.75 19.99 9.82 19.99C9.89 20 9.94 20 10 20L10.13 19.99 10.25 19.99 10.43 19.95 10.58 19.91 10.67 19.89 10.81 19.83 10.95 19.76 11.08 19.68 11.23 19.57 11.35 19.48 11.45 19.37 11.57 19.23 11.66 19.12 11.71 19.03 11.73 19C11.9 18.71 12 18.37 12 18 12 17.64 11.9 17.29 11.73 17L11.68 16.91 11.58 16.77 11.43 16.61 11.33 16.51 11.28 16.46 11.2 16.4 11.08 16.32 10.92 16.22 10.77 16.15 10.63 16.1 10.46 16.05 10.31 16.02 10.17 16.01C10.11 16 10.06 16 10 16ZM22 16C21.94 16 21.88 16 21.81 16.01L21.69 16.02 21.54 16.05 21.33 16.11 21.13 16.2 21.05 16.24C20.96 16.29 20.88 16.34 20.8 16.4L20.65 16.52 20.53 16.65 20.42 16.77 20.36 16.86 20.27 17C20.1 17.29 20 17.64 20 18 20 18.37 20.1 18.71 20.27 19L20.32 19.08 20.43 19.24 20.51 19.33 20.6 19.43 20.67 19.5 20.8 19.6 20.92 19.68 21.08 19.78 21.23 19.85 21.37 19.9 21.54 19.95 21.69 19.98 21.75 19.99 21.82 19.99C21.89 20 21.94 20 22 20L22.13 19.99 22.25 19.99 22.43 19.95 22.58 19.91 22.67 19.89 22.81 19.83 22.95 19.76 23.08 19.68 23.23 19.57 23.35 19.48 23.45 19.37 23.57 19.23 23.66 19.12 23.71 19.03 23.73 19C23.9 18.71 24 18.37 24 18 24 17.64 23.9 17.29 23.73 17L23.68 16.91 23.58 16.77 23.43 16.61 23.33 16.51 23.28 16.46 23.2 16.4 23.08 16.32 22.92 16.22 22.77 16.15 22.63 16.1 22.46 16.05 22.31 16.02 22.17 16.01 22.08 16 22 16ZM20.59 5L6 5C5.45 5 5 5.45 5 6L5 16C5 16.55 5.45 17 6 17L6.13 17C6.57 15.27 8.14 14 10 14 11.86 14 13.43 15.27 13.87 17L18.13 17C18.57 15.27 20.14 14 22 14 23.86 14 25.43 15.27 25.87 17L26 17C26.55 17 27 16.55 27 16L27 12.62C27 12.24 26.79 11.89 26.45 11.72L24.15 10.07C24.05 10.02 23.96 9.96 23.89 9.89L21.29 5.29C21.11 5.11 20.85 5 20.59 5ZM19 7C19.55 7 20 7.45 20 8L20 10C20 10.55 19.55 11 19 11 18.45 11 18 10.55 18 10L18 8C18 7.45 18.45 7 19 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, v0 = {
  icon: [
    32,
    24,
    [],
    "",
    "M29 18L17.46 18 17.35 18.19 17.28 18.29 17.19 18.41 17.09 18.54 16.97 18.68 16.86 18.8 16.75 18.91 16.64 19.01 16.53 19.1 16.39 19.2 16.24 19.31 16.1 19.4 15.97 19.48 15.84 19.55 15.7 19.62 15.56 19.68 15.41 19.74 15.29 19.79 15.08 19.85 14.93 19.89 14.76 19.93 14.58 19.96 14.41 19.98 14.25 19.99 14.23 19.99 14.17 20 14 20C13.89 20 13.78 20 13.61 19.98L13.41 19.96 13.15 19.91 12.99 19.87 12.83 19.82 12.67 19.77 12.53 19.72 12.38 19.66 12.24 19.59 12.08 19.51 11.92 19.41 11.77 19.32 11.65 19.24 11.53 19.14 11.4 19.04 11.31 18.96 11.15 18.81 11.06 18.71 10.97 18.61 10.89 18.52 10.8 18.4 10.69 18.25 10.61 18.13 10.54 18 5 18C3.34 18 2 16.66 2 15L2 7C2 5.34 3.34 4 5 4L19 4C22.87 4 26 7.13 26 11L26 16 29 16C29.55 16 30 16.45 30 17 30 17.55 29.55 18 29 18ZM14 14C13.94 14 13.88 14 13.81 14.01L13.69 14.02 13.54 14.05 13.33 14.11 13.13 14.2 13.05 14.24C12.96 14.29 12.88 14.34 12.8 14.4L12.65 14.52 12.53 14.65 12.42 14.77 12.36 14.86 12.27 15C12.1 15.29 12 15.64 12 16 12 16.37 12.1 16.71 12.27 17L12.32 17.08 12.43 17.24 12.51 17.33 12.6 17.43 12.67 17.5 12.8 17.6 12.92 17.68 13.08 17.78 13.23 17.85 13.37 17.9 13.54 17.95 13.69 17.98 13.75 17.99 13.91 18 14.03 18 14.25 17.99 14.43 17.95 14.58 17.91 14.67 17.89 14.81 17.83 14.95 17.76 15.08 17.68 15.23 17.57 15.35 17.48 15.45 17.37 15.57 17.23 15.66 17.12 15.71 17.03 15.73 17C15.9 16.71 16 16.37 16 16 16 15.64 15.9 15.29 15.73 15L15.68 14.91 15.58 14.77 15.43 14.61 15.33 14.51 15.28 14.46 15.2 14.4 15.08 14.32 14.92 14.22 14.77 14.15 14.63 14.1 14.46 14.05 14.31 14.02 14.17 14.01 14.08 14 14 14ZM19 6L5 6C4.45 6 4 6.45 4 7L4 15C4 15.55 4.45 16 5 16L10 16C10 15.29 10.19 14.6 10.58 13.93L10.67 13.79 10.75 13.67 10.81 13.58 10.9 13.47 11 13.35 11.12 13.23 11.24 13.1 11.38 12.98 11.52 12.86 11.59 12.81C11.75 12.69 11.92 12.58 12.13 12.46L12.22 12.42 12.36 12.35 12.56 12.27 12.76 12.2 12.97 12.14 13.15 12.09 13.3 12.06 13.44 12.04 13.63 12.02C13.75 12.01 13.88 12 14.04 12L14.21 12.01 14.29 12.01 14.55 12.04 14.7 12.06 14.85 12.09 15.01 12.13 15.17 12.18 15.33 12.23 15.47 12.28 15.62 12.34 15.76 12.41 15.92 12.49 16.08 12.59 16.23 12.68 16.35 12.76 16.45 12.84 16.64 12.99 16.71 13.06 16.82 13.16 16.94 13.29 17.08 13.45 17.2 13.61 17.31 13.75 17.38 13.87 17.46 14C17.77 14.53 17.95 15.12 17.99 15.73L18 16 24 16 24 11 24 10.78C23.88 8.12 21.69 6 19 6Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, k0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 13C13.21 13 15 14.79 15 17L15 20C15 20.55 14.55 21 14 21 13.45 21 13 20.55 13 20L13 17C13 15.9 12.1 15 11 15L5 15C3.9 15 3 15.9 3 17L3 20C3 20.55 2.55 21 2 21 1.45 21 1 20.55 1 20L1 17C1 14.79 2.79 13 5 13L11 13ZM19 6.83C19.55 6.83 20 7.28 20 7.83L20 10 22.17 10C22.72 10 23.17 10.45 23.17 11 23.17 11.55 22.72 12 22.17 12L20 12 20 14.17C20 14.72 19.55 15.17 19 15.17 18.45 15.17 18 14.72 18 14.17L18 12 15.83 12C15.28 12 14.83 11.55 14.83 11 14.83 10.45 15.28 10 15.83 10L18 10 18 7.83C18 7.28 18.45 6.83 19 6.83ZM8 3C10.21 3 12 4.79 12 7 12 9.21 10.21 11 8 11 5.79 11 4 9.21 4 7 4 4.79 5.79 3 8 3ZM8 5C6.9 5 6 5.9 6 7 6 8.1 6.9 9 8 9 9.1 9 10 8.1 10 7 10 5.9 9.1 5 8 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, $0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM15 17L9 17C7.9 17 7 17.9 7 19L7 20.66C8.47 21.51 10.18 22 12 22 13.82 22 15.53 21.51 17 20.66L17 19C17 17.9 16.1 17 15 17ZM12 2C6.48 2 2 6.48 2 12 2 14.8 3.15 17.33 5 19.14L5 19C5 16.79 6.79 15 9 15L15 15C17.21 15 19 16.79 19 19L19 19.14C20.85 17.33 22 14.8 22 12 22 6.48 17.52 2 12 2ZM12 5C14.21 5 16 6.79 16 9 16 11.21 14.21 13 12 13 9.79 13 8 11.21 8 9 8 6.79 9.79 5 12 5ZM12 7C10.9 7 10 7.9 10 9 10 10.1 10.9 11 12 11 13.1 11 14 10.1 14 9 14 7.9 13.1 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, A0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 14C18.21 14 20 15.79 20 18L20 21C20 21.55 19.55 22 19 22 18.45 22 18 21.55 18 21L18 18C18 16.9 17.1 16 16 16L8 16C6.9 16 6 16.9 6 18L6 21C6 21.55 5.55 22 5 22 4.45 22 4 21.55 4 21L4 18C4 15.79 5.79 14 8 14L16 14ZM20 10C22.21 10 24 11.79 24 14L24 15C24 15.55 23.55 16 23 16 22.45 16 22 15.55 22 15L22 14C22 12.9 21.1 12 20 12L19 12C18.45 12 18 11.55 18 11 18 10.45 18.45 10 19 10L20 10ZM5 10C5.55 10 6 10.45 6 11 6 11.55 5.55 12 5 12L4 12C2.9 12 2 12.9 2 14L2 15C2 15.55 1.55 16 1 16 0.45 16 0 15.55 0 15L0 14C0 11.79 1.79 10 4 10L5 10ZM12 4C14.21 4 16 5.79 16 8 16 10.21 14.21 12 12 12 9.79 12 8 10.21 8 8 8 5.79 9.79 4 12 4ZM12 6C10.9 6 10 6.9 10 8 10 9.1 10.9 10 12 10 13.1 10 14 9.1 14 8 14 6.9 13.1 6 12 6ZM20 2C21.66 2 23 3.34 23 5 23 6.66 21.66 8 20 8 18.34 8 17 6.66 17 5 17 3.34 18.34 2 20 2ZM4 2C5.66 2 7 3.34 7 5 7 6.66 5.66 8 4 8 2.34 8 1 6.66 1 5 1 3.34 2.34 2 4 2ZM20 4C19.45 4 19 4.45 19 5 19 5.55 19.45 6 20 6 20.55 6 21 5.55 21 5 21 4.49 20.61 4.06 20.12 4.01L20 4ZM4 4L3.88 4.01C3.39 4.06 3 4.49 3 5 3 5.55 3.45 6 4 6 4.55 6 5 5.55 5 5 5 4.45 4.55 4 4 4Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, I0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 15C13.21 15 15 16.79 15 19L15 21C15 21.55 14.55 22 14 22 13.45 22 13 21.55 13 21L13 19C13 17.9 12.1 17 11 17L5 17C3.9 17 3 17.9 3 19L3 21C3 21.55 2.55 22 2 22 1.45 22 1 21.55 1 21L1 19C1 16.79 2.79 15 5 15L11 15ZM19 11C21.21 11 23 12.79 23 15L23 16C23 16.55 22.55 17 22 17 21.45 17 21 16.55 21 16L21 15C21 13.9 20.1 13 19 13L16 13C15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11L19 11ZM8 5C10.21 5 12 6.79 12 9 12 11.21 10.21 13 8 13 5.79 13 4 11.21 4 9 4 6.79 5.79 5 8 5ZM8 7C6.9 7 6 7.9 6 9 6 10.1 6.9 11 8 11 9.1 11 10 10.1 10 9 10 7.9 9.1 7 8 7ZM18 3C19.66 3 21 4.34 21 6 21 7.66 19.66 9 18 9 16.34 9 15 7.66 15 6 15 4.34 16.34 3 18 3ZM18 5C17.45 5 17 5.45 17 6 17 6.55 17.45 7 18 7 18.55 7 19 6.55 19 6 19 5.49 18.61 5.06 18.12 5.01L18 5Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, H0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M10 16C12.21 16 14 17.79 14 20L14 22C14 22.55 13.55 23 13 23 12.45 23 12 22.55 12 22L12 20C12 18.9 11.1 18 10 18L4 18C2.9 18 2 18.9 2 20L2 22C2 22.55 1.55 23 1 23 0.45 23 0 22.55 0 22L0 20C0 17.79 1.79 16 4 16L10 16ZM20 12C22.21 12 24 13.79 24 16L24 18C24 18.55 23.55 19 23 19 22.45 19 22 18.55 22 18L22 16C22 14.9 21.1 14 20 14L15 14C14.45 14 14 13.55 14 13 14 12.45 14.45 12 15 12L20 12ZM7 4C9.76 4 12 6.24 12 9 12 11.76 9.76 14 7 14 4.24 14 2 11.76 2 9 2 6.24 4.24 4 7 4ZM7 6C5.34 6 4 7.34 4 9 4 10.66 5.34 12 7 12 8.66 12 10 10.66 10 9 10 7.34 8.66 6 7 6ZM18.5 1C20.99 1 23 3.01 23 5.5 23 7.99 20.99 10 18.5 10 16.01 10 14 7.99 14 5.5 14 3.01 16.01 1 18.5 1ZM18.5 3C17.12 3 16 4.12 16 5.5 16 6.88 17.12 8 18.5 8 19.88 8 21 6.88 21 5.5 21 4.12 19.88 3 18.5 3Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, R0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C14.76 2 17 4.24 17 7 17 9.76 14.76 12 12 12 9.24 12 7 9.76 7 7 7 4.24 9.24 2 12 2ZM12 4C10.34 4 9 5.34 9 7 9 8.66 10.34 10 12 10 13.66 10 15 8.66 15 7 15 5.34 13.66 4 12 4ZM20 21C20 21.55 19.55 22 19 22 18.45 22 18 21.55 18 21L18 18C18 16.9 17.1 16 16 16L8 16C6.9 16 6 16.9 6 18L6 21C6 21.55 5.55 22 5 22 4.45 22 4 21.55 4 21L4 18C4 15.79 5.79 14 8 14L16 14C18.21 14 20 15.79 20 18L20 21Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, T0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM21 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L5 22 5 19C5 16.79 6.79 15 9 15L15 15C17.21 15 19 16.79 19 19L19 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM15 17L9 17C7.9 17 7 17.9 7 19L7 22 17 22 17 19C17 17.9 16.1 17 15 17ZM12 5C14.21 5 16 6.79 16 9 16 11.21 14.21 13 12 13 9.79 13 8 11.21 8 9 8 6.79 9.79 5 12 5ZM12 7C10.9 7 10 7.9 10 9 10 10.1 10.9 11 12 11 13.1 11 14 10.1 14 9 14 7.9 13.1 7 12 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, V0 = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM21 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM9 14C10.66 14 12 15.34 12 17L12 18C12 18.55 11.55 19 11 19 10.45 19 10 18.55 10 18L10 17C10 16.45 9.55 16 9 16L7 16C6.45 16 6 16.45 6 17L6 18C6 18.55 5.55 19 5 19 4.45 19 4 18.55 4 18L4 17C4 15.34 5.34 14 7 14L9 14ZM18 15C18 14.45 17.55 14 17 14L14 14C13.45 14 13 13.55 13 13 13 12.45 13.45 12 14 12L17 12C18.66 12 20 13.34 20 15L20 17C20 17.55 19.55 18 19 18 18.45 18 18 17.55 18 17L18 15ZM8 7C9.66 7 11 8.34 11 10 11 11.66 9.66 13 8 13 6.34 13 5 11.66 5 10 5 8.34 6.34 7 8 7ZM8 9C7.45 9 7 9.45 7 10 7 10.55 7.45 11 8 11 8.55 11 9 10.55 9 10 9 9.49 8.61 9.06 8.12 9.01L8 9ZM16 5C17.66 5 19 6.34 19 8 19 9.66 17.66 11 16 11 14.34 11 13 9.66 13 8 13 6.34 14.34 5 16 5ZM16 7C15.45 7 15 7.45 15 8 15 8.55 15.45 9 16 9 16.55 9 17 8.55 17 8 17 7.49 16.61 7.06 16.12 7.01L16 7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium"
}, D0 = {
  icon: [
    67,
    78,
    [],
    "",
    "M32.56 0C33.13 0 33.59 0.47 33.59 1.04L33.59 3.71C36.39 4.17 38.56 6.41 38.94 9.25L40.99 9.25C41.56 9.25 42.02 9.71 42.02 10.29 42.02 10.86 41.56 11.33 40.99 11.33L39.01 11.33 39.01 17.3 40.99 17.3C41.26 17.3 41.51 17.41 41.7 17.6 41.89 17.79 42 18.05 42 18.31L42 22.79C42 23.06 41.89 23.32 41.7 23.51 41.51 23.7 41.26 23.8 40.99 23.8L39.06 23.8 41.1 65.05 43.78 65.05C44.35 65.05 44.81 65.52 44.81 66.09L44.81 74.83 44.88 74.79C47.44 73.58 50.4 73.58 52.96 74.79L53.83 75.21C55.83 76.15 58.15 76.15 60.15 75.21L60.58 75C60.83 74.88 61.11 74.87 61.37 74.96 61.63 75.05 61.84 75.25 61.96 75.5 62.07 75.75 62.09 76.03 62 76.29 61.9 76.55 61.71 76.77 61.47 76.88L61.03 77.09C59.77 77.7 58.38 78 56.99 78 55.6 78 54.21 77.7 52.94 77.09L52.08 76.68C50.08 75.74 47.76 75.74 45.76 76.68L44.89 77.09C43.62 77.7 42.23 78 40.85 78 39.46 78 38.07 77.7 36.8 77.09L35.94 76.68C33.93 75.74 31.62 75.74 29.62 76.68L28.75 77.09C27.48 77.7 26.1 78 24.71 78 23.32 78 21.93 77.7 20.66 77.09L19.8 76.68C17.79 75.73 15.48 75.73 13.47 76.68L12.61 77.09C11.34 77.7 9.95 78 8.56 78 7.17 78 5.79 77.7 4.52 77.09L3.66 76.68C3.32 76.52 3.09 76.19 3.06 75.82 3.03 75.45 3.2 75.09 3.5 74.87 3.81 74.66 4.2 74.63 4.54 74.79L5.4 75.21C7.41 76.15 9.72 76.15 11.73 75.21L12.16 75 12.59 74.79C15 73.64 17.86 73.6 20.31 74.64L20.31 66.09C20.31 65.52 20.77 65.05 21.34 65.05L24.02 65.05 26.06 23.8 24.13 23.8C23.58 23.8 23.13 23.35 23.13 22.79L23.13 18.31C23.13 17.76 23.58 17.3 24.13 17.3L26.11 17.3 26.11 11.33 24.13 11.33C23.56 11.33 23.1 10.86 23.1 10.29 23.1 9.71 23.56 9.25 24.13 9.25L26.18 9.25C26.57 6.41 28.74 4.17 31.53 3.71L31.53 1.04C31.53 0.47 31.99 0 32.56 0ZM42.74 67.13L22.38 67.13 22.38 75.54C24.18 76.13 26.15 76.01 27.87 75.21L28.3 75 28.74 74.79C31.3 73.58 34.26 73.58 36.82 74.79L37.69 75.21C39.27 75.95 41.06 76.11 42.74 75.66L42.74 67.13ZM38.6 56.31L26.52 56.31 26.09 65.05 39.04 65.05 38.6 56.31ZM38.07 45.48L27.05 45.48 26.62 54.23 38.5 54.23 38.07 45.48ZM37.53 34.66L27.59 34.66 27.16 43.4 37.96 43.4 37.53 34.66ZM36.99 23.8L28.13 23.8 27.69 32.57 37.43 32.57 36.99 23.8ZM39.99 19.33L36.42 19.33 36.42 21.78 39.99 21.78 39.99 19.33ZM34.42 19.33L30.7 19.33 30.7 21.78 34.42 21.78 34.42 19.33ZM28.7 19.33L25.13 19.33 25.13 21.78 28.7 21.78 28.7 19.33ZM49.91 16.93L50.03 16.94 64.03 19.24C64.26 19.28 64.47 19.41 64.61 19.6 64.74 19.79 64.8 20.03 64.76 20.26 64.73 20.49 64.6 20.7 64.41 20.83 64.22 20.97 63.98 21.03 63.75 20.99L49.74 18.69C49.43 18.64 49.17 18.42 49.06 18.13 48.95 17.83 49 17.5 49.2 17.25 49.38 17.04 49.64 16.92 49.91 16.93ZM16.86 17.25C17.06 17.5 17.11 17.83 17 18.13 16.89 18.42 16.63 18.64 16.32 18.69L2.31 20.99C2.08 21.03 1.84 20.97 1.65 20.83 1.46 20.7 1.33 20.49 1.29 20.26 1.26 20.03 1.31 19.79 1.45 19.6 1.58 19.41 1.79 19.28 2.02 19.24L16.03 16.94C16.34 16.89 16.66 17.01 16.86 17.25ZM36.95 11.33L28.18 11.33 28.18 17.3 36.95 17.3 36.95 11.33ZM65.03 13C65.6 13 66.06 13.45 66.06 14 66.06 14.55 65.6 15 65.03 15L60.08 15C59.52 15 59.06 14.55 59.06 14 59.06 13.45 59.52 13 60.08 13L65.03 13ZM5.97 13C6.54 13 7 13.45 7 14 7 14.55 6.54 15 5.97 15L1.03 15C0.46 15 0 14.55 0 14 0 13.45 0.46 13 1.03 13L5.97 13ZM63.75 7.01C64.06 6.96 64.37 7.08 64.57 7.32 64.77 7.57 64.83 7.9 64.72 8.2 64.61 8.49 64.34 8.71 64.03 8.76L50.03 11.06C49.98 11.07 49.93 11.07 49.88 11.07 49.42 11.07 49.04 10.71 49.01 10.26 48.97 9.8 49.29 9.39 49.74 9.31L63.75 7.01ZM2.31 7.01L16.32 9.31C16.77 9.39 17.09 9.8 17.05 10.26 17.01 10.71 16.63 11.07 16.17 11.07 16.13 11.07 16.08 11.07 16.03 11.06L2.02 8.76C1.71 8.71 1.45 8.49 1.34 8.2 1.23 7.9 1.28 7.57 1.48 7.32 1.68 7.08 2 6.96 2.31 7.01ZM32.56 5.7C30.48 5.7 28.68 7.18 28.26 9.24L36.86 9.24C36.46 7.25 34.77 5.8 32.78 5.7L32.56 5.7Z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "xl"
}, F0 = {
  icon: [
    1024,
    1024,
    [],
    "",
    "M409.06 273.86c6.14 0 10.76 3.08 12.29 7.68v1.53l18.43 72.21h318.04c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04l50.7 116.77h196.66c9.22 0 15.37 9.22 12.29 18.43l-1.53 1.54-122.92 204.34c3.08 0 6.14 1.53 9.22 1.53 9.22 0 15.37-3.08 24.59-7.68l13.83-9.22c23.05-15.37 46.09-23.05 84.5-23.04 7.68 0 13.83 6.14 13.83 13.83s-6.14 13.83-13.83 13.83c-32.27 0-50.7 6.14-69.14 18.43l-13.83 9.22c-13.83 9.22-24.59 12.29-39.95 12.29s-26.12-4.61-39.94-12.29l-13.83-9.22c-18.43-12.29-36.88-18.43-69.14-18.43s-50.7 6.14-69.14 18.43l-13.83 9.22c-13.83 9.22-24.59 12.29-39.95 12.29s-26.12-4.61-39.94-12.29l-13.83-9.22c-18.43-12.29-36.88-18.43-69.14-18.43s-50.7 6.14-69.14 18.43l-13.83 9.22c-13.83 9.22-24.59 12.29-39.95 12.29s-26.12-4.61-39.94-12.29l-13.83-9.22c-18.43-12.29-36.88-18.43-69.14-18.43s-50.7 6.14-69.14 18.43l-13.83 9.22c-13.83 9.22-24.59 12.29-39.95 12.29s-26.12-4.61-39.94-12.29l-13.83-9.22c-18.43-12.29-36.88-18.43-69.14-18.43-7.68 0-13.83-6.14-13.83-13.83s6.14-13.83 13.83-13.83c27.66 0 49.16 4.61 66.06 12.29l-18.43-182.84c0-7.68 4.61-13.83 10.75-13.83h69.14c12.29 0 24.59-9.22 26.12-21.51v-3.07l13.83-99.87c1.53-10.76 10.76-18.43 21.51-19.97h82.97v-69.14c0-6.14 4.61-12.29 10.76-13.83h1.53c0 0 102.94 0 102.94 0zM885.35 648.74h-775.89l6.15 64.53c1.53 1.53 3.08 1.53 3.07 3.08 9.22 6.14 15.37 7.68 24.59 7.67s15.37-3.08 24.58-7.67l13.83-9.23c23.05-15.37 46.09-23.05 84.51-23.04 35.34 0 58.38 6.14 79.89 19.97l4.61 3.08c3.08 1.53 12.29 9.22 13.83 9.22 9.22 6.14 15.37 7.68 24.59 7.68s15.37-3.08 24.58-7.68l13.83-9.22c23.05-15.37 46.09-23.05 84.51-23.05 35.34 0 58.38 6.14 79.89 19.98l4.61 3.08c3.08 1.53 12.29 9.22 13.83 9.21 9.22 6.14 15.37 7.68 24.59 7.68s15.37-3.08 24.58-7.68l13.83-9.22c23.05-15.37 46.09-23.05 84.51-23.04 35.34 0 58.38 6.14 79.89 19.97l4.61 3.08c1.53 1.53 4.61 3.08 6.15 4.61v0l36.87-62.99zM708.66 381.4h-491.65l-13.83 96.8c-3.08 26.12-24.59 44.55-50.7 46.09h-55.31l9.22 96.8h795.86l58.38-96.8h-182.83c-4.61 0-9.22-3.08-10.75-6.14l-1.54-1.54-32.26-73.75h-58.39c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.76-13.83h49.16l-12.29-33.8zM409.06 478.2c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM470.51 478.2c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.75 13.83h-23.05c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.76-13.83h23.04zM531.98 478.2c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM593.43 478.2c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM347.61 478.2c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM286.15 478.2c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM409.06 416.75c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM470.51 416.75c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.75 13.83h-23.05c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.76-13.83h23.04zM531.98 416.75c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM593.43 416.75c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM347.61 416.75c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM286.15 416.75c7.68 0 13.83 6.14 13.83 13.83 0 6.14-4.61 12.29-10.76 13.83h-23.04c-7.68 0-13.83-6.14-13.83-13.83 0-6.14 4.61-12.29 10.75-13.83h23.05zM399.84 299.98h-78.36v55.31h92.19l-13.83-55.31z"
  ],
  iconName: "random",
  prefix: "fal",
  size: "xl"
}, h = f(function({
  className: L,
  color: e = "var(--swui-text-primary-color)",
  flip: i,
  icon: o,
  pulse: a,
  rotation: t,
  size: s = 16,
  spin: c,
  style: m,
  transform: d,
  display: Z,
  ..._
}, N) {
  if (!o)
    return null;
  const g = typeof s == "string" ? s : s / 10 + "rem";
  return /* @__PURE__ */ C(
    p,
    {
      justifyContent: "center",
      alignItems: "center",
      display: Z,
      ref: N,
      children: /* @__PURE__ */ C(
        T,
        {
          className: L,
          color: e,
          flip: i,
          icon: o,
          pulse: a,
          rotation: t,
          spin: c,
          style: { fontSize: g, ...m },
          transform: d,
          ..._
        }
      )
    }
  );
}), t2 = "_banner_hmwzu_1", a2 = "_iconBackground_hmwzu_7", s2 = "_standard_hmwzu_17", c2 = "_info_hmwzu_21", r2 = "_success_hmwzu_25", m2 = "_warning_hmwzu_29", l2 = "_error_hmwzu_33", j = {
  banner: t2,
  iconBackground: a2,
  standard: s2,
  info: c2,
  success: r2,
  warning: m2,
  error: l2
}, d2 = ({
  title: n,
  titleId: L,
  ...e
}, i) => /* @__PURE__ */ y.createElement("svg", { className: "spinner", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", ref: i, "aria-labelledby": L, ...e }, n ? /* @__PURE__ */ y.createElement("title", { id: L }, n) : null, /* @__PURE__ */ y.createElement("circle", { className: "path", fill: "none", strokeWidth: 6, strokeLinecap: "round", cx: 50, cy: 50, r: 45 })), M2 = f(d2), Z2 = "_spinner_1xjtk_1", u2 = "_rotator_1xjtk_1", f2 = "_standard_1xjtk_13", p2 = "_dash_1xjtk_1", x2 = "_inverted_1xjtk_21", h2 = "_customColor_1xjtk_29", _2 = "_medium_1xjtk_35", N2 = "_small_1xjtk_40", z2 = "_tiny_1xjtk_45", E = {
  spinner: Z2,
  rotator: u2,
  standard: f2,
  dash: p2,
  inverted: x2,
  customColor: h2,
  medium: _2,
  small: N2,
  tiny: z2
}, B1 = ({
  size: n = "medium",
  variant: L = "standard",
  color: e,
  ...i
}) => /* @__PURE__ */ C(
  M2,
  {
    className: l(
      E.spinner,
      E[n],
      e ? E.customColor : E[L]
    ),
    style: { stroke: e },
    ...H(i)
  }
), p1 = {
  standard: J1,
  info: C2,
  success: F,
  warning: Y1,
  error: t1
}, x1 = "56px", g2 = ({
  headerText: n,
  text: L,
  children: e,
  contentRight: i,
  icon: o,
  variant: a = "standard",
  loading: t = !1,
  ...s
}) => /* @__PURE__ */ r(
  x,
  {
    className: l(j.banner, j[a]),
    spacing: e || n && L ? 2 : 1,
    indent: 2,
    ...H(s),
    children: [
      /* @__PURE__ */ r(u, { justifyContent: "space-between", children: [
        /* @__PURE__ */ C(u, { flex: "none", width: x1, alignItems: "center", children: /* @__PURE__ */ C("div", { className: j.iconBackground, children: (o || p1[a] || t) && /* @__PURE__ */ C(B, { children: t ? /* @__PURE__ */ C(B1, { size: "tiny" }) : /* @__PURE__ */ C(
          h,
          {
            icon: o ?? p1[a],
            size: 20,
            className: j.icon
          }
        ) }) }) }),
        /* @__PURE__ */ r(u, { justifyContent: "space-between", flexGrow: 1, gap: !0, children: [
          /* @__PURE__ */ r(x, { justifyContent: "center", gap: !0, children: [
            n && /* @__PURE__ */ C(X, { variant: "h5", children: n }),
            L && /* @__PURE__ */ C($, { children: L })
          ] }),
          i && /* @__PURE__ */ C(x, { justifyContent: "center", children: i })
        ] })
      ] }),
      e && /* @__PURE__ */ r(u, { children: [
        /* @__PURE__ */ C(p, { minWidth: x1 }),
        /* @__PURE__ */ r(p, { children: [
          /* @__PURE__ */ C(I, {}),
          e
        ] })
      ] })
    ]
  }
), b2 = "_link_oed7a_1", y2 = "_disabled_oed7a_31", w2 = "_standard_oed7a_61", S2 = "_bold_oed7a_64", B2 = "_caption_oed7a_68", v2 = "_overline_oed7a_75", k2 = "_large_oed7a_82", $2 = "_medium_oed7a_88", A2 = "_small_oed7a_93", I2 = "_smaller_oed7a_99", O = {
  link: b2,
  disabled: y2,
  standard: w2,
  bold: S2,
  caption: B2,
  overline: v2,
  large: k2,
  medium: $2,
  small: A2,
  smaller: I2
}, H2 = f(
  ({
    children: n,
    className: L,
    onClick: e,
    tabIndex: i = 0,
    disableTabIndex: o,
    disabled: a,
    variant: t = "standard",
    size: s = "medium",
    iconLeft: c,
    iconRight: m,
    href: d,
    ...Z
  }, _) => /* @__PURE__ */ r(
    "a",
    {
      tabIndex: o ? void 0 : i,
      className: l(
        O.link,
        O[t],
        O[s],
        a && O.disabled,
        L
      ),
      ref: _,
      href: a ? void 0 : d,
      onClick: a ? void 0 : e,
      ...Z,
      children: [
        c && /* @__PURE__ */ C("span", { style: { marginLeft: "2px", marginRight: "6px" }, children: /* @__PURE__ */ C(T, { icon: c }) }),
        n,
        m && /* @__PURE__ */ C("span", { style: { marginLeft: "6px", marginRight: "2px" }, children: /* @__PURE__ */ C(T, { icon: m }) })
      ]
    }
  )
), R2 = "_resultItemRow_1y7mx_1", T2 = "_link_1y7mx_5", h1 = {
  resultItemRow: R2,
  link: T2
}, V2 = ({
  text: n,
  onClickLink: L,
  linkText: e
}) => /* @__PURE__ */ r("div", { className: h1.resultItemRow, children: [
  /* @__PURE__ */ C($, { children: n }),
  e && /* @__PURE__ */ C(H2, { className: h1.link, onClick: L, children: e })
] }), D2 = "_resultList_13lxa_1", F2 = {
  resultList: D2
}, j2 = ({ children: n }) => /* @__PURE__ */ C("ul", { className: F2.resultList, children: a1.map(n, (L) => /* @__PURE__ */ C("li", { children: L })) }), j0 = ({
  bannerState: n,
  variant: L = "standard",
  children: e,
  ...i
}) => /* @__PURE__ */ r(
  g2,
  {
    ...i,
    headerText: n.headerText,
    text: n.text,
    variant: L,
    children: [
      n.items && /* @__PURE__ */ C(B, { children: /* @__PURE__ */ C(j2, { children: n.items.map((o, a) => /* @__PURE__ */ C(
        V2,
        {
          text: o.text,
          linkText: o.linkText,
          onClickLink: o.onClickLink
        },
        a
      )) }) }),
      e
    ]
  }
), E0 = (n) => {
  const [L, e] = T1(n), i = D(
    (t) => {
      e((s) => ({
        ...s,
        items: t.map((c) => ({ text: c }))
      }));
    },
    [e]
  ), o = D(
    (t) => {
      i(t.map((s) => s.message));
    },
    [i]
  ), a = D(() => {
    e(void 0);
  }, [e]);
  return {
    bannerState: L,
    setBannerState: e,
    setBannerResultWithTexts: i,
    setBannerResultWithErrors: o,
    clearBannerResult: a
  };
}, E2 = ({
  title: n,
  titleId: L,
  ...e
}, i) => /* @__PURE__ */ y.createElement("svg", { viewBox: "0 0 1024 1024", focusable: "false", "data-icon": "loading", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ref: i, "aria-labelledby": L, ...e }, n ? /* @__PURE__ */ y.createElement("title", { id: L }, n) : null, /* @__PURE__ */ y.createElement("path", { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" })), O2 = f(E2), P2 = U1`
  100% {
    transform:rotate(360deg)
  }
`, v1 = ({
  className: n,
  color: L,
  size: e
}) => /* @__PURE__ */ C(W1, { children: ({ css: i, cx: o }) => /* @__PURE__ */ C(
  O2,
  {
    className: o(
      n,
      i`
              color: ${L};
              width: ${e};
              height: ${e};
              fill: currentColor;
              animation: ${P2} 1s infinite linear;
            `
    )
  }
) }), O0 = ({ children: n }) => /* @__PURE__ */ C(u, { alignItems: "center", children: a1.map(n, (L, e) => /* @__PURE__ */ C(B, { children: L && /* @__PURE__ */ r(B, { children: [
  e > 0 && /* @__PURE__ */ C(s1, { num: 2, children: /* @__PURE__ */ C(
    h,
    {
      icon: L2,
      size: 8,
      color: z("--lhds-color-ui-700")
    }
  ) }),
  L
] }) })) }), U2 = "_crumb_c5ozi_1", _1 = {
  crumb: U2
}, P0 = ({ label: n, render: L }) => {
  if (L) {
    const e = n.toUpperCase();
    return /* @__PURE__ */ C(B, { children: L({ children: e, className: _1.crumb }) });
  }
  return /* @__PURE__ */ C("span", { className: _1.crumb, children: n.toUpperCase() });
}, W2 = "_button_5nfpd_1", q2 = "_roundButton_5nfpd_44", G2 = "_small_5nfpd_54", K2 = "_medium_5nfpd_60", X2 = "_large_5nfpd_66", Q2 = "_larger_5nfpd_72", A = {
  button: W2,
  roundButton: q2,
  small: G2,
  medium: K2,
  large: X2,
  larger: Q2
}, c1 = (n, L, e, i, o) => L ? e : i ? o : n, J2 = "_buttonContent_u48in_1", Y2 = "_iconLeft_u48in_6", C5 = "_iconRight_u48in_7", L5 = "_leftWrapper_u48in_12", e5 = "_rightWrapper_u48in_13", n5 = "_responsiveIconOnly_u48in_19", i5 = "_label_u48in_25", o5 = "_spinnerLeft_u48in_32", b = {
  buttonContent: J2,
  iconLeft: Y2,
  iconRight: C5,
  leftWrapper: L5,
  rightWrapper: e5,
  responsiveIconOnly: n5,
  label: i5,
  spinnerLeft: o5
}, r1 = ({
  success: n,
  loading: L,
  leftIcon: e,
  left: i,
  right: o,
  rightIcon: a,
  label: t,
  iconClassName: s,
  labelClassName: c,
  spinnerClassName: m,
  leftWrapperClassName: d,
  rightWrapperClassName: Z,
  size: _ = "medium",
  responsiveIconOnly: N = !1
}) => {
  const g = (n || L || e || i) && /* @__PURE__ */ C(
    "div",
    {
      className: l(
        b.leftWrapper,
        b[_],
        d,
        N && b.responsiveIconOnly
      ),
      children: n ? /* @__PURE__ */ C(
        T,
        {
          icon: F,
          className: l(b.iconLeft, s)
        }
      ) : L ? /* @__PURE__ */ C(
        "div",
        {
          className: l(b.iconLeft, b.spinnerLeft, m),
          children: /* @__PURE__ */ C(v1, {})
        }
      ) : i || (e ? /* @__PURE__ */ C(
        T,
        {
          icon: e,
          className: l(b.iconLeft, s)
        }
      ) : null)
    }
  ), w = (o || a) && /* @__PURE__ */ C(
    "div",
    {
      className: l(
        b.rightWrapper,
        b[_],
        Z,
        N && b.responsiveIconOnly
      ),
      children: o || (a ? /* @__PURE__ */ C(
        T,
        {
          icon: a,
          className: l(b.iconRight, s)
        }
      ) : null)
    }
  );
  return /* @__PURE__ */ r("div", { className: b.buttonContent, children: [
    g,
    t ? /* @__PURE__ */ C(I, {}) : null,
    t && /* @__PURE__ */ C(
      "span",
      {
        className: l(
          b.label,
          c,
          N && b.responsiveIconOnly
        ),
        children: t
      }
    ),
    t ? /* @__PURE__ */ C(I, {}) : null,
    w
  ] });
}, m1 = f(
  function({
    label: L,
    className: e,
    size: i = "medium",
    loadingLabel: o,
    loading: a = !1,
    success: t = !1,
    successLabel: s,
    leftIcon: c,
    left: m,
    rightIcon: d,
    right: Z,
    variant: _ = "normal",
    disabled: N,
    onClick: g,
    iconClassName: w,
    labelClassName: v,
    spinnerClassName: R,
    leftWrapperClassName: Q,
    rightWrapperClassName: J,
    responsiveIconOnly: k1,
    forceRound: $1,
    ...A1
  }, I1) {
    const H1 = c1(
      L,
      t,
      s,
      a,
      o
    ), u1 = !!(L && !t && !a || t && s || a && o), R1 = $1 || c && !u1 && !m && !Z && !d || d && !u1 && !m && !Z && !c || a && !o || t && !s;
    return /* @__PURE__ */ C(
      "button",
      {
        ref: I1,
        onClick: (Y) => {
          if (g) {
            if (Y.stopPropagation(), Y.preventDefault(), N || t || a)
              return;
            g(Y);
          }
        },
        className: l(
          A.button,
          A[i],
          R1 && A.roundButton,
          e
        ),
        disabled: N,
        ...A1,
        children: /* @__PURE__ */ C(
          r1,
          {
            success: t,
            loading: a,
            leftIcon: c,
            left: m,
            right: Z,
            rightIcon: d,
            label: H1,
            iconClassName: w,
            labelClassName: v,
            spinnerClassName: R,
            leftWrapperClassName: Q,
            rightWrapperClassName: J,
            size: i,
            responsiveIconOnly: k1
          }
        )
      }
    );
  }
), t5 = "_flatButton_3cffo_1", a5 = "_normal_3cffo_25", s5 = "_danger_3cffo_28", c5 = "_success_3cffo_44", q = {
  flatButton: t5,
  normal: a5,
  danger: s5,
  success: c5
}, r5 = f(
  function({ className: L, variant: e = "normal", ...i }, o) {
    return /* @__PURE__ */ C(
      m1,
      {
        ref: o,
        className: l(q.flatButton, q[e], L),
        variant: e,
        ...i
      }
    );
  }
), m5 = "_primaryButton_lo2p8_1", l5 = "_normal_lo2p8_29", d5 = "_danger_lo2p8_32", M5 = "_success_lo2p8_54", G = {
  primaryButton: m5,
  normal: l5,
  danger: d5,
  success: M5
}, U0 = f(
  function({ className: L, variant: e = "normal", ...i }, o) {
    return /* @__PURE__ */ C(
      m1,
      {
        ref: o,
        className: l(G.primaryButton, G[e], L),
        variant: e,
        ...i
      }
    );
  }
), W0 = f(
  function(L, e) {
    return /* @__PURE__ */ C(
      r5,
      {
        leftIcon: o2,
        variant: "danger",
        ref: e,
        "aria-label": "Close",
        ...L
      }
    );
  }
), Z5 = "_secondaryButton_16omp_1", u5 = "_normal_16omp_28", f5 = "_danger_16omp_31", p5 = "_success_16omp_51", K = {
  secondaryButton: Z5,
  normal: u5,
  danger: f5,
  success: p5
}, q0 = f(function({ className: L, variant: e = "normal", ...i }, o) {
  return /* @__PURE__ */ C(
    m1,
    {
      ref: o,
      className: l(K.secondaryButton, K[e], L),
      variant: e,
      ...i
    }
  );
}), x5 = "_textInputButton_rl087_1", h5 = "_icon_rl087_20", _5 = "_normal_rl087_24", N5 = "_error_rl087_40", z5 = "_warning_rl087_56", g5 = "_success_rl087_72", C1 = {
  textInputButton: x5,
  icon: h5,
  normal: _5,
  error: N5,
  warning: z5,
  success: g5
}, b5 = {
  normal: f1,
  error: t1,
  warning: t1,
  success: F,
  passive: f1
}, G0 = f(function({
  variant: L = "normal",
  icon: e = b5[L],
  className: i,
  spin: o = !1,
  size: a = "medium",
  ...t
}, s) {
  return /* @__PURE__ */ C(
    "button",
    {
      ...t,
      ref: s,
      type: "button",
      className: l(
        A.button,
        C1.textInputButton,
        A[a],
        C1[L],
        i
      ),
      children: /* @__PURE__ */ C(
        h,
        {
          icon: e,
          size: "var(--current-icon-height)",
          className: C1.icon,
          spin: o
        }
      )
    }
  );
}), y5 = "_menuButton_vd51h_1", w5 = "_label_vd51h_44", S5 = "_buttonLink_vd51h_50", B5 = "_button_vd51h_50", v5 = "_hasLabel_vd51h_69", k5 = "_success_vd51h_73", $5 = "_danger_vd51h_80", A5 = "_disabled_vd51h_87", I5 = "_iconOnly_vd51h_119", H5 = "_selected_vd51h_124", M = {
  menuButton: y5,
  label: w5,
  buttonLink: S5,
  button: B5,
  hasLabel: v5,
  success: k5,
  danger: $5,
  disabled: A5,
  iconOnly: I5,
  selected: H5
}, R5 = "_menuButtonGroupBox_164qh_1", T5 = {
  menuButtonGroupBox: R5
}, V5 = ({
  children: n
}) => /* @__PURE__ */ C("div", { className: T5.menuButtonGroupBox, children: n }), l1 = ({
  label: n,
  leftIcon: L,
  left: e,
  right: i,
  rightIcon: o
}) => /* @__PURE__ */ r(u, { flex: 1, gap: 2, alignItems: "center", children: [
  /* @__PURE__ */ C(N1, { content: e, icon: L }),
  n && /* @__PURE__ */ C(
    $,
    {
      variant: "bold",
      className: M.label,
      color: "var(--current-text-color)",
      children: n
    }
  ),
  /* @__PURE__ */ C(N1, { content: i, icon: o })
] });
function N1({
  content: n,
  icon: L
}) {
  return n ? /* @__PURE__ */ C(B, { children: n }) : L ? /* @__PURE__ */ C(p, { alignItems: "center", justifyContent: "center", width: "20px", children: /* @__PURE__ */ C(
    h,
    {
      icon: L,
      size: 20,
      color: "var(--current-text-color)",
      "data-hover": !0
    }
  ) }) : null;
}
const D5 = f(
  function({
    label: n,
    expanded: L,
    expandable: e,
    selected: i,
    className: o,
    leftIcon: a,
    rightIcon: t,
    children: s,
    disabled: c,
    variant: m = "standard",
    left: d,
    right: Z,
    success: _ = !1,
    loading: N = !1,
    ...g
  }, w) {
    const v = !n && !e;
    return /* @__PURE__ */ r(p, { children: [
      /* @__PURE__ */ C(
        p,
        {
          "aria-expanded": L,
          className: l(M.menuButton),
          width: "100%",
          children: /* @__PURE__ */ r(
            "button",
            {
              className: l(
                M.button,
                i && M.selected,
                c && M.disabled,
                M[m],
                n ? M.hasLabel : void 0,
                v && M.iconOnly,
                o
              ),
              disabled: c,
              ref: w,
              ...g,
              children: [
                /* @__PURE__ */ C(
                  l1,
                  {
                    label: n,
                    leftIcon: a,
                    left: d,
                    right: N ? /* @__PURE__ */ C(v1, {}) : Z,
                    rightIcon: _ ? F : t
                  }
                ),
                e && /* @__PURE__ */ C(
                  h,
                  {
                    icon: L ? S1 : w1,
                    size: 18,
                    color: z("--lhds-color-blue-600")
                  }
                )
              ]
            }
          )
        }
      ),
      L && /* @__PURE__ */ r(B, { children: [
        /* @__PURE__ */ C(I, {}),
        /* @__PURE__ */ C(V5, { children: s })
      ] })
    ] });
  }
), F5 = "_contentMenuButton_c906v_1", j5 = {
  contentMenuButton: F5
}, K0 = f(({ children: n, ...L }, e) => /* @__PURE__ */ C("label", { className: j5.contentMenuButton, ref: e, ...L, children: /* @__PURE__ */ C(u, { justifyContent: "flex-start", alignItems: "center", indent: 2, children: n }) })), X0 = f(function({ selected: n, className: L, icon: e, disabled: i, variant: o = "standard", ...a }, t) {
  return /* @__PURE__ */ C(
    p,
    {
      className: l(M.menuButton),
      width: "100%",
      borderRadius: "99rem",
      overflow: "hidden",
      flexShrink: 0,
      children: /* @__PURE__ */ C(
        "button",
        {
          className: l(
            M.button,
            n && M.selected,
            i && M.disabled,
            M.iconOnly,
            M[o],
            L
          ),
          disabled: i,
          ref: t,
          ...a,
          children: /* @__PURE__ */ C(u, { justifyContent: "center", alignItems: "center", indent: 1, children: /* @__PURE__ */ C(p, { alignItems: "center", justifyContent: "center", width: "20px", children: /* @__PURE__ */ C(
            h,
            {
              icon: e,
              size: 20,
              color: "var(--current-text-color)",
              "data-hover": !0
            }
          ) }) })
        }
      )
    }
  );
}), E5 = f(function({
  label: n,
  className: L,
  leftIcon: e,
  children: i,
  disabled: o,
  variant: a = "standard",
  href: t,
  ...s
}, c) {
  var R;
  const m = /* @__PURE__ */ C(l1, { label: n, leftIcon: e }), d = "renderLink" in s ? s : void 0, Z = "selected" in s ? s : void 0, _ = l(
    M.button,
    M.buttonLink,
    n ? M.hasLabel : void 0,
    o && M.disabled,
    (Z == null ? void 0 : Z.selected) && M.selected,
    M[a],
    L
  ), { renderLink: N, selected: g, ...w } = s, v = ((R = d == null ? void 0 : d.renderLink) == null ? void 0 : R.call(
    d,
    {
      ...w,
      className: _,
      href: o ? void 0 : t,
      children: m
    },
    M.selected
  )) ?? /* @__PURE__ */ C(
    "a",
    {
      className: _,
      href: o ? void 0 : t,
      ref: c,
      ...w,
      children: m
    }
  );
  return /* @__PURE__ */ C(p, { className: l(M.menuButton), width: "100%", children: v });
}), Q0 = f(function({
  className: n,
  icon: L,
  children: e,
  disabled: i,
  variant: o = "standard",
  href: a,
  ...t
}, s) {
  var v;
  const c = /* @__PURE__ */ C(u, { justifyContent: "center", indent: 1, children: /* @__PURE__ */ C(p, { alignItems: "center", justifyContent: "center", width: "20px", children: /* @__PURE__ */ C(
    h,
    {
      icon: L,
      size: 20,
      color: "var(--current-text-color)",
      "data-hover": !0
    }
  ) }) }), m = "renderLink" in t ? t : void 0, d = "selected" in t ? t : void 0, Z = l(
    M.button,
    M.buttonLink,
    i && M.disabled,
    (d == null ? void 0 : d.selected) && M.selected,
    M.iconOnly,
    M[o],
    n
  ), { renderLink: _, selected: N, ...g } = t, w = ((v = m == null ? void 0 : m.renderLink) == null ? void 0 : v.call(
    m,
    {
      ...g,
      className: Z,
      href: i ? void 0 : a,
      children: c
    },
    M.selected
  )) ?? /* @__PURE__ */ C(
    "a",
    {
      className: Z,
      href: i ? void 0 : a,
      ref: s,
      ...g,
      children: c
    }
  );
  return /* @__PURE__ */ C(
    p,
    {
      className: l(M.menuButton),
      width: "100%",
      borderRadius: "99rem",
      overflow: "hidden",
      justifyContent: "space-between",
      children: w
    }
  );
}), O5 = "_buttonLink_1wbp2_1", P5 = {
  buttonLink: O5
}, d1 = f(function({
  label: L,
  className: e,
  size: i = "medium",
  loadingLabel: o,
  loading: a = !1,
  success: t = !1,
  successLabel: s,
  leftIcon: c,
  left: m,
  rightIcon: d,
  right: Z,
  variant: _ = "normal",
  responsiveIconOnly: N,
  ...g
}, w) {
  const v = c1(
    L,
    t,
    s,
    a,
    o
  ), R = !!(L && !t && !a || t && s || a && o), Q = R && !m && !c && !Z && !d, J = c && !R && !m && !Z && !d;
  return /* @__PURE__ */ C(
    "a",
    {
      ref: w,
      className: l(
        P5.buttonLink,
        A.button,
        A[i],
        J && A.iconOnly,
        Q && A.labelOnly,
        e
      ),
      ...g,
      children: /* @__PURE__ */ C(
        r1,
        {
          success: t,
          loading: a,
          leftIcon: c,
          left: m,
          right: Z,
          rightIcon: d,
          label: v,
          responsiveIconOnly: N
        }
      )
    }
  );
}), J0 = f(function({ className: L, variant: e = "normal", ...i }, o) {
  return /* @__PURE__ */ C(
    d1,
    {
      ref: o,
      variant: e,
      className: l(q.flatButton, q[e], L),
      ...i
    }
  );
}), Y0 = f(function({ className: L, variant: e = "normal", ...i }, o) {
  return /* @__PURE__ */ C(
    d1,
    {
      ref: o,
      variant: e,
      className: l(G.primaryButton, G[e], L),
      ...i
    }
  );
}), CC = f(function({ className: L, variant: e = "normal", ...i }, o) {
  return /* @__PURE__ */ C(
    d1,
    {
      ref: o,
      variant: e,
      className: l(K.secondaryButton, K[e], L),
      ...i
    }
  );
}), U5 = "_buttonGroup_1a3xe_1", W5 = {
  buttonGroup: U5
}, LC = ({
  className: n,
  children: L
}) => /* @__PURE__ */ C("div", { className: l(W5.buttonGroup, n), children: L }), q5 = "_upDownButtons_1688z_1", G5 = "_button_1688z_5", L1 = {
  upDownButtons: q5,
  button: G5
}, eC = ({
  onClickDown: n,
  onClickUp: L,
  iconColor: e,
  disabled: i
}) => /* @__PURE__ */ r(x, { className: L1.upDownButtons, children: [
  /* @__PURE__ */ C("button", { onClick: L, className: L1.button, disabled: i, children: /* @__PURE__ */ C(u, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ C(
    h,
    {
      icon: S1,
      size: 16,
      color: i ? "var(--swui-textinput-text-color-disabled)" : e
    }
  ) }) }),
  /* @__PURE__ */ C("button", { onClick: n, className: L1.button, disabled: i, children: /* @__PURE__ */ C(u, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ C(
    h,
    {
      icon: w1,
      size: 16,
      color: i ? "var(--swui-textinput-text-color-disabled)" : e
    }
  ) }) })
] }), nC = ({
  backgroundColor: n,
  iconColor: L = "--swui-text-primary-color",
  size: e = "medium",
  variant: i = "normal",
  ...o
}) => {
  const a = K5(e), t = X5(e);
  return /* @__PURE__ */ C(
    p,
    {
      borderRadius: "50%",
      background: z(n ?? Q5(i)),
      width: a,
      height: a,
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ C(h, { ...o, color: z(L), size: t })
    }
  );
}, K5 = (n) => {
  switch (n) {
    case "small":
      return "32px";
    case "medium":
      return "40px";
    case "large":
      return "64px";
    case "xl":
      return "160px";
    default:
      return y1(n);
  }
}, X5 = (n) => {
  switch (n) {
    case "small":
      return 16;
    case "medium":
      return 20;
    case "large":
      return 32;
    case "xl":
      return 80;
    default:
      return y1(n);
  }
}, Q5 = (n) => n === "whiteBg" ? "--lhds-color-ui-50" : "--lhds-color-ui-200", iC = ({
  background: n = "white",
  ...L
}) => /* @__PURE__ */ C(
  x,
  {
    shadow: "box",
    background: n,
    borderRadius: "var(--swui-border-radius)",
    ...L
  }
), oC = ({
  text: n,
  variant: L = "standard",
  leftIcon: e,
  contentAfterHeading: i,
  contentRight: o,
  contentLeft: a,
  contentCenter: t,
  headingLevel: s = "h2",
  ...c
}) => /* @__PURE__ */ r(
  u,
  {
    height: L === "compact" ? 40 : 56,
    justifyContent: "space-between",
    indent: 3,
    ...c,
    children: [
      /* @__PURE__ */ r(u, { alignItems: "center", gap: L === "compact" ? 1 : 2, children: [
        a,
        e && /* @__PURE__ */ C(h, { icon: e, size: L === "compact" ? 16 : 24 }),
        n && /* @__PURE__ */ C(X, { variant: "h5", as: s, children: n }),
        i
      ] }),
      t && /* @__PURE__ */ C(u, { alignItems: "center", children: t }),
      /* @__PURE__ */ C(u, { alignItems: "center", children: o })
    ]
  }
), tC = ({
  variant: n = "standard",
  ...L
}) => /* @__PURE__ */ C(x, { indent: 3, spacing: n === "compact" ? 1 : 3, ...L }), J5 = "_cardy_voxad_1", Y5 = "_cardyIndent_voxad_12", M1 = {
  cardy: J5,
  cardyIndent: Y5
}, aC = ({
  children: n,
  color: L = "--lhds-color-ui-200",
  loading: e,
  className: i,
  ...o
}) => /* @__PURE__ */ r(
  p,
  {
    ...o,
    background: z(L),
    position: e ? "relative" : void 0,
    className: l(M1.cardy, i),
    children: [
      n,
      e && /* @__PURE__ */ C(
        p,
        {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
          background: "var(--swui-overlay-bg-color-light)",
          children: /* @__PURE__ */ C(B1, {})
        }
      )
    ]
  }
), sC = ({
  text: n,
  right: L,
  leftIcon: e,
  ...i
}) => /* @__PURE__ */ r(p, { className: M1.cardyIndent, children: [
  /* @__PURE__ */ r(u, { alignItems: "center", justifyContent: "space-between", gap: 2, children: [
    /* @__PURE__ */ r(u, { alignItems: "center", gap: 2, children: [
      e && /* @__PURE__ */ C(h, { icon: e, size: "var(--swui-heading-font-size)" }),
      /* @__PURE__ */ C(X, { ...H(i), children: n })
    ] }),
    L
  ] }),
  /* @__PURE__ */ C(I, { num: 3 })
] }), cC = (n) => /* @__PURE__ */ C(p, { className: M1.cardyIndent, ...n }), C4 = "_chip_1k9u8_1", L4 = "_chipCell_1k9u8_25", e4 = "_label_1k9u8_36", n4 = "_removable_1k9u8_40", i4 = "_close_1k9u8_79", o4 = "_circle_1k9u8_83", t4 = "_primary_1k9u8_104", a4 = "_secondary_1k9u8_112", k = {
  chip: C4,
  chipCell: L4,
  label: e4,
  removable: n4,
  close: i4,
  circle: o4,
  primary: t4,
  secondary: a4
}, rC = ({
  onClickRemove: n,
  onClick: L,
  label: e,
  variant: i = "primary",
  className: o,
  ...a
}) => {
  const t = (m) => {
    m.stopPropagation(), m.preventDefault(), L == null || L(m);
  }, s = (m) => {
    m.stopPropagation(), m.preventDefault(), n == null || n(m);
  }, c = n ? k.removable : void 0;
  return /* @__PURE__ */ r(
    "div",
    {
      className: l(k.chip, k[i], c, o),
      ...H(a),
      children: [
        L ? /* @__PURE__ */ C(
          "button",
          {
            onClick: t,
            className: l(k.chipCell, k.label, c),
            children: e
          }
        ) : /* @__PURE__ */ C("div", { className: l(k.chipCell, k.label, c), children: e }),
        n && /* @__PURE__ */ C(
          "button",
          {
            className: l(k.chipCell, k.close),
            onClick: s,
            children: /* @__PURE__ */ C("div", { className: k.circle, children: /* @__PURE__ */ C(h, { icon: i2, size: 8 }) })
          }
        )
      ]
    }
  );
}, mC = y.memo(
  ({
    text: n,
    optional: L = !1,
    children: e,
    maxCharacters: i,
    row: o,
    textWidth: a,
    htmlFor: t,
    labelClassName: s,
    ...c
  }) => {
    const m = s4(L, i), d = m && /* @__PURE__ */ C(
      $,
      {
        color: z("--lhds-color-ui-800"),
        variant: "caption",
        size: "small",
        children: m
      }
    );
    return /* @__PURE__ */ r("label", { htmlFor: t, className: s, children: [
      /* @__PURE__ */ r(p, { ...c, row: o, gap: !0, children: [
        /* @__PURE__ */ r(u, { alignItems: "center", width: a, children: [
          /* @__PURE__ */ C(
            $,
            {
              color: z("--tjara"),
              variant: "bold",
              size: "small",
              whiteSpace: "nowrap",
              children: n
            }
          ),
          !o && /* @__PURE__ */ C(s1, { num: 1.5, children: d })
        ] }),
        e
      ] }),
      o && /* @__PURE__ */ C(u, { justifyContent: "flex-end", indent: 0.5, spacing: 0.5, children: d })
    ] });
  }
), s4 = (n, L) => {
  const e = [];
  if (n && e.push("optional"), L && e.push("max " + L + " characters"), e.length)
    return "(" + e.join(", ") + ")";
}, c4 = "_badge_1b6e7_1", r4 = "_info_1b6e7_17", m4 = "_warning_1b6e7_21", l4 = "_error_1b6e7_25", d4 = "_label_1b6e7_29", e1 = {
  badge: c4,
  info: r4,
  warning: m4,
  error: l4,
  label: d4
}, M4 = ({
  label: n,
  variant: L = "info",
  ...e
}) => /* @__PURE__ */ C("div", { className: l(e1.badge, e1[L]), ...H(e), children: /* @__PURE__ */ C(
  $,
  {
    size: "smaller",
    color: "var(--swui-badge-text-color)",
    className: e1.label,
    children: n
  }
) }), lC = ({
  children: n,
  top: L = "10px",
  left: e = "-5px",
  hideBadge: i = !1,
  ...o
}) => /* @__PURE__ */ r(u, { children: [
  n,
  /* @__PURE__ */ C("div", { style: { position: "relative" }, children: i ? null : /* @__PURE__ */ C(p, { top: L, left: e, position: "absolute", children: /* @__PURE__ */ C(M4, { ...o }) }) })
] }), Z4 = "_toggleButton_ei1l4_1", u4 = "_selected_ei1l4_50", f4 = "_disabled_ei1l4_56", p4 = "_small_ei1l4_62", x4 = "_medium_ei1l4_69", h4 = "_large_ei1l4_73", P = {
  toggleButton: Z4,
  selected: u4,
  disabled: f4,
  small: p4,
  medium: x4,
  large: h4
}, dC = f(function({
  label: L,
  value: e,
  size: i = "medium",
  onValueChange: o,
  onChange: a,
  disabled: t,
  ...s
}, c) {
  const m = V1(), d = D(
    (Z) => {
      a == null || a(Z), o == null || o(!e);
    },
    [a, o, e]
  );
  return /* @__PURE__ */ r(
    "div",
    {
      className: l(
        P.toggleButton,
        P[i],
        e && P.selected,
        t && P.disabled
      ),
      children: [
        /* @__PURE__ */ C(
          "input",
          {
            type: "checkbox",
            onChange: d,
            disabled: t,
            checked: e,
            ref: c,
            id: m,
            value: L,
            ...s
          }
        ),
        /* @__PURE__ */ C("label", { htmlFor: m, children: L })
      ]
    }
  );
}), MC = ({
  top: n,
  children: L,
  width: e,
  shadow: i,
  trapFocus: o,
  className: a
}) => L ? /* @__PURE__ */ C(q1, { contain: o, children: /* @__PURE__ */ r(
  x,
  {
    width: e,
    shadow: i,
    indent: 1,
    spacing: 1,
    className: a,
    borderRadius: "8px",
    children: [
      n,
      /* @__PURE__ */ C(x, { gap: 1, children: L })
    ]
  }
) }) : null, _4 = y.createContext({}), Z1 = ({ disableCloseOnClick: n, onClick: L }, e) => {
  const { close: i } = D1(_4), o = j1(e), a = D(
    (c) => {
      n || i == null || i(), L == null || L(c);
    },
    [L, i, n]
  ), t = G1();
  return {
    onClickHandler: a,
    onKeyDown: (c) => {
      var m;
      switch (c.key) {
        case "ArrowDown":
        case "ArrowRight":
          c.preventDefault(), t == null || t.focusNext({ wrap: !0 });
          break;
        case "ArrowUp":
        case "ArrowLeft":
          c.preventDefault(), t == null || t.focusPrevious({ wrap: !0 });
          break;
        case " ":
          c.preventDefault(), (m = o.current) == null || m.click();
      }
    },
    innerRef: o
  };
}, ZC = f(function({ disabled: L, onClick: e, disableCloseOnClick: i, ...o }, a) {
  const { onClickHandler: t, onKeyDown: s, innerRef: c } = Z1(
    { disableCloseOnClick: i, onClick: e },
    a
  );
  return /* @__PURE__ */ C(
    E5,
    {
      onKeyDown: s,
      disabled: L,
      onClick: L ? void 0 : t,
      ref: c,
      ...o
    }
  );
}), uC = f(function({ disableCloseOnClick: L, onClick: e, ...i }, o) {
  const { onClickHandler: a, onKeyDown: t, innerRef: s } = Z1(
    { disableCloseOnClick: L, onClick: e },
    o
  );
  return /* @__PURE__ */ C(
    D5,
    {
      onKeyDown: t,
      onClick: i.disabled ? void 0 : a,
      ref: s,
      ...i
    }
  );
}), fC = f(function({
  leftIcon: L,
  right: e,
  label: i,
  disabled: o,
  bottom: a,
  fullWidthBottomContent: t,
  ...s
}, c) {
  const { onKeyDown: m, innerRef: d } = Z1(s, c);
  return /* @__PURE__ */ C(B, { children: /* @__PURE__ */ r(
    x,
    {
      gap: 1,
      ...s,
      minHeight: "var(--swui-default-item-height)",
      justifyContent: "center",
      indent: 2,
      ref: d,
      onKeyDown: m,
      "aria-disabled": o,
      children: [
        /* @__PURE__ */ r(u, { justifyContent: "space-between", alignItems: "center", gap: 1, children: [
          /* @__PURE__ */ C(l1, { label: i, leftIcon: L }),
          e
        ] }),
        a && /* @__PURE__ */ r(u, { children: [
          !t && L && /* @__PURE__ */ C(s1, { num: 2 }),
          /* @__PURE__ */ C(u, { alignItems: "center", width: "100%", children: a })
        ] })
      ]
    }
  ) });
}), pC = () => /* @__PURE__ */ C(E1, { children: /* @__PURE__ */ C(O1, {}) }), N4 = "_tab_9rve8_1", z4 = "_selected_9rve8_50", z1 = {
  tab: N4,
  selected: z4
}, xC = f(function({
  selected: L,
  label: e,
  loading: i = !1,
  left: o,
  leftIcon: a,
  right: t,
  rightIcon: s,
  success: c = !1,
  tabIndex: m = 0,
  // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role
  responsiveIconOnly: d,
  ...Z
}, _) {
  const N = c1(
    e,
    c,
    void 0,
    i,
    void 0
  );
  return /* @__PURE__ */ C(
    "button",
    {
      className: l(z1.tab, L && z1.selected),
      role: "tab",
      "aria-selected": L,
      tabIndex: m,
      ref: _,
      ...Z,
      children: /* @__PURE__ */ C(
        r1,
        {
          success: c,
          loading: i,
          leftIcon: a,
          left: o,
          right: t,
          rightIcon: s,
          label: N,
          responsiveIconOnly: d
        }
      )
    }
  );
}), g4 = "_tabMenu_vtxe7_1", b4 = "_withBorder_vtxe7_10", g1 = {
  tabMenu: g4,
  withBorder: b4
}, hC = ({ children: n, enableBorder: L }) => /* @__PURE__ */ C(
  "div",
  {
    className: l(g1.tabMenu, { [g1.withBorder]: L }),
    role: "tablist",
    children: n
  }
), y4 = "_tag_1rqyd_1", w4 = "_icon_1rqyd_18", S4 = "_medium_1rqyd_22", B4 = "_withIcon_1rqyd_23", v4 = "_small_1rqyd_28", k4 = "_info_1rqyd_37", $4 = "_error_1rqyd_42", A4 = "_warning_1rqyd_47", I4 = "_success_1rqyd_52", H4 = "_passive_1rqyd_57", V = {
  tag: y4,
  icon: w4,
  medium: S4,
  withIcon: B4,
  small: v4,
  info: k4,
  error: $4,
  warning: A4,
  success: I4,
  passive: H4,
  "info-strong": "_info-strong_1rqyd_62",
  "error-strong": "_error-strong_1rqyd_67",
  "warning-strong": "_warning-strong_1rqyd_72",
  "success-strong": "_success-strong_1rqyd_77"
}, _C = ({
  className: n,
  style: L,
  variant: e = "info",
  size: i = "medium",
  label: o,
  icon: a,
  ...t
}) => /* @__PURE__ */ r(
  "div",
  {
    className: l(
      V.tag,
      V[e],
      V[i],
      a && V.withIcon,
      n
    ),
    style: L,
    ...H(t),
    children: [
      a && /* @__PURE__ */ C(T, { icon: a, className: V.icon }),
      /* @__PURE__ */ C("span", { children: o })
    ]
  }
), R4 = "_valueTable_14pft_1", T4 = "_withBorder_14pft_8", V4 = "_row_14pft_8", D4 = "_relaxed_14pft_13", F4 = "_condensed_14pft_17", j4 = "_compact_14pft_21", U = {
  valueTable: R4,
  withBorder: T4,
  row: V4,
  relaxed: D4,
  condensed: F4,
  compact: j4
}, NC = ({
  children: n,
  header: L,
  footer: e,
  disableBorder: i = !1,
  variant: o = "standard"
}) => /* @__PURE__ */ r(x, { children: [
  L && /* @__PURE__ */ C(u, { spacing: !0, children: /* @__PURE__ */ C(X, { variant: "h5", children: L }) }),
  /* @__PURE__ */ C(
    "table",
    {
      cellPadding: 0,
      cellSpacing: 0,
      className: l(
        U.valueTable,
        !i && U.withBorder,
        U[o]
      ),
      children: /* @__PURE__ */ C("tbody", { children: a1.map(n, (a, t) => /* @__PURE__ */ C("tr", { className: U.row, children: a }, t)) })
    }
  ),
  e && /* @__PURE__ */ C(u, { spacing: !0, children: /* @__PURE__ */ C($, { size: "small", color: z("--lhds-color-ui-600"), children: e }) })
] }), zC = ({
  label: n,
  value: L,
  alignValue: e = "left",
  labelIndent: i
}) => {
  const o = F1(() => L == null ? "-" : typeof L == "boolean" ? L ? /* @__PURE__ */ C(
    h,
    {
      icon: F,
      size: 14,
      color: z("--lhds-color-ui-700")
    }
  ) : "-" : typeof L == "number" ? String(L) : L, [L]);
  return /* @__PURE__ */ r(B, { children: [
    /* @__PURE__ */ C("td", { children: /* @__PURE__ */ C(
      u,
      {
        height: "var(--swui-value-table-height)",
        alignItems: "center",
        indent: i,
        children: /* @__PURE__ */ C(
          $,
          {
            color: z("--tjara"),
            variant: "bold",
            whiteSpace: "nowrap",
            children: n
          }
        )
      }
    ) }),
    /* @__PURE__ */ C("td", { children: /* @__PURE__ */ C(
      u,
      {
        height: "var(--swui-value-table-height)",
        alignItems: "center",
        justifyContent: e,
        children: typeof o == "string" ? /* @__PURE__ */ C($, { children: o }) : o
      }
    ) })
  ] });
}, E4 = "_routeLeg_um7oj_1", O4 = "_selectedIcon_um7oj_4", P4 = "_grid_um7oj_10", n1 = {
  routeLeg: E4,
  selectedIcon: O4,
  grid: P4
}, b1 = ({ location: n, dateTime: L, originalDateTime: e, size: i }) => i === "compact" ? /* @__PURE__ */ r(u, { gap: 2, justifyContent: "space-between", children: [
  /* @__PURE__ */ C(S, { size: "small", children: n }),
  /* @__PURE__ */ r(x, { children: [
    e && /* @__PURE__ */ C(
      S,
      {
        size: "small",
        variant: "bold",
        color: z("--lhds-color-ui-600"),
        style: { textDecoration: "line-through" },
        children: e
      }
    ),
    /* @__PURE__ */ C(S, { size: "small", variant: "bold", children: L })
  ] })
] }) : i === "relaxed" ? /* @__PURE__ */ r(x, { gap: 0.5, children: [
  /* @__PURE__ */ C(S, { size: "large", variant: "bold", children: n }),
  /* @__PURE__ */ r(x, { children: [
    e && /* @__PURE__ */ C(
      S,
      {
        size: "small",
        variant: "bold",
        color: z("--lhds-color-ui-600"),
        style: { textDecoration: "line-through" },
        children: e
      }
    ),
    /* @__PURE__ */ C(S, { size: "small", variant: "bold", children: L })
  ] })
] }) : /* @__PURE__ */ r(x, { gap: 0.5, children: [
  /* @__PURE__ */ C(S, { children: n }),
  /* @__PURE__ */ r(x, { children: [
    e && /* @__PURE__ */ C(
      S,
      {
        variant: "bold",
        color: z("--lhds-color-ui-600"),
        style: { textDecoration: "line-through" },
        children: e
      }
    ),
    /* @__PURE__ */ C(S, { variant: "bold", children: L })
  ] })
] }), gC = ({
  variant: n,
  departure: L,
  arrival: e,
  label: i,
  size: o = "standard",
  selected: a = !1,
  children: t
}) => {
  const s = n === "ship" ? e2 : n2;
  return /* @__PURE__ */ r("div", { className: n1.routeLeg, children: [
    i && /* @__PURE__ */ r(B, { children: [
      /* @__PURE__ */ C(S, { variant: "overline", size: "smaller", children: i }),
      /* @__PURE__ */ C(I, { num: 2 })
    ] }),
    a && /* @__PURE__ */ C(
      h,
      {
        icon: X1,
        size: 16,
        color: z("--lhds-color-blue-600"),
        className: n1.selectedIcon
      }
    ),
    /* @__PURE__ */ r("div", { className: n1.grid, children: [
      /* @__PURE__ */ r(x, { alignItems: "center", children: [
        /* @__PURE__ */ C(h, { icon: s, fixedWidth: !0, size: 20 }),
        /* @__PURE__ */ C(I, { half: !0 }),
        /* @__PURE__ */ C(
          p,
          {
            flex: 1,
            border: `1px solid ${z("--lhds-color-ui-900")}`,
            borderRadius: "2px 2px 0 0"
          }
        ),
        /* @__PURE__ */ C(
          p,
          {
            borderRadius: "50%",
            border: `2px solid ${z("--lhds-color-ui-900")}`,
            width: 16,
            height: 16
          }
        )
      ] }),
      /* @__PURE__ */ r(x, { gap: o === "standard" ? 3 : 2, children: [
        /* @__PURE__ */ C(b1, { ...L, size: o }),
        /* @__PURE__ */ C(b1, { ...e, size: o })
      ] }),
      t && /* @__PURE__ */ r(B, { children: [
        /* @__PURE__ */ C("div", {}),
        /* @__PURE__ */ C("div", { children: t })
      ] })
    ] })
  ] });
}, U4 = "_timeTag_1srws_1", W4 = "_icon_1srws_4", q4 = "_waiting_1srws_8", G4 = "_total_1srws_12", i1 = {
  timeTag: U4,
  icon: W4,
  waiting: q4,
  total: G4
}, bC = ({
  label: n,
  variant: L = "waiting"
}) => /* @__PURE__ */ C("div", { className: l(i1.timeTag, i1[L]), children: /* @__PURE__ */ r(u, { flex: "none", alignItems: "center", gap: !0, children: [
  /* @__PURE__ */ C(h, { icon: Q1, size: 16, className: i1.icon }),
  /* @__PURE__ */ C(S, { variant: "overline", size: "smaller", children: n })
] }) }), K4 = "_shimmerBox_73hsi_1", X4 = "_shimmer_73hsi_1", Q4 = {
  shimmerBox: K4,
  shimmer: X4
}, yC = ({
  className: n,
  ...L
}) => /* @__PURE__ */ C(p, { className: l(Q4.shimmerBox, n), ...L }), J4 = "_line_vg53u_1", Y4 = "_currentStep_vg53u_13", C3 = "_passedStep_vg53u_17", o1 = {
  line: J4,
  currentStep: Y4,
  passedStep: C3
}, L3 = ({
  status: n,
  className: L
}) => {
  const e = n === "current", i = n === "passed";
  return /* @__PURE__ */ C(
    "div",
    {
      className: l(
        o1.line,
        e && o1.currentStep,
        i && o1.passedStep,
        L
      )
    }
  );
}, e3 = "_text_17tbt_1", n3 = "_currentStep_17tbt_11", i3 = "_passedStep_17tbt_15", o3 = "_item_17tbt_30", W = {
  text: e3,
  currentStep: n3,
  passedStep: i3,
  item: o3
}, wC = ({
  id: n,
  label: L,
  status: e,
  className: i,
  screenReaderCurrentStepText: o,
  screenReaderPassedStepText: a,
  lineClassName: t,
  textClassName: s,
  ...c
}) => {
  const m = e === "current", d = e === "passed", Z = t3(
    o,
    a,
    e
  );
  return /* @__PURE__ */ r("li", { className: l(W.item, i), ...H(c), children: [
    /* @__PURE__ */ C(L3, { status: e, className: t }),
    /* @__PURE__ */ C(I, {}),
    Z == null ? null : /* @__PURE__ */ C(P1, { children: Z }),
    /* @__PURE__ */ C(
      $,
      {
        className: l(
          W.text,
          m && W.currentStep,
          d && W.passedStep,
          s
        ),
        children: L
      }
    )
  ] });
}, t3 = (n, L, e) => {
  if (e === "current")
    return n;
  if (e === "passed")
    return L;
}, a3 = "_list_1s4t8_1", s3 = {
  list: a3
}, SC = ({
  children: n,
  ...L
}) => /* @__PURE__ */ C("ol", { ...H(L), className: s3.list, children: n });
export {
  MC as ActionMenu,
  _4 as ActionMenuContext,
  uC as ActionMenuItem,
  fC as ActionMenuItemContent,
  ZC as ActionMenuLink,
  pC as ActionMenuSeparator,
  M4 as Badge,
  g2 as Banner,
  m1 as BaseButton,
  O0 as BreadCrumbs,
  r1 as ButtonContent,
  LC as ButtonGroup,
  iC as Card,
  tC as CardBody,
  oC as CardHeader,
  aC as Cardy,
  cC as CardyBody,
  sC as CardyHeader,
  rC as Chip,
  nC as CircledIcon,
  W0 as CloseButton,
  K0 as ContentMenuButton,
  P0 as Crumb,
  r5 as FlatButton,
  J0 as FlatButtonLink,
  h as Icon,
  X0 as IconMenuButton,
  Q0 as IconMenuButtonLink,
  v1 as InputSpinner,
  mC as Label,
  H2 as Link,
  D5 as MenuButton,
  E5 as MenuButtonLink,
  U0 as PrimaryButton,
  Y0 as PrimaryButtonLink,
  j2 as ResultList,
  j0 as ResultListBanner,
  V2 as ResultListRow,
  gC as RouteLeg,
  q0 as SecondaryButton,
  CC as SecondaryButtonLink,
  yC as ShimmerBox,
  B1 as Spinner,
  N3 as StenaFlag,
  wC as StepIndicatorItem,
  SC as StepIndicatorList,
  xC as Tab,
  hC as TabMenu,
  _C as Tag,
  G0 as TextInputButton,
  bC as TimeTag,
  dC as ToggleButton,
  eC as UpDownButtons,
  NC as ValueTable,
  zC as ValueTableItem,
  lC as WithBadge,
  Z6 as stenaAccount,
  w1 as stenaAngleDown,
  z3 as stenaAngleDownDouble,
  b3 as stenaAngleLeft,
  g3 as stenaAngleLeftDouble,
  w3 as stenaAngleRight,
  y3 as stenaAngleRightDouble,
  S1 as stenaAngleUp,
  S3 as stenaAngleUpDouble,
  u6 as stenaAnimals,
  B3 as stenaArrowCircleDown,
  v3 as stenaArrowCircleLeft,
  k3 as stenaArrowCircleRight,
  $3 as stenaArrowCircleUp,
  I3 as stenaArrowDouble,
  A3 as stenaArrowDoubleVertical,
  H3 as stenaArrowDown,
  R3 as stenaArrowLeft,
  T3 as stenaArrowPath,
  D3 as stenaArrowRight,
  V3 as stenaArrowRightAngle,
  F3 as stenaArrowShortDown,
  j3 as stenaArrowShortLeft,
  E3 as stenaArrowShortRight,
  O3 as stenaArrowShortUp,
  P3 as stenaArrowUp,
  U3 as stenaArrowWideDown,
  W3 as stenaArrowWideLeft,
  q3 as stenaArrowWideRight,
  G3 as stenaArrowWideUp,
  f6 as stenaAtm,
  p6 as stenaBackspace,
  x6 as stenaBan,
  h6 as stenaBar,
  N6 as stenaBell,
  _6 as stenaBellFilled,
  h0 as stenaBicycle,
  z6 as stenaBookmark,
  C6 as stenaBusinessAgreement,
  L6 as stenaBusinessArticle,
  e6 as stenaBusinessCard,
  n6 as stenaBusinessClaim,
  i6 as stenaBusinessInvoice,
  o6 as stenaBusinessNslh,
  t6 as stenaBusinessSignature,
  g6 as stenaBuy,
  b6 as stenaCafe,
  y6 as stenaCalculate,
  k6 as stenaCalendar,
  w6 as stenaCalendarFilled,
  S6 as stenaCalendarManage,
  B6 as stenaCalendarSortDown,
  v6 as stenaCalendarSortUp,
  $6 as stenaCameraError,
  A6 as stenaCameraOk,
  I6 as stenaCarRentalDesk,
  H6 as stenaCargoConstruction,
  R6 as stenaCargoMetal,
  T6 as stenaChangingTable,
  F as stenaCheck,
  X1 as stenaCheckCircle,
  V6 as stenaCheckCircleFilled,
  D6 as stenaCheckDouble,
  F6 as stenaCheckThick,
  j6 as stenaClean,
  O6 as stenaClear,
  E6 as stenaClearRow,
  Q1 as stenaClock,
  P6 as stenaClockFilled,
  W6 as stenaCloud,
  U6 as stenaCloudArrow,
  q6 as stenaCog,
  G6 as stenaCompare,
  K3 as stenaCompress,
  K6 as stenaContactAt,
  X6 as stenaCookies,
  J6 as stenaCopy,
  Q6 as stenaCopyDocument,
  Y6 as stenaDetails,
  C9 as stenaDimensions,
  L9 as stenaDotFilled,
  e9 as stenaDotOutline,
  i9 as stenaDots,
  n9 as stenaDotsVertical,
  t9 as stenaDownload,
  o9 as stenaDownloadPdf,
  a9 as stenaDrag,
  c9 as stenaEdit,
  s9 as stenaEditColumns,
  r9 as stenaElectricCharger,
  m9 as stenaEmptyRead,
  u0 as stenaEnjoyHyggeXl,
  f0 as stenaEnjoyLoungeXl,
  J1 as stenaExclamationCircle,
  l9 as stenaExclamationCircleFilled,
  t1 as stenaExclamationTriangle,
  d9 as stenaExclamationTriangleFilled,
  X3 as stenaExpand,
  M9 as stenaExternalLink,
  Z9 as stenaExtra,
  u9 as stenaEyeClose,
  f9 as stenaEyeHide,
  p9 as stenaEyeOpen,
  x9 as stenaEyeShow,
  h9 as stenaFavorites,
  N9 as stenaFileCsv,
  _9 as stenaFileCsvLabel,
  g9 as stenaFilePdf,
  z9 as stenaFilePdfLabel,
  y9 as stenaFileXls,
  b9 as stenaFileXlsLabel,
  w9 as stenaFilter,
  a6 as stenaFinancePaid,
  c6 as stenaFinancePay,
  s6 as stenaFinancePayPartially,
  r6 as stenaFinanceRaise,
  m6 as stenaFinanceRebate,
  d6 as stenaFinanceUnpaid,
  l6 as stenaFinanceUnpaidAlt,
  M6 as stenaFinanceWallet,
  S9 as stenaFoodDrink,
  p0 as stenaFoodRestaurantXl,
  B9 as stenaHamburger,
  v9 as stenaHandicapped,
  k9 as stenaHazardous,
  $9 as stenaHelp,
  A9 as stenaHistory,
  H9 as stenaHotel,
  I9 as stenaHotelBed,
  m0 as stenaHumanAdult,
  r0 as stenaHumanAdultWoman,
  l0 as stenaHumanChild,
  R9 as stenaHumanHappy,
  d0 as stenaHumanInfant,
  T9 as stenaHumanSad,
  M0 as stenaHumanSenior,
  Z0 as stenaHumanStudent,
  f1 as stenaInfoCircle,
  V9 as stenaInfoCircleFilled,
  Y1 as stenaInfoMegaphone,
  C2 as stenaInfoSpeech,
  D9 as stenaInfoSpeechAlert,
  F9 as stenaIntermodal,
  j9 as stenaKeyboard,
  P9 as stenaKeycard,
  E9 as stenaKeycardPin,
  O9 as stenaKeycardWifi,
  U9 as stenaLanguage,
  W9 as stenaLightbulb,
  D0 as stenaLighthouseXl,
  q9 as stenaLightning,
  G9 as stenaLineDotted,
  L2 as stenaLineSlash,
  K9 as stenaLineStraight,
  X9 as stenaLink,
  Q9 as stenaLockClosed,
  J9 as stenaLockOpen,
  Y9 as stenaLogoPlus,
  C7 as stenaLogout,
  L7 as stenaMail,
  e7 as stenaMapNavigation,
  Q3 as stenaMerge,
  i7 as stenaMinus,
  n7 as stenaMinusCircle,
  o7 as stenaMobile,
  t7 as stenaMouse,
  c7 as stenaMove,
  a7 as stenaMoveIn,
  s7 as stenaMoveOut,
  r7 as stenaMovieTheatre,
  m7 as stenaOverview,
  l7 as stenaParking,
  d7 as stenaPen,
  M7 as stenaPercentage,
  Z7 as stenaPerformance,
  u7 as stenaPets,
  f7 as stenaPhone,
  p7 as stenaPhoto,
  x7 as stenaPhotobooth,
  h7 as stenaPin,
  N7 as stenaPlugin,
  _7 as stenaPluginCheck,
  g7 as stenaPlus,
  z7 as stenaPlusCircle,
  b7 as stenaPrint,
  y7 as stenaQuestionBubble,
  w7 as stenaQuestionCircle,
  S7 as stenaRateThumbDown,
  B7 as stenaRateThumbUp,
  v7 as stenaRefresh,
  k7 as stenaRestrooms,
  $7 as stenaRobot,
  A7 as stenaRunningPerson,
  I7 as stenaSailingBus,
  H7 as stenaSailingCar,
  R7 as stenaSailingCargo,
  T7 as stenaSailingCrane,
  V7 as stenaSailingGate,
  D7 as stenaSailingImportExport,
  F7 as stenaSailingLocation,
  j7 as stenaSailingNoTicket,
  E7 as stenaSailingOffpeak,
  O7 as stenaSailingOnQuay,
  W7 as stenaSailingOnRoute,
  U7 as stenaSailingOnRouteArrow,
  P7 as stenaSailingOnRouteArrowFlipped,
  q7 as stenaSailingPeak,
  J3 as stenaSailingRoundTrip,
  K7 as stenaSailingRoute,
  G7 as stenaSailingRouteAlt,
  e2 as stenaSailingShip,
  X7 as stenaSailingShoulder,
  Q7 as stenaSailingTaxi,
  Y7 as stenaSailingTicket,
  J7 as stenaSailingTicketFilled,
  e8 as stenaSailingTrailer,
  C8 as stenaSailingTrailerDo,
  L8 as stenaSailingTrailerPu,
  n2 as stenaSailingTrain,
  n8 as stenaSailingTram,
  i8 as stenaSailingTruckAlt,
  o8 as stenaSailingTruckSide,
  t8 as stenaSailingVehicle,
  a8 as stenaSave,
  m8 as stenaSearch,
  s8 as stenaSearchError,
  c8 as stenaSearchMinus,
  r8 as stenaSearchPlus,
  l8 as stenaSendPlane,
  d8 as stenaService,
  M8 as stenaShare,
  Z8 as stenaShield,
  u8 as stenaSignIn,
  f8 as stenaSignOut,
  x0 as stenaSleepCabinXl,
  x8 as stenaSliders,
  p8 as stenaSlidersMini,
  h8 as stenaSms,
  N8 as stenaSortDown,
  _8 as stenaSortDownMini,
  g8 as stenaSortUp,
  z8 as stenaSortUpMini,
  b8 as stenaSpa,
  w8 as stenaStack,
  y8 as stenaStackCheck,
  S8 as stenaStar,
  B8 as stenaStatisticsBar,
  v8 as stenaStatisticsLine,
  k8 as stenaStatisticsPie,
  $8 as stenaStatusActive,
  A8 as stenaStatusBlock,
  I8 as stenaStatusCanceled,
  H8 as stenaStatusConfirmed,
  R8 as stenaStatusDone,
  V8 as stenaStatusInProgress,
  T8 as stenaStatusInProgressAlt,
  D8 as stenaStatusMissing,
  F8 as stenaStatusNoShow,
  j8 as stenaStatusTodo,
  E8 as stenaSupport,
  O8 as stenaSwitch,
  Y3 as stenaSync,
  P8 as stenaTag,
  U8 as stenaTags,
  W8 as stenaTemperature,
  o2 as stenaTimes,
  q8 as stenaTimesCircle,
  G8 as stenaTimesSmall,
  i2 as stenaTimesThick,
  K8 as stenaTodoCreate,
  X8 as stenaTodoDone,
  Q8 as stenaTodoList,
  J8 as stenaTrash,
  Y8 as stenaTravelEnjoyHygge,
  F0 as stenaTripFerryXl,
  C0 as stenaTurnOff,
  L0 as stenaUndo,
  e0 as stenaUnlink,
  n0 as stenaUpload,
  T0 as stenaUser,
  k0 as stenaUserAdd,
  $0 as stenaUserCircle,
  A0 as stenaUserGroupLarge,
  I0 as stenaUserGroupSmall,
  H0 as stenaUserMultiple,
  R0 as stenaUserSingle,
  V0 as stenaUsers,
  _0 as stenaVehicleCarLarge,
  N0 as stenaVehicleCarMpv,
  z0 as stenaVehicleCarStandard,
  g0 as stenaVehicleCaravan,
  b0 as stenaVehicleMotorcycle,
  y0 as stenaVehicleMotorhomeExtraLarge,
  w0 as stenaVehicleMotorhomeLarge,
  S0 as stenaVehicleMotorhomeMedium,
  B0 as stenaVehicleMotorhomeStandard,
  v0 as stenaVehicleTrailer,
  i0 as stenaVendingMachine,
  o0 as stenaWarehouse,
  t0 as stenaWeather,
  a0 as stenaWeight,
  c0 as stenaWifi,
  s0 as stenaWifiOff,
  E0 as useResultListBannerState
};
//# sourceMappingURL=index.es.js.map
